var myApplication = {
    projectName: '',
    apiName: '',
    appName: '',
    appCtrl: '',
    generalCtrl: '',
    protocol: 'http',
    projectType: '',
    projectTypeMobile: 'Mobile',
    projectTypeWeb: 'Web',
    language: '',
    defaultLanguage: '',
    projectTitle: '',
    apiMobileServerLink: '',
    apiMobileServerPort: '',
    dateTimeFormat: 'yyyy/MM/dd HH:mm:ss',
    dateFormat: 'yyyy/MM/dd',
    dateTimeFormatToDisplay: 'yyyy/MM/dd HH:mm:ss',
    dateShortTimeFormatToDisplay: 'yyyy/MM/dd HH:mm',
    dateFormatToDisplay: 'yyyy/MM/dd',
    timeFormat: 'HH:mm:ss',
    timeFormatWithMilliseconds: 'HH:mm:ss:SSS',
    shortTimeFormat: 'HH:mm',
    yearMonthFormat: 'yyyyMM',
    yearMonthFormatToDisplay: 'yyyy/MM',
    moneyTwoDecimalCase: { currency: "EUR", minimumFractionDigits: 2 },
    moneyFiveDecimalCase: { currency: "EUR", minimumFractionDigits: 5 },
    twoDecimalCase: { type: "fixedPoint", precision: 2 },
    threeDecimalCase: { type: "fixedPoint", precision: 3 },
    fourDecimalCase: { type: "fixedPoint", precision: 4 },
    fiveDecimalCase: { type: "fixedPoint", precision: 5 },
    dateMonthYearFormat: 'monthAndYear',
    dateMonthFormat: 'month',
    dateYearFormat: 'year',
    horizontalScrollAuxiliaryMenus: true,
    numberOfElementsToLoad: 50000,
    gridFont: {},
    differentLoginPages: [],
    differentLogin: '',
    loginPage: 'Login',
    maxLimitFile: '1GB',
    guidEmpty: "00000000-0000-0000-0000-000000000000",
    listOfTranslationsAreas: [],
    defaultNif: '999999990',
    numberRequestsToFormat: 5000,
    getLanguageObject: new function (typeObject, myApplication) {
        this.selectedLanguage = function (typeObject, myApplication) {
            if ((myApplication.language.toUpperCase() === "EN") || (myApplication.language.toUpperCase() === "PT-PT")) {
                return myApplication[typeObject][myApplication.language.toUpperCase()];
            }
            else {
                return myApplication[typeObject][myApplication.defaultLanguage.toUpperCase()];
            }
        };
    },
    SetApplicationParametrization: new function () {
        this.BasicParametrization = function (projectName, apiName, appName, appCtrl, generalCtrl, projectTitle) {
            myApplication.projectName = projectName;
            myApplication.apiName = apiName;
            myApplication.appName = appName;
            myApplication.appCtrl = appCtrl;
            myApplication.generalCtrl = generalCtrl;
            myApplication.projectTitle = projectTitle;
        };
        this.Protocol = function (protocol) {
            myApplication.protocol = protocol;
        };
        this.Language = function (language, defaultLanguage) {
            myApplication.language = language;
            myApplication.defaultLanguage = defaultLanguage;
        };
        this.Layout = function (family, size, color) {
            myApplication.gridFont = { family: family, size: size, color: color };
        };
        this.ProjectType = function (projectType) {
            myApplication.projectType = projectType;
        };
        this.ApiMobileServerLink = function (apiMobileServerLink) {
            myApplication.apiMobileServerLink = apiMobileServerLink;
        };
        this.ApiMobileServerPort = function (apiMobileServerPort) {
            myApplication.apiMobileServerPort = apiMobileServerPort;
        };
        this.ListOfTranslationsAreas = function (listOfTranslationsAreas) {
            myApplication.listOfTranslationsAreas = listOfTranslationsAreas;
        };
        this.Modules = function (modules) {
            myApplication.modules = modules;
        };
        this.DateTimeFormatToDisplay = function (dateTimeFormatToDisplay) {
            myApplication.dateTimeFormatToDisplay = dateTimeFormatToDisplay;
        };
        this.DateFormatToDisplay = function (dateFormatToDisplay) {
            myApplication.dateFormatToDisplay = dateFormatToDisplay;
        };
        this.YearMonthFormatToDisplay = function (yearMonthFormatToDisplay) {
            myApplication.yearMonthFormatToDisplay = yearMonthFormatToDisplay;
        };
    },
    gridWarningMessages: {
        EN: {
            required: new function () {
                return function () { return "Mandatory Field."; };
            },
            email: new function () {
                return function () { return "Email Field."; };
            },
            numeric: new function () {
                return function () { return "Numeric Field."; };
            },
            stringLenghtMax: new function () {
                return function (max) { return "This field can have a maximum amount of " + max + " characters."; };
            },
            stringLenghtFixedValue: new function () {
                return function (value) { return "This field has to have " + value + " characters."; };
            },
            stringLenghtMin: new function () {
                return function (min) { return "This field can have a minimum amount of " + min + " characters."; };
            },
            stringLenghtMinAndMax: new function () {
                return function (min, max) { return "This field can have between " + min + " and " + max + " characters."; };
            },
            numericRangeMax: new function () {
                return function (max) { return "This value has to have a maximum of " + max + "."; };
            },
            numericRangeMin: new function () {
                return function (min) { return "This value has to have a minimum of " + min + "."; };
            },
            numericRangeMinAndMax: new function () {
                return function (min, max) { return "This value has to bee between " + min + " and " + max + "."; };
            }
        },
        "PT-PT": {
            required: new function () {
                return function () { return "Campo obrigatório."; };
            },
            email: new function () {
                return function () { return "Campo email."; };
            },
            numeric: new function () {
                return function () { return "Campo numérico."; };
            },
            stringLenghtMax: new function () {
                return function (max) { return "Este campo pode ter no máximo " + max + " carateres."; };
            },
            stringLenghtFixedValue: new function () {
                return function (value) { return "Este campo tem de ter " + value + " carateres."; };
            },
            stringLenghtMin: new function () {
                return function (min) { return "Este campo pode ter no mínimo " + min + " carateres."; };
            },
            stringLenghtMinAndMax: new function () {
                return function (min, max) { return "Este campo tem de ter entre " + min + " e " + max + "carateres."; };
            },
            numericRangeMax: new function () {
                return function (max) { return "Este valor tem de ser no máximo " + max + "."; };
            },
            numericRangeMin: new function () {
                return function (min) { return "Este valor tem de ser no mínimo " + min + "."; };
            },
            numericRangeMinAndMax: new function () {
                return function (min, max) { return "Este valor tem de ser entre " + min + " e " + max + "."; };
            }
        }
    },
    warningMessages: {
        EN: {
            fieldsRequired: new function () {
                return function () { return "There are mandatory fields to fill!"; };
            },
            thereWasError: new function () {
                return function () { return "There was an error saving your data."; };
            },
            thereWasErrorTryAgain: new function () {
                return function () { return "There was an error saving your data. Please try again."; };
            },
            leavePage: new function () {
                return function () { return "Leave this page? It is possible that your alterations have not been made."; };
            },
            thereWasErrorGettingData: new function () {
                return function () { return "There was an error getting your data."; };
            }
        },
        "PT-PT": {
            fieldsRequired: new function () {
                return function () { return "Há Campos Obrigatórios por Preencher!"; };
            },
            thereWasError: new function () {
                return function () { return "Houve um erro ao guardar os seus dados."; };
            },
            thereWasErrorTryAgain: new function () {
                return function () { return "Houve um erro ao guardar os seus dados. Por favor, tente novamente."; };
            },
            leavePage: new function () {
                return function () { return "Quer deixar a página? É possível que as suas alterações não tenham sido feitas."; };
            }
        }
    },
    concurrencyDataTexts: {
        EN: {
            deletedRegister: "This register was deleted from server.",
            serverData: "Server Data",
            enabled: "Enabled",
            disabled: "Disabled",
            editedRegister: "This register was edited."
        },
        "PT-PT": {
            deletedRegister: "Este registo foi eliminado no servidor.",
            serverData: "Dados no Servidor",
            enabled: "Ativo",
            disabled: "Inativo",
            editedRegister: "Este registo foi editado."
        }
    },
    loginMobileTexts: {
        EN: {
            errorProcessingLogin: "Error processing your login.",
            errorReadingData: "There was an error reading your data, please try again.",
            invalidLogin: "Invalid Login.",
            chooseValidConnection: "Choose a valid connection."
        },
        "PT-PT": {
            errorProcessingLogin: "Erro ao processar login.",
            errorReadingData: "Houve um erro a ler os seus dados, por favor tente novamente.",
            invalidLogin: "Login inválido.",
            chooseValidConnection: "Escolha uma conexão válida."
        }
    },
    basePageTexts: {
        EN: {
            tools: "Tools",
            exportExcel: "Export to Excel",
            exportXML: "Export to XML",
            exportPDF: "Export to PDF",
            hideDisabled: "Hide Disabled",
            showDisabled: "Show Disabled",
            loadingData: "There are still data loading.",
            loading: "Loading...",
            enabled: "Enabled",
            disabled: "Disabled",
            deleteSuccess: " was deleted successfully.",
            insert: "Insert",
            all: "(All)",
            yes: "Yes",
            no: "No",
            noDataFound: "No data was found.",
            continueNextPage: "Continues on the next page",
            selectLater: "Select Later...",
            chooseOption: "Choose an option...",
            confirmDelete: "Are you sure you want to delete this register?",
            welcome: "Welcome, ",
            your: "Your ",
            new: "New",
            changeProfile: "Change User Profile",
            userData: "User Data",
            photography: "Photography",
            name: "Name",
            email: "Email",
            language: "Language",
            updateProfile: "Update Profile",
            changePassword: "Change Password",
            newPassword: "New Password",
            confirmNewPassword: "Confirm New Password",
            currentPassword: "Current Password",
            canNotBeEqualToYourPreviousPassword: "Your new password can not be equal to your previous password.",
            passwordsDoNotMatch: "The passwords do not match.",
            state: "State",
            goBack: "Go Back",
            somethingWentWrong: "Oops, something went wrong",
            success: "Success",
            filters: "Filters",
            options: "Options",
            list: "View in List",
            thumbnails: "Thumbnails",
            history: "History",
            warning: "Warning",
            search: "Search",
            stillDataLoading: "There is still data loading.",
            errorEstablishingConnection: "There was an error establishing the connection!"
        },
        "PT-PT": {
            tools: "Ferramentas",
            exportExcel: "Exportar para Excel",
            exportPDF: "Exportar para PDF",
            exportXML: "Exportar para XML",
            hideDisabled: "Esconder os Inativos",
            showDisabled: "Mostrar os Inativos",
            loadingData: "Ainda há dados a ser carregados.",
            loading: "A Carregar...",
            enabled: "Ativo",
            disabled: "Inativo",
            deleteSuccess: " foi removido com sucesso.",
            insert: "Inserir",
            all: "(Tudo)",
            yes: "Sim",
            no: "Não",
            noDataFound: "Não foram encontrados dados.",
            continueNextPage: "Continua na página seguinte",
            selectLater: "Escolher depois...",
            chooseOption: "Escolha uma opção...",
            confirmDelete: "Tem a certeza de que pretende eliminar este registo?",
            welcome: "Bem vindo, ",
            your: "",
            new: "Novo",
            changeProfile: "Editar Perfil",
            userData: "Dados Utilizador",
            photography: "Fotografia",
            name: "Nome",
            email: "E-mail",
            language: "Linguagem",
            updateProfile: "Alterar Dados",
            changePassword: "Alterar Password",
            newPassword: "Nova Password",
            confirmNewPassword: "Confirmar Nova Password",
            currentPassword: "Password Atual",
            canNotBeEqualToYourPreviousPassword: "A sua nova Password não pode ser igual à anterior.",
            passwordsDoNotMatch: "As Passwords não correspondem.",
            success: "Sucesso",
            state: "Estado",
            goBack: "Voltar",
            somethingWentWrong: "Ups, algo está errado",
            filters: "Filtros",
            options: "Opções",
            list: "Vista em Lista",
            thumbnails: "Cartões",
            history: "Histórico",
            warning: "Aviso",
            search: "Pesquisa",
            stillDataLoading: "Ainda há dados a serem carregados.",
            errorEstablishingConnection: "Houve um erro a estabelecer a ligação!"
        }
    },
    historyTexts: {
        EN: {
            field: "Field",
            oldRegister: "Old Register",
            newRegister: "New Register",
            user: "User",
            alterationDate: "Alteration Date",
            noDataFound: "No data was found"
        },
        "PT-PT": {
            field: "Campo",
            oldRegister: "Registo Antigo",
            newRegister: "Novo Registo",
            user: "Utilizador",
            alterationDate: "Data de Alteração",
            noDataFound: "Não foram encontrados dados."
        }
    },
    saveCancelButtonsTexts: {
        EN: {
            save: "Save",
            cancel: "Cancel",
            successfullSave: "Your data was saved successfully.",
            new: "New",
            delete: "Delete",
            submit: "Submit",
            successProfileSave: "Your data was updated successfully. Please login again.",
            setValues: "Set Standard Values",
            successValuesSave: "Your standard values were defined successfully."
        },
        "PT-PT": {
            save: "Guardar",
            cancel: "Cancelar",
            successfullSave: "Os seus dados foram guardados com sucesso.",
            new: "Novo",
            delete: "Eliminar",
            submit: "Submeter",
            successProfileSave: "Os seus dados foram atualizados com sucesso. Por favor faça login novamente.",
            setValues: "Definir Valores Padrão",
            successValuesSave: "Os seus valores padrão foram definidos com sucesso."
        }
    },
    validationsTexts: {
        EN: {
            notAllowed: "Not Allowed",
            error: "Error",
            errorLoadingTranslations: "There was an error loading your translations.",
            browserBlockingTranslations: "Your browser configurations is blocking the translations."
        },
        "PT-PT": {
            notAllowed: "Não Permitido",
            error: "Erro",
            errorLoadingTranslations: "Houve um erro ao carregar as suas traduções.",
            browserBlockingTranslations: "As configurações do seu browser estão a bloquear as traduções."
        }
    },
    generalFunctionsTexts: {
        EN: {
            pendingChanges: "There are pending changes. Are you sure you want to leave this page?",
            confirmDelete: "Are you sure you want to delete this registers?",
            irreversible: "This option is <b>irreversible</b>.",
            delete: "Delete",
            exportExcel: "Export to Excel",
            search: "Search...",
            enabled: "Enabled",
            disabled: "Disabled",
            loading: "Loading...",
            loadingRequests: "Loading your requests...",
            loadImage: "Load Image",
            saveImage: "Save Image",
            removeImage: "Delete Image",
            select: "Select",
            noDataFound: "No data was found.",
            offline: "Internet connection lost.",
            online: "Internet connection recovered.",
            days: "days",
            clearTime: "Clear Time",
            selectColor: "Select Color",
            clearColor: "Clear Color",
            selectTime: "Select Time",
            Days: "Days",
            time: "Time",
            insertImage: "Insert Image",
            selectImageOrDrag: "Select a File or Drag it Here.",
            nameOfFile: "Nome do Ficheiro:",
            today: "Today",
            clear: "Clear",
            PasswordSentToYourEmail: "We will send you an email with the new password.",
            DateMustBeUnique: "The date must be unique in this column.",
            annexesSelectOrDrag: "Select your file or drag it here."
        },
        "PT-PT": {
            pendingChanges: "Há alterações pendentes.Tem a certeza que pretende sair desta página?",
            confirmDelete: "Tem a certeza que deseja eliminar estes registos?",
            irreversible: "Esta opção é <b>irreversível</b>.",
            delete: "Apagar",
            exportExcel: "Exportar para Excel",
            search: "Pesquisar...",
            enabled: "Ativo",
            disabled: "Inativo",
            loading: "A Carregar...",
            loadingRequests: "A carregar os seus pedidos...",
            loadImage: "Carregar Imagem",
            saveImage: "Guardar Imagem",
            removeImage: "Remover Imagem",
            select: "Selecionar",
            noDataFound: "Não foram encontrados dados.",
            offline: "Sem ligação à internet.",
            online: "Ligação à internet recuperada.",
            days: "dias",
            clearTime: "Limpar Tempo",
            selectColor: "Selecionar Cor",
            clearColor: "Limpar Cor",
            selectTime: "Selecionar Tempo",
            Days: "Dias",
            time: "Tempo",
            insertImage: "Inserir Imagem",
            selectImageOrDrag: "Selecione um Ficheiro ou Arraste-o para Aqui.",
            nameOfFile: "Nome do Ficheiro:",
            today: "Hoje",
            clear: "Limpar",
            PasswordSentToYourEmail: "Vamos enviar-lhe um email com a nova password.",
            DateMustBeUnique: "A data tem que ser única nesta coluna.",
            annexesSelectOrDrag: "Selecione o seu ficheiro ou arraste-o para aqui."
        }
    },
    saveFunctions: {
        EN: {
            invalidFields: "There are invalid fields on this page information.",
            invalidFieldsOnTable: "There are invalid fields on internal table ",
            invalidFieldsTable: "There are invalid fields on table ",
            invalidFieldsOnContacts: "There are invalid fields on contacts.",
            internalTable: "Internal table ",
            isRequired: " is required.",
            invalidApi: "No API was found in this connection URL.",
            duplicatedConnection: "A connection with same Name or Url already exists.",
            defaultConnection: "A default connection already exists.",
            oneConnection: "Can't remove this connection, one default connection should exist.",
            invalidFilters: "There are mandatory filters to fill!"
        },
        "PT-PT": {
            invalidFields: "Há campos inválidos nas informações desta página.",
            invalidFieldsOnTable: "Há campos inválidos na tabela interna de ",
            invalidFieldsTable: "Há campos inválidos na tabela ",
            invalidFieldsOnContacts: "Há campos inválidos nos contactos.",
            internalTable: "A tabela interna de ",
            isRequired: " é obrigatória.",
            invalidApi: "Não foi encontrada API no URL inserido.",
            duplicatedConnection: "Uma conexão com o mesmo Nome ou Url já existem.",
            defaultConnection: "Já existe uma conexão por defeito.",
            oneConnection: "Não é possivel eliminar esta conexão, deve existir uma conexão por defeito.",
            invalidFilters: "Há filtros obrigatórios por preencher!"
        }
    },
    notesFunctions: {
        EN: {
            noNotesWereFound: "No notes were found.",
            downloadAttachment: "Download Attachment",
            deleteAttachment: "Delete Attachment",
            deleteImage: "Delete Image",
            edit: "edit",
            delete: "delete",
            invalidFile: "Invalid File!",
            addAttachment: "Add Attachment",
            invalidPhoto: "Invalid Photo!",
            addPhoto: "Add Photo",
            image: "Image",
            notesOf: "Notes of ",
            thereWarAnErrorUploading: "There was an error uploading your attachments.",
            fileAttached: "File Attached",
            photoAttached: "Photo Attached",
            areYouSureDeleteNote: "Are you sure you want to delete this note?",
            areYouSureDeletePhoto: "Are you sure you want to delete this photo?",
            areYouSureDeleteAttachment: "Are you sure you want to delete this attachment?",
            photoRemovedSuccessfully: "Photo removed successfully.",
            attachmentRemovedSuccessfully: "Attachment removed successfully.",
            noteSavedSuccessfully: "Note saved successfully.",
            noteRemovedSuccessfully: "Note removed successfully.",
            at: " at ",
            yesterday: "Yesterday",
            today: "Today",
            pleaseAddTextOrImage: "Please add text or an image to your note."
        },
        "PT-PT": {
            noNotesWereFound: "Não foram encontradas notas.",
            downloadAttachment: "Download Anexo",
            deleteAttachment: "Apagar Anexo",
            deleteImage: "Apagar Imagem",
            edit: "editar",
            delete: "delete",
            invalidFile: "Ficheiro Inválido!",
            addAttachment: "Adicionar Anexo",
            invalidPhoto: "Foto Inválida!",
            addPhoto: "Adicionar Fotografia",
            image: "Imagem",
            notesOf: "Notas de ",
            thereWarAnErrorUploading: "Houve um erro ao fazer upload dos seus anexos.",
            fileAttached: "Ficheiro Anexado",
            photoAttached: "Foto Anexada",
            areYouSureDeleteNote: "Tem a certeza que pretende eliminar esta nota?",
            areYouSureDeletePhoto: "Tem a certeza que pretende eliminar esta fotografia?",
            areYouSureDeleteAttachment: "Tem a certeza que pretende eliminar este anexo?",
            photoRemovedSuccessfully: "Fotografia removida com sucesso.",
            attachmentRemovedSuccessfully: "Anexo removido com sucesso.",
            noteSavedSuccessfully: "Nota guardarda com sucesso.",
            noteRemovedSuccessfully: "Nota removida com sucesso.",
            at: " às ",
            yesterday: "Ontem",
            today: "Hoje",
            pleaseAddTextOrImage: "Por favor adicione texto ou uma imagem à sua nota."
        }
    },
    pivotGridTexts: {
        EN: {
            allFields: "All Fields",
            columnFields: "Columns",
            dataFields: "Values",
            filterFields: "Filters",
            rowFields: "Rows",
            title: "Table Options",
            fromFilter: "From",
            toFilter: "to",
            applyFilter: "Apply",
            grandTotal: "Total"
        },
        "PT-PT": {
            allFields: "Todos Campos",
            columnFields: "Colunas",
            dataFields: "Valores",
            filterFields: "Filtros",
            rowFields: "Linhas",
            title: "Opções Tabela",
            fromFilter: "Desde",
            toFilter: "até",
            applyFilter: "Aplicar",
            grandTotal: "Total"
        }
    }
};
myApplication.SetApplicationParametrization.BasicParametrization('SolutionConfigurator', 'ProposalApi', 'SolutionsApp', 'BaseSolutionsAppCtrl', 'GeneralSolutionsAppCtrl', 'SolutionConfigurator');

myApplication.SetApplicationParametrization.Protocol('http');

myApplication.SetApplicationParametrization.Language('pt-PT', 'pt-PT');

myApplication.SetApplicationParametrization.Layout("Roboto", '12px', '#333333');

myApplication.SetApplicationParametrization.ProjectType('Web');

var myApp;
if (myApplication.projectType === myApplication.projectTypeWeb) {
    myApp = angular.module(myApplication.appName, ['dx', 'ngStorage', 'ngMaterial', 'ngMessages', 'ngDraggable',
        'ui.sortable', 'ui.router', 'ngSanitize', 'jQueryScrollbar', 'ui.bootstrap', 'ngFileUpload', 'oc.lazyLoad', 'textAngular', 'pascalprecht.translate', 'chrisjsherm.service.uuid', 'angular.bind.notifier', 'ngLocale'], function ($locationProvider) {
            if (angular.lowercase === undefined) {
                angular.lowercase = angular.$$lowercase;
            }

            $locationProvider.html5Mode({
                enabled: true,
                requireBase: false
            });
        }).run(function ($rootScope, $http, $location, $sessionStorage, $timeout, $q, GeneralModel, $state) {
            window.onhashchange = function (evt) {
                $timeout(function () {
                    var pendingRequests = [];

                    $http.pendingRequests.forEach(function (request) {
                        if (request.cancel) {
                            pendingRequests.push(request.cancel);
                        }
                    });

                    if (typeof $sessionStorage.HashObject !== "undefined") {
                        $q.all(pendingRequests).then(function () {
                            if ($sessionStorage.HashObject.Hash !== "") {
                                $timeout(function () {
                                    angular.element('#' + $sessionStorage.HashObject.Hash).click();
                                }, 500);
                            }
                        });
                    }
                }, 500);
            };

            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, _fromState, _fromParams) {
                GeneralModel.model.OldParentId = '';
                GeneralModel.model.SecondLevelMenu = false;

                if ((myApplication.appName === 'SwebApp') || (myApplication.appName === 'LidarcoApp') || (myApplication.appName === 'SingestJCApp')) {
                    GeneralModel.Initializer();
                }

                if (toState.module) {
                    let hasAccessToModule = false;
                    let moduleListToCheck = $sessionStorage.Modules;

                    if (myApplication.appName === 'SwebApp') {
                        moduleListToCheck = $sessionStorage.ConfigurationBase.Modules;
                    }

                    for (var s = 0; s < toState.module.length; s++) {
                        let moduleCode = toState.module[s];

                        if (moduleListToCheck[moduleCode]) {
                            hasAccessToModule = true;
                            break;
                        }
                    }

                    if ((typeof moduleListToCheck !== 'undefined') && !hasAccessToModule) {
                        event.preventDefault();
                        $state.go(toState.redirectTo, toParams, { location: 'replace' });
                        $rootScope.generalModel.FullPageLoading = false;
                    }
                }

                $sessionStorage.HashObject = { PageName: '', Hash: '' };

                if ((typeof $location.$$hash !== "undefined") && ($location.$$hash !== null) && ($location.$$hash !== '')) {
                    $sessionStorage.HashObject = { PageName: toState.name, Hash: $location.$$hash };
                }

                $http.pendingRequests.forEach(function (request) {
                    if (request.cancel) {
                        request.cancel.resolve({ data: [], statusText: "OK", status: 200 });
                    }
                });
            });

            $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                if (typeof $sessionStorage.HashObject === "undefined") {
                    return;
                }

                $timeout(function () {
                    if ((typeof GeneralModel.model.TranslationsObject !== "undefined") && (angular.equals(GeneralModel.model.TranslationsObject, {}))) {
                        GeneralModel.model.TranslationsObject = $sessionStorage.Translations;
                    }
                    $rootScope.$broadcast('$$rebind::refresh');
                    if ((typeof $sessionStorage.HashObject !== "undefined") && ($sessionStorage.HashObject.PageName === toState.name) && ($location.$$hash === "")) {
                        window.history.pushState('', '', $location.absUrl() + '#' + $sessionStorage.HashObject.Hash);
                    }

                });
            });
        });
}

myApp.value('Settings', { IsOnline: true });

(function () {
    "use strict";
    myApp.factory('GeneralFunctions', ["GeneralModel", "$q", "$window", "$mdSidenav", "$compile", "$state", "$timeout", "$filter", "$mdDialog", "$parse", "ExportFiles", "UploadMethod", "ConcurrencyData", "SaveFunctions", "HistoryService", "DateOperations", "SwebModal", "$sessionStorage", "$location", function (GeneralModel, $q, $window, $mdSidenav, $compile, $state, $timeout, $filter, $mdDialog, $parse, ExportFiles, UploadMethod, ConcurrencyData, SaveFunctions, HistoryService, DateOperations, SwebModal, $sessionStorage, $location) {

        function GeneralFunctions(scope, rootScope) {
            SwebModal(scope);

            ConcurrencyData(scope);

            SaveFunctions(scope);

            HistoryService(scope);

            DateOperations(scope);

            scope.generalModel.GetMenus = function () {
                var menus = $sessionStorage.ParentMenus;

                SetMenusDescription(menus);

                scope.Menus = menus;

                return menus;
            }

            scope.generalModel.GetChildrenMenus = function () {
                if (!scope.Menus) {
                    return null;
                }

                var parentMenu = scope.Menus.find(find => (find.MenuId === scope.generalModel.ParentId));

                if (!parentMenu) {
                    return null;
                }

                var menus = parentMenu.ChildrenMenus;

                SetMenusDescription(menus);

                return menus;
            }

            function SetMenusDescription(menus) {
                if (!menus || !menus.length) {
                    return;
                }

                menus.forEach(function (menu) {
                    if (menu.TranslationCode && scope.generalModel.TranslationsObject) {
                        menu.Description = scope.generalModel.TranslationsObject[menu.TranslationCode] || menu.TranslationCode;
                    }
                });
            }

            scope.generalModel.ChangeMenu = function (Menu) {
                if (scope.generalModel.SecondLevelMenu && Menu.ChildrenMenus.length && (scope.generalModel.OldParentId === Menu.MenuId)) {
                    scope.generalModel.OldParentId = '';
                    scope.generalModel.SecondLevelMenu = false;
                } else if (scope.generalModel.SecondLevelMenu && !Menu.ChildrenMenus.length) {
                    $state.go(Menu.Link);
                }
                else {
                    if (!Menu.ChildrenMenus.length) {
                        $state.go(Menu.Link);
                    }
                    else {
                        scope.generalModel.ParentId = Menu.MenuId;
                        scope.generalModel.OldParentId = Menu.MenuId;
                        scope.generalModel.SecondLevelMenu = true;
                    }
                }
            };

            scope.generalModel.MenuActiveClass = function (Menu) {
                var activeClass = false;

                if ((typeof Menu !== "undefined") && (typeof scope.generalModel.CurrentPage !== "undefined")) {
                    var parent = $filter('filter')($sessionStorage.ParentMenus, { ChildrenMenus: { Link: scope.generalModel.CurrentPage } }, true);

                    if ((scope.generalModel.CurrentPage === Menu.Link) || (parent.length && (parent[0].MenuId === Menu.MenuId))) {
                        activeClass = true;
                    }
                }

                return activeClass;
            };

            scope.generalModel.getMenuList = function () {
                GeneralModel.GetMenuList();
            };

            scope.generalModel.CheckLogin = function () {
                GeneralModel.CheckLogin();
            };

            scope.generalModel.RefreshPage = function () {
                $window.location.reload();
            };

            scope.generalModel.ToggleMenu = function () {
                $mdSidenav('left').toggle();
            };

            scope.generalModel.DownloadFile = function (model, fileName, format, controller, myId, additionalParameters, customAction) {
                new ExportFiles(scope, model, fileName, format, controller, myId, additionalParameters, customAction);
            };

            scope.generalModel.CallUploadMethod = function () {
                UploadMethod(scope);
            };

            scope.generalModel.SetMyForms = function () {
                if (typeof scope.MyForms === 'undefined') {
                    scope.MyForms = {};
                }
            };

            scope.generalModel.OpenTools = function ($mdMenu, event) {
                $mdMenu.open(event);
            };

            scope.generalModel.CloseTools = function ($mdMenu, event) {
                $mdMenu.close(event);
            };

            scope.generalModel.OpenDatePicker = function (name) {
                var element = $parse(name)(scope);

                if (typeof element === 'undefined') {
                    element = false;
                }

                $parse(name).assign(scope, !element);
            };

            scope.generalModel.CheckLinkBreadCrumbs = function ($event, path, parameters) {
                $event.preventDefault();
                GeneralModel.GoToPageBreadCrumbs(path, parameters);
            };

            scope.jqueryScrollbarOptions = {
                "onScroll": function (y, x) {
                    if (y.scroll > 100) {
                        GeneralModel.UpdateStateButton(true);
                    }
                    else {
                        GeneralModel.UpdateStateButton(false);
                    }
                }
            };

            scope.ScrollToTop = function (scroll) {
                angular.element(scroll).animate({ scrollTop: 0 }, 400);
            };

            scope.generalModel.GoToPage = function (path, parameters, reload) {
                if (!scope.generalModel.IsOnline) {
                    return;
                }

                var reloadPage = false;
                var finalParameters = "";

                if ((typeof reload !== "undefined") && (reload)) {
                    reloadPage = true;
                }

                if (typeof parameters !== 'undefined') {
                    finalParameters = parameters;
                }

                if (finalParameters !== "") {
                    if (typeof parameters === 'object') {
                        parameters = JSON.stringify(parameters);
                    }

                    $state.go(path, JSON.parse(parameters), { reload: reloadPage });
                }
                else {
                    $state.go(path, {}, { reload: reloadPage });
                }
            };

            $window.onbeforeunload = function () {
                if (($state.current.name === "Login") && !scope.generalModel.IsUndefinedEmptyOrNull($sessionStorage.DatabaseName)) {
                    Translations.DeleteDatabase($sessionStorage.DatabaseName);
                }

                if (scope.generalModel.SidebarOptions && scope.generalModel.SidebarOptions.State.SaveOption) {
                    return !scope.generalModel.IsUndefinedEmptyOrNull(Helpers.Translations.PendingChanges) ? Helpers.Translations.PendingChanges : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).pendingChanges;
                }
            };

            scope.generalModel.OpenDialog = function (name, multiple) {
                $mdDialog.show({
                    contentElement: '#' + name + '',
                    parent: angular.element(document.body),
                    multiple: (typeof multiple !== 'undefined') ? multiple : true,
                    clickOutsideToClose: false
                });

                scope.generalModel.FullPageLoading = false;
            };

            scope.generalModel.CloseDialog = function (name) {
                $mdDialog.hide({
                    contentElement: '#' + name + ''
                });

                if (name === "DialogHistory") {
                    scope.generalModel.IsHistoryOpen = false;
                }
            };

            scope.generalModel.CloseDialogConfirmDelete = function () {
                $mdDialog.hide({ contentElement: '#DialogConfirmDelete' });
                angular.element('#DialogConfirmDelete #DialogConfirmMessage').text(Helpers.Translations.ConfirmDelete);
                angular.element('#DialogConfirmDelete #DialogConfirmMessageIrreversible').html(Helpers.Translations.ThisOption + ' <b>' + Helpers.Translations.Irreversible + '</b>');
                angular.element('#DialogConfirmDelete #DialogButtonConfirm').text(Helpers.Translations.Delete);
            };

            scope.generalModel.ShowDialogConfirmDelete = function () {
                $mdDialog.show({
                    contentElement: '#DialogConfirmDelete',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false
                });
            };

            scope.generalModel.GeneralGridCheckbox = function (e, tools) {
                if ((e.column.userDataType === 'boolean') && e.column.allowEditing) {
                    angular.element(e.cellElement).find('.dx-widget.dx-checkbox').attr('ng-click', 'generalModel.GeneralGridCheckboxClicked(' + tools + ')');
                    $compile(e.cellElement)(scope);
                }
            };

            scope.generalModel.GeneralGridCheckboxClicked = function (tools) {
                if (typeof tools !== 'undefined') {
                    tools = true;
                }

                scope.generalModel.SidebarOptions.State.SaveOption = true;
                scope.generalModel.SidebarOptions.State.CancelOption = true;
            };

            scope.generalModel.RefreshFilterSideBarHeight = function () {
                var sideBarHeight = parseInt(angular.element('#SideBar').css('height'));
                var value = 250;
                var element = angular.element('#OptionsArea');
                var tools = angular.element('#ToolsArea');
                var title = angular.element('#FilterArea > h3');

                if (element.length && tools.length && ((element.height() + tools.height() + title.height()) > value)) {
                    value = element.height() + tools.height() + title.height;
                }

                $timeout(angular.element('#FilterArea > .SideBarFilters').css('height', '' + (sideBarHeight - value) + 'px'), 100);
            };

            scope.generalModel.CloseOpenSideBarArea = function (area) {
                var findElement = angular.element('.' + area);

                if (findElement.hasClass('DisplayNone')) {
                    angular.element('#IconOpenClose' + area + '.IconOpenClose').text('-');
                    findElement.removeClass('DisplayNone');
                }
                else {
                    angular.element('#IconOpenClose' + area + '.IconOpenClose').text('+');
                    findElement.addClass('DisplayNone');
                }

                if (area === 'SideBarFilters') {
                    scope.generalModel.RefreshFilterSideBarHeight();
                }
            };

            scope.generalModel.CreateExportToExcelButton = function (buttonName, gridName, drawFunction) {
                angular.element("#" + buttonName + "").dxButton({
                    onClick: function () {
                        if (!angular.element("#" + gridName).hasClass("dx-widget")) {
                            if (typeof drawFunction !== "undefined") {
                                drawFunction();
                                scope.generalModel.PendingExportToExcel = true;
                            }
                        }
                        else {
                            var grid;
                            grid = angular.element("#" + gridName + "").dxDataGrid('instance');
                            grid.exportToExcel();
                        }
                    }
                });
            };

            scope.generalModel.CreateSearchBox = function (boxName, gridName, model) {
                var delaySearch;
                angular.element("#" + boxName + "").dxTextBox({
                    placeholder: !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Search : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).search,
                    mode: 'search',
                    valueChangeEvent: 'keyup',
                    onValueChanged: function (e) {
                        if ((typeof model !== "undefined") && (typeof model.HasMasterDetail !== "undefined") && model.HasMasterDetail) {
                            scope.generalModel.FilterGridModeMasterDetail(e.value, model, [model.GridListName, model.MasterDetailsListName], model.MainElementName);
                            angular.element("#" + gridName).dxDataGrid('instance').option('dataSource', model[model.MainElementName]);
                            angular.element("#" + gridName).dxDataGrid('instance').refresh();
                        }
                        else if ((typeof model !== "undefined") && (typeof model.OverrideGridSearch !== "undefined") && model.OverrideGridSearch) {
                            clearTimeout(delaySearch);

                            delaySearch = setTimeout(function () {
                                var filterFunction = function (item) {
                                    return model.FilteredConditionsGrid(item);
                                };

                                scope.generalModel.SearchGridModeValue = e.value;
                                model[model.MainElementName] = $filter('filter')(model[model.GridListName], filterFunction);
                                angular.element("#" + gridName).dxDataGrid('instance').option('dataSource', model[model.MainElementName]);
                                angular.element("#" + gridName).dxDataGrid('instance').refresh();
                            }, 1000);
                        }
                        else {
                            var grid = angular.element("#" + gridName + "").dxDataGrid('instance');
                            grid.searchByText(e.value);
                        }
                    }
                });
            };

            scope.generalModel.CreateSearchBoxForGridMode = function (boxName) {
                angular.element("#" + boxName + "").html('<div class="dx-textbox dx-texteditor dx-searchbox dx-editor-outlined dx-show-clear-button dx-widget" ng-class="{\'dx-texteditor-empty\' : !generalModel.SearchGridModeValue.length }"><div class="dx-texteditor-container"><div class="dx-icon dx-icon-search"></div><input autocomplete="off" class="dx-texteditor-input" type="text" spellcheck="false" role="textbox" tabindex="0" ng-model="generalModel.SearchGridModeValue"><div ng-show="!generalModel.SearchGridModeValue.length" data-dx_placeholder="{{:refresh: !generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? (\'Search\' | Translations) : generalModel.MyApplication.getLanguageObject.selectedLanguage(\'generalFunctionsTexts\',generalModel.MyApplication).search }}" class="dx-placeholder"></div><div class="dx-texteditor-buttons-container"><span class="dx-clear-button-area"><span ng-click="generalModel.SearchGridModeValue = \'\'" class="dx-icon dx-icon-clear"></span></span></div></div></div>');
                $compile(angular.element("#" + boxName + " > div"))(scope);
            };

            scope.generalModel.GenerateDisableEnableObject = function (gridName, object, id, container) {
                angular.element('<a/>').html(object[id] ? '<span class="pull-left Disabled ColorRed">' + ((!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.Disabled : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).disabled) + '</span><i class="lnr lnr-cross-circle"></i>' : '<span class="pull-left">' + (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Enabled : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).enabled) + '</span><i class="lnr lnr-checkmark-circle"></i>')
                    .on('dxclick', function () {
                        var index = scope.generalModel.FindIndex(this);

                        if (!angular.element(this).hasClass("LinkDisabled")) {
                            scope.generalModel.DisableEnable(index, gridName, (object[id] ? false : true));
                            var grid;

                            if (angular.element("#" + gridName).hasClass('dx-treelist')) {
                                grid = angular.element('#' + gridName).dxTreeList('instance');
                            }
                            else {
                                grid = angular.element('#' + gridName).dxDataGrid('instance');
                            }

                            if (typeof grid !== 'undefined') {
                                grid.refresh();
                            }
                        }
                    }).appendTo(container);
            };

            scope.generalModel.GenerateCheckboxObject = function (gridName, object, id, container) {
                angular.element('<md-checkbox ng-value="' + object[id] + '" aria-label="\'\'" ng-checked="' + object[id] + '"></md-checkbox>')
                    .on('dxclick', function () {
                        var index = scope.generalModel.FindIndex(this);
                        if (!angular.element(this).hasClass("LinkDisabled")) {
                            scope.generalModel.SetCheckboxValue(index, gridName, (object[id] ? false : true), id);
                        }
                    }).appendTo(container);
            };

            scope.generalModel.GenerateDisableEnableObjectNotAllowEdition = function (gridName, object, id, container) {
                angular.element('<span/>')
                    .html(object[id] ? '<span class="pull-left Disabled ColorRed">' + ((!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.Disabled : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).disabled) + '</span><i class="lnr lnr-cross-circle"></i>' : '<span class="pull-left">' + ((!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.Enabled : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).enabled) + '</span><i class="lnr lnr-checkmark-circle"></i>')
                    .appendTo(container);
            };

            scope.generalModel.DisableEnable = function (rowIndex, gridName, status) {
                if ((gridName === '') || (typeof gridName === 'undefined')) {
                    return;
                }

                var grid;
                var findElement = angular.element("#" + gridName);

                if (findElement.hasClass('dx-treelist')) {
                    grid = findElement.dxTreeList('instance');
                }
                else {
                    grid = findElement.dxDataGrid('instance');
                }

                grid.cellValue(rowIndex, 'Disabled', status);
            };

            scope.generalModel.SetCheckboxValue = function (rowIndex, gridName, status, dataField) {
                if ((gridName === '') || (typeof gridName === 'undefined')) {
                    return;
                }

                var grid = angular.element("#" + gridName + "").dxDataGrid('instance');
                grid.cellValue(rowIndex, dataField, status);
            };

            scope.generalModel.FilterGridMode = function (value, model, objectName, filteredObjectName) {
                var filterFunction = function (item) {
                    return model.FilteredConditions(item);
                };

                model[filteredObjectName] = $filter('filter')(model[objectName], filterFunction, value);
                if (!scope.generalModel.IsUndefinedEmptyOrNull(model.CurrentPage) && !model.PageClick && $('#alt-style-pagination').length) {
                    model.CurrentPage = 1;
                    $('#alt-style-pagination').pagination('selectPage', 1);

                    if ($location.absUrl().substr(0, $location.absUrl().indexOf('#')) !== '') {
                        window.history.pushState('', '', $location.absUrl().substr(0, $location.absUrl().indexOf('#')) + '#page-1');
                    }
                }
            };

            Array.prototype.unique = function () {
                var a = this.concat();

                for (var i = 0; i < a.length; ++i) {
                    for (var j = i + 1; j < a.length; ++j) {
                        if (a[i] === a[j])
                            a.splice(j--, 1);
                    }
                }

                return a;
            };

            scope.generalModel.FilterGridModeMasterDetail = function (value, model, objectNames, filteredObjectName) {
                var filterFunction = function (item) {
                    return model.FilteredConditionsMasterDetail(item, value);
                };

                var mainElementFilteredIds = $filter('filter')(model[objectNames[0]], filterFunction, value).map(function (item) {
                    return item[model.IdName];
                });

                var childElementFilteredIds = $filter('filter')(model[objectNames[1]], filterFunction, value).map(function (item) {
                    return item[model.IdName];
                });

                var concateArray = mainElementFilteredIds.concat(childElementFilteredIds).unique();

                model[filteredObjectName] = $filter('filter')(model[objectNames[0]],
                    function (item) {
                        return (concateArray.indexOf(item[model.IdName]) !== -1)
                    }, concateArray);
            };

            scope.$watch('generalModel.ViewMode', function (_value, oldValues, scope) {
                if (angular.element('#GridBase').length && (angular.element("#GridBase").hasClass("dx-widget"))) {
                    if (angular.element('#SearchTextBoxBase').length) {
                        if (oldValues) {
                            angular.element('#SearchTextBoxBase').dxTextBox('instance').option("value", scope.generalModel.SearchGridModeValue);
                        }
                        else {
                            scope.generalModel.SearchGridModeValue = angular.element('#SearchTextBoxBase').dxTextBox('instance').option("value");
                        }
                    }

                    if (!scope.generalModel.ViewMode) {
                        angular.element('#GridBase').dxDataGrid('instance').refresh();
                    }
                }
            });

            scope.generalModel.GetMainId = function (idName, object) {
                var id = scope.generalModel.AngularCopy(scope.generalModel.GetObjectByString(object, idName));

                if (typeof id === 'undefined') {
                    id = object.__KEY__;
                }

                return id;
            };

            scope.generalModel.GetObjectByString = function (object, string) {
                if (angular.isObject(object) && !scope.generalModel.IsUndefinedEmptyOrNull(string)) {
                    string = string.replace(/\[(\w+)\]/g, '.$1');
                    string = string.replace(/^\./, '');
                    var division = string.split('.');

                    for (var i = 0, n = division.length; i < n; ++i) {
                        var k = division[i];
                        if (object !== null) {
                            if (k in object) {
                                object = object[k];
                            }
                            else {
                                return;
                            }
                        } else {
                            return;
                        }
                    }
                }

                return object;
            };

            scope.generalModel.IsNotUndefinedEmptyOrNull = function (value) {
                var result = (!angular.isUndefined(value) && (value !== null) && (value !== '') && (value !== 'null') && (value !== 'undefined'));

                return result;
            };

            scope.generalModel.IsNotUndefinedEmptyOrNullObject = function (value) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(value)) {
                    return false;
                }

                if (value instanceof Date) {
                    return true;
                }

                if ((typeof value === 'object') && !(value instanceof Date)) {
                    var result = (Object.keys(value).length !== 0);

                    return result;
                }

                return false;
            };

            scope.generalModel.IsUndefinedEmptyOrNull = function (value) {
                var result = (!scope.generalModel.IsNotUndefinedEmptyOrNull(value));

                return result;
            };

            scope.generalModel.IsUndefinedEmptyOrNullObject = function (value) {
                var result = (!scope.generalModel.IsNotUndefinedEmptyOrNullObject(value));

                return result;
            };

            scope.generalModel.IsObjectEmpty = function (object) {
                if (typeof object === 'object') {
                    return !Object.keys(object).length;
                }

                return true;
            };

            scope.generalModel.SetObjectValueByString = function (object, string, value) {
                var stringArray = [];
                var cutedString = scope.generalModel.AngularCopy(string);
                var i;
                var total = 1;
                total += string.replace(/[^.]/g, "").length;
                total += string.replace(/[^[]/g, "").length;

                for (var n = 0; n < total; n++) {
                    if ((cutedString.indexOf('.') > -1) && ((cutedString.indexOf('.') < cutedString.indexOf('[')) || (cutedString.indexOf('[') === -1))) {
                        stringArray[n] = cutedString.split('.')[0];

                        if (cutedString.split('.')[0].substring(cutedString.split('.')[0].length - 1) === ']') {
                            stringArray[n] = cutedString.split('.')[0].substring(0, cutedString.split('.')[0].length - 1);
                        }

                        cutedString = cutedString.substr(cutedString.split('.')[0].length + 1);
                    }
                    else if ((cutedString.indexOf('[') > -1) && ((cutedString.indexOf('[') < cutedString.indexOf('.')) || (cutedString.indexOf('.') === -1))) {
                        stringArray[n] = cutedString.split('[')[0];

                        if (cutedString.split('[')[0].substring(cutedString.split('[')[0].length - 1) === ']') {
                            stringArray[n] = cutedString.split('.')[0].substring(0, cutedString.split('.')[0].length - 1);
                        }

                        cutedString = cutedString.substr(cutedString.split('[')[0].length + 1);
                    }
                    else {
                        stringArray[n] = scope.generalModel.AngularCopy(cutedString);
                        break;
                    }
                }

                for (i = 0; i < stringArray.length - 1; i++) {
                    object = object[stringArray[i]];
                }

                object[stringArray[i]] = scope.generalModel.AngularCopy(value);
            };

            scope.generalModel.HasObjectKeys = function (object) {
                for (var key in object) {
                    if (object.hasOwnProperty(key)) {
                        return true;
                    }
                }

                return false;
            };

            scope.generalModel.ValidateDate = function (string) {
                var dateRegex = /^(?:\d{4}|\d{2})([./-])\d{2}\1(?:\d{4}|\d{2})$/;
                var isoDateRegex = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d/;

                if (!scope.generalModel.IsUndefinedEmptyOrNull(string) && (typeof string !== "object")) {
                    if (isNaN(string) && (typeof string !== "boolean") && ((string.match(dateRegex) !== null) || (string.match(isoDateRegex) !== null))) {
                        var date = new Date(string);

                        if (isNaN(string) && !isNaN(date.getTime())) {
                            return true;
                        }
                    }
                }

                return false;
            };

            scope.generalModel.FindIndex = function (element) {
                if (angular.element(element).parents('.dx-datagrid-table').find('tbody').length > 1) {
                    var rowsCount = 0;

                    angular.element(element).parents('.dx-datagrid-table').find('tbody').each(function (index) {
                        if (angular.element(element).closest('tbody').index() > index + 1) {
                            rowsCount += angular.element(this).find('.dx-row').length;
                        }
                    });

                    return (rowsCount + angular.element(element).closest('.dx-row').index());
                }
                else {
                    return angular.element(element).closest('.dx-row').index();
                }
            };

            scope.generalModel.GetExtraConnection = function (id) {
                return GeneralModel.GetExtraConnection(id);
            };

            scope.generalModel.DownloadFileObject = function (fileName, fileData, contentType, extension, action) {
                var blob;
                if ((extension === '.pdf') && scope.generalModel.IsUndefinedEmptyOrNull(action)) {
                    var loading = '';

                    if (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) {
                        loading = Helpers.Translations.Loading;
                    }
                    else {
                        loading = myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).loading;
                    }

                    scope.generalModel.NewWindow.document.write('<div id="Loading" class="NoHeight">' + loading + '</div><div id="LoadingBackground"></div>');
                    $(scope.generalModel.NewWindow.document).find("head").append('<link rel="stylesheet" type="text/css" href="Application/Content/Bundles/GeneralBundle.min.css">');

                    if (scope.generalModel.NewWindow.canRunAds === undefined) {
                        scope.generalModel.NewWindow.close();
                        scope.generalModel.DownloadFileObject(fileName, fileData, 'application/pdf', '.pdf', 'download');
                    }
                    else {
                        blob = scope.generalModel.Base64ToBlob(fileData, 'application/pdf');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob);
                            scope.generalModel.NewWindow.close();
                        }
                        else {
                            scope.generalModel.NewWindow.location.href = URL.createObjectURL(blob);
                        }

                        scope.generalModel.FullPageLoading = false;
                    }

                    scope.generalModel.NewWindow = "";
                }
                else {
                    blob = scope.generalModel.Base64ToBlob(fileData, contentType);
                    var completeFileName = fileName + extension;

                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        window.navigator.msSaveBlob(blob, completeFileName);

                        $timeout(function () {
                            scope.generalModel.FullPageLoading = false;
                        });

                        return;
                    }

                    const blobURL = window.URL.createObjectURL(blob);

                    if (myApplication.projectType === myApplication.projectTypeMobile) {
                        window.createFileChooser.GetBase64FromBlobData(fileData, completeFileName);
                    }

                    const tempLink = document.createElement('a');
                    tempLink.style.display = 'none';
                    tempLink.href = blobURL;
                    tempLink.setAttribute('download', completeFileName);

                    if (typeof tempLink.download === 'undefined') {
                        tempLink.setAttribute('target', '_blank');
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);

                    $timeout(function () {
                        window.URL.revokeObjectURL(blobURL);
                    }, 100);

                    scope.generalModel.FullPageLoading = false;
                }
            };

            scope.generalModel.ShowInsertImageDialog = function () {
                $mdDialog.show({
                    multiple: true,
                    contentElement: '#DialogInsertImage',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false
                });
            };

            scope.generalModel.CloseInsertImageDialog = function () {
                scope.invalidFields = [];
                scope.generalModel.InvalidFields = [];
                scope.generalModel.StoredImageGridModel = "";
                scope.generalModel.StoredImageGridKey = "";
                scope.generalModel.ObjectToStoreImage = "";
                scope.generalModel.ObjectToStoreImageId = "";
                scope.generalModel.ObjectToStoreImageContentId = "";
                scope.generalModel.StoredImageFieldName = "";
                $mdDialog.hide({ contentElement: '#DialogInsertImage' });
            };

            scope.generalModel.AddPhotography = function (object, id, model, gridKey, fieldId) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(gridKey)) {
                    gridKey = "";
                }

                var element = null;

                if (scope.generalModel.IsUndefinedEmptyOrNull(gridKey)) {
                    element = $parse(object)(rootScope);
                }

                if (!scope.generalModel.IsOnline) {
                    return;
                }

                var image;

                for (var j = 0; j < scope.generalModel.PhotographyList.length; j++) {
                    if (scope.generalModel.PhotographyList[j].Id === id) {
                        image = scope.generalModel.PhotographyList[j].Photography;
                    }
                }

                if ((element === null) && (typeof image === 'undefined')) {
                    image = angular.element('#' + id + '').attr('src');
                }

                if ((image !== '') && (typeof image !== 'undefined')) {
                    scope.generalModel.Files = image;
                }
                else if ((image !== '') && (typeof image !== 'undefined') && (element !== null) && (element.indexOf("data:image/gif;base64,") >= 0)) {
                    scope.generalModel.Files = scope.generalModel.Base64ToBlob(image, 'image/gif');
                }
                else if ((element !== null) && (element.indexOf("data:image/gif;base64,") >= 0)) {
                    var newImage = element.replace('data:image/gif;base64,', '');
                    scope.generalModel.Files = scope.generalModel.Base64ToBlob(newImage, 'image/gif');
                }
                else {
                    scope.generalModel.Files = [];
                }

                scope.generalModel.StoredImageGridModel = model;
                scope.generalModel.StoredImageGridKey = gridKey;
                scope.generalModel.ObjectToStoreImage = scope.generalModel.AngularCopy(object);
                scope.generalModel.ObjectToStoreImageId = "";
                scope.generalModel.ObjectToStoreImageContentId = id;
                scope.generalModel.StoredImageFieldName = fieldId;
                scope.generalModel.FileUploadTitle = !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.LoadImage : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).loadImage;
                scope.generalModel.ButtonFileUpload = !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.SaveImage : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).saveImage;
                scope.generalModel.ButtonFileUploadRemove = !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.RemoveImage : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).removeImage;
                scope.generalModel.FileUploadDocuments = false;
                scope.generalModel.FileUploadImage = true;
                scope.generalModel.FileUploadImageRemove = true;

                scope.generalModel.UploadBox = Helpers.Upload.GetUploadBox('image/*', '1MB', true);

                scope.generalModel.ShowInsertImageDialog();
            };

            scope.generalModel.InsertImage = function () {
                var element = null;
                var array;

                if (scope.generalModel.StoredImageGridKey !== "") {
                    array = $parse(scope.generalModel.ObjectToStoreImage)(scope);
                    var id = scope[scope.generalModel.StoredImageGridModel].ArrayGridObjects[scope.generalModel.StoredImageGridKey].MainId;
                    var gridName = scope[scope.generalModel.StoredImageGridModel].ArrayGridObjects[scope.generalModel.StoredImageGridKey].GridName;
                    var fieldName = scope.generalModel.StoredImageFieldName;
                    var object = {};
                    object[id] = scope.generalModel.ObjectToStoreImageContentId.substr(11);
                    var rowIndex;

                    if (typeof angular.element('#' + gridName + '').dxDataGrid('instance') !== 'undefined') {
                        var grid = angular.element('#' + gridName + '').dxDataGrid('instance');
                        var data = $filter('filter')(grid.getDataSource()._store._array, object, true)[0];

                        if (typeof data !== 'undefined') {
                            rowIndex = grid.getRowIndexByKey(data);
                        }
                        else {
                            rowIndex = Helpers.DevExtreme.Grid.GetInsertedRowByKey(grid, scope.generalModel.ObjectToStoreImageContentId.substr(11));
                        }

                        if ($filter('filter')(scope.generalModel.PhotographyList, { Id: scope.generalModel.ObjectToStoreImageContentId }, true).length) {
                            scope.generalModel.PhotographyList[0].Photography = scope.generalModel.Files[0];
                        }
                        else {
                            scope.generalModel.PhotographyList.push({ 'Id': scope.generalModel.ObjectToStoreImageContentId, 'Photography': scope.generalModel.Files[0], 'Grid': gridName, 'FieldName': fieldName, 'FieldId': id });
                        }

                        grid.cellValue(rowIndex, fieldName, scope.generalModel.Files[0].$ngfBlobUrl);
                    }
                }
                else {
                    element = $parse(scope.generalModel.ObjectToStoreImage);
                    array = $parse(scope.generalModel.ObjectToStoreImage)(scope);

                    if (scope.generalModel.ObjectToStoreImageId !== '') {
                        if (typeof $filter('filter')(array, { Id: scope.generalModel.ObjectToStoreImageId }, true)[0] !== 'undefined') {
                            $filter('filter')(array, { Id: scope.generalModel.ObjectToStoreImageId }, true)[0].Photography = scope.generalModel.Files[0];
                        }
                        else {
                            array.push({ 'Id': scope.generalModel.ObjectToStoreImageId, 'Photography': scope.generalModel.Files[0], 'Grid': scope.generalModel.GridToStoreImageId, 'FieldName': scope.generalModel.GridFieldToStoreImage, 'FieldId': scope.generalModel.GridFieldIdToStoreImage });
                        }

                        angular.element(scope.generalModel.ObjectToStoreImageId).attr('src', scope.generalModel.Files[0].$ngfBlobUrl);
                    }
                    else {
                        if ((array !== null) && (typeof $filter('filter')(scope.generalModel.PhotographyList, { Id: scope.generalModel.ObjectToStoreImageContentId }, true)[0] !== 'undefined')) {
                            $filter('filter')(scope.generalModel.PhotographyList, { Id: scope.generalModel.ObjectToStoreImageContentId }, true)[0].Photography = scope.generalModel.Files[0];
                        }
                        else {
                            scope.generalModel.PhotographyList.push({ 'Id': scope.generalModel.ObjectToStoreImageContentId, 'Photography': scope.generalModel.Files[0], 'Grid': '', 'FieldName': '', 'FieldId': '' });
                        }

                        element.assign(scope, scope.generalModel.Files[0].$ngfBlobUrl);
                    }
                }

                scope.generalModel.CloseInsertImageDialog();
            };

            scope.generalModel.RemoveImage = function () {
                if (scope.generalModel.ObjectToStoreImage === '') {
                    return;
                }

                $parse(scope.generalModel.ObjectToStoreImage)(scope);

                if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.StoredImageGridKey)) {
                    var rowIndex;
                    var id = scope[scope.generalModel.StoredImageGridModel].ArrayGridObjects[scope.generalModel.StoredImageGridKey].MainId;
                    var gridName = scope[scope.generalModel.StoredImageGridModel].ArrayGridObjects[scope.generalModel.StoredImageGridKey].GridName;

                    if (typeof angular.element('#' + gridName + '').dxDataGrid('instance') !== 'undefined') {
                        var grid = angular.element('#' + gridName + '').dxDataGrid('instance');
                        var objectForFilter = {};
                        objectForFilter[id] = scope.generalModel.ObjectToStoreImageContentId.substr(11);

                        var data = $filter('filter')(grid.getDataSource()._store._array, objectForFilter, true)[0];

                        if (typeof data !== 'undefined') {
                            rowIndex = grid.getRowIndexByKey(data);
                        }
                        else {
                            rowIndex = Helpers.DevExtreme.Grid.GetInsertedRowByKey(grid, scope.generalModel.ObjectToStoreImageContentId.substr(11));
                        }

                        for (var j = 0; j < scope.generalModel.PhotographyList.length; j++) {
                            if (scope.generalModel.PhotographyList[j].Id === scope.generalModel.ObjectToStoreImageContentId) {
                                scope.generalModel.PhotographyList.splice(j, 1);
                                break;
                            }
                        }

                        grid.cellValue(rowIndex, scope.generalModel.StoredImageFieldName, "");
                    }

                    scope.generalModel.CloseInsertImageDialog();
                }
                else {
                    if (scope.generalModel.ObjectToStoreImageId !== '') {
                        for (var q = 0; q < scope.generalModel.PhotographyList.length; q++) {
                            if (scope.generalModel.PhotographyList[q].Id === scope.generalModel.ObjectToStoreImageId) {
                                scope.generalModel.PhotographyList.splice(q, 1);
                            }
                        }

                        angular.element(scope.generalModel.ObjectToStoreImageId).attr('src', 'Application/Images/FallBackImage.1739284541000.png');
                    }
                    else {
                        for (var k = 0; k < scope.generalModel.PhotographyList.length; k++) {
                            if (scope.generalModel.PhotographyList[k].Id === "Main") {
                                scope.generalModel.PhotographyList.splice(k, 1);
                            }
                        }

                        $parse(scope.generalModel.ObjectToStoreImage).assign(scope, "");
                    }

                    scope.generalModel.CloseInsertImageDialog();
                }
            };

            scope.generalModel.Base64ToBlob = function (base64Data, contentType) {
                contentType = contentType || '';
                var sliceSize = 512;
                var byteCharacters = atob(base64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);
                    var byteNumbers = new Array(slice.length);

                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, { type: contentType });

                return blob;
            };

            scope.generalModel.ConvertImages = function (blobFile, key, list) {
                var deferred = $q.defer();
                var response;
                var base64data;
                var position;
                var reader = new window.FileReader();

                reader.readAsDataURL(blobFile);

                reader.onloadend = function () {
                    base64data = reader.result;
                    position = base64data.indexOf(',');
                    response = { Photography: base64data.substr(position + 1), Key: key, List: list };
                    deferred.resolve(response);
                };

                return deferred.promise;
            };

            scope.generalModel.ConvertAllFiles = function (blobFile) {
                var deferred = $q.defer();
                var response;
                var base64data;
                var position;
                var reader = new window.FileReader();

                reader.readAsDataURL(blobFile);

                reader.onloadend = function () {
                    base64data = reader.result;
                    position = base64data.indexOf(',');
                    response = base64data.substr(position + 1);
                    deferred.resolve(response);
                };

                return deferred.promise;
            };

            scope.generalModel.GetEditDataClean = function (grid) {
                var finalObject = [];
                var editData = Helpers.DevExtreme.Grid.GetEditData(grid);
                var editDataValid = editData.filter(where => where.type && (where.type !== 'undefined'));

                for (var g = 0; g < editDataValid.length; g++) {
                    var editDataRow = editDataValid[g];

                    finalObject.push(editDataRow);
                }

                return finalObject;
            };

            scope.generalModel.CreateBaseViewGridSelectElements = function (gridName, mainId, object, id, fieldShow, container, extraConnectionId, required, model, defaultSelectText) {
                var description = '';
                var tagIndex = 2;

                if (scope.generalModel.IsUndefinedEmptyOrNull(defaultSelectText)) {
                    defaultSelectText = '';
                }

                if (scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetObjectByString(object, id + "." + fieldShow))) {
                    description = defaultSelectText;
                }
                else {
                    description = (scope.generalModel.GetObjectByString(object, id + "." + fieldShow));
                }

                if (required || (description === defaultSelectText)) {
                    tagIndex = 1;
                }

                $('<i/>').addClass("lnr lnr-list").appendTo($('<a/>').html('<span class="ParentContentWithMagnifierBaseView"><span class="ContentWithMagnifier">' + scope.generalModel.encodeHtml(description) + '</span></span>').on('dxclick', function (event) {
                    scope.generalModel.GenerateSelectObject(gridName, mainId, object, id, fieldShow, container, extraConnectionId, required, model, defaultSelectText, true);
                    container[0].getElementsByTagName("a")[tagIndex].getElementsByClassName("ParentContentWithMagnifier")[0].click();
                    event.stopPropagation();
                    container[0].getElementsByTagName("a")[0].style.display = "none";

                    if (container[0].getElementsByTagName("a")[0].parentElement.className.indexOf("dx-highlight-outline") !== -1) {
                        container[0].getElementsByTagName("a")[0].parentElement.style.display = "none";
                    }

                    if (tagIndex !== 1) {
                        container[0].getElementsByTagName("a")[1].style.display = "none";
                    }
                }).appendTo(container));

                if ((!required) && (description !== defaultSelectText)) {
                    $('<a/>')
                        .addClass('SelectIconClearBaseView')
                        .html('<i class="lnr lnr-cross"></i>').on('dxclick', function () {
                            if (!object.Disabled && !angular.element(this).parent('td').hasClass('Disabled') && !object.NonEditable) {
                                var index = scope.generalModel.FindIndex(this);
                                scope.generalModel.ExtraConnectionId = extraConnectionId;

                                if (defaultSelectText === '') {
                                    scope.SelectGridDropDownElement(id + '.' + fieldShow, null, null, mainId, index, gridName);
                                }
                                else {
                                    scope.SelectGridDropDownElement(id + '.' + fieldShow, null, defaultSelectText, mainId, index, gridName);
                                }
                            }
                        }).appendTo(container);
                }
            };

            scope.generalModel.GenerateSelectObject = function (gridName, mainId, object, id, fieldShow, container, extraConnectionId, required, model, defaultSelectText, gridElementsLoaded) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(gridElementsLoaded) || (!scope.generalModel.IsUndefinedEmptyOrNull(gridName) && !gridElementsLoaded)) {
                    scope.generalModel.CreateBaseViewGridSelectElements(gridName, mainId, object, id, fieldShow, container, extraConnectionId, required, model, defaultSelectText);

                    return;
                }

                if (scope.generalModel.IsUndefinedEmptyOrNull(defaultSelectText)) {
                    defaultSelectText = '';
                }

                var objectLoadedByString = scope.generalModel.GetObjectByString(object, id);

                if ((objectLoadedByString === null) || (typeof objectLoadedByString === 'undefined')) {
                    if (!object.hasOwnProperty('__KEY__')) {
                        scope.generalModel.FillConcurrencyDataSource(gridName, model);

                        var gridMainId = scope.generalModel.GetExtraConnection(extraConnectionId).MainId;
                        var gridInstance = angular.element('#' + gridName).dxDataGrid('instance');

                        if (typeof gridMainId === 'undefined') {
                            gridMainId = scope.generalModel.GetMainIdFromKey(gridInstance);
                        }

                        var findNewObject;
                        var editedObject;
                        var edited = scope.generalModel.GetEditDataClean(gridInstance);
                        var extraConnection = scope.generalModel.ExtraConnections.filter(where => where.ObjectPathName === id)[0];

                        var index = extraConnection.Key;
                        var innerId = extraConnection.InnerId;

                        if (edited.length && !scope.generalModel.IsUndefinedEmptyOrNull(index)) {
                            for (var e = 0; e < edited.length; e++) {
                                var editedItem = edited[e];
                                var editedItemOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(editedItem);

                                if ((editedItem.type === 'update') && (editedItemOldData[gridMainId] === mainId) && !scope.generalModel.IsUndefinedEmptyOrNull(model.MainObjectPreviousSave[index]) && !scope.generalModel.IsUndefinedEmptyOrNull(model.MainObjectPreviousSave[index][e])) {
                                    if (editedItemOldData[innerId] === model.MainObjectPreviousSave[index][e][innerId]) {
                                        editedObject = model.MainObjectPreviousSave[index][e];
                                    }
                                }
                            }
                        }

                        if (scope.generalModel.IsUndefinedEmptyOrNull(editedObject) && !scope.generalModel.IsUndefinedEmptyOrNull(model.MainObjectPreviousSave[index])) {
                            var mainObjectPreviousSave = model.MainObjectPreviousSave[index].filter(where => where.ParentObjectId === mainId);

                            if (mainObjectPreviousSave.length === 1) {
                                editedObject = mainObjectPreviousSave[0];
                            }
                        }

                        if (scope.generalModel.IsUndefinedEmptyOrNull(editedObject)) {
                            var filterCondition = {};

                            filterCondition[gridMainId] = mainId;
                            findNewObject = scope.generalModel.GetObjectByString($filter('filter')(gridInstance.getDataSource()._store._array, filterCondition, true)[0], id);
                        }
                        else {
                            findNewObject = editedObject;
                        }

                        if (!scope.generalModel.IsUndefinedEmptyOrNull(findNewObject)) {
                            if (id.indexOf(".") > 0) {
                                var dividedId = id.split('.');

                                object[dividedId[0]][dividedId[1]] = findNewObject;
                            }
                            else {
                                object[id] = findNewObject;
                            }
                        }
                    }

                    $('<a/>')
                        .html('<span class="ParentContentWithMagnifier Fullwidth">' +
                            '<span class="ContentWithMagnifier Empty">' + defaultSelectText + '</span>' +
                            '<i class="lnr lnr-list"></i>' +
                            '</span>')
                        .on('dxclick', function () {
                            if ((!object.Disabled) && (!angular.element(this).parent('td').hasClass('Disabled')) && (!object.NonEditable)) {
                                var index = scope.generalModel.FindIndex(this);
                                scope.generalModel.CallGridDropDownGeneral(mainId, index, extraConnectionId, false, gridName);
                            }
                        }).appendTo(container);
                }
                else {
                    var description = "";

                    if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetObjectByString(object, id + "." + fieldShow))) {
                        description = (scope.generalModel.GetObjectByString(object, id + "." + fieldShow));
                    }

                    $('<a/>')
                        .html('<span class="ParentContentWithMagnifier' + ((required) || (description === defaultSelectText) ? ' Fullwidth' : '') + '">' +
                            '<span class="ContentWithMagnifier">' + (description === null ? '' : description) + '</span>' +
                            '<i class="lnr lnr-list"></i>' +
                            '</span>')
                        .on('dxclick', function () {
                            if ((!object.Disabled) && (!angular.element(this).parent('td').hasClass('Disabled')) && (!object.NonEditable)) {
                                var index = scope.generalModel.FindIndex(this);
                                scope.generalModel.CallGridDropDownGeneral(mainId, index, extraConnectionId, false, gridName);
                            }
                        }).appendTo(container);

                    if (!required && (description !== defaultSelectText)) {
                        $('<a/>')
                            .addClass('SelectIconClear')
                            .html('<i class="lnr lnr-cross"></i>')
                            .on('dxclick', function () {
                                if ((!object.Disabled) && (!angular.element(this).parent('td').hasClass('Disabled')) && (!object.NonEditable)) {
                                    var index = scope.generalModel.FindIndex(this);
                                    scope.generalModel.ExtraConnectionId = extraConnectionId;
                                    if (defaultSelectText === '') {
                                        scope.SelectGridDropDownElement(id + '.' + fieldShow, null, null, mainId, index, gridName);
                                    }
                                    else {
                                        scope.SelectGridDropDownElement(id + '.' + fieldShow, null, defaultSelectText, mainId, index, gridName);
                                    }
                                }
                            }).appendTo(container);
                    }
                }
            };

            scope.generalModel.CallGridDropDownGeneral = function (parentId, rowIndex, extraConnectionId, multipleSelect, gridName, index, pageSize) {
                scope.generalModel.FullPageLoading = true;

                if (multipleSelect) {
                    scope.generalModel.DropDownGeneralDialogButton = true;
                    angular.element('#GeneralDialogButtonArea').html('<button id="ButtonDropDownGeneralDialog" class="btn btn-primary close-button" ng-click="SaveMultipleSelectionGeneral();">' + !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Select : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).select + '</button>');
                    $compile(angular.element('#GeneralDialogButtonArea'))(scope);
                }

                scope.generalModel.SelectedRow = parentId;
                scope.generalModel.ExtraConnectionId = extraConnectionId;

                if (!scope.generalModel.IsUndefinedEmptyOrNull(index)) {
                    scope.generalModel.ExtraConnectionArrayIndex = index;

                    if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataFieldAfterIndex'])) {
                        scope.generalModel.SelectedRow = parentId + '[' + index + '].' + scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['InnerId'];
                    }
                    else {
                        scope.generalModel.SelectedRow = parentId + '[' + index + ']';
                    }
                }

                scope.generalModel.GridName = gridName;
                scope.generalModel.SelectedRowIndex = rowIndex;
                scope.generalModel.Controller = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['PathName'];

                if ((typeof scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['SpecificCall'] !== 'undefined') && (scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['SpecificCall'] !== '')) {
                    scope.generalModel.DropDownAction = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['SpecificCall'];
                }
                else {
                    scope.generalModel.DropDownAction = 'ListEnables';
                }

                scope.generalModel.ExtraConnectionsFinishedLoading = false;
                scope.generalModel.FirstTimeLoadingExtra = true;

                scope.generalModel.CallGridDropDownGeneralContent(pageSize);
            };

            scope.generalModel.CallGridDropDownGeneralContent = function (pageSize) {
                $q.when(GeneralModel.ListSearchGeneral()).then(function () {
                    if (scope.generalModel.FirstTimeLoadingExtra) {
                        scope.generalModel.DrawGridDropDownGeneral(pageSize);
                    }
                    else {
                        angular.element("#GridDropDownGeneralDialog").dxDataGrid("option", "dataSource", scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Object']);
                    }

                    if (scope.generalModel.RefreshLoadExtra) {
                        scope.generalModel.CallGridDropDownGeneralContent();
                        scope.generalModel.FirstTimeLoadingExtra = false;
                    }
                }).catch(function (reason) {
                    GeneralModel.ShowToastWarning(reason);
                    scope.generalModel.FullPageLoading = false;
                });
            };

            scope.generalModel.DrawGridDropDownGeneral = function (pageSize) {
                var selectionState = false;
                var configurePageSize = false;

                if (scope.generalModel.DropDownGeneralDialogButton) {
                    selectionState = { mode: "multiple" };
                }

                var caption = '';
                var extraConnection = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId);

                if (scope.generalModel.ExtraConnectionId !== '') {
                    if (scope.generalModel.IsUndefinedEmptyOrNull(extraConnection['TranslationValue'])) {
                        extraConnection['TranslationValue'] = Helpers.Translations[extraConnection['NameTranslation']];
                    }

                    caption = extraConnection['TranslationValue'];
                }

                var columnDataField = ''
                var indexOfName = -1;
                var arrayToPrint;

                if (scope.generalModel.ExtraConnectionId !== '') {
                    columnDataField = extraConnection['Name'];

                    indexOfName = columnDataField.indexOf(',');

                    if (indexOfName > 0) {
                        arrayToPrint = columnDataField.split(",");
                        columnDataField = arrayToPrint[0];
                    }
                }

                if (scope.generalModel.IsUndefinedEmptyOrNull(pageSize)) {
                    configurePageSize = true;
                    pageSize = 20;
                }

                scope.GridDropDownGeneralDialog = {
                    dataSource: extraConnection['Object'],
                    paging: {
                        pageSize: pageSize
                    },
                    "export": {
                        enabled: false
                    },
                    height: (myApplication.projectType === myApplication.projectTypeWeb) ? 500 : '100%',
                    showBorders: true,
                    rowAlternationEnabled: true,
                    sorting: true,
                    groupPaging: true,
                    grouping: true,
                    summary: true,
                    filterRow: {
                        visible: true
                    },
                    headerFilter: {
                        visible: true
                    },
                    selection: selectionState,
                    allowColumnResizing: true,
                    columnAutoWidth: true,
                    columns: [{
                        dataField: columnDataField,
                        caption: caption,
                        cellTemplate: function (container, options) {
                            if (scope.generalModel.ExtraConnectionId === '') {
                                return;
                            }

                            if (!scope.generalModel.DropDownGeneralDialogButton) {
                                var nameToPrint = '';
                                var nameToSend = '';
                                var indexOfDataField = extraConnection['DataField'].indexOf(',');

                                if ((indexOfName > 0) && (indexOfDataField !== 0)) {
                                    if (indexOfDataField < 0) {
                                        for (var a = 0; a < arrayToPrint.length; a++) {
                                            var itemToPrint = arrayToPrint[a];

                                            if (nameToPrint.length) {
                                                nameToPrint = nameToPrint + ' - ' + options.data[itemToPrint];
                                                nameToSend = nameToPrint;
                                            }
                                            else {
                                                nameToPrint = scope.generalModel.GetObjectByString(options.data, itemToPrint);
                                            }
                                        }
                                    }
                                    else {
                                        nameToPrint = scope.generalModel.GetObjectByString(options.data, arrayToPrint[0]);
                                        nameToSend = options.data;
                                    }
                                }
                                else {
                                    nameToPrint = scope.generalModel.GetObjectByString(options.data, extraConnection['Name']);
                                    nameToSend = nameToPrint;
                                }

                                options.value = nameToPrint;

                                $('<a/>').addClass('dx-link')
                                    .text(nameToPrint)
                                    .on('dxclick', function () {
                                        if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.ExtraConnectionId)) {
                                            var extraConnection = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId);
                                            var dataField = extraConnection['DataField'];

                                            if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.ExtraConnectionArrayIndex)) {
                                                var datafieldAfterIndex = extraConnection['DataFieldAfterIndex'];

                                                if (!scope.generalModel.IsUndefinedEmptyOrNull(datafieldAfterIndex)) {
                                                    dataField = dataField + '[' + scope.generalModel.ExtraConnectionArrayIndex + '].' + datafieldAfterIndex;
                                                }
                                                else {
                                                    dataField = dataField + '[' + scope.generalModel.ExtraConnectionArrayIndex + ']';
                                                }
                                            }

                                            scope.SelectGridDropDownElement(dataField, options.data[extraConnection['Id']], nameToSend, scope.generalModel.SelectedRow, scope.generalModel.SelectedRowIndex, scope.generalModel.GridName);
                                        }
                                    }).appendTo(container);
                            }
                            else {
                                angular.element(container).append(options.data[scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Name']]);
                            }
                        },
                        calculateCellValue: function (data) {
                            var oldValue = data[columnDataField];

                            if ((scope.generalModel.ExtraConnectionId === '') || scope.generalModel.DropDownGeneralDialogButton || (indexOfName <= 0)) {
                                return oldValue;
                            }

                            var indexOfDataField = extraConnection['DataField'].indexOf(',');

                            if (indexOfDataField >= 0) {
                                return oldValue;
                            }

                            var newValue = "";

                            for (var a = 0; a < arrayToPrint.length; a++) {
                                var itemToPrint = arrayToPrint[a];

                                if (newValue.length) {
                                    newValue += ' - ' + data[itemToPrint];
                                }
                                else {
                                    newValue = scope.generalModel.GetObjectByString(data, itemToPrint);
                                }
                            }

                            return newValue;
                        }
                    }],
                    noDataText: (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.NoDataFound : myApplication.getLanguageObject.selectedLanguage('basePageTexts', myApplication).noDataFound,
                    font: myApplication.gridFont,
                    onContentReady: function (e) {
                        if (scope.generalModel.GridName !== '') {
                            var rowsToSelect = [];
                            var grid = angular.element("#" + scope.generalModel.GridName + "").dxDataGrid('instance');
                            var editData = scope.generalModel.GetEditDataClean(grid);
                            var existingElements = '';

                            if (editData.length) {
                                for (var h = 0; h < editData.length; h++) {
                                    if (editData[h].type === 'update') {
                                        var itemEditDataOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(editData[h]);

                                        if (itemEditDataOldData[scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)] === scope.generalModel.SelectedRow) {
                                            if (typeof editData[h].data[scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['ObjectPathName']] !== 'undefined') {
                                                existingElements = editData[h].data[scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['ObjectPathName']];
                                            }
                                        }
                                    }
                                    else if (editData[h].type === 'insert') {
                                        if (editData[h].data.__KEY__ === scope.generalModel.SelectedRow) {
                                            if (typeof editData[h].data[scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['ObjectPathName']] !== 'undefined') {
                                                existingElements = editData[h].data[scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['ObjectPathName']];
                                            }
                                        }
                                    }
                                }
                            }
                            if (grid._controllers.data._dataSource._items.length) {
                                for (var i = 0; i < grid._controllers.data._dataSource._items.length; i++) {
                                    if ((grid._controllers.data._dataSource._items[i][scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['MainId']] === scope.generalModel.SelectedRow) || (grid._controllers.data._dataSource._items[i][scope.generalModel.GetMainIdFromKey(grid)] === scope.generalModel.SelectedRow)) {
                                        if (typeof grid._controllers.data._dataSource._items[i][scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['ObjectPathName']] !== 'undefined') {
                                            existingElements = grid._controllers.data._dataSource._items[i][scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['ObjectPathName']];
                                        }
                                    }
                                }
                            }
                            if ((existingElements !== null) && existingElements.length) {
                                for (var l = 0; l < scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Object'].length; l++) {
                                    for (var j = 0; j < existingElements.length; j++) {
                                        if (scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Object'][l][scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Id']] === existingElements[j][scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Id']]) {
                                            rowsToSelect.push(l);
                                        }
                                    }
                                }
                            }
                            else {
                                e.component.clearSelection();
                            }

                            if (rowsToSelect.length) {
                                e.component.selectRowsByIndexes(rowsToSelect);
                            }
                        }
                    }
                };

                angular.element("#GridDropDownGeneralDialog").dxDataGrid(scope.GridDropDownGeneralDialog);

                var gridInstance = angular.element("#GridDropDownGeneralDialog").dxDataGrid('instance');

                if (scope.generalModel.DropDownGeneralDialogButton) {
                    gridInstance.startSelectionWithCheckboxes();
                }

                if (configurePageSize && (myApplication.projectType === myApplication.projectTypeWeb)) {
                    Helpers.DevExtreme.SetDataGridPageSize(gridInstance, 500);
                }

                gridInstance.refresh();

                $mdDialog.show({
                    multiple: true,
                    contentElement: '#DropDownGeneralDialog',
                    parent: angular.element(document.body),
                    targetEvent: window.event,
                    clickOutsideToClose: false,
                    onComplete: function () {
                        scope.generalModel.GeneralModelIsOpened = true;
                        angular.element("#GridDropDownGeneralDialog").dxDataGrid('instance').refresh();
                    }
                });

                scope.generalModel.FullPageLoading = false;
            };

            scope.SelectGridDropDownElement = function (element, data, dataContent, lineId, rowIndex, gridName) {
                if (rowIndex !== '') {
                    var grid = angular.element("#" + gridName + "").dxDataGrid('instance');

                    if (typeof scope.generalModel.DropdDownsEditedValues[gridName] === 'undefined') {
                        scope.generalModel.DropdDownsEditedValues[gridName] = {};
                    }

                    if (typeof scope.generalModel.DropdDownsEditedValues[gridName][rowIndex] === 'undefined') {
                        scope.generalModel.DropdDownsEditedValues[gridName][rowIndex] = {};
                    }

                    scope.generalModel.DropdDownsEditedValues[gridName][rowIndex][element] = grid.cellValue(rowIndex, element);
                    var editData = scope.generalModel.GetEditDataClean(grid);
                    var innerId = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['InnerId'];

                    if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.ExtraConnectionArrayIndex)) {
                        if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataFieldAfterIndex'])) {
                            innerId = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['InnerId'] + '[' + scope.generalModel.ExtraConnectionArrayIndex + '].' + scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataFieldAfterIndex'];
                        }
                        else {
                            innerId = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['InnerId'] + '[' + scope.generalModel.ExtraConnectionArrayIndex + ']';
                        }
                    }

                    if (!editData.length) {
                        editData = grid.getDataSource()._store._array;

                        for (var i = 0; i < editData.length; i++) {
                            if (((editData[i][scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['MainId']] === lineId) || (editData[i][scope.generalModel.GetMainIdFromKey(grid)] === lineId)) || (editData[i].__KEY__ === lineId)) {
                                if (innerId.indexOf('.') > 0) {
                                    scope.generalModel.SetObjectValueByString(editData[i], innerId, data);
                                }
                                else {
                                    editData[i][innerId] = data;
                                }

                                break;
                            }
                        }
                    }
                    else if (editData.length) {
                        var fields;

                        for (var t = 0; t < editData.length; t++) {
                            if (editData[t].type === 'update') {
                                var itemEditDataOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(editData[t]);

                                if ((itemEditDataOldData[scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['MainId']] === lineId) || (itemEditDataOldData[scope.generalModel.GetMainIdFromKey(grid)] === lineId)) {
                                    if (innerId.indexOf('.') > 0) {
                                        fields = innerId.split('.');
                                        editData[t].data[fields[0]][fields[1]] = data;
                                    }
                                    else {
                                        editData[t].data[innerId] = data;
                                    }

                                    break;
                                }
                                else if ((itemEditDataOldData.hasOwnProperty('__KEY__')) && (itemEditDataOldData.__KEY__ === lineId)) {
                                    if (innerId.indexOf('.') > 0) {
                                        fields = innerId.split('.');
                                        editData[t].data[fields[0]][fields[1]] = data;
                                    }
                                    else {
                                        editData[t].data[innerId] = data;
                                    }

                                    break;
                                }
                            }
                            else if (editData[t].type === 'insert') {
                                if (editData[t].data.__KEY__ === lineId) {
                                    if (innerId.indexOf('.') > 0) {
                                        fields = innerId.split('.');
                                        editData[t].data[fields[0]][fields[1]] = data;
                                    }
                                    else {
                                        editData[t].data[innerId] = data;
                                    }

                                    break;
                                }
                            }
                        }
                    }
                    else {
                        var dataSource = grid.getDataSource();

                        for (var k = 0; k < dataSource._store._array.length; k++) {
                            if (dataSource._store._array[k].__KEY__ === lineId) {
                                dataSource._store._array[k][innerId] = data;
                            }
                        }
                    }

                    grid.cellValue(rowIndex, innerId, data);
                    grid.cellValue(rowIndex, element, dataContent);
                }
                else {
                    var finalElement = $parse(lineId);
                    finalElement.assign(scope, data);
                    var fieldsInData;
                    var name;
                    var finalDataContent;
                    var model = scope.generalModel.BaseModel;

                    if (typeof scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Model'] !== 'undefined') {
                        model = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Model'];
                    }

                    if (scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataField'].indexOf(',') > 0) {
                        fieldsInData = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataField'].split(',');
                        name = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Name'].split(',');

                        for (var a = 0; a < fieldsInData.length; a++) {
                            finalDataContent = scope.generalModel.GetObjectByString(dataContent, name[a]);

                            if (fieldsInData[a].indexOf('.') > 0) {
                                var insideFields = $parse(scope.generalModel.BaseModel + '.' + fieldsInData[a]);
                                insideFields.assign(scope, finalDataContent);
                                insideFields.assign(rootScope, finalDataContent);
                            }
                            else if (Array.isArray(rootScope[scope.generalModel.BaseModel][fieldsInData[a]]) && !Array.isArray(finalDataContent)) {
                                rootScope[scope.generalModel.BaseModel][fieldsInData[a]].push(finalDataContent);
                                scope[scope.generalModel.BaseModel][fieldsInData[a]].push(finalDataContent);
                            }
                            else {
                                rootScope[scope.generalModel.BaseModel][fieldsInData[a]] = finalDataContent;
                                scope[scope.generalModel.BaseModel][fieldsInData[a]] = finalDataContent;
                            }
                        }
                    }
                    else {
                        var datafield = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataField'];

                        if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.ExtraConnectionArrayIndex)) {
                            if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataFieldAfterIndex'])) {
                                datafield = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataField'] + '[' + scope.generalModel.ExtraConnectionArrayIndex + '].' + scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataFieldAfterIndex'];
                            }
                            else {
                                datafield = scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['DataField'] + '[' + scope.generalModel.ExtraConnectionArrayIndex + ']';
                            }
                        }

                        var finalDataField = $parse(model + '.' + datafield);
                        finalDataField.assign(scope, dataContent);
                        finalDataField.assign(rootScope, dataContent);
                    }
                }

                scope.CloseDialogGridDropDownGeneral();
            };

            scope.CloseDialogGridDropDownGeneral = function () {
                $mdDialog.hide({
                    contentElement: '#DropDownGeneralDialog'
                });

                if (typeof scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId) !== 'undefined') {
                    scope.generalModel.GetExtraConnection(scope.generalModel.ExtraConnectionId)['Object'] = [];
                }

                scope.generalModel.ExtraConnectionArrayIndex = '';
                scope.generalModel.ExtraConnectionId = '';
                scope.generalModel.SelectedRow = '';
                scope.generalModel.GridName = '';
                scope.generalModel.Controller = '';
                scope.generalModel.DropDownGeneralDialogButton = false;
            };

            scope.generalModel.ClearDropDown = function (elements) {
                var elementsSeparated = elements.split(',');

                for (var e = 0; e < elementsSeparated.length; e++) {
                    var object = $parse(elementsSeparated[e]);
                    object.assign(scope, '');
                }
            };

            scope.generalModel.GenerateColorObject = function (gridName, container, object, id) {
                if ((typeof object[id] === 'undefined') || (object[id] === null) || (object[id] === "")) {
                    $('<a/>')
                        .html('<span class="ParentContentWithMagnifier"><span class="ContentWithMagnifier"><span class="ColorSquare DisplayNone"></span></span><i class="lnr lnr-magnifier"></i></span>')
                        .on('dxclick', function () {
                            if ((!object.Disabled) && (!angular.element(this).parent('td').hasClass('Disabled')) && (!object.NonEditable)) {
                                var index = scope.generalModel.FindIndex(this);
                                scope.generalModel.CallColorPicker('#ff0000', index, gridName, window.event);
                            }
                        }).appendTo(container);
                } else {
                    var description = object[id];

                    $('<a/>')
                        .html('<span class="ParentContentWithMagnifier"><span class="ContentWithMagnifier"><span class="ColorSquare" ng-style="{\'background-color\': \'' + object.Color + '\'}"></span>' + (description === null ? '' : description) + '</span><i class="lnr lnr-magnifier"></i></span>')
                        .on('dxclick', function () {
                            if ((!object.Disabled) && (!angular.element(this).parent('td').hasClass('Disabled')) && (!object.NonEditable)) {
                                var index = scope.generalModel.FindIndex(this);
                                scope.generalModel.CallColorPicker(object.Color, index, gridName, window.event);
                            }
                        }).appendTo(container);
                }

                $compile(container)(scope);
            };

            scope.generalModel.CallColorPicker = function (rowContent, rowIndex, gridName, event) {
                scope.generalModel.NewColor = rowContent;
                scope.generalModel.GridNameColorPicker = gridName;

                var changeColor = null;

                angular.element('#ColorPicker').colorpicker({
                    useAlpha: false,
                    color: rowContent,
                    format: "hex"
                }).on('changeColor',
                    function () {
                        if (changeColor !== null) {
                            clearTimeout(changeColor);
                        }

                        changeColor = setTimeout(function () {
                            scope.generalModel.NewColor = angular.element('#ColorPickerInput').val();
                        }, 200);
                    });

                angular.element('#ColorPicker').colorpicker('setValue', rowContent);
                scope.generalModel.SelectedRowIndex = rowIndex;

                $mdDialog.show({
                    contentElement: '#ColorPickerDialog',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false
                });
            };

            scope.generalModel.CloseDialogColorPicker = function () {
                $mdDialog.hide({
                    contentElement: '#ColorPickerDialog'
                });

                scope.generalModel.GridNameColorPicker = '';
                scope.generalModel.SelectedRowIndex = '';
                scope.generalModel.NewColor = '#ff0000';
            };

            scope.generalModel.SaveColor = function () {
                if ((scope.generalModel.NewColor.length === 7) && (scope.generalModel.NewColor.substr(0, 1) === '#')) {
                    scope.generalModel.SaveColorStatus = false;
                    var grid = angular.element("#" + scope.generalModel.GridNameColorPicker + "").dxDataGrid('instance');
                    grid.cellValue(scope.generalModel.SelectedRowIndex, 'Color', scope.generalModel.NewColor);
                    scope.generalModel.CloseDialogColorPicker();
                }
                else {
                    scope.generalModel.SaveColorStatus = true;
                }
            };

            scope.generalModel.ClearColor = function () {
                scope.generalModel.NewColor = "";
                scope.generalModel.SaveColorStatus = false;
                var grid = angular.element("#" + scope.generalModel.GridNameColorPicker + "").dxDataGrid('instance');
                grid.cellValue(scope.generalModel.SelectedRowIndex, 'color', scope.generalModel.NewColor);
                scope.generalModel.CloseDialogColorPicker();
            };

            scope.generalModel.GenerateTimeObject = function (gridName, container, object, id, interval, showSeconds, showQuantityDays) {
                scope.generalModel.GenerateTimeObjectWithLink(gridName, container, object, id, interval, showSeconds, showQuantityDays, true);
            };

            scope.generalModel.GenerateTimeObjectWithLink = function (gridName, container, object, id, interval, showSeconds, showQuantityDays, addLink) {
                var emptyTime = "00:00";
                var daysText = (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.Days : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).days;

                if (showQuantityDays) {
                    if (showSeconds) {
                        emptyTime = "0 " + daysText + " 00h 00m 00s";
                    }
                    else {
                        emptyTime = "0 " + daysText + " 00h 00m";
                    }
                }
                else if (showSeconds) {
                    emptyTime = "00:00:00";
                }

                if ((typeof object[id] === 'undefined') || (object[id] === null) || (object[id] === "")) {
                    if (addLink) {
                        $('<a/>')
                            .html('<span class="ParentContentWithMagnifier Fullwidth"><span class="ContentWithMagnifier TextAlignCenter">' + emptyTime + '</span><i class="lnr lnr-clock"></i></span>')
                            .on('dxclick', function () {
                                if ((!object.Disabled) && (!angular.element(this).parent('td').hasClass('Disabled')) && (!object.NonEditable)) {
                                    var index = scope.generalModel.FindIndex(this);
                                    scope.generalModel.CallTimePicker(gridName, id, emptyTime, index, interval, showSeconds, showQuantityDays);
                                }
                            }).appendTo(container);
                    } else {
                        angular.element('<span class="ParentContentWithMagnifier TextAlignCenter">' + emptyTime + '</span>').appendTo(container);
                    }
                } else {
                    var description = object[id];

                    if (!showSeconds) {
                        description = object[id].substr(0, 5);
                    }
                    else if (description.length < 8) {
                        description += ':00';
                    }

                    if (showQuantityDays) {
                        var index = description.indexOf(".");

                        if ((index < 0) || (index > description.indexOf(":"))) {
                            description = "0." + description;
                        }
                        description = description.substring(0, description.indexOf('.')) + " " + daysText + " " + description.substr(description.indexOf('.') + 1, 2) + "h " + description.substr(description.indexOf(':') + 1, 2) + "m " + description.substr(description.lastIndexOf(':') + 1, 2) + "s";
                    }

                    if (addLink) {
                        $('<a/>')
                            .html('<span class="ParentContentWithMagnifier Fullwidth"><span class="ContentWithMagnifier TextAlignCenter">' + (description === null ? '' : description) + '</span><i class="lnr lnr-clock"></i></span>')
                            .on('dxclick', function () {
                                if ((!object.Disabled) && (!angular.element(this).parent('td').hasClass('Disabled')) && (!object.NonEditable)) {
                                    var index = scope.generalModel.FindIndex(this);
                                    scope.generalModel.CallTimePicker(gridName, id, description, index, interval, showSeconds, showQuantityDays);
                                }
                            }).appendTo(container);
                    } else {
                        angular.element('<span class="ParentContentWithMagnifier TextAlignCenter">' + description + '</span>').appendTo(container);
                    }
                }

                $compile(container)(scope);
            };

            scope.generalModel.CallTimePicker = function (gridName, id, rowContent, rowIndex, interval, showSeconds, showQuantityDays) {
                var format = "HH:mm";
                var showSecondsInTime = false;
                var daysText = !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Days : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).days;
                scope.generalModel.NewTime = rowContent;

                if (showSeconds) {
                    format = "HH:mm:ss";
                    showSecondsInTime = true;
                }

                if (showQuantityDays) {
                    scope.generalModel.NewDays = parseInt(rowContent.substr(0, rowContent.indexOf(' ' + daysText + ' ')));
                    scope.generalModel.NewTime = rowContent.substr(rowContent.indexOf(' ' + daysText + ' ') + (daysText.length + 2), 2) + ":" + rowContent.substr(rowContent.indexOf('h ') + 2, 2) + ":" + rowContent.substr(rowContent.indexOf('m ') + 2, 2);
                    scope.generalModel.HasDaysPicker = true;
                }

                scope.generalModel.SelectedRowIndex = rowIndex;
                var clearTime = !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ClearTime : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).clearTime;
                var saveTime = !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Save : myApplication.getLanguageObject.selectedLanguage('saveCancelButtonsTexts', myApplication).save;

                angular.element('#TimeDialogButtonArea').html('' +
                    '<button class="btn btn-default MarginRight10" ng-click="generalModel.ClearTime(\'' + gridName + '\', \'' + id + '\', \'' + showSeconds + '\', \'' + showQuantityDays + '\')">' + clearTime + '</button><button class="btn btn-primary" ng-click="generalModel.SaveTime(\'' + gridName + '\', \'' + id + '\');">' + saveTime + '</button>');
                $compile(angular.element('#TimeDialogButtonArea'))(scope);

                angular.element('#TimePicker').timepicker({
                    showSecond: showSecondsInTime,
                    timeFormat: format,
                    interval: interval,
                    minTime: '00:00:00',
                    maxTime: '23:59:59',
                    defaultTime: scope.generalModel.NewTime,
                    dynamic: false,
                    dropdown: true
                });

                $mdDialog.show({
                    contentElement: '#TimePickerDialog',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false
                });
            };

            scope.generalModel.CloseDialogTimePicker = function () {
                $mdDialog.hide({
                    contentElement: '#TimePickerDialog'
                });

                scope.generalModel.SelectedRowIndex = '';
                scope.generalModel.NewTime = '';
            };

            scope.generalModel.SaveTime = function (gridName, id) {
                angular.element('#TimePicker').trigger("change");

                if (((scope.generalModel.NewTime.length === 5) && (scope.generalModel.NewTime.substr(2, 1) === ':')) || ((scope.generalModel.NewTime.length === 8) && (scope.generalModel.NewTime.substr(2, 1) === ':') && (scope.generalModel.NewTime.substr(5, 1) === ':'))) {
                    scope.generalModel.SaveTimeStatus = false;
                    var grid;

                    if (angular.element('#' + gridName).hasClass('dx-treelist')) {
                        grid = angular.element('#' + gridName).dxTreeList('instance');
                    }
                    else {
                        grid = angular.element('#' + gridName).dxDataGrid('instance');
                    }

                    if (scope.generalModel.HasDaysPicker) {
                        grid.cellValue(scope.generalModel.SelectedRowIndex, id, scope.generalModel.NewDays + '.' + scope.generalModel.NewTime);
                        scope.generalModel.HasDaysPicker = false;
                    }
                    else {
                        grid.cellValue(scope.generalModel.SelectedRowIndex, id, scope.generalModel.NewTime);
                    }

                    scope.generalModel.CloseDialogTimePicker();
                }
                else {
                    scope.generalModel.SaveTimeStatus = true;
                }
            };

            scope.generalModel.ClearTime = function (gridName, id, showSeconds) {
                scope.generalModel.NewDays = 0;

                if (showSeconds) {
                    scope.generalModel.NewTime = "00:00:00";
                }
                else {
                    scope.generalModel.NewTime = "00:00";
                }

                scope.generalModel.HasDaysPicker = false;
                scope.generalModel.SaveTimeStatus = false;

                var grid;

                if (angular.element('#' + gridName).hasClass('dx-treelist')) {
                    grid = angular.element('#' + gridName).dxTreeList('instance');
                }
                else {
                    grid = angular.element('#' + gridName).dxDataGrid('instance');
                }

                grid.cellValue(scope.generalModel.SelectedRowIndex, id, scope.generalModel.NewTime);
                scope.generalModel.CloseDialogTimePicker();
            };

            scope.generalModel.AddBase64ToImage = function (image) {
                if ((image !== '') && (typeof image !== 'undefined') && (image.indexOf('data:image/gif;base64,') < 0)) {
                    return 'data:image/gif;base64,' + image;
                }

                return image;
            };

            scope.generalModel.IsValidGuid = function (stringToTest) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(stringToTest)) {
                    return;
                }

                if (stringToTest[0] === "{") {
                    stringToTest = stringToTest.substring(1, stringToTest.length - 1);
                }

                var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;

                return regexGuid.test(stringToTest);
            };

            scope.generalModel.CheckIfThereAreEditedFields = function (model) {
                var thereAreChanges = false;
                var secondGrid;
                var secondGridEditData = [];
                var id;
                var grid;

                if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.MyForms) && Object.keys(scope.MyForms).length) {
                    Object.keys(scope.MyForms).forEach(function (key) {
                        if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.MyForms[key]) && scope.MyForms[key].$dirty) {
                            thereAreChanges = true;
                            return;
                        }
                    });
                }

                if (!thereAreChanges) {
                    for (var p = 0; p < model.ArrayGridObjects.length; p++) {
                        if (angular.element("#" + model.ArrayGridObjects[p].GridName + "").hasClass("dx-widget")) {
                            grid = angular.element("#" + model.ArrayGridObjects[p].GridName + "").dxDataGrid('instance');

                            if (typeof grid !== 'undefined') {
                                var dataSource = grid.getDataSource();

                                if (dataSource !== null) {
                                    for (var v = 0; v < dataSource._store._array.length; v++) {
                                        if (dataSource._store._array[v].hasOwnProperty('__KEY__')) {
                                            thereAreChanges = true;
                                            break;
                                        }

                                        else if (scope.generalModel.GetEditDataClean(grid).length) {
                                            thereAreChanges = true;
                                            break;
                                        }
                                        else if (model.ArrayGridObjects[p].SecondGrid !== '') {
                                            var mainId = model.ArrayGridObjects[p].MainId;

                                            if (typeof mainId === 'undefined') {
                                                mainId = scope.generalModel.GetMainIdFromKey(grid);
                                            }

                                            id = scope.generalModel.GetMainId(mainId, dataSource._store._array[v]);

                                            if (angular.element('#' + model.ArrayGridObjects[p].SecondGrid + id + '').length) {
                                                if (angular.element('#' + model.ArrayGridObjects[p].SecondGrid + id + '').hasClass("dx-widget")) {
                                                    secondGrid = angular.element('#' + model.ArrayGridObjects[p].SecondGrid + id).dxDataGrid('instance');
                                                    secondGridEditData = scope.generalModel.GetEditDataClean(secondGrid);

                                                    if (secondGridEditData.length) {
                                                        thereAreChanges = true;
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                return thereAreChanges;
            };

            scope.generalModel.WatchInitializerFinished = scope.$watch('generalModel.InitializerFinished', function (value, oldValues, scope) {
                if ((scope.generalModel.InitializerFinished) && (typeof scope.generalModel.WatchInitializerFinished !== 'undefined')) {
                    scope.generalModel.WatchInitializerFinished();
                }
            });

            scope.generalModel.encodeHtml = function (string) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(string)) {
                    return string;
                }

                return string
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/\"/g, '&quot;')
                    .replace(/\'/g, '&#39;')
                    .replace(/\//g, '&#x2F;');
            };

            scope.generalModel.CallCamera = function (requestCode) {
                window.createFileChooser.CallCamera(parseInt(requestCode));
            };

            scope.generalModel.RestoreClasses = function () {
                var applyLeft = $parse(scope.generalModel.BaseModel + '.ApplyLeft');
                applyLeft.assign(scope, false);

                var applyUp = $parse(scope.generalModel.BaseModel + '.ApplyUp');
                applyUp.assign(scope, false);

                var applyDown = $parse(scope.generalModel.BaseModel + '.ApplyDown');
                applyDown.assign(scope, false);

                var applyRight = $parse(scope.generalModel.BaseModel + '.ApplyRight');
                applyRight.assign(scope, false);
            };

            scope.generalModel.GetChooserImageOrVideo = function (path) {
                var rotationAndPath = path.split("~orientation:");
                var ImageField = $parse(scope.generalModel.ImageField);
                ImageField.assign(scope, rotationAndPath[0]);

                scope.generalModel.RestoreClasses();
                var rotationDegrees;

                switch (rotationAndPath[1]) {
                    case "up":
                        var applyUp = $parse(scope.generalModel.BaseModel + '.ApplyUp');
                        applyUp.assign(scope, true);
                        rotationDegrees = $parse(scope.generalModel.BaseModel + '.RotationDegrees');
                        rotationDegrees.assign(scope, 90);
                        break;
                    case "left":
                        var applyLeft = $parse(scope.generalModel.BaseModel + '.ApplyLeft');
                        applyLeft.assign(scope, true);
                        rotationDegrees = $parse(scope.generalModel.BaseModel + '.RotationDegrees');
                        rotationDegrees.assign(scope, 0);
                        break;
                    case "down":
                        var applyDown = $parse(scope.generalModel.BaseModel + '.ApplyDown');
                        applyDown.assign(scope, true);
                        rotationDegrees = $parse(scope.generalModel.BaseModel + '.RotationDegrees');
                        rotationDegrees.assign(scope, 270);
                        break;
                    case "right":
                        var applyRight = $parse(scope.generalModel.BaseModel + '.ApplyRight');
                        applyRight.assign(scope, true);
                        rotationDegrees = $parse(scope.generalModel.BaseModel + '.RotationDegrees');
                        rotationDegrees.assign(scope, 180);
                        break;
                    default:
                        "";
                }

                scope.$apply();

                if (scope.generalModel.IsPhotography) {
                    scope.generalModel.PhotographyList.push({ Photography: scope.generalModel.GetObjectByString(scope[scope.generalModel.BaseModel], "Photography"), Id: 'UserMain' });
                }
            };

            scope.generalModel.GetBase64Image = function (img, callback) {
                var canvas = document.createElement("canvas");
                var context;
                var image = document.createElement("img");
                var originalImage = document.getElementById("originalImage");

                originalImage.onload = function () {
                    this.height = img.height;
                    this.width = img.width;
                    canvas.height = img.height;
                    canvas.width = img.width;
                    context = canvas.getContext("2d");
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(originalImage, 0, 0, originalImage.width, originalImage.height);
                    var dataURL = canvas.toDataURL("image/jpeg");
                    image.src = dataURL;
                };

                originalImage.src = img.src;

                image.onload = function () {
                    var rotationDegrees = scope.generalModel.GetObjectByString(scope[scope.generalModel.BaseModel], "RotationDegrees");
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    if (scope.generalModel.GetObjectByString(scope[scope.generalModel.BaseModel], "ApplyUp") || scope.generalModel.GetObjectByString(scope[scope.generalModel.BaseModel], "ApplyDown")) {
                        canvas.width = img.height;
                        canvas.height = img.width;
                    }
                    else {
                        canvas.width = img.width;
                        canvas.height = img.height;
                    }

                    context = canvas.getContext("2d");
                    context.rotate(rotationDegrees * Math.PI / 180);

                    if (rotationDegrees === 90) {
                        context.drawImage(image, 0, -image.height);
                    } else if (rotationDegrees === 180) {
                        context.drawImage(image, -image.width, -image.height);
                    } else if (rotationDegrees === 0) {
                        context.drawImage(image, 0, 0);
                    } else if (rotationDegrees === 270) {
                        context.drawImage(image, -image.width, 0);
                    }

                    var dataURL = canvas.toDataURL("image/jpeg");
                    callback(dataURL.replace('data:image/jpeg;base64,', ''));
                };
            };

            scope.generalModel.CreateDateFilter = function (number, filterButtonName, inputDateStartId, inputDateEndId, filterFunction, filterAreaId, dateFormat) {
                var content;
                var button = '<button id="' + filterButtonName + '" type="button" class="btn btn-primary FilterButtonApply MarginLeft5" ng-click="' + filterFunction + '" ng-disabled="!generalModel.IsOnline">' + (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ApplyFilter : myApplication.getLanguageObject.selectedLanguage('pivotGridTexts', myApplication).applyFilter) + '</button>';
                var firstBlock = '<div class="DivMonthYear" id="' + inputDateStartId + '"><span class="FloatLeft MarginLeft10 MarginRight10">' + (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.FromFilter : myApplication.getLanguageObject.selectedLanguage('pivotGridTexts', myApplication).fromFilter) + '</span><div class="DateBlock"><input type="text" class="form-control" uib-datepicker-popup="' + dateFormat + '" ng-disabled="!generalModel.IsOnline" is-open="generalModel.' + inputDateStartId + 'State" show-button-bar="false" /><span class="input-group-btn"><button type="button" class="btn btn-default MarginBottomNone MarginTopNone" ng-click="generalModel.OpenDatePicker(\'generalModel.' + inputDateStartId + 'State\')"><i class="lnr lnr-calendar-full"></i></button></span></div></div>';
                var secondBlock = '';

                if (number === 2) {
                    secondBlock = '<div class="DivMonthYear" id="' + inputDateEndId + '"><span class="FloatLeft MarginLeft10 MarginRight10">' + (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ToFilter : myApplication.getLanguageObject.selectedLanguage('pivotGridTexts', myApplication).toFilter) + '</span><div class="DateBlock"><input type="text" class="form-control" uib-datepicker-popup="' + dateFormat + '" ng-disabled="!generalModel.IsOnline" is-open="generalModel.' + inputDateEndId + 'State" show-button-bar="false" /><span class="input-group-btn"><button type="button" class="btn btn-default MarginBottomNone MarginTopNone" ng-click="generalModel.OpenDatePicker(\'generalModel.' + inputDateEndId + 'State\')"><i class="lnr lnr-calendar-full"></i></button></span></div></div>';
                }

                content = button.concat(firstBlock, secondBlock);
                angular.element('#' + filterAreaId).append(content);
            };

            scope.generalModel.GetDatePartsByDate = function (date) {
                var newDate = new Date(date);

                return {
                    year: newDate.getFullYear().toString(),
                    month: newDate.getMonth() < 10 ? "0" + newDate.getMonth().toString() : newDate.getMonth().toString(),
                    day: newDate.getDate() < 10 ? "0" + newDate.getDate().toString() : newDate.getDate().toString(),
                    hour: newDate.getHours() < 10 ? "0" + newDate.getHours().toString() : newDate.getHours().toString(),
                    minutes: newDate.getMinutes() < 10 ? "0" + newDate.getMinutes().toString() : newDate.getMinutes().toString(),
                    seconds: newDate.getSeconds() < 10 ? "0" + newDate.getSeconds().toString() : newDate.getSeconds().toString()
                };
            };

            scope.generalModel.AngularCopy = function (object) {
                return GeneralModel.AngularCopy(object);
            };

            scope.generalModel.FieldSorter = function (fields) {
                return GeneralModel.FieldSorter(fields);
            };

            scope.generalModel.SetCookie = function (cookieName, cookieValue, expireDays) {
                var date = new Date();
                date.setTime(date.getTime() + (expireDays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + date.toUTCString();
                document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
            };

            scope.generalModel.GetCookie = function (cookieName) {
                var name = cookieName + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var cookieArray = decodedCookie.split(';');

                for (var i = 0; i < cookieArray.length; i++) {
                    var cookieProperty = cookieArray[i];

                    while (cookieProperty.charAt(0) === ' ') {
                        cookieProperty = cookieProperty.substring(1);
                    }

                    if (cookieProperty.indexOf(name) === 0) {
                        return cookieProperty.substring(name.length, cookieProperty.length);
                    }
                }

                return "";
            };

            scope.generalModel.GetGridEditDataCleanBeforeSave = function (grid, id, arrayElement) {
                var editedData = scope.generalModel.GetEditDataClean(grid).map(function (edit) {
                    return edit.key[id];
                });

                grid.saveEditData();

                return arrayElement.filter(function (el) {
                    return (editedData.indexOf(el[id]) !== -1);
                });
            };

            scope.generalModel.GetMainIdFromKey = function (grid) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(grid.option('dataSource').store)) {
                    return '__KEY__';
                }

                return grid.option('dataSource').store._key;
            };

            scope.generalModel.RecoverPassword = function (isValid) {
                scope.generalModel.SendRecoverClicked = true;

                if (!isValid) {
                    return;
                }

                $q.when(GeneralModel.RecoverPassword()).catch(function (reason) {
                    GeneralModel.ShowToastWarning(reason);
                });

                scope.generalModel.RecoverUser = '';
                GeneralModel.ShowToast(myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).PasswordSentToYourEmail);
                scope.generalModel.CloseDialog('RecoverPasswordDialog');
                scope.generalModel.SendRecoverClicked = false;
            };

            scope.generalModel.GoToFirstPageCardView = function (model, numberOfItems) {
                model.CurrentPage = 1;
                scope.generalModel.FullPageLoading = false;
                $('#alt-style-pagination').pagination('selectPage', 1);

                if ($('#alt-style-pagination').length) {
                    $('#alt-style-pagination').pagination('updateItems', numberOfItems);
                }

                if ($location.absUrl().substr(0, $location.absUrl().indexOf('#')) !== '') {
                    window.history.pushState('', '', $location.absUrl().substr(0, $location.absUrl().indexOf('#')) + '#page-1');
                }
            };

            scope.generalModel.RefreshGridBase = function (dataSource) {
                $timeout(function () {
                    var grid = angular.element('#GridBase').dxDataGrid('instance');
                    grid.option('dataSource', dataSource);
                    grid.refresh();
                    scope.generalModel.FullPageLoading = false;
                });
            };

            scope.generalModel.SearchContainsSplitWildCard = function (textArray, expression) {
                if (expression === '') {
                    return true;
                }

                var wordArray = [];

                if (expression.charAt(0) === '=') {
                    wordArray = expression.split('=');
                } else {
                    wordArray = expression.split('*');
                }

                for (var t = 0; t < textArray.length; t++) {
                    var text = textArray[t];
                    var isString = /[^A-Za-z0-9]/.test(text);

                    if (isString) {
                        text = textArray[t].toUpperCase();
                    } else {
                        text = text.toString();
                    }

                    for (var w = 0; w < wordArray.length; w++) {
                        if (!scope.generalModel.IsUndefinedEmptyOrNull(text)) {
                            if (wordArray[w] !== '') {
                                if (expression.charAt(0) === '=') {
                                    if (text === wordArray[w].toUpperCase()) {
                                        return true;
                                    }
                                } else {
                                    if (text.indexOf(wordArray[w].toUpperCase()) !== -1) {
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }

                return false;
            };

            scope.generalModel.WildCardMatchRule = function (textArray, expression) {
                if (expression === '') {
                    return true;
                }

                var equalExpression = false;

                if (expression.charAt(0) === '=') {
                    equalExpression = true;
                }

                for (var t = 0; t < textArray.length; t++) {
                    if (equalExpression) {
                        if (textArray[t] === expression.substring(1, expression.length)) {
                            return true;
                        }
                    } else {
                        if (new RegExp("^" + expression.split("*").join(".*") + "$").test(textArray[t])) {
                            return true;
                        }
                    }
                }

                return false;
            };

            scope.generalModel.ApplySearchFilter = function (allField, expression, disabled) {
                if ((expression === '=') || (expression === '*')) {
                    if ((!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.PreviousSearchWildCard) && ((scope.generalModel.PreviousSearchWildCard.charAt(0) === '=') || (scope.generalModel.PreviousSearchWildCard.charAt(0) === '*'))) || scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.PreviousSearchWildCard)) {
                        return true;
                    }
                }
                else if ((scope.generalModel.SearchContainsSplitWildCard(allField, expression)) && ((scope.baseModel.ShowDisabled) ? true : (disabled === false))) {
                    scope.generalModel.PreviousSearchWildCard = expression;

                    if ((scope.generalModel.SearchGridModeValue.indexOf('*') !== -1) || (scope.generalModel.SearchGridModeValue.charAt(0) === '=')) {
                        return scope.generalModel.WildCardMatchRule(allField, expression);
                    }

                    return true;
                }

                return false;
            };

            scope.generalModel.FormatValueByFieldType = function (value, fieldType) {
                return GeneralModel.FormatValueByFieldType(value, fieldType);
            };

            scope.generalModel.FormatSecondsToTimeSpanString = function (totalSeconds) {
                var valueInTimeFormat = '00:00:00';

                if (totalSeconds > 0) {
                    var days = Math.floor(totalSeconds / (3600 * 24));
                    var hours = Math.floor(totalSeconds % (3600 * 24) / 3600);
                    var minutes = Math.floor(totalSeconds % 3600 / 60);
                    var seconds = Math.floor(totalSeconds % 60);

                    var daysToDisplay = days > 0 ? days + "." : "";
                    var hoursToDisplay = hours > 0 ? ('0' + hours.toString()).slice(-2) + (":") : "00:";
                    var minutesToDisplay = minutes > 0 ? ('0' + minutes.toString()).slice(-2) + (":") : "00:";
                    var secondsToDisplay = seconds > 0 ? ('0' + seconds.toString()).slice(-2) : "00";
                    valueInTimeFormat = daysToDisplay + hoursToDisplay + minutesToDisplay + secondsToDisplay;
                }

                return valueInTimeFormat;
            };

            scope.generalModel.GetChildrensPivotGridTotal = function (children, childrenDirection, completeChildrens) {
                for (var i = 0; i < children.length; i++) {
                    var newLevel = children[i].children(childrenDirection);

                    if (newLevel.length) {
                        completeChildrens = completeChildrens.concat(newLevel);
                        scope.generalModel.GetChildrensPivotGridTotal(newLevel, childrenDirection, completeChildrens);
                    }
                    else {
                        completeChildrens = completeChildrens.concat(children[i]);
                    }
                }

                return completeChildrens;
            };

            scope.generalModel.SetModules = function () {
                $sessionStorage.Modules = {};

                for (var m = 0; m < myApplication.modules.length; m++) {
                    var moduleName = myApplication.modules[m];
                    var modules = $sessionStorage.ParentMenus.filter(filter => (filter.Code === moduleName.Code)).length;

                    if (!modules) {
                        var find = false;
                        $sessionStorage.ParentMenus.forEach(function (menu) {
                            if (!find) {
                                modules = menu.ChildrenMenus.filter(filter => (filter.Code === moduleName.Code)).length;

                                if (modules) {
                                    $sessionStorage.Modules[moduleName.Name] = modules;
                                    find = true;
                                }
                            }
                        });
                    }

                    $sessionStorage.Modules[moduleName.Name] = modules;
                }
            };

            scope.generalModel.UploadAnnex = function (model, hasParent, id, index, parentList, idName) {
                scope.generalModel.FormUploadFileSubmitted = true;

                if (scope.generalModel.FilesAnnex.length && (scope.generalModel.FileUploadNameAnnex !== '')) {
                    var formData = new FormData();
                    formData.append("", scope.generalModel.FilesAnnex[0]);
                    var fileType = '';

                    if (typeof scope.generalModel.FilesAnnex[0].$ngfName !== 'undefined') {
                        fileType = scope.generalModel.FilesAnnex[0].$ngfName.substr(scope.generalModel.FilesAnnex[0].$ngfName.lastIndexOf('.'));
                    }
                    else {
                        fileType = scope.generalModel.FilesAnnex[0].name.substr(scope.generalModel.FilesAnnex[0].name.lastIndexOf('.'));
                    }

                    var fileName = scope.generalModel.FileUploadNameAnnex;

                    if (hasParent) {
                        if (typeof model.AnnexesToAddList[index] === 'undefined') {
                            model.AnnexesToAddList[index] = [];
                        }

                        model.AnnexesToAddList[index].push({ FormData: formData, FileType: fileType, FileName: fileName });
                    }
                    else {
                        model.AnnexesToAddList.push({ FormData: formData, FileType: fileType, FileName: fileName });
                    }
                    if (!scope.generalModel.IsUndefinedEmptyOrNull(id) && (!hasParent || (hasParent && model.AnnexesToAddList[index].length))) {
                        $q.when(scope.generalModel.ProcessUploadAnnexes(model, hasParent, parentList, idName)).then(function () {
                            GeneralModel.ShowToast(Helpers.Translations.AnnexesSuccessfullyAdded);
                            model.AnnexesToAddList[index] = [];
                        }).catch(function (reason) {
                            GeneralModel.ShowToastWarning(reason);
                        });
                    }
                    else if (scope.generalModel.IsUndefinedEmptyOrNull(id)) {
                        GeneralModel.ShowToast(Helpers.Translations.AttachmentAddedAvailableAfter);
                    }

                    scope.generalModel.FilesAnnex = [];
                    scope.generalModel.FileUploadNameAnnex = '';
                    scope.generalModel.FormUploadFilesAnnexSubmitted = false;
                }
                else {
                    scope.generalModel.FormUploadFilesAnnexSubmitted = true;
                }
            };

            scope.generalModel.ProcessUploadAnnexes = function (model, hasParent, parentList, idName) {
                var defer = $q.defer();
                var success = 0;
                var id;
                var parameters;

                for (var a = 0; a < model.AnnexesToAddList.length; a++) {
                    if (hasParent) {
                        success = [];

                        if (typeof model.AnnexesToAddList[a] !== 'undefined') {
                            for (var p = 0; p < model.AnnexesToAddList[a].length; p++) {
                                id = model[parentList][a][idName];
                                model.AnnexesToAddList[a][p].FormData.append("newAnnex", '{\n\"RegisterId\":\"' + id + '\",\n\"FileName\":\"' + model.AnnexesToAddList[a][p].FileName + '\",\n\"FileType\":\"' + model.AnnexesToAddList[a][p].FileType + '\"\n}');
                                parameters = model.AnnexesToAddList[a][p].FormData;

                                $q.when(GeneralModel.PostFiles(model, parameters, model.Documents, a)).then(function (result) {
                                    if (typeof success[result.Index] === 'undefined') {
                                        success[result.Index] = 0;
                                    }

                                    success[result.Index] += 1;

                                    if ((success.length === model.AnnexesToAddList.length) && (success[result.Index] === model.AnnexesToAddList[result.Index].length)) {
                                        defer.resolve();
                                    }
                                }).catch(function (reason) {
                                    GeneralModel.ShowToastWarning(reason);
                                    defer.reject(reason);
                                });
                            }
                        }
                    }
                    else {
                        id = model[idName];
                        model.AnnexesToAddList[a].FormData.append("newAnnex", '{\n\"RegisterId\":\"' + id + '\",\n\"FileName\":\"' + model.AnnexesToAddList[a].FileName + '\",\n\"FileType\":\"' + model.AnnexesToAddList[a].FileType + '\"\n}');
                        parameters = model.AnnexesToAddList[a].FormData;

                        $q.when(GeneralModel.PostFiles(model, parameters, model.Documents)).then(function () {
                            success = success + 1;

                            if (success === model.AnnexesToAddList.length) {
                                defer.resolve();
                            }
                        }).catch(function (reason) {
                            GeneralModel.ShowToastWarning(reason);
                            defer.reject(reason);
                        });
                    }
                }

                return defer.promise;
            };

            scope.generalModel.DeleteAnnex = function (model, index) {
                scope.generalModel.FullPageLoading = true;
                model.AnnexId = model.Documents[index].AnnexId;

                $q.when(GeneralModel.DeleteAnnexes(model)).then(function () {
                    model.Documents.splice(index, 1);
                    model.AnnexId = '';
                    GeneralModel.ShowToast(scope.generalModel.GeneralMessageInformation);
                }).catch(function (reason) {
                    GeneralModel.ShowToastWarning(reason);
                }).finally(function () {
                    scope.generalModel.FullPageLoading = false;
                });
            };

            scope.generalModel.DownloadResultBlob = function (result) {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(result.BlobObject, result.FileName);
                } else {
                    var a = document.createElement("a");

                    document.body.appendChild(a);
                    a.style.display = "none";
                    a.href = result.Blob;
                    a.download = result.FileName;
                    a.click();
                    a.remove();
                }

                scope.generalModel.FullPageLoading = false;
            };

            scope.generalModel.DownloadAnnex = function (model, index) {
                scope.generalModel.FullPageLoading = true;
                model.AnnexId = model.Documents[index].AnnexId;

                $q.when(GeneralModel.PreviewAnnexes(model)).then(function (result) {
                    scope.generalModel.DownloadResultBlob(result);
                    model.ExportObjectName = '';
                    model.ExportObject = '';
                    model.ExportObjectType = '';
                    model.AnnexId = '';
                }).catch(function (reason) {
                    GeneralModel.ShowToastWarning(reason);
                    scope.generalModel.FullPageLoading = false;
                });
            };

            scope.generalModel.LeftPadding = function (number) {
                return (((number < 10) && (number >= 0)) ? '0' : '') + number;
            };

            scope.generalModel.CountDecimals = function (number) {
                if (!scope.generalModel.IsUndefinedEmptyOrNull(number) && ((number % 1) !== 0)) {
                    return number.toString().split(".")[1].length;
                }

                return 0;
            };

            scope.generalModel.AngularCopy = function (object) {
                return GeneralModel.AngularCopy(object);
            };

            scope.generalModel.SetBreadCrumbs = function (link, linkParameters, name, edit) {
                var breadCrumb = new BreadCrumb(name, link, linkParameters);

                if (edit) {
                    rootScope.$broadcast('editBreadCrumb', breadCrumb);
                }
                else {
                    rootScope.$broadcast('addBreadCrumb', breadCrumb);
                }

                return GeneralModel.SetBreadCrumbs(link, linkParameters, name);
            };

            scope.generalModel.LoadAttachmentComponent = function () {
                scope.generalModel.ShowAttachmentsComponent = true;
            };

            scope.generalModel.HandleResultException = function (exception) {
                var message = exception;

                if (!scope.generalModel.IsUndefinedEmptyOrNull(exception.Message)) {
                    message = exception.Message;
                }

                GeneralModel.ShowToastWarning(message);
            };

        }

        return GeneralFunctions;
    }]);

    myApp.filter("trust", ['$sce', function ($sce) {
        return function (htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        };
    }]);

    myApp.filter('Translations', function () {
        return function (code) {
            var text = Helpers.Translations[code];

            if (!text) {
                text = code;
            }

            return text;
        };
    });

    myApp.filter('SwebTranslation', function (GeneralModel, $filter) {
        return function (code, replaceObject) {
            var localWebTranslations;
            var localSharedTranslations;

            if (typeof replaceObject === "undefined") {
                replaceObject = {};
            }

            try {
                localWebTranslations = webTranslations;
            } catch (e) {
                if (e instanceof ReferenceError) {
                    localWebTranslations = [];
                }
            }

            try {
                localSharedTranslations = sharedTranslations;
            } catch (e) {
                if (e instanceof ReferenceError) {
                    localSharedTranslations = [];
                }
            }

            function ReplaceDynamicInformation(translation, replaceObject) {
                for (var key in replaceObject) {
                    if (translation.indexOf('{' + key + '}') !== -1) {
                        translation = translation.replace('{' + key + '}', replaceObject[key]);
                    }
                }

                return translation;
            }

            if (!GeneralModel.model.IsUndefinedEmptyOrNull(Helpers.Translations) && !GeneralModel.model.IsUndefinedEmptyOrNull(Helpers.Translations[code])) {

                if (!angular.equals(replaceObject, {})) {
                    return ReplaceDynamicInformation(Helpers.Translations[code], replaceObject);
                }

                return Helpers.Translations[code];
            }

            if (!GeneralModel.model.IsUndefinedEmptyOrNull($filter('filter')(localWebTranslations.concat(localSharedTranslations), { Code: code }, true)[0])) {
                if (!angular.equals(replaceObject, {})) {
                    return ReplaceDynamicInformation($filter('filter')(localWebTranslations.concat(localSharedTranslations), { Code: code }, true)[0].OriginalText, replaceObject);
                }

                return $filter('filter')(localWebTranslations.concat(localSharedTranslations), { Code: code }, true)[0].OriginalText;
            }

            if (!GeneralModel.model.IsUndefinedEmptyOrNull($filter('filter')(localSharedTranslations, { Code: code }, true)[0])) {
                if (!angular.equals(replaceObject, {})) {
                    return ReplaceDynamicInformation($filter('filter')(localSharedTranslations, { Code: code }, true)[0].OriginalText, replaceObject);
                }

                return $filter('filter')(localSharedTranslations, { Code: code }, true)[0].OriginalText;
            }

            try {
                var myApplicationBasePageTranslation = myApplication.getLanguageObject.selectedLanguage('basePageTexts', myApplication)[Object.keys(myApplication.getLanguageObject.selectedLanguage('basePageTexts', myApplication)).find(key => key.toLowerCase() === code.toLowerCase())];
            }
            catch (_exception) {
                throw code;
            }

            if (!GeneralModel.model.IsUndefinedEmptyOrNull(myApplicationBasePageTranslation)) {
                return myApplicationBasePageTranslation;
            }

            var myApplicationGeneralFunctionsTranslation = myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication)[Object.keys(myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication)).find(key => key.toLowerCase() === code.toLowerCase())];

            if (!GeneralModel.model.IsUndefinedEmptyOrNull(myApplicationGeneralFunctionsTranslation)) {
                return myApplicationGeneralFunctionsTranslation;
            }

            return code;
        };
    });

    myApp.directive('dynamicCtrlnv', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            terminal: true,
            priority: 100000,
            link: function (scope, elem) {
                elem.removeAttr('dynamic-ctrlnv');
                elem.attr('ng-controller', ctrlName);
                $compile(elem)(scope);
            }
        };
    }]);

    myApp.config(['$translateProvider', function ($translateProvider) {
        $translateProvider.translations(myApplication.language, {}).preferredLanguage(myApplication.language);
    }]);

    myApp.run(function ($window, $rootScope, GeneralModel, Settings) {
        $rootScope.generalModel = GeneralModel.model;

        $window.addEventListener("offline", function () {
            if ($rootScope.generalModel.IsOnline) {
                $rootScope.$apply(function () {
                    $rootScope.generalModel.IsOnline = false;
                    Settings.IsOnline = false;
                    GeneralModel.ShowToastWarningNoHide((!$rootScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.Offline : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).offline);
                });
            }
        }, false);

        $window.addEventListener("online", function () {
            if (!$rootScope.generalModel.IsOnline) {
                $rootScope.$apply(function () {
                    $rootScope.generalModel.IsOnline = true;
                    Settings.IsOnline = true;
                    GeneralModel.ShowToast(!$rootScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).online);
                });
            }
        }, false);
    });

    myApp.directive('swebAccordion', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            scope: {
                noteDate: '='
            },
            link: function (scope, element, attrs) {

                var listOfBlocks = angular.element(element).find('.SwebAccordionBlock');

                for (var l = 0; l < listOfBlocks.length; l++) {
                    if (angular.element(listOfBlocks[l]).hasClass('SwebAccordionExpanded')) {
                        angular.element(listOfBlocks[l]).find('.SwebAccordionBlockIcon').addClass('glyphicon-chevron-down');
                    }
                    else {
                        angular.element(listOfBlocks[l]).find('.SwebAccordionBlockIcon').addClass('glyphicon-chevron-right');
                    }
                }

                scope.$parent.AccordionExpand = function (event) {
                    if (angular.element(event.currentTarget).parent('.SwebAccordionBlock').hasClass('SwebAccordionExpanded')) {
                        angular.element(event.currentTarget).parent('.SwebAccordionBlock').removeClass('SwebAccordionExpanded');
                        angular.element(event.currentTarget).find('.SwebAccordionBlockIcon').removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-right');
                    }
                    else {
                        angular.element(event.currentTarget).parent('.SwebAccordionBlock').addClass('SwebAccordionExpanded');
                        angular.element(event.currentTarget).find('.SwebAccordionBlockIcon').removeClass('glyphicon-chevron-right').addClass('glyphicon-chevron-down');
                    }
                };
            }
        };
    }]);

    myApp.directive('formatNumber', ["$parse", "$filter", "$timeout", function ($parse, $filter, $timeout) {
        return {
            restrict: 'A',
            scope: {
                formatNumber: '=',
                angularCopyFunction: '&',
                required: "=required"
            },
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators[attrs.name] = function (modelValue) {
                    var formatContent = scope.angularCopyFunction()(angular.element(element).val())
                        .replace(',', '.')
                        .replace(/[^\d.]/g, '')
                        .replace(/(\..*)\./g, '$1');

                    var object = $parse(attrs.ngModel);
                    object.assign(scope, formatContent);
                    var formatNumber = scope.$parent.$eval(attrs.formatNumber);
                    if (typeof formatNumber === 'function') {
                        formatNumber = formatNumber();
                    }

                    var minimum = formatNumber[1];
                    if ((typeof minimum === 'undefined') || ((typeof minimum !== 'undefined')) && (parseFloat(formatContent) !== parseFloat(minimum))) {
                        return true;
                    }
                    else {
                        return false;
                    }
                };

                angular.element('#' + attrs.id).bind('blur', function () {
                    var content = angular.element(this).val();
                    var object = $parse(attrs.ngModel);
                    var formatNumber = scope.$parent.$eval(attrs.formatNumber);
                    if (typeof formatNumber === 'function') {
                        formatNumber = formatNumber();
                    }
                    var number = formatNumber[0];
                    object.assign(scope, parseFloat(content).toFixed(number));
                    angular.element(this).val($filter('number')(parseFloat(content).toFixed(number), number));
                });

                angular.element('#' + attrs.id).bind('focus', function () {
                    var content = $parse(attrs.ngModel)(scope);
                    angular.element(this).val(content);
                });

                angular.element('#' + attrs.id).change(function () {
                    var content = $parse(attrs.ngModel)(scope);
                    angular.element(this).val(content);
                });
            }
        };
    }]);

    myApp.directive('formatNumberWithDecimals', function ($filter, $locale) {
        var decimalSep = $locale.NUMBER_FORMATS.DECIMAL_SEP;
        var toNumberRegex = new RegExp('[^0-9\\' + decimalSep + ']', 'g');

        var filterFunc = function (value, decimalPlaces) {
            if (typeof decimalPlaces === 'undefined') {
                decimalPlaces = 3;
            }

            return $filter('number')(value, decimalPlaces);
        };

        function getCaretPosition(input) {
            if (!input) {
                return 0;
            }

            if (input.selectionStart !== undefined) {
                return input.selectionStart;
            } else if (document.selection) {
                input.focus();
                var selection = document.selection.createRange();
                selection.moveStart('character', input.value ? -input.value.length : 0);

                return selection.text.length;
            }

            return 0;
        }

        function setCaretPosition(input, oldPos, newPos) {
            if (!input) {
                return 0;
            }

            if ((input.offsetWidth === 0) || (input.offsetHeight === 0)) {
                return;
            }

            if (oldPos === newPos) {
                return;
            }

            if (input.setSelectionRange) {
                input.setSelectionRange(newPos, newPos);
            }
            else if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', newPos);
                range.moveStart('character', newPos);
                range.select();
            }
        }

        function toNumber(numberStr) {
            return parseFloat(numberStr.replace(toNumberRegex, ''), 10);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function postLink(scope, elem, attrs, modelCtrl) {
                modelCtrl.$formatters.push(filterFunc);
                modelCtrl.$parsers.push(function (newViewValue) {
                    var oldModelValue = modelCtrl.$modelValue;
                    var newModelValue = toNumber(newViewValue);
                    var decimalPlaces = attrs.formatNumberWithDecimals;

                    modelCtrl.$viewValue = filterFunc(newModelValue, decimalPlaces);

                    var oldPos = getCaretPosition(elem[0]);
                    elem.val(modelCtrl.$viewValue);
                    var newPos = oldPos + modelCtrl.$viewValue.length - newViewValue.length;

                    if ((oldModelValue === undefined) || isNaN(oldModelValue)) {
                        newPos -= 3;
                    }

                    setCaretPosition(elem[0], oldPos, newPos);

                    return newModelValue;
                });
            }
        };
    });

    myApp.directive('selectOnClick', ['$window', function ($window) {
        return function (scope, element, attrs) {
            element.bind('click', function () {
                if (!$window.getSelection().toString()) {
                    this.setSelectionRange(0, this.value.length);
                }
            });
        };
    }]);

    myApp.directive('draggableModal', ['$document', function ($document) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var handle = element.find('.ModalHeader');
                var offsetX, offsetY, initialMouseX, initialMouseY;

                handle.bind('mousedown', function ($event) {
                    offsetX = element.prop('offsetLeft');
                    offsetY = element.prop('offsetTop');
                    initialMouseX = $event.clientX;
                    initialMouseY = $event.clientY;

                    $document.bind('mousemove', mousemove);
                    $document.bind('mouseup', mouseup);
                });

                function mousemove($event) {
                    var mouseX = $event.clientX - initialMouseX;
                    var mouseY = $event.clientY - initialMouseY;

                    element.css({
                        left: mouseX + offsetX + 'px',
                        top: mouseY + offsetY + 'px'
                    });
                }

                function mouseup() {
                    $document.unbind('mousemove', mousemove);
                    $document.unbind('mouseup', mouseup);
                }
            }
        }
    }]);
})();
(function () {
    "use strict";
    myApp.factory('SaveFunctions', ["$q", "GeneralModel", "$filter", "$compile", "$parse", "NumberOperations", function ($q, GeneralModel, $filter, $compile, $parse, NumberOperations) {

        function SaveFunctions(scope) {

            scope.generalModel.SavePage = function (model, formName, modelReference, mainObject, useDeprecated) {
                scope.generalModel.FullPageLoading = true;

                var id;
                var grid;
                var editData;
                var secondGrid;
                var invalidFields = false;
                var existsSecondGrid = false;
                model.SecondGridEditData = [];
                model.SaveButtonClicked = true;
                model.CancelSaveProcess = true;
                model.MainObjectPreviousSave = [];

                model.UpdatedData = scope.generalModel.AngularCopy(model[mainObject]);
                model.InsertedData = scope.generalModel.AngularCopy(model[mainObject]);

                if (typeof model.ArrayGridObjects !== 'undefined') {
                    for (var g = 0; g < model.ArrayGridObjects.length; g++) {
                        model[model.ArrayGridObjects[g].ObjectName] = scope.generalModel.AngularCopy(model[mainObject][model.ArrayGridObjects[g].ObjectName]);
                        model[model.ArrayGridObjects[g].GridName + 'ValidState'] = 0;
                    }
                }

                if (!scope.generalModel.IsUndefinedEmptyOrNull(formName)) {
                    for (var i = 0; i < scope.MyForms[formName].$$controls.length; i++) {
                        if (typeof scope.MyForms[formName].$$controls[i].$$attr.validations !== 'undefined') {
                            scope.ValidateField(scope.MyForms[formName].$$controls[i].$$attr.validations, scope.MyForms[formName][scope.MyForms[formName].$$controls[i].$name]);

                            if (scope.MyForms[formName][scope.MyForms[formName].$$controls[i].$name].$invalid) {
                                invalidFields = true;
                            }
                        }
                        else if (scope.MyForms[formName].$$controls[i].$invalid) {
                            invalidFields = true;
                        }

                        if (typeof scope.MyForms[formName].$$controls[i].$$attr.formatNumber !== 'undefined') {
                            var array = scope.MyForms[formName].$$controls[i].$$attr.ngModel.split('.');

                            if ((array.length <= 3) && array.length) {
                                var nameToObject = array[array.length - 1];

                                if (!NumberOperations.CheckIfFloat(model.UpdatedData[nameToObject])) {
                                    if (!scope.generalModel.IsUndefinedEmptyOrNull(model.ElementId)) {
                                        model.UpdatedData[nameToObject] = scope.generalModel.AngularCopy(model.UpdatedData[nameToObject]).replace(',', '.').replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
                                    }
                                    else {
                                        model.InsertedData[nameToObject] = scope.generalModel.AngularCopy(model.InsertedData[nameToObject]).replace(',', '.').replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1');
                                    }
                                }
                            }
                        }
                    }
                }

                if (invalidFields && !scope.generalModel.IsSettingStandards) {
                    scope.generalModel.FullPageLoading = false;
                    GeneralModel.ShowToastWarning(!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.InvalidFields : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).invalidFields);
                    return;
                }

                if (typeof model.ArrayGridObjects !== 'undefined') {
                    for (var p = 0; p < model.ArrayGridObjects.length; p++) {
                        if (model.ArrayGridObjects[p].SecondGrid !== '') {
                            existsSecondGrid = true;
                            grid = angular.element("#" + model.ArrayGridObjects[p].GridName).dxDataGrid('instance');

                            if (typeof grid !== 'undefined') {
                                var dataSource = grid.getDataSource();

                                if (dataSource !== null) {
                                    for (var v = 0; v < dataSource._store._array.length; v++) {
                                        id = scope.generalModel.GetMainId(model.ArrayGridObjects[p].MainId, dataSource._store._array[v]);

                                        if (id === scope.generalModel.GuidEmpty) {
                                            editData = scope.generalModel.GetEditDataClean(grid);
                                            var secondGridElementName = model.ArrayGridObjects[p].SecondGrid.substr(4);

                                            for (var a = 0; a < editData.length; a++) {
                                                if (editData[a].key.__KEY__ === dataSource._store._array[v].__KEY__) {
                                                    scope.generalModel.CreateObjectsSecondGrid(editData[a].key[secondGridElementName], model, p, dataSource._store._array[v], model.ArrayGridObjects[p].ObjectName);
                                                    break;
                                                }
                                            }
                                        }
                                        else {
                                            secondGrid = angular.element('#' + model.ArrayGridObjects[p].SecondGrid + id).dxDataGrid('instance');

                                            if (typeof secondGrid !== 'undefined') {
                                                editData = scope.generalModel.GetEditDataClean(secondGrid);

                                                if (editData.length) {
                                                    model[model.ArrayGridObjects[p].SecondGrid + 'ValidState'][id] = 0;
                                                    scope.generalModel.CreateObjectsSecondGrid(editData, model, p, dataSource._store._array[v], model.ArrayGridObjects[p].ObjectName);
                                                }
                                                secondGrid.saveEditData();

                                                if ((typeof model[model.ArrayGridObjects[p].SecondGrid + 'ValidState'][id] !== 'undefined') && (model[model.ArrayGridObjects[p].SecondGrid + 'ValidState'][id] !== 0) && (!scope.generalModel.IsSettingStandards)) {
                                                    GeneralModel.ShowToastWarning(!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.InvalidFieldsOnTable : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).invalidFieldsOnTable + model.ArrayGridObjects[p].DisplayName + ".");
                                                    scope.generalModel.FullPageLoading = false;

                                                    return;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    for (var l = 0; l < model.ArrayGridObjects.length; l++) {
                        if (scope.generalModel.IsUndefinedEmptyOrNull(model.ArrayGridObjects[l].ParentArray)) {
                            grid = angular.element("#" + model.ArrayGridObjects[l].GridName + "").dxDataGrid('instance');

                            if (typeof grid !== 'undefined') {
                                editData = scope.generalModel.GetEditDataClean(grid);
                                scope.generalModel.CreateObjectsParentGrid(editData, l, model, model.ArrayGridObjects[l].MainId, model.ArrayGridObjects[l].ObjectName);
                            }
                        }
                    }

                    for (var listGrids = 0; listGrids < model.ArrayGridObjects.length; listGrids++) {
                        grid = angular.element("#" + model.ArrayGridObjects[listGrids].GridName + "").dxDataGrid('instance');

                        if (typeof grid !== 'undefined') {
                            grid.saveEditData();
                        }
                    }

                    if (!scope.generalModel.IsSettingStandards) {
                        for (var m = 0; m < model.ArrayGridObjects.length; m++) {
                            if (model[model.ArrayGridObjects[m].GridName + 'ValidState'] !== 0) {
                                GeneralModel.ShowToastWarning(!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.InvalidFieldsTable : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).invalidFieldsTable + model.ArrayGridObjects[m].DisplayName + ".");
                                scope.generalModel.FullPageLoading = false;

                                return;
                            }
                        }
                    }
                }

                if (!scope.generalModel.IsUndefinedEmptyOrNull(formName)) {
                    for (var j = 0; j < scope.MyForms[formName].$$controls.length; j++) {
                        if (typeof scope.MyForms[formName].$$controls !== 'undefined') {
                            var newArray = scope.MyForms[formName].$$controls[j].$$attr.ngModel.split('.');
                            if ((newArray.length <= 3) && newArray.length) {
                                var objectName = newArray[newArray.length - 1];
                                var elementToAdd = $parse(scope.MyForms[formName].$$controls[j].$$attr.ngModel)(scope);

                                if (typeof elementToAdd !== 'undefined') {
                                    if (!scope.generalModel.IsUndefinedEmptyOrNull(model.ElementId)) {
                                        model.UpdatedData[objectName] = elementToAdd;
                                    }
                                    else {
                                        model.InsertedData[objectName] = elementToAdd;
                                    }
                                }
                            }
                        }
                    }
                }

                scope.generalModel.ClearExtraConnectionsWithoutGrid(model);

                if ((typeof scope.generalModel.CheckIfThereAreEditedContacts !== 'undefined') && (scope.generalModel.CheckIfThereAreEditedContacts()) && (!scope.generalModel.IsSettingStandards)) {
                    var object = "UpdatedData";

                    if (!scope.generalModel.IsUndefinedEmptyOrNull(model.ElementId)) {
                        object = "InsertedData";
                    }

                    $q.when(scope.generalModel.SavePageWithContacts(model[object])).then(function (result) {
                        if (result !== '200') {
                            GeneralModel.ShowToastWarning(!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.InvalidFieldsOnContacts : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).invalidFieldsOnContacts);
                            scope.generalModel.FullPageLoading = false;

                            return;
                        }

                        scope.generalModel.FinalProcessSavePage(model, modelReference, existsSecondGrid, mainObject, useDeprecated);
                    });
                }
                else {
                    scope.generalModel.FinalProcessSavePage(model, modelReference, existsSecondGrid, mainObject, useDeprecated);
                }
            };

            scope.generalModel.FinalProcessSavePage = function (model, modelReference, existsSecondGrid, mainObject, useDeprecated) {
                if (scope.generalModel.PhotographyList.length && (scope.generalModel.PhotographyList !== '')) {
                    for (var a = 0; a < scope.generalModel.PhotographyList.length; a++) {
                        $q.when(scope.generalModel.ConvertImages(scope.generalModel.PhotographyList[a].Photography, a, '')).then(function (result) {
                            if (scope.generalModel.PhotographyList[result.Key].Id === 'Main') {
                                model.InsertedData.Photography = result.Photography;
                                model.UpdatedData.Photography = result.Photography;
                            }
                            else {
                                scope.generalModel.SetObjectValueByString(model.InsertedData, scope.generalModel.PhotographyList[result.Key].Id, result.Photography);
                                scope.generalModel.SetObjectValueByString(model.UpdatedData, scope.generalModel.PhotographyList[result.Key].Id, result.Photography);
                            }

                            if (result.Key + 1 === scope.generalModel.PhotographyList.length) {
                                scope.generalModel.ProcessSavePage(model, modelReference, existsSecondGrid, mainObject, useDeprecated);
                            }
                        });
                    }
                }
                else if (!scope.generalModel.IsUndefinedEmptyOrNull(model.InsertedData.Photography) && (model.InsertedData.Photography.indexOf("data:image/gif;base64,") >= 0)) {
                    model.InsertedData.Photography = model.InsertedData.Photography.replace('data:image/gif;base64,', '');
                    model.UpdatedData.Photography = model.UpdatedData.Photography.replace('data:image/gif;base64,', '');
                    scope.generalModel.ProcessSavePage(model, modelReference, existsSecondGrid, mainObject, useDeprecated);
                }
                else {
                    scope.generalModel.ProcessSavePage(model, modelReference, existsSecondGrid, mainObject, useDeprecated);
                }
            };

            scope.generalModel.ClearExtraConnectionsWithoutGrid = function (model) {
                for (var propertyName in model.InsertedData) {
                    var extraConnections = $filter('filter')(scope.generalModel.ExtraConnections, { ObjectPathName: propertyName }, true);

                    if (extraConnections.length) {
                        delete model.InsertedData[propertyName];
                    }
                }

                for (var propertyNameUpdate in model.UpdatedData) {
                    var extraConnectionsUpdate = $filter('filter')(scope.generalModel.ExtraConnections, { ObjectPathName: propertyNameUpdate }, true);

                    if (extraConnectionsUpdate.length) {
                        delete model.UpdatedData[propertyNameUpdate];
                    }
                }
            };

            scope.generalModel.ProcessSavePage = function (model, modelReference, existsSecondGrid, mainObject, useDeprecated) {
                scope.generalModel.ClearDeletedEditedObjects();
                scope.generalModel.FullPageLoading = true;

                if (scope.generalModel.IsSettingStandards) {
                    $q.when(GeneralModel.SetStandardValues(model, model.MainController)).then(function () {
                        model.SaveButtonClicked = false;
                        scope.generalModel.SuccessSave();
                    }).catch(function (exception) {
                        scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                        scope.generalModel.SidebarOptions['State']['CancelOption'] = true;

                        GeneralModel.ShowToastWarning(exception.Message);

                        if (existsSecondGrid) {
                            scope.generalModel.ResetSecondGridData(model);
                        }

                        if (exception.Code === '409') {
                            scope.generalModel.ConcurrencyError = true;
                            scope.generalModel.ValidateServerData(model, '', mainObject);
                        }

                        scope.generalModel.FullPageLoading = false;
                    });
                }
                else {
                    if (!scope.generalModel.IsUndefinedEmptyOrNull(model.ElementId)) {
                        if ((typeof useDeprecated !== "undefined") && (!useDeprecated)) {
                            $q.when(GeneralModel.Put(model, modelReference)).then(function () {
                                model.ServerData = {};
                                scope.generalModel.ConcurrencyError = false;
                                angular.element('#MainObjectServerConcurrency').html('');
                                scope.generalModel.PhotographyList = [];
                                scope.generalModel.SuccessSave();
                            }).catch(function (exception) {
                                scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                scope.generalModel.SidebarOptions['State']['CancelOption'] = true;
                                GeneralModel.ShowToastWarning(exception.Message);

                                if (existsSecondGrid) {
                                    scope.generalModel.ResetSecondGridData(model);
                                }
                                if (exception.Code === '409') {
                                    scope.generalModel.ConcurrencyError = true;
                                    scope.generalModel.ValidateServerData(model, '', mainObject);
                                }

                                scope.generalModel.FullPageLoading = false;
                            });
                        }
                        else {
                            $q.when(GeneralModel.PutDeprecatedObject(model, modelReference)).then(function (result) {
                                if (result !== '200') {
                                    scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                    scope.generalModel.SidebarOptions['State']['CancelOption'] = true;
                                    GeneralModel.ShowToastWarning(scope.generalModel.GeneralMessageError);

                                    if (existsSecondGrid) {
                                        scope.generalModel.ResetSecondGridData(model);
                                    }

                                    if (result === '409') {
                                        scope.generalModel.ConcurrencyError = true;
                                        scope.generalModel.ValidateServerData(model, '', mainObject);
                                    }

                                    scope.generalModel.FullPageLoading = false;

                                    return;
                                }

                                model.ServerData = {};
                                scope.generalModel.ConcurrencyError = false;
                                angular.element('#MainObjectServerConcurrency').html('');
                                scope.generalModel.PhotographyList = [];
                                scope.generalModel.SuccessSave();
                            }).catch(function () {
                                scope.generalModel.FullPageLoading = false;
                                scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                scope.generalModel.SidebarOptions['State']['CancelOption'] = true;
                                GeneralModel.ShowToastWarning(scope.generalModel.GeneralMessageError);
                            });
                        }
                    }
                    else {
                        if ((typeof useDeprecated !== "undefined") && (!useDeprecated)) {
                            var sucess = false;
                            var showMessage = true;

                            $q.when(GeneralModel.Post(model, modelReference)).then(function (result) {
                                sucess = true;

                                if (typeof model.ElementId !== "undefined") {
                                    model.ElementId = result;
                                }
                            }).catch(function (exception) {
                                if (exception.Code === '417') {
                                    GeneralModel.ShowToastAlert(exception.Message);
                                    showMessage = false;
                                    sucess = true;
                                    return;
                                }

                                scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                scope.generalModel.SidebarOptions['State']['CancelOption'] = true;

                                GeneralModel.ShowToastWarning(exception.Message);

                                if (existsSecondGrid) {
                                    scope.generalModel.ResetSecondGridData(model);
                                }

                                if (exception.Code === '409') {
                                    scope.generalModel.ConcurrencyError = true;
                                    scope.generalModel.ValidateServerData(model, '', mainObject);
                                }

                                scope.generalModel.FullPageLoading = false;
                            }).finally(function () {
                                if (!sucess) {
                                    return;
                                }

                                model.ServerData = {};

                                scope.generalModel.ConcurrencyError = false;
                                angular.element('#MainObjectServerConcurrency').html('');
                                scope.generalModel.PhotographyList = [];
                                scope.generalModel.SuccessSave(showMessage);
                                scope.generalModel.SidebarOptions['State']['NewOption'] = true;
                                scope.generalModel.SidebarOptions['State']['ExportOption'] = true;
                            });
                        }
                        else {
                            $q.when(GeneralModel.PostDeprecatedObject(model, modelReference)).then(function (result) {
                                var showMessage = true;
                                if ((result !== '200') && (result !== '417')) {
                                    scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                    scope.generalModel.SidebarOptions['State']['CancelOption'] = true;
                                    GeneralModel.ShowToastWarning(scope.generalModel.GeneralMessageError);

                                    if (existsSecondGrid) {
                                        scope.generalModel.ResetSecondGridData(model);
                                    }

                                    if (result === '409') {
                                        scope.generalModel.ConcurrencyError = true;
                                        scope.generalModel.ValidateServerData(model, '', mainObject);
                                    }

                                    scope.generalModel.FullPageLoading = false;

                                    return;
                                }

                                if (result === '417') {
                                    GeneralModel.ShowToastAlert(scope.generalModel.GeneralMessageError);
                                    showMessage = false;
                                }

                                model.ServerData = {};
                                scope.generalModel.ConcurrencyError = false;
                                angular.element('#MainObjectServerConcurrency').html('');
                                scope.generalModel.PhotographyList = [];
                                scope.generalModel.SuccessSave(showMessage);
                                scope.generalModel.SidebarOptions['State']['NewOption'] = true;
                                scope.generalModel.SidebarOptions['State']['ExportOption'] = true;
                            }).catch(function () {
                                scope.generalModel.FullPageLoading = false;
                                scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                scope.generalModel.SidebarOptions['State']['CancelOption'] = true;
                                GeneralModel.ShowToastWarning(scope.generalModel.GeneralMessageError);
                            });
                        }
                    }
                }
            };

            scope.generalModel.CreateObjects = function (devExtremeObject, model) {
                for (var i = 0; i < devExtremeObject.length; i++) {
                    var name;
                    var objectOldData;
                    var extraConnection;
                    var object = devExtremeObject[i];

                    if (object.type === 'update') {
                        var keys = [];
                        var oldData = null;

                        for (var k in object.data) {
                            keys.push(k);
                        }

                        objectOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(object);
                        oldData = scope.generalModel.AngularCopy(objectOldData);

                        for (var y = 0; y < keys.length; y++) {
                            var keyName = keys[y];
                            oldData[keyName] = object.data[keyName];
                        }

                        for (var x = 0; x < scope.generalModel.ExtraConnections.length; x++) {
                            extraConnection = scope.generalModel.ExtraConnections[x];

                            if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key] = [];
                            }

                            name = extraConnection.BasicName;

                            if (typeof name === 'undefined') {
                                name = extraConnection.ObjectPathName;
                            }

                            if (typeof scope.generalModel.GetObjectByString(oldData, name) !== 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(oldData, name));

                                if (!Array.isArray(scope.generalModel.GetObjectByString(oldData, name))) {
                                    scope.generalModel.SetObjectValueByString(oldData, name, null);
                                }
                                else {
                                    for (var f = 0; f < oldData[name].length; f++) {
                                        for (var key in oldData[name][f]) {
                                            if (typeof oldData[name][f][key] === 'object') {
                                                scope.generalModel.SetObjectValueByString(oldData, name + '[' + f + '].' + key, null);
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        model.UpdatedData.push(oldData);
                    } else if (object.type === 'remove') {
                        objectOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(object);

                        var oldDataForDelete = scope.generalModel.AngularCopy(objectOldData);

                        for (var extraDelete = 0; extraDelete < scope.generalModel.ExtraConnections.length; extraDelete++) {
                            extraConnection = scope.generalModel.ExtraConnections[extraDelete];

                            if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key] = [];
                            }

                            name = extraConnection.BasicName;

                            if (typeof name === 'undefined') {
                                name = extraConnection.ObjectPathName;
                            }

                            if (typeof scope.generalModel.GetObjectByString(oldDataForDelete, name) !== 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(oldDataForDelete, name));

                                if (!Array.isArray(scope.generalModel.GetObjectByString(oldDataForDelete, name))) {
                                    scope.generalModel.SetObjectValueByString(oldDataForDelete, name, null);
                                }
                                else {
                                    for (var clearExtraDelete = 0; clearExtraDelete < oldDataForDelete[name].length; clearExtraDelete++) {
                                        for (var keyForDelete in oldDataForDelete[name][clearExtraDelete]) {
                                            if (typeof oldDataForDelete[name][clearExtraDelete][keyForDelete] === 'object') {
                                                scope.generalModel.SetObjectValueByString(oldDataForDelete, name + '[' + clearExtraDelete + '].' + keyForDelete, null);
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        model.DeletedData.push(oldDataForDelete);
                        model.DeletedData[model.DeletedData.length - 1].Delete = true;
                    } else if (object.type === 'insert') {
                        var newData = scope.generalModel.AngularCopy(object.data);

                        for (var z = 0; z < scope.generalModel.ExtraConnections.length; z++) {
                            extraConnection = scope.generalModel.ExtraConnections[z];

                            if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key] = [];
                            }

                            name = extraConnection.BasicName;

                            if (typeof name === 'undefined') {
                                name = extraConnection.ObjectPathName;
                            }

                            if (typeof scope.generalModel.GetObjectByString(newData, name) !== 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(newData, name));

                                if (!Array.isArray(scope.generalModel.GetObjectByString(newData, name))) {
                                    scope.generalModel.SetObjectValueByString(newData, name, null);
                                }
                                else {
                                    for (var q = 0; q < newData[name].length; q++) {
                                        for (var keyNewData in newData[name][q]) {
                                            if (typeof newData[name][q][keyNewData] === 'object') {
                                                scope.generalModel.SetObjectValueByString(newData, name + '[' + q + '].' + keyNewData, null);
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        model.InsertedData.push(newData);
                    }
                }
            };

            scope.generalModel.CreateObjectsParentGrid = function (devExtremeObject, arrayGridKey, model, mainId, parent) {
                var name;
                var element;
                var newData;
                var foundInner;
                var foundInsertion;
                var extraConnection;
                var objectsByString;
                var addedElements = [];
                var elementToInsert = [];
                var secondGridEditedData = [];
                var secondGridMainId = model.ArrayGridObjects[arrayGridKey].SecondGridMainId;
                var objectName = model.ArrayGridObjects[arrayGridKey].ObjectName + 'Element';
                var secondGridObjectName = model.ArrayGridObjects[arrayGridKey].SecondGrid.substr(4);

                if (parent !== '') {
                    model.InsertedData[parent] = [];
                }

                for (var i = 0; i < devExtremeObject.length; i++) {
                    var object = devExtremeObject[i];
                    var objectOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(object);

                    if (object.type === 'update') {
                        var keys = [];
                        var oldData = null;

                        for (var k in object.data) {
                            keys.push(k);
                        }

                        oldData = scope.generalModel.AngularCopy(objectOldData);

                        for (var y = 0; y < keys.length; y++) {
                            var keyName = keys[y];

                            oldData[keyName] = object.data[keyName];
                        }

                        for (var x = 0; x < scope.generalModel.ExtraConnections.length; x++) {
                            extraConnection = scope.generalModel.ExtraConnections[x];

                            if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key] = [];
                            }

                            name = extraConnection.BasicName;

                            if (typeof name === 'undefined') {
                                name = extraConnection.ObjectPathName;
                            }

                            if (typeof scope.generalModel.GetObjectByString(oldData, name) === 'undefined') {
                                continue;
                            }

                            model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(oldData, name));

                            if (!Array.isArray(oldData[name])) {
                                scope.generalModel.SetObjectValueByString(oldData, name, null);

                                continue;
                            }

                            for (var f = 0; f < oldData[name].length; f++) {
                                var itemOldData = oldData[name][f];

                                for (var key in itemOldData) {
                                    if (typeof itemOldData[key] === 'object') {
                                        scope.generalModel.SetObjectValueByString(oldData, name + '[' + f + '].' + key, null);
                                    }
                                }
                            }
                        }

                        if (typeof oldData.__KEY__ === 'undefined') {
                            if (parent === '') {
                                model.UpdatedData.push(oldData);
                            }
                            else {
                                foundInner = false;
                                objectsByString = scope.generalModel.GetObjectByString(model.UpdatedData, parent);

                                for (var u = 0; u < objectsByString.length; u++) {
                                    var itemObjectsByString = objectsByString[u];

                                    if (itemObjectsByString[mainId] === null) {
                                        if (angular.equals(objectOldData, itemObjectsByString)) {
                                            foundInner = true;
                                            (objectsByString)[u] = scope.generalModel.AngularCopy(oldData);
                                            break;
                                        }
                                    } else if (itemObjectsByString[mainId] === objectOldData[mainId]) {
                                        foundInner = true;
                                        (objectsByString)[u] = scope.generalModel.AngularCopy(oldData);
                                        break;
                                    }
                                }

                                if (!foundInner) {
                                    (objectsByString).push(oldData);
                                }
                            }

                            addedElements.push(objectOldData[mainId]);
                        }
                        else {
                            var isInsertedData = false;

                            for (var b = 0; b < model.InsertedData.length; b++) {
                                var itemModelInsertedData = model.InsertedData[b];

                                if (itemModelInsertedData.__KEY__ === oldData.__KEY__) {
                                    isInsertedData = true;
                                    model.InsertedData[b] = scope.generalModel.AngularCopy(oldData);
                                    addedElements.push(objectOldData[mainId]);
                                }
                            }

                            if (!isInsertedData) {
                                if (parent === '') {
                                    model.InsertedData.push(oldData);
                                }
                                else {
                                    (scope.generalModel.GetObjectByString(model.InsertedData, parent)).push(oldData);
                                }

                                addedElements.push(objectOldData.__KEY__);
                            }
                        }
                    }
                    else if (object.type === 'remove') {
                        if (parent === '') {
                            model.DeletedData.push(objectOldData);
                            model.DeletedData[model.DeletedData.length - 1].Delete = true;
                            addedElements.push(objectOldData[mainId]);
                        }
                        else {
                            objectsByString = scope.generalModel.GetObjectByString(model.UpdatedData, parent);

                            for (var o = objectsByString.length - 1; o >= 0; o--) {
                                var itemObjectByString = objectsByString[o];

                                if (itemObjectByString[mainId] === objectOldData[mainId]) {
                                    if (scope.generalModel.IsSettingStandards && angular.equals(objectOldData, itemObjectByString)) {
                                        model.UpdatedData[parent].splice(o, 1);
                                    } else {
                                        (objectsByString)[o].Delete = true;
                                    }
                                }
                            }
                        }
                    }
                    else if (devExtremeObject[i].type === 'insert') {
                        if ((parent !== '') && !scope.generalModel.IsUndefinedEmptyOrNull(model.ElementId)) {
                            if (!$filter('filter')(scope.generalModel.DeletedElements, { Id: devExtremeObject[i].data[mainId] }, true).length) {
                                newData = scope.generalModel.AngularCopy(devExtremeObject[i].data);

                                for (var z = 0; z < scope.generalModel.ExtraConnections.length; z++) {
                                    extraConnection = scope.generalModel.ExtraConnections[z];

                                    if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                        model.MainObjectPreviousSave[extraConnection.Key] = [];
                                    }

                                    name = extraConnection.BasicName;

                                    if (typeof name === 'undefined') {
                                        name = extraConnection.ObjectPathName;
                                    }

                                    if (typeof scope.generalModel.GetObjectByString(newData, name) !== 'undefined') {
                                        model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(newData, name));

                                        if (Array.isArray(newData[name])) {
                                            for (var t = 0; t < newData[name].length; t++) {
                                                var itemNewData = newData[name][t];

                                                for (var keyNewDataInsert in itemNewData) {
                                                    if (typeof itemNewData[keyNewDataInsert] === 'object') {
                                                        scope.generalModel.SetObjectValueByString(newData, name + '[' + t + '].' + keyNewDataInsert, null);
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            scope.generalModel.SetObjectValueByString(newData, name, null);
                                        }
                                    }
                                }

                                objectsByString = scope.generalModel.GetObjectByString(model.UpdatedData, parent);
                                (objectsByString).push(newData);
                                addedElements.push(newData.__KEY__);
                            }
                        }
                        else {
                            newData = scope.generalModel.AngularCopy(object.data);

                            for (var h = 0; h < scope.generalModel.ExtraConnections.length; h++) {
                                extraConnection = scope.generalModel.ExtraConnections[h];

                                if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                    model.MainObjectPreviousSave[extraConnection.Key] = [];
                                }

                                name = extraConnection.BasicName;

                                if (typeof name === 'undefined') {
                                    name = extraConnection.ObjectPathName;
                                }

                                if (typeof scope.generalModel.GetObjectByString(newData, name) !== 'undefined') {
                                    model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(newData, name));
                                    scope.generalModel.SetObjectValueByString(newData, name, null);
                                }
                            }
                            if (parent === '') {
                                model.InsertedData.push(newData);
                            }
                            else {
                                (scope.generalModel.GetObjectByString(model.InsertedData, parent)).push(newData);
                            }

                            addedElements.push(newData.__KEY__);
                        }
                    }
                }

                for (var parentObject = 0; parentObject < model[objectName].length; parentObject++) {
                    var objectWasAdded = false;

                    for (var added = 0; added < addedElements.length; added++) {
                        if ((addedElements[added] === model[objectName][parentObject][mainId]) || (addedElements[added] === model[objectName][parentObject].__KEY__)) {
                            objectWasAdded = true;
                            secondGridEditedData = [];

                            for (var editedChild = 0; editedChild < model.SecondGridEditData.length; editedChild++) {
                                var itemModelSecondGridEditData = model.SecondGridEditData[editedChild];

                                for (var secondGridElement = 0; secondGridElement < itemModelSecondGridEditData.length; secondGridElement++) {
                                    var itemSecondGridElementModelSecondGridEditData = itemModelSecondGridEditData[secondGridElement];

                                    if (itemSecondGridElementModelSecondGridEditData[mainId] === addedElements[added]) {
                                        secondGridEditedData.push(scope.generalModel.AngularCopy(itemSecondGridElementModelSecondGridEditData));
                                    }
                                }
                            }

                            if (secondGridEditedData.length) {
                                if (addedElements[added] === model[objectName][parentObject][mainId]) {
                                    if (parent !== '') {
                                        objectsByString = scope.generalModel.GetObjectByString(model.UpdatedData, parent);

                                        for (var updated = 0; updated < objectsByString.length; updated++) {
                                            for (var secondGridParent = 0; secondGridParent < secondGridEditedData.length; secondGridParent++) {
                                                if (secondGridEditedData[secondGridParent][mainId] === (objectsByString)[updated][mainId]) {
                                                    if ((secondGridEditedData[secondGridParent].hasOwnProperty('__KEY__')) && !$filter('filter')((objectsByString)[updated][secondGridObjectName], { __KEY__: secondGridEditedData[secondGridParent].__KEY__ }, true).length) {
                                                        (objectsByString)[updated][secondGridObjectName].push(secondGridEditedData[secondGridParent]);
                                                    } else {
                                                        for (var secondGridUpdated = 0; secondGridUpdated < (objectsByString)[updated][secondGridObjectName].length; secondGridUpdated++) {
                                                            if ((objectsByString)[updated][secondGridObjectName][secondGridUpdated][secondGridMainId] === secondGridEditedData[secondGridParent][secondGridMainId]) {

                                                                if (secondGridEditedData[secondGridParent].hasOwnProperty('ToDelete')) {
                                                                    (objectsByString)[updated][secondGridObjectName][secondGridUpdated].Delete = true;
                                                                }
                                                                else {
                                                                    (objectsByString)[updated][secondGridObjectName][secondGridUpdated] = scope.generalModel.AngularCopy(secondGridEditedData[secondGridParent]);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        for (var updatedNoParent = 0; updatedNoParent < model.UpdatedData.length; updatedNoParent++) {
                                            for (var secondGridNoParent = 0; secondGridNoParent < secondGridEditedData.length; secondGridNoParent++) {
                                                if (secondGridEditedData[secondGridNoParent][mainId] === model.UpdatedData[updatedNoParent][mainId]) {
                                                    if (secondGridEditedData[secondGridNoParent].hasOwnProperty('__KEY__')) {
                                                        model.UpdatedData[updatedNoParent][secondGridObjectName].push(secondGridEditedData[secondGridNoParent]);
                                                    } else {
                                                        for (var secondGridUpdatedNoParent = 0; secondGridUpdatedNoParent < model.UpdatedData[updatedNoParent][secondGridObjectName].length; secondGridUpdatedNoParent++) {
                                                            if (model.UpdatedData[updatedNoParent][secondGridObjectName][secondGridUpdatedNoParent][secondGridMainId] === secondGridEditedData[secondGridNoParent][secondGridMainId]) {

                                                                if (secondGridEditedData[secondGridNoParent].hasOwnProperty('ToDelete')) {
                                                                    model.UpdatedData[updatedNoParent][secondGridObjectName][secondGridUpdatedNoParent].Delete = true;
                                                                }
                                                                else {
                                                                    model.UpdatedData[updatedNoParent][secondGridObjectName][secondGridUpdatedNoParent] = scope.generalModel.AngularCopy(secondGridEditedData[secondGridNoParent]);
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    if (scope.generalModel.IsUndefinedEmptyOrNull(model.ElementId)) {
                                        if (parent !== '') {
                                            for (var inserted = 0; inserted < scope.generalModel.GetObjectByString(model.InsertedData, parent).length; inserted++) {
                                                for (var secondGridEdited = 0; secondGridEdited < secondGridEditedData.length; secondGridEdited++) {
                                                    if (secondGridEditedData[secondGridEdited][mainId] === scope.generalModel.GetObjectByString(model.InsertedData, parent)[inserted].__KEY__) {
                                                        (scope.generalModel.GetObjectByString(model.InsertedData, parent))[inserted][secondGridObjectName].push(secondGridEditedData[secondGridEdited]);
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            for (var insertedOnEdited = 0; insertedOnEdited < model.InsertedData.length; insertedOnEdited++) {
                                                for (var secondGridInserted = 0; secondGridInserted < secondGridEditedData.length; secondGridInserted++) {
                                                    if (secondGridEditedData[secondGridInserted][mainId] === model.InsertedData[insertedOnEdited].__KEY__) {
                                                        model.InsertedData[insertedOnEdited][secondGridObjectName].push(secondGridEditedData[secondGridInserted]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        if (parent !== '') {
                                            objectsByString = scope.generalModel.GetObjectByString(model.UpdatedData, parent);

                                            for (var updatedOnEditedParent = 0; updatedOnEditedParent < objectsByString.length; updatedOnEditedParent++) {
                                                for (var secondGridEditWithParent = 0; secondGridEditWithParent < secondGridEditedData.length; secondGridEditWithParent++) {
                                                    if (secondGridEditedData[secondGridEditWithParent][mainId] === objectsByString[updatedOnEditedParent].__KEY__) {
                                                        (objectsByString)[updatedOnEditedParent][secondGridObjectName].push(secondGridEditedData[secondGridEditWithParent]);
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            for (var updatedOnEdited = 0; updatedOnEdited < model.UpdatedData.length; updatedOnEdited++) {
                                                for (var secondGridEditWithoutParent = 0; secondGridEditWithoutParent < secondGridEditedData.length; secondGridEditWithoutParent++) {
                                                    if (secondGridEditedData[secondGridEditWithoutParent][mainId] === model.UpdatedData[updatedOnEdited].__KEY__) {
                                                        model.UpdatedData[updatedOnEdited][secondGridObjectName].push(secondGridEditedData[secondGridEditWithoutParent]);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (!objectWasAdded) {
                        if (model[objectName][parentObject].hasOwnProperty('__KEY__')) {
                            element = scope.generalModel.AngularCopy(model[objectName][parentObject]);

                            for (var editedChildAdded = 0; editedChildAdded < model.SecondGridEditData.length; editedChildAdded++) {
                                for (var secondGridElementAdded = 0; secondGridElementAdded < model.SecondGridEditData[editedChildAdded].length; secondGridElementAdded++) {
                                    element[secondGridObjectName].push(scope.generalModel.AngularCopy(model.SecondGridEditData[editedChildAdded][secondGridElementAdded]));
                                }
                            }
                            for (var connectionsAdded = 0; connectionsAdded < scope.generalModel.ExtraConnections.length; connectionsAdded++) {
                                if (typeof model.MainObjectPreviousSave[scope.generalModel.ExtraConnections[connectionsAdded].Key] === 'undefined') {
                                    model.MainObjectPreviousSave[scope.generalModel.ExtraConnections[connectionsAdded].Key] = [];
                                }

                                name = scope.generalModel.ExtraConnections[connectionsAdded].BasicName;

                                if (typeof name === 'undefined') {
                                    name = scope.generalModel.ExtraConnections[connectionsAdded].ObjectPathName;
                                }

                                if (typeof scope.generalModel.GetObjectByString(element, name) !== 'undefined') {
                                    model.MainObjectPreviousSave[scope.generalModel.ExtraConnections[connectionsAdded].Key].push(scope.generalModel.GetObjectByString(element, name));

                                    if (Array.isArray(element[name])) {
                                        for (var currentConnection = 0; currentConnection < element[name].length; currentConnection++) {
                                            for (var keyInConnection in element[name][currentConnection]) {
                                                if (typeof element[name][currentConnection][keyInConnection] === 'object') {
                                                    scope.generalModel.SetObjectValueByString(element, name + '[' + currentConnection + '].' + keyInConnection, null);
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        scope.generalModel.SetObjectValueByString(element, name, null);
                                    }
                                }
                            }

                            if ((parent !== '') && (typeof model.ElementId !== 'undefined')) {
                                foundInsertion = false;
                                objectsByString = scope.generalModel.GetObjectByString(model.UpdatedData, parent);

                                for (var objectWithParent = 0; objectWithParent < objectsByString.length; objectWithParent++) {
                                    if (objectsByString[objectWithParent][mainId] === element[mainId]) {
                                        foundInsertion = true;
                                        (objectsByString)[objectWithParent] = scope.generalModel.AngularCopy(element);

                                        break;
                                    }
                                }

                                if (!foundInsertion) {
                                    (objectsByString).push(element);
                                }
                            }

                            if (parent === '') {
                                model.InsertedData.push(element);
                            }
                            else {
                                foundInsertion = false;

                                for (var objectWithParentInserted = 0; objectWithParentInserted < scope.generalModel.GetObjectByString(model.InsertedData, parent).length; objectWithParentInserted++) {
                                    if (scope.generalModel.GetObjectByString(model.InsertedData, parent)[objectWithParentInserted][mainId] === element[mainId]) {
                                        foundInsertion = true;
                                        (scope.generalModel.GetObjectByString(model.InsertedData, parent))[objectWithParentInserted] = scope.generalModel.AngularCopy(element);

                                        break;
                                    }
                                }

                                if (!foundInsertion) {
                                    (scope.generalModel.GetObjectByString(model.InsertedData, parent)).push(element);
                                }
                            }
                        }
                        else {
                            for (var editedChildNoKey = 0; editedChildNoKey < model.SecondGridEditData.length; editedChildNoKey++) {
                                elementToInsert = [];
                                element = scope.generalModel.AngularCopy(model[objectName][parentObject]);

                                if (model.SecondGridEditData[editedChildNoKey].length && (model.SecondGridEditData[editedChildNoKey][0][mainId] === model[objectName][parentObject][mainId])) {
                                    for (var secondGridElementNoKey = 0; secondGridElementNoKey < model.SecondGridEditData[editedChildNoKey].length; secondGridElementNoKey++) {
                                        if (model.SecondGridEditData[editedChildNoKey][secondGridElementNoKey].hasOwnProperty(secondGridMainId)) {
                                            for (var originalSecondGridElement = 0; originalSecondGridElement < element[secondGridObjectName].length; originalSecondGridElement++) {
                                                if (element[secondGridObjectName][originalSecondGridElement][secondGridMainId] === model.SecondGridEditData[editedChildNoKey][secondGridElementNoKey][secondGridMainId]) {
                                                    if (model.SecondGridEditData[editedChildNoKey][secondGridElementNoKey].hasOwnProperty('ToDelete')) {
                                                        element[secondGridObjectName][originalSecondGridElement].Delete = true;
                                                    }
                                                    else {
                                                        element[secondGridObjectName][originalSecondGridElement] = scope.generalModel.AngularCopy(model.SecondGridEditData[editedChildNoKey][secondGridElementNoKey]);
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            if (model.SecondGridEditData[editedChildNoKey][secondGridElementNoKey][mainId] === element[mainId]) {
                                                elementToInsert.push(scope.generalModel.AngularCopy(model.SecondGridEditData[editedChildNoKey][secondGridElementNoKey]));
                                            }
                                        }
                                    }

                                    for (var insertInUpdate = 0; insertInUpdate < elementToInsert.length; insertInUpdate++) {
                                        element[secondGridObjectName].push(scope.generalModel.AngularCopy(elementToInsert[insertInUpdate]));
                                    }

                                    for (var connectionNoKey = 0; connectionNoKey < scope.generalModel.ExtraConnections.length; connectionNoKey++) {
                                        if (typeof model.MainObjectPreviousSave[scope.generalModel.ExtraConnections[connectionNoKey].Key] === 'undefined') {
                                            model.MainObjectPreviousSave[scope.generalModel.ExtraConnections[connectionNoKey].Key] = [];
                                        }

                                        name = scope.generalModel.ExtraConnections[connectionNoKey].BasicName;

                                        if (typeof name === 'undefined') {
                                            name = scope.generalModel.ExtraConnections[connectionNoKey].ObjectPathName;
                                        }

                                        if (typeof scope.generalModel.GetObjectByString(element, name) !== 'undefined') {
                                            model.MainObjectPreviousSave[scope.generalModel.ExtraConnections[connectionNoKey].Key].push(scope.generalModel.GetObjectByString(element, name));

                                            if (Array.isArray(element[name])) {
                                                for (var connectionSecondGrid = 0; connectionSecondGrid < element[name].length; connectionSecondGrid++) {
                                                    for (var keyConnectionSecondGrid in element[name][connectionSecondGrid]) {
                                                        if (typeof element[name][connectionSecondGrid][keyConnectionSecondGrid] === 'object') {
                                                            scope.generalModel.SetObjectValueByString(element, name + '[' + connectionSecondGrid + '].' + keyConnectionSecondGrid, null);
                                                        }
                                                    }
                                                }
                                            }
                                            else {
                                                scope.generalModel.SetObjectValueByString(element, name, null);
                                            }
                                        }
                                    }

                                    if (parent === '') {
                                        model.UpdatedData.push(element);
                                    }
                                    else {
                                        foundInner = false;
                                        objectsByString = scope.generalModel.GetObjectByString(model.UpdatedData, parent);

                                        for (var updateWithParent = 0; updateWithParent < objectsByString.length; updateWithParent++) {
                                            if (objectsByString[updateWithParent][mainId] === element[mainId]) {
                                                foundInner = true;
                                                (objectsByString)[updateWithParent] = scope.generalModel.AngularCopy(element);

                                                break;
                                            }
                                        }

                                        if (!foundInner) {
                                            (objectsByString).push(element);
                                        }
                                    }

                                    break;
                                }
                            }
                        }
                    }
                }
            };

            scope.generalModel.CreateObjectsSecondGrid = function (devExtremeObject, model, key, parentObject, parent) {
                var name;
                var serverData;
                var objectOldData;
                var extraConnection;
                var secondGridChild = [];
                var secondGridFullChild = [];
                var mainId = model.ArrayGridObjects[key].MainId;
                var gridElement = model.ArrayGridObjects[key].ObjectName;
                var secondGridIdName = model.ArrayGridObjects[key].SecondGridMainId;
                var secondGridElement = model.ArrayGridObjects[key].SecondGrid.substr(4);

                for (var i = 0; i < devExtremeObject.length; i++) {
                    var object = devExtremeObject[i];

                    if ((object.type === 'update') || (object.type === 'remove')) {
                        var keys = [];
                        var oldData = null;

                        for (var k in object.data) {
                            keys.push(k);
                        }

                        objectOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(object);
                        oldData = scope.generalModel.AngularCopy(objectOldData);

                        for (var y = 0; y < keys.length; y++) {
                            var keyName = keys[y];
                            oldData[keyName] = object.data[keyName];
                        }

                        if (object.type === 'remove') {
                            oldData.ToDelete = true;
                            oldData.Delete = true;
                        }

                        secondGridFullChild.push(scope.generalModel.AngularCopy(oldData));

                        for (var x = 0; x < scope.generalModel.ExtraConnections.length; x++) {
                            extraConnection = scope.generalModel.ExtraConnections[x];

                            if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key] = [];
                            }

                            name = extraConnection.BasicName;

                            if (typeof name === 'undefined') {
                                name = extraConnection.ObjectPathName;
                            }

                            if (typeof scope.generalModel.GetObjectByString(oldData, name) !== 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(oldData, name));

                                if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetObjectByString(oldData, name))) {
                                    model.MainObjectPreviousSave[extraConnection.Key][model.MainObjectPreviousSave[extraConnection.Key].length - 1].ParentObjectId = oldData[model.ArrayGridObjects[key].SecondGridMainId];
                                }

                                if (Array.isArray(oldData[name])) {
                                    for (var f = 0; f < oldData[name].length; f++) {
                                        for (var keyInConnection in oldData[name][f]) {
                                            if (typeof oldData[name][f][keyInConnection] === 'object') {
                                                scope.generalModel.SetObjectValueByString(oldData, name + '[' + f + '].' + keyInConnection, null);
                                            }
                                        }
                                    }
                                }
                                else {
                                    scope.generalModel.SetObjectValueByString(oldData, name, null);
                                }
                            }
                        }

                        secondGridChild.push(oldData);
                    }
                    else if (object.type === 'insert') {
                        var newData = scope.generalModel.AngularCopy(object.data);
                        secondGridFullChild.push(scope.generalModel.AngularCopy(newData));

                        for (var z = 0; z < scope.generalModel.ExtraConnections.length; z++) {
                            extraConnection = scope.generalModel.ExtraConnections[z];

                            if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key] = [];
                            }

                            name = extraConnection.BasicName;

                            if (typeof name === 'undefined') {
                                name = extraConnection.ObjectPathName;
                            }

                            if (typeof scope.generalModel.GetObjectByString(newData, name) !== 'undefined') {
                                model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(newData, name));

                                if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetObjectByString(newData, name))) {
                                    model.MainObjectPreviousSave[extraConnection.Key][model.MainObjectPreviousSave[extraConnection.Key].length - 1].ParentObjectId = newData[model.ArrayGridObjects[key].SecondGridMainId];
                                }

                                if (!Array.isArray(newData[name])) {
                                    newData[name] = null;
                                    scope.generalModel.SetObjectValueByString(newData, name, null);
                                }
                                else {
                                    for (var extraConnectionCounter = 0; extraConnectionCounter < newData[name].length; extraConnectionCounter++) {
                                        for (var keyExtraConnection in newData[name][extraConnectionCounter]) {
                                            if (typeof newData[name][extraConnectionCounter][keyExtraConnection] === 'object') {
                                                scope.generalModel.SetObjectValueByString(newData, name + '[' + extraConnectionCounter + '].' + keyExtraConnection, null);
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        secondGridChild.push(newData);
                    }
                }

                if ((secondGridChild.length !== 1) || ((secondGridChild.length === 1) && ((secondGridChild[0].hasOwnProperty('__KEY__')) || (secondGridChild[0].hasOwnProperty(mainId))))) {
                    for (var secondGrid = 0; secondGrid < secondGridChild.length; secondGrid++) {
                        if (!secondGridChild[secondGrid].hasOwnProperty(mainId)) {
                            if (parentObject.hasOwnProperty('__KEY__')) {
                                secondGridChild[secondGrid][mainId] = parentObject.__KEY__;
                                secondGridFullChild[secondGrid][mainId] = parentObject.__KEY__;
                            }
                            else {
                                secondGridChild[secondGrid][mainId] = parentObject[mainId];
                                secondGridFullChild[secondGrid][mainId] = parentObject[mainId];
                            }
                        }

                        if ((parent !== '') && isNaN(model.ServerData.length)) {
                            serverData = model.ServerData[gridElement];
                        } else {
                            serverData = model.ServerData;
                        }

                        for (var c = 0; c < serverData.length; c++) {
                            if ((typeof serverData[c][secondGridElement] !== 'undefined') && (serverData[c][secondGridElement] !== null)) {
                                for (var d = 0; d < serverData[c][secondGridElement].length; d++) {
                                    if (serverData[c][secondGridElement][d][secondGridIdName] === secondGridChild[secondGrid][secondGridIdName]) {
                                        scope.generalModel.ReplaceRowVersion(secondGridChild, secondGridIdName, serverData[c][secondGridElement][d][secondGridIdName], serverData[c][secondGridElement][d].RowVersion);
                                    }
                                }
                            }
                        }
                    }

                    model.SecondGridFullEditData.push(secondGridFullChild);
                    model.SecondGridEditData.push(secondGridChild);
                }
            };

            scope.generalModel.ProcessSaveGridsPatchMode = function (model) {
                var id;
                var name;
                var grid;
                var reason;
                var editData;
                var dataSource;
                var secondGrid;
                var deferred = $q.defer();
                var noDataForEditFound = 0;
                var secondGridDataSource = [];

                model.MainObjectPreviousSave = [];
                model.SecondGridFullEditData = [];
                model.SecondGridEditData = [];

                for (var m = 0; m < model.ArrayGridObjects.length; m++) {
                    var itemM = model.ArrayGridObjects[m];

                    model[itemM.GridName + 'ValidState'] = 0;

                    if (itemM.SecondGrid !== '') {
                        grid = angular.element("#" + itemM.GridName + "").dxDataGrid('instance');
                        dataSource = grid.getDataSource();

                        if (dataSource !== null) {
                            if ((itemM.SecondGrid !== '') && itemM.SecondGridRequired) {
                                for (var w = 0; w < dataSource._store._array.length; w++) {
                                    var itemDataSource = dataSource._store._array[w];

                                    id = scope.generalModel.GetMainId(itemM.MainId, itemDataSource);
                                    secondGrid = angular.element('#' + itemM.SecondGrid + id).dxDataGrid('instance');

                                    if (typeof secondGrid !== 'undefined') {
                                        secondGridDataSource = secondGrid.getDataSource();
                                    }

                                    var secondGridEditData = Helpers.DevExtreme.Grid.GetEditData(secondGrid);
                                    var secondGridEditDataToRemove = secondGridEditData.filter(where => where.type === "remove");

                                    if ((!itemDataSource.hasOwnProperty('__KEY__') && (
                                        ((typeof itemDataSource[itemM.SecondGrid.substr(4)] !== 'undefined') && !itemDataSource[itemM.SecondGrid.substr(4)].length) ||
                                        ((typeof secondGrid !== 'undefined') && secondGridEditData.length && (secondGridEditDataToRemove.length === secondGridDataSource._store._array.length))
                                    )) ||
                                        (itemDataSource.hasOwnProperty('__KEY__') && ((typeof secondGrid === 'undefined') || (!secondGridEditData.length && !secondGridDataSource._store._array.length)
                                        ))) {
                                        reason = (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.InternalTable : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).internalTable) + itemM.DisplayName + ((!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.IsRequired : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).isRequired);
                                        deferred.reject(reason);

                                        return deferred.promise;
                                    }
                                }
                            }

                            for (var v = 0; v < dataSource._store._array.length; v++) {
                                id = scope.generalModel.GetMainId(itemM.MainId, dataSource._store._array[v]);

                                if (typeof model[itemM.SecondGrid + 'ValidState'][id] !== 'undefined') {
                                    model[itemM.SecondGrid + 'ValidState'][id] = 0;
                                }

                                var secondGridData = dataSource._store._array[v][itemM.SecondGrid.substr(4)];

                                for (var z = 0; z < scope.generalModel.ExtraConnections.length; z++) {
                                    var extraConnection = scope.generalModel.ExtraConnections[z];

                                    if (typeof model.MainObjectPreviousSave[extraConnection.Key] === 'undefined') {
                                        model.MainObjectPreviousSave[extraConnection.Key] = [];
                                    }

                                    name = extraConnection.BasicName;

                                    if (typeof name === 'undefined') {
                                        name = extraConnection.ObjectPathName;
                                    }

                                    if (typeof secondGridData !== 'undefined') {
                                        for (var x = 0; x < secondGridData.length; x++) {
                                            var itemSecondGridData = secondGridData[x];

                                            if (typeof scope.generalModel.GetObjectByString(itemSecondGridData, name) !== 'undefined') {
                                                model.MainObjectPreviousSave[extraConnection.Key].push(scope.generalModel.GetObjectByString(itemSecondGridData, name));

                                                if (!scope.generalModel.IsUndefinedEmptyOrNull(scope.generalModel.GetObjectByString(itemSecondGridData, name))) {
                                                    model.MainObjectPreviousSave[extraConnection.Key][model.MainObjectPreviousSave[extraConnection.Key].length - 1].ParentObjectId = secondGridData[x][itemM.SecondGridMainId];
                                                }

                                                if (Array.isArray(itemSecondGridData[name])) {
                                                    for (var f = 0; f < itemSecondGridData[name].length; f++) {
                                                        for (var key in itemSecondGridData[name][f]) {
                                                            if (typeof itemSecondGridData[name][f][key] === 'object') {
                                                                scope.generalModel.SetObjectValueByString(itemSecondGridData, name + '[' + f + '].' + key, null);
                                                            }
                                                        }
                                                    }
                                                }
                                                else {
                                                    scope.generalModel.SetObjectValueByString(itemSecondGridData, name, null);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                for (var n = 0; n < model.ArrayGridObjects.length; n++) {
                    var itemN = model.ArrayGridObjects[n];

                    grid = angular.element("#" + itemN.GridName + "").dxDataGrid('instance');

                    if (itemN.SecondGrid !== '') {
                        dataSource = grid.getDataSource();

                        if (dataSource !== null) {
                            for (var arrayList = 0; arrayList < dataSource._store._array.length; arrayList++) {
                                id = scope.generalModel.GetMainId(itemN.MainId, dataSource._store._array[arrayList]);

                                if (id === scope.generalModel.GuidEmpty) {
                                    editData = scope.generalModel.GetEditDataClean(grid);
                                    var secondGridElementName = model.ArrayGridObjects[n].SecondGrid.substr(4);

                                    for (var a = 0; a < editData.length; a++) {
                                        if (editData[a].key.__KEY__ === dataSource._store._array[arrayList].__KEY__) {
                                            scope.generalModel.CreateObjectsSecondGrid(editData[a].key[secondGridElementName], model, n, dataSource._store._array[arrayList], '');

                                            break;
                                        }
                                    }
                                }
                                else {
                                    secondGrid = angular.element('#' + itemN.SecondGrid + id).dxDataGrid('instance');

                                    if (typeof secondGrid !== 'undefined') {
                                        editData = scope.generalModel.GetEditDataClean(secondGrid);

                                        if (editData.length) {
                                            scope.generalModel.CreateObjectsSecondGrid(editData, model, n, dataSource._store._array[arrayList], '');
                                        }

                                        secondGrid.saveEditData();

                                        if ((typeof model[itemN.SecondGrid + 'ValidState'][id] !== 'undefined') && (model[itemN.SecondGrid + 'ValidState'][id] !== 0)) {
                                            reason = ((!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.InvalidFieldsOnTable : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).invalidFieldsOnTable) + model.ArrayGridObjects[n].DisplayName + ".";
                                            deferred.reject(reason);

                                            return deferred.promise;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    grid.saveEditData();

                    for (var e = 0; e < scope.generalModel.DeletedElements.length; e++) {
                        editData = scope.generalModel.GetEditDataClean(grid);
                        for (var editDataInGrid = 0; editDataInGrid < editData.length; editDataInGrid++) {
                            if (editData[editDataInGrid].key.__KEY__ === scope.generalModel.DeletedElements[e].Id) {
                                editData[editDataInGrid].data = scope.generalModel.AngularCopy(editData[editDataInGrid].key);
                            }
                        }
                    }

                    if (model[itemN.GridName + 'ValidState'] !== 0) {
                        reason = ((!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.InvalidFieldsTable : myApplication.getLanguageObject.selectedLanguage('saveFunctions', myApplication).invalidFieldsTable) + model.ArrayGridObjects[n].DisplayName + ".";
                        deferred.reject(reason);

                        return deferred.promise;
                    }
                }

                model.ObjectPatch = [];
                model.UpdatedData = [];
                model.DeletedData = [];
                model.InsertedData = [];

                for (var l = 0; l < model.ArrayGridObjects.length; l++) {
                    grid = angular.element("#" + model.ArrayGridObjects[l].GridName + "").dxDataGrid('instance');
                    editData = scope.generalModel.GetEditDataClean(grid);

                    if ((model.ArrayGridObjects[l].SecondGrid !== '') || editData.length) {
                        if (model.ArrayGridObjects[l].SecondGrid !== '') {
                            scope.generalModel.CreateObjectsParentGrid(editData, l, model, model.ArrayGridObjects[l].MainId, '');
                        }
                        else {
                            scope.generalModel.CreateObjects(editData, model, model.ArrayGridObjects[l].MainId);
                            model.CancelSaveProcess = false;
                        }

                        if (model.InsertedData.length || model.UpdatedData.length || model.DeletedData.length) {
                            scope.generalModel.ObjectPatch = model.InsertedData.concat(model.UpdatedData).concat(model.DeletedData);
                            noDataForEditFound = 0;
                            model.GridsToSave.push(model.ArrayGridObjects[l].ObjectName);
                            scope.generalModel.deferredToSave = deferred;
                            scope.generalModel.modelToSave = model;
                            scope.generalModel.positionToSave = l;
                            scope.generalModel.ValidatePhotographies(model);
                        }
                        else {
                            noDataForEditFound = noDataForEditFound + 1;
                            break;
                        }
                    }
                    else if (scope.generalModel.ConcurrencyError || (noDataForEditFound === 0)) {
                        // Isto aqui faz sentido? Não estamos a enviar um resolve por iteração?
                        deferred.resolve();
                    }
                }

                if (noDataForEditFound > 0) {
                    deferred.resolve();
                }

                return deferred.promise;
            };

            scope.generalModel.ValidatePhotographies = function (model) {
                if (scope.generalModel.PhotographyList.length && (scope.generalModel.PhotographyList !== '')) {
                    for (var a = 0; a < scope.generalModel.PhotographyList.length; a++) {
                        $q.when(scope.generalModel.ConvertImages(scope.generalModel.PhotographyList[a].Photography, a, '')).then(function (result) {
                            if (scope.generalModel.PhotographyList[result.Key].Id !== 'Main') {
                                var id = scope.generalModel.PhotographyList[result.Key].Id.substr(11);
                                var objectForFilter = {};
                                objectForFilter[model.ArrayGridObjects[scope.generalModel.positionToSave].MainId] = id;

                                if ($filter('filter')(model.InsertedData, { __KEY__: id }, true).length) {
                                    $filter('filter')(model.InsertedData, { __KEY__: id }, true)[0].Photography = result.Photography;
                                }
                                else if ($filter('filter')(model.UpdatedData, objectForFilter, true).length) {
                                    $filter('filter')(model.UpdatedData, objectForFilter, true)[0].Photography = result.Photography;
                                }
                                else if ($filter('filter')(model.UpdatedData, { __KEY__: id }, true).length) {
                                    $filter('filter')(model.UpdatedData, { __KEY__: id }, true)[0].Photography = result.Photography;
                                }
                            }
                            if (result.Key + 1 === scope.generalModel.PhotographyList.length) {
                                if (model.DeletedData.length) {
                                    scope.generalModel.ConfirmDeleteData();
                                }
                                else {
                                    scope.generalModel.CallProcessFinalSaveGridsPatchMode();
                                }
                            }
                        });
                    }
                }
                else {
                    if (model.DeletedData.length) {
                        scope.generalModel.ConfirmDeleteData();
                    }
                    else {
                        scope.generalModel.CallProcessFinalSaveGridsPatchMode();
                    }
                }
            };

            scope.generalModel.ConfirmDeleteData = function () {
                angular.element('#DialogConfirmDelete .HalfWidthWithPadding:first').html('<button id="DialogButtonConfirmDelete" class="btn btn-danger Width" ng-click="generalModel.CallProcessFinalSaveGridsPatchMode(); generalModel.CloseDialogConfirmDelete()">Delete</button>');
                angular.element('#DialogConfirmDelete #DialogButtonConfirm').attr('ng-click', 'generalModel.CallProcessFinalSaveGridsPatchMode(); generalModel.CloseDialogConfirmDelete()');
                $compile(angular.element('#DialogConfirmDelete #DialogButtonConfirmDelete'))(scope);
                scope.generalModel.FullPageLoading = false;
                scope.generalModel.ShowDialogConfirmDelete();
            };

            scope.generalModel.CallProcessFinalSaveGridsPatchMode = function () {
                var deferred = scope.generalModel.deferredToSave;
                var model = scope.generalModel.modelToSave;
                var l = scope.generalModel.positionToSave;

                $q.when(scope.generalModel.ProcessFinalSaveGridsPatchMode(model, l)).then(function () {
                    if (model.LastSavedGrid === model.GridsToSave[model.GridsToSave.length - 1]) {
                        deferred.resolve();
                    }
                }).catch(function (reason) {
                    deferred.reject(reason);
                });
            };

            scope.generalModel.ProcessFinalSaveGridsPatchMode = function (model, l) {
                var deferred = $q.defer();

                $q.when(scope.generalModel.SaveGridPatchMode(model.ArrayGridObjects[l].ObjectName, l, model)).then(function () {
                    if (model.LastSavedGrid === model.GridsToSave[model.GridsToSave.length - 1]) {
                        deferred.resolve();
                    }
                }).catch(function (exception) {
                    if (exception.Code === '500') {
                        exception = (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.ThereWasError : myApplication.warningMessages.thereWasError();
                    }

                    deferred.reject(exception);
                });

                return deferred.promise;
            };

            scope.generalModel.SaveGridPatchMode = function (gridObjectName, key, model) {
                var deferred = $q.defer();
                var grid;

                if ((typeof model.ContentLoading === 'object') && model.ContentLoading.hasOwnProperty(gridObjectName)) {
                    model.ContentLoading[gridObjectName] = true;
                }
                else {
                    model.ContentLoading = true;
                }

                if (typeof model.MainController === 'undefined') {
                    model.MainController = model.ArrayGridObjects[key].ObjectName;
                }

                scope.generalModel.ArrayPosition = '';
                scope.generalModel.EditedElements = [];
                scope.generalModel.DeletedElements = [];
                scope.generalModel.FullPageLoading = true;

                $q.when(GeneralModel.Patch(model)).then(function () {
                    scope.generalModel.ConcurrencyError = false;
                    grid = angular.element("#" + model.ArrayGridObjects[key].GridName + "").dxDataGrid('instance');
                    Helpers.DevExtreme.Grid.RemoveEditData(grid, true, false);
                    model.LastSavedGrid = gridObjectName;
                    model.ServerData = [];

                    if ((typeof model.ContentLoading === 'object') && model.ContentLoading.hasOwnProperty(gridObjectName)) {
                        model.ContentLoading[gridObjectName] = false;
                    }
                    else {
                        model.ContentLoading = false;
                    }

                    deferred.resolve();
                }).catch(function (exception) {
                    if (typeof model['' + model.ArrayGridObjects[key].ObjectName + 'ToolsState'] !== 'undefined') {
                        model['' + model.ArrayGridObjects[key].ObjectName + 'ToolsState'] = true;
                    }
                    else {
                        model.ToolsState = true;
                    }

                    scope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                    scope.generalModel.SidebarOptions['State']['CancelOption'] = true;

                    if ((typeof model.ContentLoading === 'object') && model.ContentLoading.hasOwnProperty(gridObjectName)) {
                        model.ContentLoading[gridObjectName] = false;
                    }
                    else {
                        model.ContentLoading = false;
                    }

                    if (model.ArrayGridObjects[key].SecondGrid !== '') {
                        scope.generalModel.ResetSecondGridData(model);
                    }

                    if (exception.Code === '409') {
                        scope.generalModel.ValidateServerData(model, key, '');
                    }

                    deferred.reject(exception);
                });

                return deferred.promise;
            };

            scope.generalModel.ResetSecondGridData = function (model) {
                if (!model.SecondGridFullEditData.length) {
                    return
                }

                var grid;
                var secondGrid;
                var editData;
                var secondEditData;
                var elementWasFound;
                var dataSource;
                var secondDataSource;
                var rowIndex;

                for (var a = 0; a < model.SecondGridFullEditData.length; a++) {
                    for (var l = 0; l < model.ArrayGridObjects.length; l++) {
                        if (model.SecondGridFullEditData[a][0].hasOwnProperty(model.ArrayGridObjects[l].MainId)) {
                            grid = angular.element("#" + model.ArrayGridObjects[l].GridName + "").dxDataGrid('instance');
                            dataSource = grid.getDataSource();
                            editData = scope.generalModel.GetEditDataClean(grid);

                            for (var s = 0; s < model.SecondGridFullEditData[a].length; s++) {
                                elementWasFound = false;

                                for (var m = 0; m < editData.length; m++) {
                                    if (editData[m][model.ArrayGridObjects[l].MainId] === model.SecondGridFullEditData[a][s][model.ArrayGridObjects[l].MainId]) {
                                        elementWasFound = true;

                                        break;
                                    }
                                }

                                if (!elementWasFound) {
                                    for (var f = 0; f < dataSource._store._array.length; f++) {
                                        if (dataSource._store._array[f][model.ArrayGridObjects[l].MainId] === model.SecondGridFullEditData[a][s][model.ArrayGridObjects[l].MainId]) {
                                            secondGrid = angular.element("#" + model.ArrayGridObjects[l].SecondGrid + dataSource._store._array[f][model.ArrayGridObjects[l].MainId] + "").dxDataGrid('instance');

                                            if (model.SecondGridFullEditData[a][s].hasOwnProperty('__KEY__')) {
                                                secondGrid.addRow();
                                                secondEditData = scope.generalModel.GetEditDataClean(secondGrid);
                                                angular.forEach(model.SecondGridFullEditData[a][s], function (value, dataField) {
                                                    if ((dataField !== 'Disabled') || ((dataField !== 'Disabled') && (value !== model.SecondGridFullEditData[a][s][dataField]))) {
                                                        secondEditData[secondEditData.length - 1].data[dataField] = value;
                                                    }
                                                });
                                                secondGrid.refresh();
                                            }
                                            else {
                                                secondDataSource = secondGrid.getDataSource();

                                                for (var r = 0; r < secondDataSource._store._array.length; r++) {
                                                    if (secondDataSource._store._array[r][model.ArrayGridObjects[l].SecondGridMainId] === model.SecondGridFullEditData[a][s][model.ArrayGridObjects[l].SecondGridMainId]) {
                                                        rowIndex = secondGrid.getRowIndexByKey(secondDataSource._store._array[r]);

                                                        if (model.SecondGridFullEditData[a][s].hasOwnProperty('ToDelete')) {
                                                            secondGrid.deleteRow(rowIndex);
                                                        }
                                                        else {
                                                            angular.forEach(model.SecondGridFullEditData[a][s], function (value, dataField) {
                                                                if ((dataField !== 'Disabled') || ((dataField !== 'Disabled') && (value !== model.SecondGridFullEditData[a][s][dataField]))) {
                                                                    if (typeof model.SecondGridFullEditData[a][s][dataField] === "object") {

                                                                        angular.forEach(model.SecondGridFullEditData[a][s][dataField], function (insideValue, insideDataField) {
                                                                            for (var x = 0; x < scope.generalModel.ExtraConnections.length; x++) {

                                                                                if (dataField + '.' + insideDataField === scope.generalModel.ExtraConnections[x].DataField) {
                                                                                    secondGrid.cellValue(rowIndex, dataField + '.' + insideDataField, insideValue);

                                                                                    break;
                                                                                }
                                                                            }
                                                                        });
                                                                    }
                                                                    else {
                                                                        secondGrid.cellValue(rowIndex, dataField, value);
                                                                    }
                                                                }
                                                            });
                                                            secondEditData = scope.generalModel.GetEditDataClean(secondGrid);
                                                            angular.forEach(model.SecondGridFullEditData[a][s], function (value, dataField) {
                                                                if ((dataField !== 'Disabled') || ((dataField !== 'Disabled') && (value !== model.SecondGridFullEditData[a][s][dataField]))) {
                                                                    secondEditData[secondEditData.length - 1].data[dataField] = value;
                                                                }
                                                            });
                                                        }

                                                        secondGrid.refresh();
                                                    }
                                                }
                                            }

                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            };
        }

        return SaveFunctions;
    }]);
})();
(function () {
    "use strict";
    angular.module(myApplication.appName).service('GeneralLoadData', ["$q", "$http", "GetIp", "Validations", "$sessionStorage", function ($q, $http, GetIp, Validations, $sessionStorage) {

        this.GeneralGetDeprecated = function (controller, action, parameters, token, specificApiName, controlledDefer) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            if ((typeof controlledDefer !== "undefined") && controlledDefer) {
                defer.Controlled = true;
            }

            $http.get(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralGet = function (controller, action, parameters, token, specificApiName, controlledDefer, ignoreSessionStorageToken) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token || ignoreSessionStorageToken) {
                tokenToSend = token;
            }

            if ((typeof controlledDefer !== "undefined") && controlledDefer) {
                defer.Controlled = true;
            }

            $http.get(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.PreviewFilesDeprecated = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            var params = '';
            var paramIndex = 0;

            for (var property in parameters) {
                var propertyValue = parameters[property];

                if (paramIndex !== 0) {
                    params += "&" + property + "=" + propertyValue;
                }
                else {
                    params += property + "=" + propertyValue;
                }

                paramIndex++;
            }

            var req = new XMLHttpRequest();
            req.open("GET", GetIp(specificApiName) + '/api/' + controller + '/' + action + '?' + params, true);
            req.responseType = "blob";
            req.setRequestHeader("Authorization", tokenToSend);

            req.onreadystatechange = function () {
                if ((req.readyState === 4) && (req.status === 200)) {
                    var newAnnex = {};
                    var fileInformation = req.getResponseHeader("Content-Disposition");
                    var blob = req.response;
                    newAnnex.FileName = fileInformation.split("attachment; filename=")[1].replace(/['"]+/g, '');
                    newAnnex.FileType = newAnnex.FileName.split(".")[1];
                    newAnnex.Blob = window.URL.createObjectURL(blob);
                    newAnnex.BlobObject = blob;

                    return defer.resolve(newAnnex);
                }
                else if (req.status === 400) {
                    return defer.resolve("400");
                }
            };

            req.send();

            return defer.promise;
        };

        this.PreviewFiles = function (controller, action, parameters, token, specificApiName, blobType) {
            var defer = $q.defer();
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            var params = '';
            var paramIndex = 0;

            for (var property in parameters) {
                var propertyValue = parameters[property];

                if (paramIndex !== 0) {
                    params += "&" + property + "=" + propertyValue;
                }
                else {
                    params += property + "=" + propertyValue;
                }

                paramIndex++;
            }

            var req = new XMLHttpRequest();
            req.open("GET", GetIp(specificApiName) + '/api/' + controller + '/' + action + '?' + params, true);
            req.responseType = "blob";
            req.setRequestHeader("Authorization", tokenToSend);

            req.onreadystatechange = function () {
                if ((req.readyState === 4) && (req.status === 200)) {
                    var newAnnex = {};
                    var fileInformation = req.getResponseHeader("Content-Disposition");
                    var blob = req.response;
                    newAnnex.FileName = fileInformation.split("attachment; filename=")[1].replace(/['"]+/g, '');
                    newAnnex.FileType = newAnnex.FileName.split(".")[1];

                    if (blobType) {
                        blob = new Blob([blob], { type: blobType });
                    }

                    newAnnex.Blob = window.URL.createObjectURL(blob);
                    newAnnex.BlobObject = blob;

                    return defer.resolve(newAnnex);
                }
                else if (req.status !== 200) {
                    return defer.reject();
                }
            };

            req.send();

            return defer.promise;
        };

        this.GeneralPostDeprecated = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.post(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', data, { headers: { "Authorization": tokenToSend }, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralPost = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.post(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', data, { headers: { "Authorization": tokenToSend }, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.PostFilesDeprecated = function (controller, action, data, token, specificApiName) {
            var defer = $q.defer();
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            var settings = {
                "cache": false,
                "method": 'POST',
                headers: { "Authorization": tokenToSend, "Content-Type": undefined },
                cancel: defer
            };

            $http.post(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', data, settings).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );

            return defer.promise;
        };

        this.PostFiles = function (controller, action, data, token, specificApiName) {
            var defer = $q.defer();
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            var settings = {
                "cache": false,
                "method": 'POST',
                headers: { "Authorization": tokenToSend, "Content-Type": undefined },
                cancel: defer
            };

            $http.post(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', data, settings).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );

            return defer.promise;
        };

        this.GeneralPostWithParametersInUrlDeprecated = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.post(GetIp(specificApiName) + '/api/' + controller + '/' + action, null, { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralPostWithParametersInUrl = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.post(GetIp(specificApiName) + '/api/' + controller + '/' + action, null, { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralPutDeprecated = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = JSON.stringify(Validations.ValidationsParameters(parameters));
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.put(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', data, { headers: { "Authorization": tokenToSend }, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralPut = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = JSON.stringify(Validations.ValidationsParameters(parameters));
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.put(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', data, { headers: { "Authorization": tokenToSend }, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralPutWithParametersInUrlDeprecated = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.put(GetIp(specificApiName) + '/api/' + controller + '/' + action, null, { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralPutWithParametersInUrl = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.put(GetIp(specificApiName) + '/api/' + controller + '/' + action, null, { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralDeleteDeprecated = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.delete(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GeneralDelete = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.delete(GetIp(specificApiName) + '/api/' + controller + '/' + action + '', { headers: { "Authorization": tokenToSend }, params: data, cancel: defer }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.ExportToXmlDeprecated = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.get(GetIp(specificApiName) + '/api/' + controller + '/' + action, { headers: { "Authorization": tokenToSend }, params: data, cancel: defer, responseType: "arraybuffer" }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.ExportToXml = function (controller, action, parameters, token, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            var tokenToSend = $sessionStorage.Token;

            if (token) {
                tokenToSend = token;
            }

            $http.get(GetIp(specificApiName) + '/api/' + controller + '/' + action, { headers: { "Authorization": tokenToSend }, params: data, cancel: defer, responseType: "arraybuffer" }).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsGeneral(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GetTokenDeprecated = function (parameters, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            $.post(GetIp(specificApiName) + '/api/Token', data).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.resolve(Validations.ValidationsLogin(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };

        this.GetToken = function (parameters, specificApiName) {
            var defer = $q.defer();
            var data = Validations.ValidationsParameters(parameters);
            $.post(GetIp(specificApiName) + '/api/Token', data).then(
                function (result) {
                    return defer.resolve(result);
                }, function (xhr, ajaxOptions, thrownError) {
                    return defer.reject(Validations.ValidationsLogin(xhr, ajaxOptions, thrownError));
                }
            );
            return defer.promise;
        };
    }]);
})();
(function () {
    "use strict";
    myApp.factory('DateOperations', function () {

        function DateOperations(scope) {
            scope.generalModel.ParseMinutesToTime = function (time) {
                var hours = Math.floor(time / 60);
                var minutes = scope.generalModel.LeftPadding(time % 60);

                return hours + "." + minutes;
            };

            scope.generalModel.ValidateDayInMonth = function (day, month) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(day) || scope.generalModel.IsUndefinedEmptyOrNull(month)) {
                    return true;
                }

                switch (month) {
                    case 2:
                        if (day > 29) {
                            return false;
                        }
                        break;
                    case 4:
                    case 6:
                    case 9:
                    case 11:
                        if (day > 30) {
                            return false;
                        }
                        break;
                }

                return true;
            };

            scope.generalModel.CheckUniqueDateInColumn = function (model, options, gridName, nameOfField) {
                var grid = angular.element("#" + gridName + "").dxDataGrid('instance');
                var duplicate = 0;
                var index = grid.getRowIndexByKey(options.data);
                var mainKey = grid.getKeyByRowIndex(index);
                var fromDate;
                var editData = scope.generalModel.GetEditDataClean(grid);
                var dataSource = grid.getDataSource()._store._array;
                var mainId;

                for (var a = 0; a < model.ArrayGridObjects.length; a++) {
                    var gridObject = model.ArrayGridObjects[a];

                    if (gridObject.GridName === gridName) {
                        mainId = gridObject.MainId;
                        break;
                    }
                }

                if ((options.value === null) || (options.value === "")) {
                    options.rule.message = (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.FieldRequired : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).FieldRequired);
                    return false;
                }
                else {
                    for (var e = 0; e < dataSource.length; e++) {
                        if ((options.data.hasOwnProperty('__KEY__') && dataSource[e].hasOwnProperty('__KEY__') && (options.data.__KEY__ !== dataSource[e].__KEY__)) || (options.data.hasOwnProperty('__KEY__') && !dataSource[e].hasOwnProperty('__KEY__')) || (options.data.hasOwnProperty(mainId) && dataSource[e].hasOwnProperty(mainId) && (options.data[mainId] !== dataSource[e][mainId]))) {
                            if (new Date(options.value).getTime() === new Date(dataSource[e][nameOfField]).getTime()) {
                                duplicate = 2;
                                break;
                            }
                        }
                    }

                    if ((duplicate === 0) && editData.length) {
                        for (var d = 0; d < editData.length; d++) {
                            var item = editData[d];
                            var itemOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(item);

                            if (((item.type === 'insert') || (item.type === 'update')) && (typeof item.data !== 'undefined')) {
                                fromDate = '';

                                if (item.data.hasOwnProperty(nameOfField)) {
                                    fromDate = item.data[nameOfField];
                                }
                                else if ((typeof itemOldData !== 'undefined') && itemOldData.hasOwnProperty(nameOfField)) {
                                    if ((typeof mainKey === 'undefined') || ((typeof mainKey !== 'undefined') && (itemOldData.WageDefinitionId !== mainKey.WageDefinitionId))) {
                                        fromDate = itemOldData[nameOfField];
                                    }
                                }

                                if ((fromDate !== '') && (new Date(options.value).getTime() === new Date(fromDate).getTime())) {
                                    duplicate = duplicate + 1;

                                    if (duplicate > 1) {
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    if (duplicate > 1) {
                        options.rule.message = (!scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.DateMustBeUnique : myApplication.getLanguageObject.selectedLanguage('generalFunctionsTexts', myApplication).DateMustBeUnique);

                        return false;
                    }

                    return true;
                }
            };

            scope.generalModel.CheckDateBiggerThan = function (options, firstDateName, currentDateName) {
                if (scope.generalModel.IsUndefinedEmptyOrNull(options.data[firstDateName]) || scope.generalModel.IsUndefinedEmptyOrNull(options.data[currentDateName])) {
                    return true;
                }

                var startDate = new Date(options.data[firstDateName]).getTime();
                var endDate = new Date(options.data[currentDateName]).getTime();

                if (endDate > startDate) {
                    return true;
                }

                return false;
            };
        }

        return DateOperations;
    });
})();
(function () {
    "use strict";
    myApp.service('NumberOperations', function () {
        this.CheckIfInt = function (value) {
            if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
                return !isNaN(Number(value));
            }

            return false;
        };

        this.CheckIfFloat = function (value) {
            if (/^\-?[0-9]+(e[0-9]+)?(\.[0-9]+)?$/.test(value)) {
                return !isNaN(Number(value));
            }

            return false;
        };
    });

    Number.prototype.round = function (places) {
        return +(Math.round(this + "e+" + places) + "e-" + places);
    }
})();
(function () {
    "use strict";
    myApp.service('ProductionOperations', function () {
        this.CalculateServiceTax = function (done, planned, tolerance, allowExceedProduction) {
            if (done === planned) {
                return 1;
            }

            if ((done === 0) || (planned === 0)) {
                return 0;
            }

            if (typeof allowExceedProduction === undefined) {
                allowExceedProduction = false;
            }

            if (allowExceedProduction && (done > planned)) {
                return 1;
            }

            if (done >= (2 * planned)) {
                return 0;
            }

            if ((done > planned) && (done <= (planned + tolerance))) {
                return 1;
            }

            if ((done < planned) && ((done + tolerance) >= planned)) {
                return 1;
            }

            return 1 - Math.abs((done - planned) / planned);
        };
    });
})();
(function () {
    "use strict";
    angular.module(myApplication.appName).service('HistoryModel', ["$q", "$sessionStorage", "GeneralLoadData", "GeneralModel", function ($q, $sessionStorage, GeneralLoadData, GeneralModel) {

        var _model = {
            Token: $sessionStorage.Token,
            HistoryId: '',
            ListHistory: [],
            GridHistory: '',
            HistoryIdName: '',
            CreationUserId: '',
            CreationDatetime: ''
        };

        var _ListHistory = function () {
            var defer = $q.defer();
            var parameters = { 'registerId': _model.HistoryId, 'creationUserId': _model.CreationUserId, 'creationDatetime': _model.CreationDatetime };
            $q.when(GeneralLoadData.GeneralGet('History', 'ListByRegisterId', parameters, _model.Token)).then(function (result) {
                _model.ListHistory = GeneralModel.AngularCopy(result.data);
                defer.resolve();
            }, function (reason) {
                defer.reject(reason);
            });

            return defer.promise;
        };

        return {
            model: _model,
            ListHistory: function () {
                return _ListHistory();
            }
        };
    }]);
})();
(function () {
    "use strict";
    myApp.factory('ConcurrencyData', ["$q", "GeneralModel", "$window", "$compile", "$timeout", "$filter", "$parse", function ($q, GeneralModel, $window, $compile, $timeout, $filter, $parse) {

        function ConcurrencyData(pageScope) {

            pageScope.ArrayFunctions = {
                FindInObject: function (object, property, propertyValue) {
                    var objectLine = null;

                    for (var i = 0; i < object.length; i++) {
                        var item = object[i];

                        if (item[property] === propertyValue) {
                            objectLine = item;
                        }
                    }

                    return objectLine;
                }
            };

            pageScope.generalModel.ValidateServerData = function (model, key, parent) {
                model.ServerData = [];
                model.DifferentLines = [];

                if ((model.MainObjectId === undefined) || pageScope.generalModel.IsUndefinedEmptyOrNull(pageScope.generalModel.GetObjectByString(model, model.MainObjectId))) {
                    return;
                }

                if (parent !== '') {
                    $q.when(GeneralModel.ListFromServerById(model)).then(function () {

                        pageScope.generalModel.FullPageLoading = false;

                        if ((typeof model.ArrayGridObjects !== 'undefined') && model.ArrayGridObjects.length) {
                            for (var a = 0; a < model.ArrayGridObjects.length; a++) {
                                pageScope.generalModel.CompareServerData(model, a, parent);
                            }

                            if (pageScope.generalModel.HasObjectKeys(pageScope.generalModel.ObjectDataForConcurrency)) {
                                pageScope.generalModel.CallConcurrencyByObject(parent, key, model);
                            }
                        }
                        else if (typeof model.ArrayScheduleObjects !== 'undefined') {
                            pageScope.generalModel.CompareServerDataInSchedule(model, parent);
                        }

                        if ((typeof model.ArrayGridObjects === 'undefined') || ((typeof model.ArrayGridObjects !== 'undefined') && !model.ArrayGridObjects.length)) {
                            pageScope.generalModel.ConcurrencyParentWithoutTables(parent, model, false);
                            if (pageScope.generalModel.HasObjectKeys(pageScope.generalModel.ObjectDataForConcurrency)) {
                                pageScope.generalModel.CallConcurrencyByObject(parent, key, model);
                            }
                        }
                    }).catch(function (exception) {
                        if (exception.Code === '409') {
                            pageScope.generalModel.FullPageLoading = false;
                            pageScope.generalModel.ConcurrencyParentWithoutTables(parent, model, true);
                        }
                        else {
                            GeneralModel.ShowToastWarning(exception.Message);
                        }
                    });
                }
                else {
                    $q.when(GeneralModel.ListFromServer(model)).then(function () {
                        if (pageScope.generalModel.HasObjectKeys(pageScope.generalModel.ObjectDataForConcurrency)) {
                            pageScope.generalModel.CallConcurrencyByObject('', key, model);
                        }

                        pageScope.generalModel.CompareServerData(model, key, '');
                    }).catch(function (reason) {
                        GeneralModel.ShowToastWarning(reason);
                    }).finally(function () {
                        pageScope.generalModel.FullPageLoading = false;
                    });
                }
            };

            pageScope.generalModel.ConcurrencyParentWithoutTables = function (parent, model, deleted) {
                if (deleted) {
                    if (!angular.element('#MainObjectServerConcurrency').find('.InfoTextServer').length) {
                        delete model[parent].CreationDatetime;
                        delete model[parent].CreationUser;
                        delete model[parent].CreationUserId;
                        delete model[parent].RowVersion;
                        delete model[parent].User;
                        delete model[parent][model.MainObjectId];
                        model[model.MainObjectId] = null;
                        model.ElementId = null;
                        var deletedText = (!pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.DeletedRegister : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).deletedRegister;
                        angular.element('#MainObjectServerConcurrency').prepend('<span class="InfoTextServer"><span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone"><span class="PopUpTitle">' + deletedText + '</span></span></span>');
                    }
                }
                else {
                    if ((model[parent] !== null) && (typeof model[parent] !== 'undefined')) {
                        var insideObject = pageScope.generalModel.CheckInnerObjectRowVersion(model[parent], model.ServerData, model);

                        if ((model.ServerData.RowVersion !== model[parent].RowVersion) || insideObject.length) {
                            pageScope.generalModel.ReplaceRowVersion(model[parent], model.MainObjectId, model.ServerData[model.MainObjectId], model.ServerData.RowVersion, insideObject);
                            if (!angular.element('#MainObjectServerConcurrency').find('.InfoTextServer').length) {
                                pageScope.generalModel.ShowServerData('#MainObjectServerConcurrency', angular.element('#MainObjectServerConcurrency'), '', model, '', '', parent);
                            }
                        }

                        for (var propertyName in model[parent]) {
                            var innerObject = pageScope.generalModel.GetObjectByString(model[parent], propertyName);
                            var innerObjectServerData = pageScope.generalModel.GetObjectByString(model.ServerData, propertyName);

                            if (!angular.isArray(innerObject)) {
                                continue;
                            }

                            for (var o = 0; o < innerObject.length; o++) {
                                var item = innerObject[o];

                                var property = model.InnerObjectId;
                                var propertyId = pageScope.generalModel.AngularCopy(pageScope.generalModel.GetObjectByString(item, property));
                                var serverObject = [];

                                for (var s = 0; s < innerObjectServerData.length; s++) {
                                    if (pageScope.generalModel.GetObjectByString(innerObjectServerData[s], model.InnerObjectId) === propertyId) {
                                        serverObject.push(innerObjectServerData[s]);
                                    }
                                }
                                if (serverObject.length) {
                                    item.RowVersion = pageScope.generalModel.AngularCopy(serverObject[0].RowVersion);
                                }
                                else {
                                    delete item[model.InnerObjectId];
                                    delete item.CreationDatetime;
                                    delete item.CreationUser;
                                    delete item.CreationUserId;
                                    delete item.RowVersion;
                                    delete item[model.MainObjectId];
                                }
                            }
                        }

                        if (!angular.element('#MainObjectServerConcurrency').find('.InfoTextServer').length) {
                            pageScope.generalModel.ShowServerData('#MainObjectServerConcurrency', angular.element('#MainObjectServerConcurrency'), '', model, '', '', parent);
                        }
                    }
                }
                angular.element('.InfoTextServer').off('mouseover').mouseover(function (e) {
                    if (angular.element(this).parents('md-tab-content').length) {
                        angular.element('.PopUp', this).css({ 'top': angular.element(this)[0].getBoundingClientRect().top - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().top, 'right': angular.element(this)[0].getBoundingClientRect().left - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().width });
                    }
                    else {
                        angular.element('.PopUp', this).css({ 'top': e.pageY, 'right': $window.innerWidth - e.pageX });
                    }
                    angular.element('.PopUp', this).removeClass('DisplayNone');
                });
                angular.element('.InfoTextServer').off('mouseout').mouseout(function () {
                    angular.element('.PopUp', this).addClass('DisplayNone');
                });
            };

            pageScope.generalModel.CallConcurrency = function (pageScope, e, model, gridKey, key, modelReference, parent, deleteVisible) {
                if (!pageScope.generalModel.IsUndefinedEmptyOrNull(model.ArrayGridObjects[gridKey])) {
                    var id;
                    var element;
                    var toolStateItem
                    var idName = model.ArrayGridObjects[gridKey].MainId;
                    var gridName = model.ArrayGridObjects[gridKey].GridName;
                    var grid = angular.element(e.element).dxDataGrid('instance');
                    var columns = grid.getVisibleColumns();
                    var twoLevels = false;
                    var rowIndex;

                    if (typeof parent === 'undefined') {
                        parent = '';
                    }

                    if (key !== '') {
                        gridName = model.ArrayGridObjects[gridKey].SecondGrid + key[model.ArrayGridObjects[gridKey].MainId];
                        idName = model.ArrayGridObjects[gridKey].SecondGridMainId;
                        twoLevels = true;
                    }

                    if (twoLevels) {
                        var insertedRows = [];
                        var hasChanges = (pageScope.generalModel.EditedElements.length || pageScope.generalModel.DeletedElements.length);

                        if (!hasChanges) {
                            insertedRows = Helpers.DevExtreme.Grid.GetEditData(null, e, ["insert"]);
                        }

                        if (hasChanges || ((e.component.hasEditData() && (e.component.getDataSource() !== null) && (e.component.getDataSource()._store._array.length)) || pageScope.generalModel.ParentRowInserted.length || insertedRows.length)) {
                            $timeout(function () {
                                pageScope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                pageScope.generalModel.SidebarOptions['State']['CancelOption'] = true;
                            });

                            for (var d = 0; d < model.ToolsStateItems.length; d++) {
                                toolStateItem = model.ToolsStateItems[d];

                                if (toolStateItem.Id === key[idName]) {
                                    toolStateItem.State = true;
                                    break;
                                }
                            }
                        }
                        else {
                            if (!pageScope.generalModel.CheckIfThereAreEditedFields(model)) {
                                $timeout(function () {
                                    model.ToolsState = false;
                                    pageScope.generalModel.SidebarOptions['State']['SaveOption'] = false;
                                    pageScope.generalModel.SidebarOptions['State']['CancelOption'] = false;
                                });

                                for (var tool = 0; tool < model.ToolsStateItems.length; tool++) {
                                    toolStateItem = model.ToolsStateItems[tool];

                                    if (toolStateItem.Id === key[idName]) {
                                        toolStateItem.State = false;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    else {
                        if (!pageScope.generalModel.IsUndefinedEmptyOrNull(model.ToolsStateItems)) {
                            var myActualGrid = angular.element("#" + gridName + "").dxDataGrid('instance');

                            if ((pageScope.generalModel.EditedElements.length || pageScope.generalModel.DeletedElements.length) || (e.component.hasEditData() && pageScope.generalModel.GetEditDataClean(myActualGrid).length) || (e.component.hasEditData() && (e.component.getDataSource() !== null) && e.component.getDataSource()._store._array.length || pageScope.generalModel.ParentRowInserted.length)) {
                                model.ToolsStateItems[gridKey] = true;
                            }
                            else {
                                model.ToolsStateItems[gridKey] = false;
                            }
                        }
                        if ((pageScope.generalModel.EditedElements.length || pageScope.generalModel.DeletedElements.length) || (e.component.hasEditData() && pageScope.generalModel.GetEditDataClean(grid).length) || (e.component.hasEditData() && (e.component.getDataSource() !== null) && e.component.getDataSource()._store._array.length || pageScope.generalModel.ParentRowInserted.length)) {
                            $timeout(function () {
                                model.ToolsState = true;
                                pageScope.generalModel.SidebarOptions['State']['SaveOption'] = true;
                                pageScope.generalModel.SidebarOptions['State']['CancelOption'] = true;
                            });
                        }
                        else if (pageScope.generalModel.IsUndefinedEmptyOrNull(parent)) {
                            var editData = Helpers.DevExtreme.Grid.GetEditData(null, e);
                            var validEditData = editData.find(find => (find.type !== 'undefined'));

                            if (!validEditData) {
                                $timeout(function () {
                                    model.ToolsState = false;
                                    if (!pageScope.generalModel.CheckIfThereAreEditedFields(model)) {
                                        pageScope.generalModel.SidebarOptions['State']['SaveOption'] = false;
                                        pageScope.generalModel.SidebarOptions['State']['CancelOption'] = false;
                                    }
                                });
                            }
                        }
                    }

                    var toDelete = false;

                    if ((model.ShowDeleteIcon) && ((typeof model.AllowRemoval === 'undefined') || ((typeof model.AllowRemoval !== 'undefined') && (model.AllowRemoval)))) {
                        toDelete = true;
                    }

                    angular.element(".dx-datagrid .dx-link.dx-link-delete").each(function (index) {
                        angular.element(this).removeAttr('href');
                        if (angular.element(".dx-row.dx-data-row.dx-column-lines").eq(index).find('.' + idName + '') && angular.element(".dx-row.dx-data-row.dx-column-lines").eq(index).find('.' + idName + '').text() !== 'undefined') {
                            id = angular.element(".dx-row.dx-data-row.dx-column-lines").eq(index).find('.' + idName + '').text();
                        }
                        else {
                            id = '';
                        }

                        element = angular.element(this);
                        if (!angular.element(this).hasClass('dx-command-edit')) {
                            element = angular.element(this).parent('.dx-command-edit');
                        }

                        id = angular.element(this).closest('tr').find('.' + idName + '').text();

                        if (pageScope.generalModel.ConcurrencyError) {
                            if (pageScope.ArrayFunctions.FindInObject(pageScope.generalModel.EditedElements, "Id", id) !== null) {
                                var trLine = angular.element('.' + idName + ':contains("' + id + '")').closest('tr');
                                if (!angular.element(trLine).find('.dx-cell-modified').length) {
                                    var columns = grid.getVisibleColumns();
                                    var rowIndex = pageScope.generalModel.FindIndex(trLine);
                                    angular.element('td', trLine).each(function (index) {
                                        pageScope.generalModel.IsUpdating = true;
                                        if (typeof columns[index].dataField !== 'undefined') {
                                            var dataCell = grid.cellValue(rowIndex, columns[index].dataField);

                                            if (pageScope.generalModel.ValidateDate(dataCell)) {
                                                dataCell = $filter('date')(dataCell, myApplication.dateFormat);
                                            }

                                            if (columns[index].dataField === 'Disabled') {
                                                if (dataCell === 'Disabled') {
                                                    dataCell = true;
                                                }
                                                else {
                                                    dataCell = false;
                                                }
                                            }

                                            if (dataCell === null) {
                                                dataCell = "";
                                            }

                                            if (typeof dataCell !== 'undefined') {
                                                grid.cellValue(rowIndex, columns[index].dataField, dataCell);
                                            }
                                            angular.element(this).removeClass('dx-datagrid-invalid');
                                        }
                                        if (index === angular.element('td', trLine).length - 1) {
                                            pageScope.generalModel.IsUpdating = false;
                                        }
                                    });
                                }
                            }
                        }

                        element = angular.element(".dx-datagrid .dx-link.dx-link-delete").eq(index);

                        if ((typeof pageScope.generalModel.EditedElements !== 'undefined') && (pageScope.ArrayFunctions.FindInObject(pageScope.generalModel.EditedElements, "Id", id) !== null)) {
                            if (!angular.element(element).find('.InfoTextServer').length) {
                                if (pageScope.generalModel.SecondLevelUpdate.length) {
                                    for (var u = 0; u < pageScope.generalModel.SecondLevelUpdate.length; u++) {
                                        for (var c = 0; c < pageScope.generalModel.SecondLevelUpdate[u].Content.length; c++) {
                                            var content = pageScope.generalModel.SecondLevelUpdate[u].Content[c];
                                            var contentOldData = Helpers.DevExtreme.Grid.GetOldDataEditedRow(content);

                                            if (((typeof contentOldData !== 'undefined') && (contentOldData[idName] === id)) || (content.key[idName] === id)) {
                                                if (typeof contentOldData === 'undefined') {
                                                    rowIndex = grid.getRowIndexByKey(content.key);
                                                }
                                                else {
                                                    rowIndex = grid.getRowIndexByKey(contentOldData);
                                                }

                                                for (var k in content.data) {
                                                    if (content.data.hasOwnProperty(k)) {
                                                        content = pageScope.generalModel.AngularCopy(content.data[k]);

                                                        delete content.data[k];

                                                        if (pageScope.generalModel.ValidateDate(content)) {
                                                            content = $filter('date')(content, myApplication.dateFormat);
                                                        }

                                                        grid.cellValue(rowIndex, k, content);
                                                    }
                                                }

                                                pageScope.generalModel.SecondLevelUpdate.splice(u, 1);

                                                break;
                                            }
                                        }
                                    }
                                }
                                else {
                                    pageScope.generalModel.ShowServerData(this, element, columns, model, id, gridKey, parent);
                                }
                            }
                        }
                        if ((id !== '') && (typeof pageScope.generalModel.DeletedElements !== 'undefined') && (pageScope.ArrayFunctions.FindInObject(pageScope.generalModel.DeletedElements, "Id", id) !== null)) {
                            if (!angular.element(element).find('.InfoTextServer').length) {
                                var deletedText = (!pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations)) ? Helpers.Translations.DeletedRegister : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).deletedRegister;
                                angular.element(element).prepend('<span class="InfoTextServer"><span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone"><span class="PopUpTitle">' + deletedText + '</span></span></span>');
                                $compile(angular.element(element))(pageScope);
                            }

                            if (deleteVisible && !angular.element(element).has("span.lnr-trash").length) {
                                angular.element(element).attr('ng-click', 'generalModel.DeleteRowDeleted(' + modelReference + ', \'0\', \'' + id + '\')');
                                angular.element(element).append('<span class="lnr lnr-trash MarginRight10" ng-show="' + toDelete + '"></span>');
                                $compile(angular.element(element))(pageScope);
                            }
                        }
                        else if (deleteVisible && !angular.element(element).has("span.lnr-trash").length && !angular.element(element).hasClass("LinkDisabled")) {
                            angular.element(element).attr('ng-click', 'CallFunction(\'delete\')');
                            angular.element(element).append('<span class="lnr lnr-trash MarginRight10" ng-show="' + toDelete + '"></span>');
                        }

                        if (!angular.element(element).parent('.dx-command-edit').find("span.lnr-undo").length && (id !== '')) {
                            var elementInner = angular.element(element);

                            if (!angular.element(elementInner).hasClass('dx-command-edit')) {
                                elementInner = angular.element(elementInner).parent('.dx-command-edit');
                            }

                            if (!angular.element(elementInner).find('.ButtonUpdateRow').length) {
                                angular.element(elementInner).prepend('<a class="ButtonUpdateRow dx-link DisplayNone"><span class="lnr lnr-undo dx-link MarginRight10" ng-class=""></span></a>');
                                angular.element(elementInner).find("a.ButtonUpdateRow").attr('ng-class', '{\'Disable\' : \'' + id + '\' === \'\'}').attr('ng-click', 'generalModel.UpdateRow(' + modelReference + ', \'' + gridKey + '\', \'' + id + '\', ' + twoLevels + ', \'' + parent + '\'); $event.stopPropagation();');
                                angular.element(elementInner).find("a.ButtonUpdateRow .lnr-undo").attr('ng-class', '{\'Disable\' : \'' + id + '\' === \'\'}');
                                $compile(angular.element(elementInner).find('a.ButtonUpdateRow'))(pageScope);
                            }
                        }
                    });

                    angular.element(".dx-datagrid .dx-link.dx-link-undelete").each(function () {
                        angular.element(this).removeAttr('href');
                        id = angular.element(this).closest('tr').find('.' + idName + '').text();
                        if ((typeof pageScope.generalModel.EditedElements !== 'undefined') && (pageScope.ArrayFunctions.FindInObject(pageScope.generalModel.EditedElements, "Id", id) !== null)) {
                            element = angular.element(this);
                            if (!angular.element(this).hasClass('dx-command-edit')) {
                                element = angular.element(this).parent('.dx-command-edit');
                            }

                            if (!angular.element(element).find('.InfoTextServer').length) {
                                pageScope.generalModel.ShowServerData(this, element, columns, model, id, gridKey, parent);
                            }
                        }
                        if (!angular.element(this).has("span.lnr-undo").length) {
                            angular.element(this).attr('ng-click', 'CallFunction(\'undelete\')');
                            angular.element(this).append('<span class="lnr lnr-undo MarginRight10"></span>');
                        }
                    });

                    angular.element(".dx-data-row .dx-command-edit").each(function (index) {
                        if (angular.element(".dx-row.dx-data-row.dx-column-lines").eq(index).find('.' + idName + '') && angular.element(".dx-row.dx-data-row.dx-column-lines").eq(index).find('.' + idName + '').text() !== 'undefined') {
                            id = angular.element(".dx-row.dx-data-row.dx-column-lines").eq(index).find('.' + idName + '').text();
                        }
                        else {
                            id = '';
                        }
                        var myActualGrid = angular.element("#" + gridName + "").dxDataGrid('instance');
                        var myActualDataSource = "";
                        var myLineObject = "";
                        if (typeof myActualGrid !== 'undefined') {
                            myActualDataSource = myActualGrid.getDataSource();
                            if (myActualDataSource !== null) {
                                var objectForFilter = {};
                                objectForFilter[idName] = id;
                                myLineObject = $filter('filter')(myActualDataSource._store._array, objectForFilter, true)[0];
                            }
                        }

                        if (!angular.element(this).has("span.lnr-history").length && (id !== '') && !pageScope.generalModel.IsUndefinedEmptyOrNull(myLineObject) && (myLineObject.CreationUser !== myApplication.guidEmpty)) {
                            var content = '<a class="dx-link HistoryButton"><span class="lnr lnr-history dx-link"></span></a>';
                            angular.element(content).appendTo(this);
                            angular.element(this).find("a.HistoryButton").attr('ng-class', '{\'Disabled\' : \'' + id + '\' === \'\'}').attr('ng-click', 'generalModel.LoadHistory(\'' + id + '\', \'' + gridName + '\', \'' + idName + '\', \'' + myLineObject.CreationUser + '\', \'' + myLineObject.CreationDatetime + '\');');
                            angular.element(this).find("span.lnr-history").attr('ng-class', '{\'Disabled\' : \'' + id + '\' === \'\'}');
                            $compile(angular.element(this).find('a.HistoryButton'))(pageScope);
                        }
                    });

                    if (angular.element('.dx-cell-modified').length) {
                        angular.element('.dx-cell-modified').each(function (index) {
                            id = angular.element(this).closest('tr').find('.' + idName + '').text();
                            if ((id !== 'undefined') && (id !== '') && (id !== pageScope.generalModel.GuidEmpty) && ((typeof pageScope.generalModel.DeletedElements === 'undefined') || ((typeof pageScope.generalModel.DeletedElements !== 'undefined') && pageScope.ArrayFunctions.FindInObject(pageScope.generalModel.DeletedElements, "Id", id) === null))) {
                                angular.element(this).closest('tr').find('.ButtonUpdateRow').removeClass('DisplayNone');
                            }
                        });
                    }

                    angular.element('.InfoTextServer').off('mouseover').mouseover(function (e) {
                        if (angular.element(this).parents('md-tab-content').length) {
                            angular.element('.PopUp', this).css({ 'top': angular.element(this)[0].getBoundingClientRect().top - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().top, 'right': angular.element(this)[0].getBoundingClientRect().left - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().width });
                        }
                        else {
                            angular.element('.PopUp', this).css({ 'top': e.pageY, 'right': $window.innerWidth - e.pageX });
                            angular.element('.PopUp', this).removeClass('DisplayNone');
                        }
                    });
                    angular.element('.InfoTextServer').off('mouseout').mouseout(function () {
                        angular.element('.PopUp', this).addClass('DisplayNone');
                    });
                }
            };

            pageScope.generalModel.CallConcurrencyByObject = function (parent, arrayKey, model) {
                var mainObject;
                var serverData;
                var newData;
                var objectForFilter;
                if (parent !== '') {
                    mainObject = model[parent];
                    serverData = model.ServerData;
                }
                else {
                    mainObject = model.ArrayGridObjects[arrayKey].ObjectName + 'Element';
                    serverData = model.ServerData[model.ArrayGridObjects[arrayKey].ObjectName];
                }

                for (var key in pageScope.generalModel.ObjectDataForConcurrency) {
                    if (angular.isArray(serverData)) {
                        for (var u = 0; u < serverData.length; u++) {
                            if (serverData[u].hasOwnProperty(key)) {
                                newData = $parse(pageScope.generalModel.ObjectDataForConcurrency[key].OriginalObjectName);
                                newData.assign(pageScope, serverData[u][key]);
                                pageScope.generalModel.ReplaceObjectRowVersion(key, serverData[u][key], pageScope.generalModel.ObjectDataForConcurrency[key].IdName);
                                pageScope.generalModel.ConcurrencyObjectChangeElement(key, mainObject, serverData);
                            }
                        }
                    }
                    else {
                        if (serverData.hasOwnProperty(key)) {
                            newData = $parse(pageScope.generalModel.ObjectDataForConcurrency[key].OriginalObjectName);
                            newData.assign(pageScope, serverData[key]);
                            pageScope.generalModel.ReplaceObjectRowVersion(key, serverData[key], pageScope.generalModel.ObjectDataForConcurrency[key].IdName);
                            pageScope.generalModel.ConcurrencyObjectChangeElement(key, mainObject, serverData);
                        }
                    }
                }
            };

            pageScope.generalModel.ConcurrencyObjectChangeElement = function (object, mainObject, serverData) {
                var idName = pageScope.generalModel.ObjectDataForConcurrency[object].IdName;
                var textServerDataContent;
                var caption;

                for (var q = 0; q < mainObject[object].length; q++) {
                    var itemQ = mainObject[object][q];

                    objectForFilter = {};
                    objectForFilter[idName] = itemQ[idName];

                    if (typeof $filter('filter')(serverData[object], objectForFilter, true) === 'undefined') {
                        continue;
                    }

                    var completeServerData = "";
                    var finalServerData = "";
                    var serverDataContent = "";
                    var mainObjectDataContent = "";
                    var image = "";

                    if ($filter('filter')(pageScope.generalModel.EditedElements, { Id: itemQ[idName] }, true).length) {
                        for (var f = 0; f < pageScope.generalModel.ObjectDataForConcurrency[object].Fields.length; f++) {
                            var field = pageScope.generalModel.ObjectDataForConcurrency[object].Fields[f];
                            objectForFilter = {};
                            objectForFilter[idName] = itemQ[idName];

                            if (typeof $filter('filter')($filter('filter')(serverData[object], objectForFilter, true), objectForFilter, true)[0][field.DataField] !== 'undefined') {
                                serverDataContent = pageScope.generalModel.GetObjectByString($filter('filter')(serverData[object], objectForFilter, true)[0], field.DataField);

                                image = '';

                                function isImage() {
                                    try {
                                        return btoa(atob(serverDataContent)) === serverDataContent;
                                    }
                                    catch (_exception) {
                                        return false;
                                    }
                                }

                                if (isNaN(serverDataContent) && isImage()) {
                                    image = serverDataContent;

                                    if (serverDataContent.indexOf("data:image/gif;base64,") < 0) {
                                        serverDataContent = "data:image/gif;base64," + image;
                                    }

                                    serverDataContent = '<img class="SmallPhoto" src="' + serverDataContent + '" />';
                                }

                                if (typeof serverDataContent === 'undefined') {
                                    serverDataContent = '';
                                }
                                else if (pageScope.generalModel.ValidateDate(serverDataContent)) {
                                    serverDataContent = $filter('date')(serverDataContent, myApplication.dateFormat);
                                }

                                if ((serverDataContent === null) || (typeof serverDataContent === 'undefined')) {
                                    serverDataContent = "";
                                }

                                if (typeof $filter('filter')(serverData[object], objectForFilter, true)[0][field.DataField] !== 'undefined') {
                                    completeServerData = completeServerData + '<p>' + field.Caption + ': ' + serverDataContent + '</p>';
                                }
                            }
                        }

                        finalServerData = "<span class=\"PopUpTitle\">" + !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ServerData : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).serverData + "</span><br>";

                        for (var p = 0; p < pageScope.generalModel.ObjectDataForConcurrency[object].Lists.length; p++) {
                            var itemP = pageScope.generalModel.ObjectDataForConcurrency[object].Lists[p];
                            var objectForFilter = {};
                            objectForFilter[idName] = itemQ[idName];

                            if (typeof $filter('filter')(serverData[object], objectForFilter, true)[0][itemP.List] !== 'undefined') {
                                serverDataContent = pageScope.generalModel.GetObjectByString($filter('filter')(serverData[object], objectForFilter, true)[0], item.List);
                                mainObjectDataContent = itemQ[itemP.List];

                                textServerDataContent = "";
                                var caption = "";

                                if (typeof serverDataContent === 'undefined') {
                                    serverDataContent = '';
                                }
                                else if (serverDataContent.length) {
                                    var objectDescription = "<ul>";

                                    for (var m = 0; m < serverDataContent.length; m++) {
                                        caption = pageScope.generalModel.GetObjectByString(serverDataContent[m], itemP.Field)
                                        objectDescription += "<li>" + caption + "</li>";
                                    }

                                    objectDescription += "</ul>";
                                    textServerDataContent = itemP.Caption;
                                    completeServerData = completeServerData + '<p>' + textServerDataContent + ': ' + objectDescription + '</p>';
                                }
                            }
                        }

                        if (!pageScope.generalModel.IsUndefinedEmptyOrNull(pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea)) {
                            if (!pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea) {
                                pageScope.generalModel.FillObjectConcurrencyCloud('' + pageScope.generalModel.ObjectDataForConcurrency[object].DrawnIdName + q + '', finalServerData, completeServerData, true);
                                $('<span id="GoBackMainObject" ng-click="generalModel.GoBackMainObject(' + pageScope.generalModel.ObjectDataForConcurrency[object].Model.ModelName + ', \'' + pageScope.generalModel.ObjectDataForConcurrency[object].ObjectName + '[' + q + ']' + '\')" class="lnr lnr-undo DisplayNone" role="button" tabindex="0"></span>').insertAfter(angular.element('#CardBigOpenArea').find('.InfoTextServer'));
                                $compile(angular.element("#CardBigOpenArea").find("#GoBackMainObject"))(pageScope);
                            }
                            else {
                                pageScope.generalModel.FillObjectConcurrencyCloud('' + pageScope.generalModel.ObjectDataForConcurrency[object].DrawnIdName + q + '', finalServerData, completeServerData, false);
                            }
                        }
                    }
                    else if ($filter('filter')(pageScope.generalModel.DeletedElements, { Id: itemQ[idName] }, true).length) {
                        finalServerData = "<span class=\"PopUpTitle\">" + !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.DeletedRegister : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).deletedRegister + "</span>";

                        if (!pageScope.generalModel.IsUndefinedEmptyOrNull(pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea)) {
                            if (!pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea) {
                                pageScope.generalModel.FillObjectConcurrencyCloud('' + pageScope.generalModel.ObjectDataForConcurrency[object].DrawnIdName + q + '', finalServerData, "", true);
                                $('<span id="GoBackMainObject" ng-click="generalModel.GoBackMainObject(' + pageScope.generalModel.ObjectDataForConcurrency[object].Model.ModelName + ', \'' + pageScope.generalModel.ObjectDataForConcurrency[object].ObjectName + '[' + q + ']' + '\')" class="lnr lnr-undo DisplayNone" role="button" tabindex="0"></span>').insertAfter(angular.element('#CardBigOpenArea').find('.InfoTextServer'));
                                $compile(angular.element("#CardBigOpenArea").find("#GoBackMainObject"))(pageScope);
                            }
                            else {
                                pageScope.generalModel.FillObjectConcurrencyCloud('' + pageScope.generalModel.ObjectDataForConcurrency[object].DrawnIdName + q + '', finalServerData, "", false);
                            }
                        }
                    }
                    else {
                        for (var p = 0; p < pageScope.generalModel.ObjectDataForConcurrency[object].Lists.length; p++) {
                            var itemP = pageScope.generalModel.ObjectDataForConcurrency[object].Lists[p];
                            objectForFilter = {};
                            objectForFilter[idName] = itemQ[idName];

                            if (typeof $filter('filter')(serverData[object], objectForFilter, true)[0][itemP.List] !== 'undefined') {
                                serverDataContent = pageScope.generalModel.GetObjectByString($filter('filter')(serverData[object], objectForFilter, true)[0], itemP.List);
                                mainObjectDataContent = itemQ[itemP.List];

                                textServerDataContent = "";
                                caption = "";

                                if (typeof serverDataContent === 'undefined') {
                                    serverDataContent = '';
                                }
                                else if (serverDataContent.length) {
                                    for (var m = 0; m < serverDataContent.length; m++) {

                                        if ($filter('filter')(pageScope.generalModel.EditedElements, { Id: serverDataContent[m][itemP.ListId] }, true).length) {
                                            caption = pageScope.generalModel.GetObjectByString(serverDataContent[m], itemP.Caption);
                                            textServerDataContent = serverDataContent[m][itemP.Field];
                                            completeServerData = completeServerData + '<p>' + caption + ': ' + textServerDataContent + '</p>';
                                        }
                                    }
                                }

                                if (serverDataContent.length < mainObjectDataContent.length) {
                                    for (var v = 0; v < mainObjectDataContent.length; v++) {
                                        if ($filter('filter')(pageScope.generalModel.DeletedElements, { Id: mainObjectDataContent[v][itemP.ListId] }, true).length) {
                                            caption = pageScope.generalModel.GetObjectByString(mainObjectDataContent[v], itemP.Caption);
                                            completeServerData = completeServerData + '<p>' + caption + ': ' + !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.DeletedRegister : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).deletedRegister + '</p>';
                                        }
                                    }
                                }
                            }

                            if ((finalServerData === "") && (completeServerData !== "")) {
                                finalServerData = "<span class=\"PopUpTitle\">" + !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ServerData : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).serverData + "</span><br>";
                            }
                        }
                        if (completeServerData !== "") {
                            if (!pageScope.generalModel.IsUndefinedEmptyOrNull(pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea)) {
                                if (!pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea) {
                                    pageScope.generalModel.FillObjectConcurrencyCloud('' + pageScope.generalModel.ObjectDataForConcurrency[object].DrawnIdName + q + '', finalServerData, "", true);
                                    $('<span id="GoBackMainObject" ng-click="generalModel.GoBackMainObject(' + pageScope.generalModel.ObjectDataForConcurrency[object].Model.ModelName + ', \'' + pageScope.generalModel.ObjectDataForConcurrency[object].ObjectName + '[' + q + ']' + '\')" class="lnr lnr-undo DisplayNone" role="button" tabindex="0"></span>').insertAfter(angular.element('#CardBigOpenArea').find('.InfoTextServer'));
                                    $compile(angular.element("#CardBigOpenArea").find("#GoBackMainObject"))(pageScope);
                                }
                                else {
                                    pageScope.generalModel.FillObjectConcurrencyCloud('' + pageScope.generalModel.ObjectDataForConcurrency[object].DrawnIdName + q + '', finalServerData, "", false);
                                }
                            }
                        }
                    }
                }

                angular.element('.ObjectWithConcurrency .InfoTextServer').off('mouseover').mouseover(function (e) {
                    if (angular.element(this).parents('section.gridContent').length) {
                        angular.element('.PopUp', this).css({ 'top': '75px', 'right': '55px', 'left': 'auto', 'bottom': 'auto' });
                    }
                    else if (angular.element(this).parents('#CardBigOpenArea').length) {
                        angular.element('.PopUp', this).css({ 'top': '0px', 'right': '30px', 'left': 'auto', 'bottom': 'auto' });
                    }
                    else if (angular.element(this).parents('.CardButtonsArea').length) {
                        angular.element('.PopUp', this).css({ 'top': '10px', 'position': 'fixed' });
                    }
                    else {
                        angular.element('.PopUp', this).css({ 'bottom': '10px', 'left': '0px' });
                    }
                    angular.element('.PopUp', this).removeClass('DisplayNone');
                });

                angular.element('.ObjectWithConcurrency .InfoTextServer').off('mouseout').mouseout(function () {
                    angular.element('.PopUp', this).addClass('DisplayNone');
                });
            };

            pageScope.generalModel.FillObjectConcurrencyCloud = function (id, text, content, displayInOpenArea) {
                if (!pageScope.generalModel.IsUndefinedEmptyOrNull(text)) {
                    if (displayInOpenArea) {
                        angular.element('#CardBigOpenArea').find('.InfoTextServer').html('<span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone">' + text + content + '</span></span>');
                    }
                    angular.element('#' + id).find('.InfoTextServer').html('<span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone">' + text + content + '</span></span>');
                }
            };

            pageScope.generalModel.ConcurrencyObjectElement = function (objectName, parent, arrayKey) {
                $timeout(function () {
                    if (!pageScope.generalModel.IsUndefinedEmptyOrNull(pageScope.generalModel.ConcurrencyModel)) {
                        var mainObject;
                        var serverData;
                        if (parent !== '') {
                            mainObject = pageScope.$eval(pageScope.generalModel.ConcurrencyModel)[parent];
                            serverData = pageScope.$eval(pageScope.generalModel.ConcurrencyModel).ServerData;
                        }
                        else {
                            mainObject = pageScope.$eval(pageScope.generalModel.ConcurrencyModel).ArrayGridObjects[arrayKey].ObjectName + 'Element';
                            serverData = pageScope.$eval(pageScope.generalModel.ConcurrencyModel).ServerData[model.ArrayGridObjects[arrayKey].ObjectName];
                        }

                        if (pageScope.generalModel.ObjectDataForConcurrency.length) {
                            pageScope.generalModel.ConcurrencyObjectChangeElement(objectName, mainObject, serverData);
                        }
                    }
                });
            };

            pageScope.generalModel.ShowServerData = function (thisElement, element, columns, model, id, gridKey, parent) {
                var completeServerData = '';
                var serverDataContent;

                if (thisElement === '#MainObjectServerConcurrency') {
                    if ((typeof model.MainObjectListOfFields !== 'undefined') && model.MainObjectListOfFields.length) {
                        for (var e = 0; e < model.MainObjectListOfFields.length; e++) {
                            var field = model.MainObjectListOfFields[e];

                            if (field.caption !== '') {
                                var dataField = field.dataField;

                                if (angular.isArray(pageScope.generalModel.GetObjectByString(model.ServerData, dataField))) {
                                    serverDataContent = [];

                                    for (var i = 0; i < pageScope.generalModel.GetObjectByString(model.ServerData, dataField).length; i++) {
                                        if ((typeof field.dataFieldToShow !== 'undefined') && (field.dataFieldToShow !== '')) {
                                            serverDataContent.push(pageScope.generalModel.GetObjectByString(pageScope.generalModel.GetObjectByString(model.ServerData, dataField)[i], field.dataFieldToShow));
                                        }
                                    }
                                }
                                else {
                                    if ((typeof field.dataFieldToShow !== 'undefined') && (field.dataFieldToShow !== '')) {
                                        dataField = field.dataFieldToShow;
                                    }

                                    serverDataContent = pageScope.generalModel.GetObjectByString(model.ServerData, dataField);
                                }

                                var image = '';

                                function isImage() {
                                    try {
                                        return btoa(atob(serverDataContent)) === serverDataContent;
                                    }
                                    catch (_exception) {
                                        return false;
                                    }
                                }

                                if (isNaN(serverDataContent) && isImage()) {
                                    image = serverDataContent;

                                    if (serverDataContent.indexOf("data:image/gif;base64,") < 0) {
                                        serverDataContent = "data:image/gif;base64," + image;
                                    }

                                    serverDataContent = '<img class="SmallPhoto" src="' + serverDataContent + '" />';
                                }

                                if ((serverDataContent === null) || (typeof serverDataContent === "undefined")) {
                                    serverDataContent = '';
                                }
                                else if (pageScope.generalModel.ValidateDate(serverDataContent)) {
                                    serverDataContent = $filter('date')(serverDataContent, myApplication.dateFormat);
                                }

                                if (dataField === 'Disabled') {
                                    if (serverDataContent) {
                                        serverDataContent = !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Disabled : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).disabled;
                                    }
                                    else {
                                        serverDataContent = !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Enabled : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).enabled;
                                    }
                                }

                                if (angular.isArray(serverDataContent)) {
                                    if (serverDataContent.length) {
                                        var object = "<ul>";

                                        for (var s = 0; s < serverDataContent.length; s++) {
                                            object += "<li>" + serverDataContent[s] + "</li>";
                                        }

                                        object += "</ul>";
                                        serverDataContent = object;
                                        completeServerData = completeServerData + '<p>' + field.caption + ': ' + serverDataContent + '</p>';
                                    }
                                } else if ((serverDataContent !== '') && (typeof serverDataContent !== 'undefined')) {
                                    completeServerData = completeServerData + '<p>' + field.caption + ': ' + serverDataContent + '</p>';
                                }
                            }
                        }
                    }

                    angular.element(element).prepend('<span class="InfoTextServer"><span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone"><span class="PopUpTitle"> {{:refresh: !generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ServerData : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).serverData}}</span><br>' + completeServerData + '</span></span>' + '<span id="GoBackMainObject" ng-click="generalModel.GoBackMainObject(' + model.ModelName + ', \'' + parent + '\')" class="lnr lnr-undo"></span>');

                    $compile(angular.element(element))(pageScope);
                }
                else {
                    var trLine = angular.element(thisElement).closest('tr');
                    var idName = model.ArrayGridObjects[gridKey].MainId;
                    var gridName = model.ArrayGridObjects[gridKey].GridName;
                    var secondGridName;
                    var secondGridElementName;
                    var secondIdName;
                    var grid = angular.element('#' + gridName).dxDataGrid('instance');
                    var secondGrid;
                    var columns = grid.getVisibleColumns();
                    var secondColumns;
                    var twoLevels = false;
                    var objectName = model.ArrayGridObjects[gridKey].ObjectName;
                    var serverData;

                    if (model.ArrayGridObjects[gridKey].SecondGridName !== '') {
                        secondGridName = model.ArrayGridObjects[gridKey].SecondGrid;
                        secondIdName = model.ArrayGridObjects[gridKey].SecondGridMainId;
                        secondGridElementName = model.ArrayGridObjects[gridKey].SecondGrid.substr(4);
                        twoLevels = true;
                    }

                    if (parent !== '') {
                        serverData = model.ServerData[objectName];
                    }
                    else {
                        serverData = model.ServerData;
                    }

                    if (typeof serverData === 'undefined') {
                        return;
                    }

                    for (var n = 0; n < serverData.length; n++) {
                        var serverDataItem = serverData[n];

                        if (serverDataItem[idName] === id) {
                            angular.element('td', trLine).each(function (index) {
                                if (typeof columns[index].dataField !== 'undefined') {
                                    serverDataContent = pageScope.generalModel.GetObjectByString(serverDataItem, columns[index].dataField);
                                    var image = "";

                                    function isImage() {
                                        try {
                                            return btoa(atob(serverDataContent)) === serverDataContent;
                                        }
                                        catch (_exception) {
                                            return false;
                                        }
                                    }

                                    if ((isNaN(serverDataContent)) && (isImage())) {
                                        image = serverDataContent;
                                        if (serverDataContent.indexOf("data:image/gif;base64,") < 0) {
                                            serverDataContent = "data:image/gif;base64," + image;
                                        }

                                        serverDataContent = '<img class="SmallPhoto" src="' + serverDataContent + '" />';
                                    }

                                    if ((serverDataContent === null) || (typeof serverDataContent === 'undefined')) {
                                        serverDataContent = "";
                                    }

                                    if (columns[index].dataField === 'Disabled') {
                                        if (serverDataContent) {
                                            serverDataContent = !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Disabled : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).disabled;
                                        }
                                        else {
                                            serverDataContent = !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Enabled : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).enabled;
                                        }
                                    }

                                    if (typeof serverDataContent === 'undefined') {
                                        serverDataContent = '';
                                    }
                                    else if (pageScope.generalModel.ValidateDate(serverDataContent)) {
                                        serverDataContent = $filter('date')(serverDataContent, myApplication.dateFormat);
                                    }

                                    if (typeof columns[index].caption !== 'undefined') {
                                        completeServerData = completeServerData + '<p>' + columns[index].caption + ': ' + serverDataContent + '</p>';
                                    }
                                }
                            });

                            angular.element(element).prepend('<span class="InfoTextServer"><span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone"><span class="PopUpTitle"> {{:refresh: !generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ServerData : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).serverData}}</span><br>' + completeServerData + '</span></span>');
                            $compile(angular.element(element))(pageScope);

                            break;
                        }
                        else if (twoLevels) {
                            secondGrid = angular.element('#' + secondGridName + serverDataItem[idName]).dxDataGrid('instance');

                            if (typeof secondGrid !== 'undefined') {
                                secondColumns = secondGrid.getVisibleColumns();

                                for (var s = 0; s < serverDataItem[secondGridElementName].length; s++) {
                                    if (serverDataItem[secondGridElementName][s][secondIdName] === id) {
                                        angular.element('td', trLine).each(function (index) {
                                            if (typeof secondColumns[index].dataField !== 'undefined') {
                                                var serverDataContent = pageScope.generalModel.GetObjectByString(serverDataItem[secondGridElementName][s], secondColumns[index].dataField);
                                                if (secondColumns[index].dataField === 'Disabled') {
                                                    if (serverDataContent) {
                                                        serverDataContent = !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Disabled : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).disabled;

                                                    }
                                                    else {
                                                        serverDataContent = !pageScope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.Enabled : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).enabled;

                                                    }
                                                }

                                                if ((typeof serverDataContent === 'undefined') || (serverDataContent === null)) {

                                                    serverDataContent = '';
                                                }
                                                else if (pageScope.generalModel.ValidateDate(serverDataContent)) {
                                                    serverDataContent = $filter('date')(serverDataContent, myApplication.dateFormat);
                                                }

                                                if (typeof secondColumns[index].caption !== 'undefined') {
                                                    completeServerData = completeServerData + '<p>' + secondColumns[index].caption + ': ' + serverDataContent + '</p>';
                                                }
                                            }
                                        });
                                        angular.element(element).prepend('<span class="InfoTextServer"><span class="lnr lnr-cloud-sync"></span> <span class="PopUp DisplayNone"><span class="PopUpTitle"> {{:refresh: !generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations) ? Helpers.Translations.ServerData : myApplication.getLanguageObject.selectedLanguage("concurrencyDataTexts", myApplication).serverData}}</span><br>' + completeServerData + '</span></span>');
                                        $compile(angular.element(element))(pageScope);
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            };

            pageScope.generalModel.FormatServerEditView = function (key, model, twoLevels, mainElementLine, deleted, parent) {
                var gridName;
                var idName;
                var grid;
                var rowIndex;
                var trLine = '';
                var columns = '';
                var gridElement;
                if (twoLevels) {
                    idName = model.ArrayGridObjects[key].SecondGridMainId;
                    gridName = model.ArrayGridObjects[key].SecondGrid + mainElementLine[model.ArrayGridObjects[key].MainId];
                    grid = angular.element('#' + gridName).dxDataGrid('instance');
                    gridElement = model.ArrayGridObjects[key].SecondGrid.substr(4);
                }
                else {
                    idName = model.ArrayGridObjects[key].MainId;
                    gridName = model.ArrayGridObjects[key].GridName;
                    grid = angular.element('#' + gridName).dxDataGrid('instance');
                    gridElement = model.ArrayGridObjects[key].ObjectName;
                }
                if (deleted) {
                    pageScope.generalModel.DeletedElements.push({ "Id": mainElementLine[idName], "Cell": trLine });
                }
                else if ((parent !== '') && (typeof model[parent][model.MainObjectId] !== 'undefined') && (model[parent][model.MainObjectId] === mainElementLine[model.MainObjectId]) && (mainElementLine.hasOwnProperty(gridElement))) {
                    pageScope.generalModel.EditedElements.push({ "Id": mainElementLine[model.MainObjectId] });
                }
                else {
                    pageScope.generalModel.EditedElements.push({ "Id": mainElementLine[idName] });
                }

                if ((parent !== '') && (typeof model[parent][model.MainObjectId] !== 'undefined') && (model[parent][model.MainObjectId] === mainElementLine[model.MainObjectId]) && (mainElementLine.hasOwnProperty(gridElement))) {
                    if (!angular.element('#MainObjectServerConcurrency').find('.InfoTextServer').length) {
                        pageScope.generalModel.ShowServerData('#MainObjectServerConcurrency', angular.element('#MainObjectServerConcurrency'), '', model, '', '', parent);
                    }
                }
                else {
                    if (typeof grid !== 'undefined') {
                        columns = grid.getVisibleColumns();
                        pageScope.generalModel.ConcurrencyError = true;
                        trLine = angular.element('.' + idName + ':contains("' + mainElementLine[idName] + '")').closest('tr');
                        if ((typeof pageScope.generalModel.DeletedElements[pageScope.generalModel.DeletedElements.length - 1] !== 'undefined') && (pageScope.generalModel.DeletedElements[pageScope.generalModel.DeletedElements.length - 1].Id === mainElementLine[idName])) {
                            pageScope.generalModel.DeletedElements[pageScope.generalModel.DeletedElements.length - 1].Cell = angular.copy(trLine);
                        }
                        rowIndex = pageScope.generalModel.FindIndex(trLine);
                        angular.element(trLine).find('td').each(function (index) {
                            if (typeof columns[index].dataField !== 'undefined') {
                                var dataCell = grid.cellValue(rowIndex, columns[index].dataField);
                                if (typeof dataCell !== 'undefined') {
                                    if (columns[index].dataField === 'Disabled') {
                                        if (dataCell === 'Disabled') {
                                            dataCell = true;
                                        }
                                        else {
                                            dataCell = false;
                                        }
                                    }

                                    if (dataCell === null) {
                                        dataCell = "";
                                    }

                                    grid.cellValue(rowIndex, columns[index].dataField, dataCell);
                                }
                                angular.element(this).removeClass('dx-datagrid-invalid');
                            }
                        });
                        pageScope.generalModel.FillConcurrencyDataSource(gridName, model);
                    }
                    else if ((twoLevels) && (typeof grid === 'undefined')) {
                        grid = angular.element('#' + model.ArrayGridObjects[key].GridName).dxDataGrid('instance');
                        columns = grid.getVisibleColumns();
                        trLine = angular.element('.' + model.ArrayGridObjects[key].MainId + ':contains("' + mainElementLine[model.ArrayGridObjects[key].MainId] + '")').closest('tr');
                        rowIndex = pageScope.generalModel.FindIndex(trLine);
                        angular.element(trLine).find('td').each(function (index) {
                            if (typeof columns[index].dataField !== 'undefined') {
                                var dataCell = grid.cellValue(rowIndex, columns[index].dataField);
                                if (typeof dataCell !== 'undefined') {
                                    if (columns[index].dataField === 'Disabled') {
                                        if (dataCell === 'Disabled') {
                                            dataCell = true;
                                        }
                                        else {
                                            dataCell = false;
                                        }
                                    }
                                    grid.cellValue(rowIndex, columns[index].dataField, dataCell);
                                }

                                if (dataCell === null) {
                                    dataCell = "";
                                }

                                angular.element(this).removeClass('dx-datagrid-invalid');
                            }
                        });
                        pageScope.generalModel.FillConcurrencyDataSource(model.ArrayGridObjects[key].GridName, model);
                    }
                }
            };

            pageScope.generalModel.CompareServerData = function (model, key, parent) {
                if (key !== "") {
                    var elementName = model.ArrayGridObjects[key].ObjectName + 'Element';
                    var serverDataToCompare = pageScope.generalModel.AngularCopy(model[elementName]);
                    var idName = model.ArrayGridObjects[key].MainId;
                    var mainElementLine;
                    var secondElementName = '';
                    var secondGridIdName = '';
                    var twoLevels = false;
                    var insideObject;
                    var objectName = model.ArrayGridObjects[key].ObjectName;
                    var serverData;
                    pageScope.generalModel.ClearDeletedEditedObjects();
                    if (model.ArrayGridObjects[key].SecondGrid !== '') {
                        twoLevels = true;
                        secondGridIdName = model.ArrayGridObjects[key].SecondGridMainId;
                        secondElementName = model.ArrayGridObjects[key].SecondGrid.substr(4);
                    }
                    if (parent !== '') {
                        serverData = model.ServerData[objectName];
                    }
                    else {
                        serverData = model.ServerData;
                    }
                }
                else {
                    serverData = model.ServerData;
                }

                for (var x = 0; x < serverData.length; x++) {
                    var serverDataItem = serverData[x];

                    if (parent !== '') {
                        mainElementLine = model[parent];

                        if ((mainElementLine !== null) && (typeof mainElementLine !== 'undefined')) {
                            insideObject = pageScope.generalModel.CheckInnerObjectRowVersion(mainElementLine, model.ServerData, model);

                            if ((model.ServerData.RowVersion !== mainElementLine.RowVersion) || insideObject.length) {
                                pageScope.generalModel.ReplaceRowVersion(model[parent], model.MainObjectId, model.ServerData[model.MainObjectId], model.ServerData.RowVersion, insideObject);
                                pageScope.generalModel.FormatServerEditView(key, model, false, mainElementLine, false, parent);
                            }
                        }
                    }

                    mainElementLine = pageScope.ArrayFunctions.FindInObject(model[elementName], idName, serverDataItem[idName]);

                    if (mainElementLine !== null) {
                        insideObject = pageScope.generalModel.CheckInnerObjectRowVersion(mainElementLine, serverDataItem, model);
                        if ((serverDataItem.RowVersion !== mainElementLine.RowVersion) || insideObject.length) {
                            pageScope.generalModel.ReplaceRowVersion(model[elementName], idName, serverDataItem[idName], serverDataItem.RowVersion, insideObject, serverData);
                            pageScope.generalModel.FormatServerEditView(key, model, false, mainElementLine, false, parent);
                        }

                        if (twoLevels) {
                            for (var a = 0; a < serverDataItem[secondElementName].length; a++) {
                                var secondElementNameItem = serverDataItem[secondElementName][a];

                                mainElementLine = pageScope.ArrayFunctions.FindInObject(model[elementName][x][secondElementName], secondGridIdName, secondElementNameItem[secondGridIdName], secondElementNameItem);

                                if (mainElementLine !== null) {
                                    insideObject = pageScope.generalModel.CheckInnerObjectRowVersion(mainElementLine, secondElementNameItem, model);
                                    if ((secondElementNameItem.RowVersion !== mainElementLine.RowVersion) || insideObject.length) {
                                        pageScope.generalModel.ReplaceRowVersion(model[elementName][x][secondElementName], secondGridIdName, secondElementNameItem[secondGridIdName], secondElementNameItem.RowVersion, insideObject, secondElementNameItem);
                                        pageScope.generalModel.FormatServerEditView(key, model, true, mainElementLine, false, parent);
                                    }
                                }
                            }
                        }
                    }
                }

                if ((parent !== '') && !serverData.length) {
                    mainElementLine = model[parent];

                    if ((mainElementLine !== null) && (typeof mainElementLine !== 'undefined')) {
                        insideObject = pageScope.generalModel.CheckInnerObjectRowVersion(mainElementLine, model.ServerData, model);

                        if ((model.ServerData.RowVersion !== mainElementLine.RowVersion) || insideObject.length) {
                            pageScope.generalModel.ReplaceRowVersion(model[parent], model.MainObjectId, model.ServerData[model.MainObjectId], model.ServerData.RowVersion, insideObject, serverData);
                            pageScope.generalModel.FormatServerEditView(key, model, false, mainElementLine, false, parent);
                        }
                    }
                }

                for (var c = model[elementName].length - 1; c >= 0; c--) {
                    var object = [];

                    if (pageScope.ArrayFunctions.FindInObject(serverData, idName, model[elementName][c][idName]) !== null) {
                        if (twoLevels) {
                            for (var a = model[elementName][c][secondElementName].length - 1; a >= 0; a--) {
                                for (var x = 0; x < serverData.length; x++) {
                                    for (var b = 0; b < serverData[x][secondElementName].length; b++) {
                                        object = [];
                                        object[0] = serverData[x][secondElementName][b];
                                        if (pageScope.ArrayFunctions.FindInObject(object, secondGridIdName, model[elementName][c][secondElementName][a][secondGridIdName]) !== null) {
                                            serverDataToCompare[c][secondElementName].splice(a, 1);
                                        }
                                    }
                                }
                            }
                            if (!serverDataToCompare[c][secondElementName].length && (pageScope.ArrayFunctions.FindInObject(serverData, idName, serverDataToCompare[c][idName]) !== null)) {
                                serverDataToCompare.splice(c, 1);
                            }
                            else if (serverDataToCompare[c][secondElementName].length && (pageScope.ArrayFunctions.FindInObject(serverData, idName, serverDataToCompare[c][idName]) === null)) {
                                var newObject = pageScope.generalModel.AngularCopy(serverDataToCompare[c]);
                                newObject[secondElementName] = [];
                                serverDataToCompare.push(newObject);
                            }
                        }
                        else {
                            serverDataToCompare.splice(c, 1);
                        }
                    }
                    else {
                        serverDataToCompare[c][secondElementName] = [];
                    }
                }

                for (var r = 0; r < serverDataToCompare.length; r++) {
                    var serverDataToCompareItem = serverDataToCompare[r];

                    if (!serverDataToCompareItem[secondElementName].length) {
                        pageScope.generalModel.FormatServerEditView(key, model, false, serverDataToCompareItem, true, parent);
                    }
                    else {
                        for (var a = 0; a < serverDataToCompareItem[secondElementName].length; a++) {
                            pageScope.generalModel.FormatServerEditView(key, model, true, serverDataToCompareItem[secondElementName][a], true, parent);
                        }
                    }
                }

                angular.element('.InfoTextServer').off('mouseover').mouseover(function (e) {
                    if (angular.element(this).parents('md-tab-content').length) {
                        angular.element('.PopUp', this).css({ 'top': angular.element(this)[0].getBoundingClientRect().top - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().top, 'right': angular.element(this)[0].getBoundingClientRect().left - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().width });
                    }
                    else {
                        angular.element('.PopUp', this).css({ 'top': ((e.pageY - angular.element(this).offsetTop) + 20), 'right': ($window.innerWidth - e.pageX) - (angular.element('#SideBar').width() + 50) });
                    }
                    angular.element('.PopUp', this).removeClass('DisplayNone');
                });
                angular.element('.InfoTextServer').off('mouseout').mouseout(function () {
                    angular.element('.PopUp', this).addClass('DisplayNone');
                });
            };

            pageScope.generalModel.ConcurrencyBeforeSave = function (model) {
                if (!pageScope.generalModel.DeletedElements.length) {
                    return;
                }

                for (var v = 0; v < model.ArrayGridObjects.length; v++) {
                    var gridObject = model.ArrayGridObjects[v];

                    var elementName = gridObject.ObjectName + 'Element';
                    var gridName = gridObject.GridName;
                    var idName = gridObject.MainId;
                    var grid = angular.element('#' + gridName).dxDataGrid('instance');
                    var editData = Helpers.DevExtreme.Grid.GetEditData(grid);
                    var twoLevels = false;
                    var secondGridElementName;
                    var secondGridId;
                    var secondGrid;
                    var secondGridName;
                    var editDataSecondGrid;
                    var listsToUnite;
                    var joinedData;

                    if (gridObject.SecondGrid !== '') {
                        twoLevels = true;
                        secondGridId = gridObject.SecondGridMainId;
                        secondGridName = gridObject.SecondGrid;
                        secondGridElementName = gridObject.SecondGrid.substr(4);
                    }

                    if (editData.length) {
                        for (var l = editData.length - 1; l >= 0; l--) {
                            var itemL = editData[l];

                            if (itemL.type !== 'insert') {
                                for (var k = 0; k < pageScope.generalModel.DeletedElements.length; k++) {
                                    if ((itemL.key[idName] === pageScope.generalModel.DeletedElements[k].Id) && (pageScope.generalModel.DeletedElements[k].Id !== pageScope.generalModel.GuidEmpty)) {
                                        listsToUnite = [itemL.key, itemL.data];
                                        joinedData = listsToUnite.reduce(function (r, o) {
                                            Object.keys(o).forEach(function (k) {
                                                r[k] = o[k];
                                            });

                                            return r;
                                        }, {});

                                        itemL.data = joinedData;

                                        if (itemL.oldData) {
                                            itemL.oldData.__KEY__ = pageScope.generalModel.AngularCopy(itemL.key[idName]);
                                            itemL.oldData[idName] = pageScope.generalModel.GuidEmpty;
                                            itemL.key = joinedData;
                                            itemL.key.__KEY__ = pageScope.generalModel.AngularCopy(itemL.key[idName]);
                                            itemL.key[idName] = pageScope.generalModel.GuidEmpty;

                                            delete itemL.key.User;
                                        } else {
                                            itemL.data.__KEY__ = pageScope.generalModel.AngularCopy(itemL.key[idName]);
                                            itemL.key = pageScope.generalModel.AngularCopy(itemL.key[idName]);
                                        }

                                        itemL.type = 'insert';

                                        delete itemL.data.CreationDatetime;
                                        delete itemL.data.CreationUser;
                                        delete itemL.data.Disabled;
                                        delete itemL.data.RowVersion;
                                        delete itemL.data.User;
                                    }
                                    else if (twoLevels) {
                                        for (var j = 0; j < itemL.key[secondGridElementName].length; j++) {
                                            if ((itemL.key[secondGridElementName][j][secondGridId] === pageScope.generalModel.DeletedElements[k].Id) && (pageScope.generalModel.DeletedElements[k].Id !== pageScope.generalModel.GuidEmpty)) {
                                                if (itemL.key.hasOwnProperty('__KEY__')) {
                                                    itemL.key[secondGridElementName][j][idName] = pageScope.generalModel.AngularCopy(itemL.key.__KEY__);
                                                }
                                                else {
                                                    itemL.key[secondGridElementName][j][idName] = pageScope.generalModel.AngularCopy(itemL.key[idName]);
                                                }

                                                itemL.key[secondGridElementName][j].__KEY__ = pageScope.generalModel.AngularCopy(itemL.key[secondGridElementName][j][secondGridId]);
                                                itemL.key[secondGridElementName][j][secondGridId] = pageScope.generalModel.GuidEmpty;

                                                if (itemL.oldData) {
                                                    itemL.oldData[secondGridElementName][j].__KEY__ = pageScope.generalModel.AngularCopy(itemL.key[secondGridElementName][j][secondGridId]);
                                                    itemL.oldData[secondGridElementName][j][secondGridId] = pageScope.generalModel.GuidEmpty;
                                                }

                                                if (itemL.type !== 'insert') {
                                                    itemL.type = 'update';
                                                }

                                                if (itemL.key[secondGridElementName].length) {
                                                    delete itemL.key[secondGridElementName][j].CreationDatetime;
                                                    delete itemL.key[secondGridElementName][j].CreationUser;
                                                    delete itemL.key[secondGridElementName][j].Disabled;
                                                    delete itemL.key[secondGridElementName][j].RowVersion;
                                                    delete itemL.key[secondGridElementName][j].User;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else if (twoLevels) {
                        for (var k = 0; k < pageScope.generalModel.DeletedElements.length; k++) {
                            for (var t = 0; t < model[elementName].length; t++) {
                                secondGrid = angular.element('#' + secondGridName + model[elementName][t][idName]).dxDataGrid('instance');
                                if (typeof secondGrid !== 'undefined') {
                                    editDataSecondGrid = Helpers.DevExtreme.Grid.GetEditData(secondGrid);

                                    for (var f = 0; f < editDataSecondGrid.length; f++) {
                                        var id = editDataSecondGrid[f].key[idName];
                                        var objectForFilter = {};

                                        objectForFilter[idName] = id;

                                        var gridChanges = Helpers.DevExtreme.Grid.GetEditData(grid);

                                        if (!gridChanges.length || !$filter('filter')(gridChanges, objectForFilter[idName], true).length) {
                                            var columns = grid.getVisibleColumns();
                                            var nextRow = true;
                                            angular.element('#' + gridName).find('.' + idName).each(function () {
                                                if ((angular.element(this).text() === id) && (nextRow)) {
                                                    var trLine = angular.element(this).closest('tr');
                                                    var rowIndex = pageScope.generalModel.FindIndex(trLine);

                                                    angular.element(trLine).find('td').each(function (index) {

                                                        if (typeof columns[index].dataField !== 'undefined') {
                                                            var dataCell = grid.cellValue(rowIndex, columns[index].dataField);

                                                            if (typeof dataCell !== 'undefined') {
                                                                if (columns[index].dataField === 'Disabled') {
                                                                    if (dataCell === 'Disabled') {
                                                                        dataCell = true;
                                                                    }
                                                                    else {
                                                                        dataCell = false;
                                                                    }
                                                                }

                                                                if (dataCell === null) {
                                                                    dataCell = "";
                                                                }

                                                                grid.cellValue(rowIndex, columns[index].dataField, dataCell);
                                                            }
                                                            angular.element(this).removeClass('dx-datagrid-invalid');
                                                        }
                                                    });
                                                    nextRow = false;
                                                }
                                            });
                                        }
                                        listsToUnite = [editDataSecondGrid[l].key, editDataSecondGrid[l].data];

                                        joinedData = editDataSecondGrid[f].data.reduce(function (r, o) {
                                            Object.keys(o).forEach(function (k) {
                                                r[k] = o[k];
                                            });

                                            return r;

                                        }, {});
                                        
                                        editDataSecondGrid[f].data = joinedData;

                                        if (editDataSecondGrid[f].oldData) {
                                            editDataSecondGrid[f].oldData.__KEY__ = pageScope.generalModel.AngularCopy(editDataSecondGrid[f].key[secondGridId]);
                                            editDataSecondGrid[f].oldData[secondGridId] = pageScope.generalModel.GuidEmpty;
                                            editDataSecondGrid[f].key.__KEY__ = pageScope.generalModel.AngularCopy(editDataSecondGrid[f].key[secondGridId]);
                                            editDataSecondGrid[f].key[secondGridId] = pageScope.generalModel.GuidEmpty;

                                            delete editDataSecondGrid[f].key.User;
                                        } else {
                                            editDataSecondGrid[f].data.__KEY__ = pageScope.generalModel.AngularCopy(editDataSecondGrid[f].key[secondGridId]);
                                            editDataSecondGrid[f].key = pageScope.generalModel.AngularCopy(editDataSecondGrid[f].key[secondGridId]);
                                        }

                                        editDataSecondGrid[f].type = 'insert';

                                        delete editDataSecondGrid[f].data.CreationDatetime;
                                        delete editDataSecondGrid[f].data.CreationUser;
                                        delete editDataSecondGrid[f].data.Disabled;
                                        delete editDataSecondGrid[f].data.RowVersion;
                                        delete editDataSecondGrid[f].data.User;
                                    }
                                }
                            }
                        }
                    }
                }
            };

            pageScope.generalModel.ReplaceObjectRowVersion = function (object, serverData, idName) {
                var objectName = pageScope.generalModel.ObjectDataForConcurrency[object].ObjectName;

                for (var r = 0; r < pageScope.$eval(objectName).length; r++) {
                    var objectNameItem = pageScope.$eval(objectName)[r];
                    var objectForFilter = {};
                    objectForFilter[idName] = objectNameItem[idName];
                    var findObjectsForFilter = $filter('filter')(serverData, objectForFilter, true);

                    if ((typeof findObjectsForFilter !== 'undefined') && findObjectsForFilter.length) {
                        var findObjectForFilter = findObjectsForFilter[0];

                        if (objectNameItem.RowVersion !== findObjectForFilter.RowVersion) {
                            pageScope.generalModel.EditedElements.push({ 'Id': objectNameItem[idName] });
                            objectNameItem.RowVersion = findObjectForFilter.RowVersion;
                        }
                    }
                    else {
                        pageScope.generalModel.DeletedElements.push({ 'Id': objectNameItem[idName] });
                        objectNameItem.New = objectNameItem[idName];
                        delete objectNameItem.CreationDatetime;
                        delete objectNameItem.CreationUser;
                        delete objectNameItem.Disabled;
                        delete objectNameItem.RowVersion;
                        delete objectNameItem.User;
                        delete objectNameItem[idName];
                    }

                    for (var t = 0; t < pageScope.generalModel.ObjectDataForConcurrency[object].Lists.length; t++) {
                        var secondObjectForFilter = {};
                        var listItem = pageScope.generalModel.ObjectDataForConcurrency[object].Lists[t];

                        for (var h = 0; h < objectNameItem[listItem.List].length; h++) {
                            var secondListItem = objectNameItem[listItem.List][h];
                            secondObjectForFilter[listItem.ListId] = secondListItem[listItem.ListId];

                            var findObjects = $filter('filter')(findObjectForFilter[listItem.List], secondObjectForFilter, true);

                            if ((typeof findObjects !== 'undefined') && findObjects.length) {
                                var findObject = findObjects[0];

                                if (secondListItem.RowVersion !== findObject.RowVersion) {
                                    pageScope.generalModel.EditedElements.push({ 'Id': secondListItem[listItem.ListId] });
                                    secondListItem.RowVersion = findObject.RowVersion;

                                    if (!pageScope.generalModel.IsUndefinedEmptyOrNull(listItem.InformationField)) {
                                        secondListItem[listItem.InformationField] = findObject[listItem.InformationField];
                                    }
                                }
                            }
                            else {
                                pageScope.generalModel.DeletedElements.push({ 'Id': secondListItem[listItem.ListId] });

                                if (!pageScope.generalModel.IsUndefinedEmptyOrNull(pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea)) {
                                    if (!pageScope.generalModel.ObjectDataForConcurrency[object].CloseOpenArea) {
                                        pageScope.generalModel.EditedElements.push({ 'Id': secondListItem[pageScope.generalModel.ObjectDataForConcurrency[object].IdName] });
                                    }
                                }

                                objectNameItem.New = secondListItem[listItem.ListId];

                                delete secondListItem.CreationDatetime;
                                delete secondListItem.CreationUser;
                                delete secondListItem.Disabled;
                                delete secondListItem.RowVersion;
                                delete secondListItem.User;
                                delete secondListItem[listItem.ListId];

                                if (!pageScope.generalModel.IsUndefinedEmptyOrNull(listItem.InformationField) && findObjects.length) {
                                    var findObject = findObjects[0];

                                    secondListItem[listItem.InformationField] = findObject[listItem.InformationField];
                                }
                            }
                        }
                    }
                }
            };

            pageScope.generalModel.ReplaceRowVersion = function (object, idName, id, rowVersion, insideObject, serverData) {
                if (!pageScope.generalModel.IsUndefinedEmptyOrNull(insideObject) && insideObject.length && (typeof serverData !== 'undefined') && ((angular.isArray(serverData) && serverData.length) || (angular.isObject(serverData) && (serverData === {})))) {
                    if (isNaN(object.length) && (object[idName] === id)) {
                        for (var n = 0; n < insideObject.length; n++) {
                            object[insideObject[n]].RowVersion = pageScope.generalModel.AngularCopy(serverData[insideObject[n]].RowVersion);
                        }
                    }
                    else {
                        for (var e = 0; object.length; e++) {
                            if (object[e][idName] === id) {
                                for (var m = 0; m < insideObject.length; m++) {
                                    if (Array.isArray(object[e][insideObject[m]])) {
                                        object[e][insideObject[m]][0].RowVersion = pageScope.generalModel.AngularCopy(serverData[e][insideObject[m]][0].RowVersion);
                                    }
                                    else {
                                        object[e][insideObject[m]].RowVersion = pageScope.generalModel.AngularCopy(serverData[e][insideObject[m]].RowVersion);
                                    }
                                }
                                object[e].RowVersion = pageScope.generalModel.AngularCopy(serverData[e].RowVersion);

                                break;
                            }
                        }
                    }
                }
                else {
                    if (isNaN(object.length) && (object[idName] === id)) {
                        object.RowVersion = pageScope.generalModel.AngularCopy(rowVersion);
                    }
                    else {
                        for (var replaceRow = 0; replaceRow < object.length; replaceRow++) {
                            if (object[replaceRow][idName] === id) {
                                object[replaceRow].RowVersion = pageScope.generalModel.AngularCopy(rowVersion);
                                break;
                            }
                        }
                    }
                }
            };

            pageScope.generalModel.UpdateRow = function (model, key, elementId, twoLevels, parent) {
                var serverData;
                var secondGrid;
                var secondEditData = [];
                var positionsResolved = [];
                var positionsResolvedSecondLevel = [];
                var elementName = model.ArrayGridObjects[key].ObjectName + 'Element';
                var gridName = model.ArrayGridObjects[key].GridName;
                var idName = model.ArrayGridObjects[key].MainId;
                var grid = angular.element('#' + gridName).dxDataGrid('instance');
                var editData = Helpers.DevExtreme.Grid.GetEditData(grid);
                var secondGridIdName = model.ArrayGridObjects[key].SecondGridMainId;
                var secondElementName = model.ArrayGridObjects[key].SecondGrid.substr(4);
                var objectName = model.ArrayGridObjects[key].ObjectName;

                if ((secondGridIdName !== '') && !twoLevels) {
                    secondGrid = angular.element('#' + model.ArrayGridObjects[key].SecondGrid + elementId).dxDataGrid('instance');

                    if (typeof secondGrid !== 'undefined') {
                        secondEditData = Helpers.DevExtreme.Grid.GetEditData(secondGrid);
                    }
                }
                else if ((secondGridIdName !== '') && (twoLevels)) {
                    for (var a = 0; a < model[elementName].length; a++) {
                        for (var b = 0; b < model[elementName][a][secondElementName].length; b++) {
                            if (model[elementName][a][secondElementName][b][secondGridIdName] === elementId) {
                                secondGrid = angular.element('#' + model.ArrayGridObjects[key].SecondGrid + model[elementName][a][idName]).dxDataGrid('instance');
                                secondEditData = Helpers.DevExtreme.Grid.GetEditData(secondGrid);

                                break;
                            }
                        }
                    }
                }

                if (twoLevels) {
                    for (var i = 0; i < secondEditData.length; i++) {
                        if (elementId === secondEditData[i].key[secondGridIdName]) {
                            pageScope.generalModel.RowBackExtraConnections(model.ArrayGridObjects[key].SecondGrid + secondEditData[i].key[idName], secondEditData[i]);
                            secondEditData.splice(i, 1);
                        }
                    }
                }
                else {
                    for (var w = 0; w < editData.length; w++) {
                        if (elementId === editData[w].key[idName]) {
                            pageScope.generalModel.RowBackExtraConnections(gridName, editData[w]);
                            editData.splice(w, 1);
                        }
                    }
                }

                for (var u = 0; u < pageScope.generalModel.SecondLevelUpdate.length; u++) {
                    if (pageScope.generalModel.SecondLevelUpdate[u].Id === elementId) {
                        pageScope.generalModel.SecondLevelUpdate.splice(u, 1);
                    }
                }

                if ((parent !== '') && (!angular.equals(model.ServerData, {}))) {
                    serverData = model.ServerData[objectName];
                }
                else {
                    serverData = model.ServerData;
                }

                for (var v = 0; v < serverData.length; v++) {
                    for (var y = 0; y < model[elementName].length; y++) {
                        if ((!twoLevels) && (elementId === serverData[v][idName]) && (elementId === model[elementName][y][idName])) {
                            var newServerData = pageScope.generalModel.AngularCopy(serverData);
                            if (secondGridIdName !== '') {
                                newServerData[v][secondElementName] = pageScope.generalModel.AngularCopy(model[elementName][y][secondElementName]);
                            }
                            model[elementName][y] = pageScope.generalModel.AngularCopy(newServerData[v]);
                            positionsResolved.push(v);
                            if ((secondGridIdName !== '') && (!twoLevels)) {
                                pageScope.generalModel.SecondLevelUpdate.push({ Grid: model.ArrayGridObjects[key].SecondGrid + elementId, Id: elementId, Content: secondEditData })
                            }
                        }
                        else if (twoLevels) {
                            for (var a = 0; a < serverData[v][secondElementName].length; a++) {
                                for (var b = 0; b < model[elementName][y][secondElementName].length; b++) {
                                    if ((elementId === serverData[v][secondElementName][a][secondGridIdName]) && (elementId === model[elementName][y][secondElementName][b][secondGridIdName])) {
                                        model[elementName][y][secondElementName][b] = pageScope.generalModel.AngularCopy(serverData[v][secondElementName][a]);
                                        positionsResolvedSecondLevel.push(v + '-' + a);
                                    }
                                }
                            }
                        }
                    }
                }

                for (var e = 0; e < pageScope.generalModel.EditedElements.length; e++) {
                    if (pageScope.generalModel.EditedElements[e].Id === elementId) {
                        pageScope.generalModel.EditedElements.splice(e, 1);
                    }
                }
                for (var p = positionsResolved.length - 1; p >= 0; p--) {
                    if ((secondGridIdName !== '') && serverData[positionsResolved[p]][secondElementName].length) {
                        var found = false;
                        for (var q = 0; q < serverData[positionsResolved[p]][secondElementName].length; q++) {
                            if (pageScope.ArrayFunctions.FindInObject(pageScope.generalModel.EditedElements, "Id", serverData[positionsResolved[p]][secondElementName][q][secondGridIdName]) !== null) {
                                found = true;
                                break;
                            }
                        }
                        if (!found) {
                            serverData.splice(positionsResolved[p], 1);
                        }
                    }
                    else {
                        serverData.splice(positionsResolved[p], 1);
                    }
                }
                for (var p = positionsResolvedSecondLevel.length - 1; p >= 0; p--) {
                    var first = positionsResolvedSecondLevel[p].split('-')[0];
                    var second = positionsResolvedSecondLevel[p].split('-')[1];
                    serverData[first][secondElementName].splice(second, 1);
                    if (!serverData[first][secondElementName].length && (pageScope.ArrayFunctions.FindInObject(pageScope.generalModel.EditedElements, "Id", serverData[first][idName]) === null)) {
                        serverData.splice(first, 1);
                    }
                }
                if (!twoLevels) {
                    grid.refresh();
                }
                else {
                    secondGrid.refresh();
                }
                if (pageScope.generalModel.CheckIfThereAreEditedFields(model)) {
                    $timeout(function () {
                        pageScope.generalModel.SidebarOptions['State']['SaveOption'] = false;
                        pageScope.generalModel.SidebarOptions['State']['CancelOption'] = false;
                    });

                    for (var l = 0; l < model.ArrayGridObjects.length; l++) {
                        if (typeof model[model.ArrayGridObjects[l].ObjectName + "ToolsState"] !== 'undefined') {
                            model[model.ArrayGridObjects[l].ObjectName + "ToolsState"] = false;
                        }
                    }

                    if (typeof model.ToolsStateItems !== 'undefined') {
                        for (var d = 0; d < model.ToolsStateItems.length; d++) {
                            if (model.ToolsStateItems[d].Id === key[idName]) {
                                model.ToolsStateItems[d].State = false;
                                break;
                            }
                        }
                    }

                    if (typeof model.ToolsState !== 'undefined') {
                        model.ToolsState = false;
                    }
                }
            };

            pageScope.generalModel.RowBackExtraConnections = function (gridName, editedData) {
                var grid = angular.element("#" + gridName + "").dxDataGrid("instance");
                var rowIndex = grid.getRowIndexByKey(editedData.key);
                for (var p = 0; p < pageScope.generalModel.ExtraConnections.length; p++) {
                    if (editedData.data.hasOwnProperty(pageScope.generalModel.ExtraConnections[p].ObjectPathName)) {
                        if ((typeof pageScope.generalModel.DropdDownsEditedValues[gridName] !== 'undefined') && (typeof pageScope.generalModel.DropdDownsEditedValues[gridName][rowIndex] !== 'undefined')) {
                            var data = pageScope.generalModel.DropdDownsEditedValues[gridName][rowIndex][pageScope.generalModel.ExtraConnections[p].DataField];
                            grid.cellValue(rowIndex, pageScope.generalModel.ExtraConnections[p].DataField, data);
                        }
                    }
                }
                if ((typeof pageScope.generalModel.DropdDownsEditedValues[gridName] !== 'undefined') && (typeof pageScope.generalModel.DropdDownsEditedValues[gridName][rowIndex] !== 'undefined')) {
                    delete pageScope.generalModel.DropdDownsEditedValues[gridName][rowIndex];
                }
            };

            pageScope.generalModel.DeleteRowDeleted = function (model, key, id) {
                var twoLevels = false;
                var gridElementName = model.ArrayGridObjects[key].ObjectName + 'Element';
                var secondGridElementName;
                var secondGridId;
                var gridName = model.ArrayGridObjects[key].GridName;
                var secondGridName;
                var grid;
                var idName = model.ArrayGridObjects[key].MainId;
                if (model.ArrayGridObjects[key].SecondGrid !== '') {
                    twoLevels = true;
                    secondGridName = model.ArrayGridObjects[key].SecondGrid;
                    secondGridId = model.ArrayGridObjects[key].SecondGridMainId;
                    secondGridElementName = model.ArrayGridObjects[key].SecondGrid.substr(4);
                }
                for (var f = 0; f < model[gridElementName].length; f++) {
                    if (model[gridElementName][f][model.ArrayGridObjects[key].MainId] === id) {
                        model[gridElementName].splice(f, 1);
                        pageScope.generalModel.IsUpdating = false;
                        grid = angular.element("#" + gridName + "").dxDataGrid('instance');
                        grid.option('dataSource', model[gridElementName]);
                        grid.refresh();
                        break;
                    }
                    else if (twoLevels) {
                        for (var h = 0; h < model[gridElementName][f][secondGridElementName].length; h++) {
                            if (model[gridElementName][f][secondGridElementName][h][secondGridId] === id) {
                                model[gridElementName][f][secondGridElementName].splice(h, 1);
                                pageScope.generalModel.IsUpdating = false;
                                grid = angular.element("#" + secondGridName + model[gridElementName][f][idName] + "").dxDataGrid('instance');
                                grid.option('dataSource', model[gridElementName][f][secondGridElementName]);
                                grid.refresh();
                                break;
                            }
                        }
                    }
                }

                for (var g = 0; g < pageScope.generalModel.DeletedElements.length; g++) {
                    if (pageScope.generalModel.DeletedElements[g].Id === id) {
                        pageScope.generalModel.DeletedElements.splice(g, 1);
                    }
                }
            };

            pageScope.generalModel.DeleteRowWithServer = function (model, key, twoLevels, id, index, parent) {
                var idName = model.ArrayGridObjects[key].MainId;
                var elementName = model.ArrayGridObjects[key].ObjectName + 'Element';
                var mainElementLine = pageScope.ArrayFunctions.FindInObject(model[elementName], idName, id);
                var objectName = model.ArrayGridObjects[key.ObjectName];
                var secondElementName;
                var serverData;
                var secondGrid;
                if (twoLevels) {
                    idName = model.ArrayGridObjects[key].SecondGridMainId;
                    secondGrid = angular.element('#' + model.ArrayGridObjects[key].SecondGrid).dxDataGrid('instance');
                    secondElementName = model.ArrayGridObjects[key].SecondGrid.substr(4);
                }
                if (parent !== '') {
                    serverData = model.ServerData[objectName];
                }
                else {
                    serverData = model.ServerData;
                }

                for (var x = 0; x < serverData.length; x++) {
                    if (!twoLevels) {
                        if (serverData[x][idName] === id) {
                            pageScope.generalModel.FormatServerEditView(key, model, twoLevels, mainElementLine, false, parent);
                        }
                    }
                    else {
                        for (var a = 0; a < serverData[x][secondElementName].length; a++) {
                            pageScope.generalModel.FormatServerEditView(key, model, twoLevels, mainElementLine, false, parent);
                        }
                    }
                }
            };

            pageScope.generalModel.FillConcurrencyEditedObject = function (model, object) {
                var extraConnection = '';
                for (var a = 0; a < pageScope.generalModel.ExtraConnections.length; a++) {
                    extraConnection = pageScope.generalModel.ExtraConnections[a].DataField;
                    if (pageScope.generalModel.ExtraConnections[a].DataField.indexOf('.') > 0) {
                        extraConnection = pageScope.generalModel.ExtraConnections[a].DataField.substr(0, pageScope.generalModel.ExtraConnections[a].DataField.indexOf('.'));
                    }

                    if ((object.hasOwnProperty(extraConnection)) && (object[extraConnection] === null)) {
                        if (model.MainObjectPreviousSave.length) {
                            for (var m = 0; m < model.MainObjectPreviousSave[a].length; m++) {
                                if ((model.MainObjectPreviousSave[a][m] !== null) && (object[pageScope.generalModel.ExtraConnections[a].InnerId] === model.MainObjectPreviousSave[a][m][pageScope.generalModel.ExtraConnections[a].InnerId])) {
                                    if (object[extraConnection] === null) {
                                        object[extraConnection] = {};
                                    }
                                    object[extraConnection] = pageScope.generalModel.AngularCopy(model.MainObjectPreviousSave[a][m]);
                                }
                            }
                        }
                    }
                }
                return object;
            };

            pageScope.generalModel.FillConcurrencyDataSource = function (gridName, model) {
                var grid = angular.element('#' + gridName).dxDataGrid('instance');
                var dataSource = grid.getDataSource();

                for (var v = 0; v < dataSource._store._array.length; v++) {
                    dataSource._store._array[v] = pageScope.generalModel.FillConcurrencyEditedObject(model, dataSource._store._array[v]);
                }
            };

            pageScope.generalModel.GoBackMainObject = function (model, parent) {
                for (var a = 0; a < model.MainObjectListOfFields.length; a++) {
                    var image;
                    function isImage() {
                        try {
                            return btoa(atob(pageScope.generalModel.GetObjectByString(model.ServerData, model.MainObjectListOfFields[a].dataField))) === model.ServerData[model.MainObjectListOfFields[a].dataField];
                        }
                        catch (err) {
                            return false;
                        }
                    }

                    if (isImage()) {
                        image = pageScope.generalModel.GetObjectByString(model.ServerData, model.MainObjectListOfFields[a].dataField);
                        if (pageScope.generalModel.GetObjectByString(model.ServerData, model.MainObjectListOfFields[a].dataField).indexOf("data:image/gif;base64,") < 0) {
                            pageScope.generalModel.SetObjectValueByString(model.ServerData, model.MainObjectListOfFields[a].dataField, "data:image/gif;base64," + image);
                        }
                    }

                    if (pageScope.generalModel.ValidateDate(pageScope.generalModel.GetObjectByString(model.ServerData, model.MainObjectListOfFields[a].dataField))) {
                        pageScope.generalModel.SetObjectValueByString(model.ServerData, model.MainObjectListOfFields[a].dataField, $filter('date')(model.ServerData[model.MainObjectListOfFields[a].dataField], myApplication.dateFormat));
                    }

                    pageScope.generalModel.SetObjectValueByString(model[parent], model.MainObjectListOfFields[a].dataField, pageScope.generalModel.GetObjectByString(model.ServerData, model.MainObjectListOfFields[a].dataField));
                    pageScope.generalModel.SetObjectValueByString(model.OriginalElements[parent], model.MainObjectListOfFields[a].dataField, pageScope.generalModel.GetObjectByString(model.ServerData, model.MainObjectListOfFields[a].dataField));

                }
                if (typeof model.ArrayScheduleObjects !== 'undefined') {
                    model[model.ArrayScheduleObjects[0].ObjectNameInSchedule] = [];
                    model[model.ArrayScheduleObjects[0].ObjectName] = model.ServerData[model.ArrayScheduleObjects[0].ScheduleObject];
                    model.OriginalElements[model.ArrayScheduleObjects[0].ObjectName] = model.ServerData[model.ArrayScheduleObjects[0].ScheduleObject];
                    pageScope.$eval(model.ArrayScheduleObjects[0].Convertion)(model.ServerData[model.ArrayScheduleObjects[0].ScheduleObject], false);
                }

                if (pageScope.generalModel.SpecificCheckIfThereAreEditedFields()) {
                    pageScope.generalModel.SidebarOptions['State']['SaveOption'] = false;
                    pageScope.generalModel.SidebarOptions['State']['CancelOption'] = false;
                }
                pageScope.generalModel.ClearDeletedEditedObjects();
                angular.element('#MainObjectServerConcurrency').html('');
            };

            pageScope.generalModel.CompareServerDataInSchedule = function (model, parent) {
                var mainElement;
                var elementName = model.ArrayScheduleObjects[0].ObjectName;
                var elementNameInSchedule = model.ArrayScheduleObjects[0].ObjectNameInSchedule;
                var editedIdName = model.ArrayScheduleObjects[0].EditedScheduleId;
                var mainIdName = model.ArrayScheduleObjects[0].ScheduleId;
                var idName = model.ArrayScheduleObjects[0].ScheduleId;
                var serverData = model.ServerData[model.ArrayScheduleObjects[0].ScheduleObject];
                var action = model.ArrayScheduleObjects[0].Convertion;
                var concurrencyObject = [];
                var number = 1;
                var objectToSend = [];

                model.OriginalElements[parent] = pageScope.generalModel.AngularCopy(model.ServerData);
                model.OriginalElements[model.ArrayScheduleObjects[0].ObjectName] = pageScope.generalModel.AngularCopy(serverData);

                pageScope.generalModel.ReplaceRowVersion(model[parent], mainIdName, model.ServerData[mainIdName], model.ServerData.RowVersion);

                for (var s = 0; s < serverData.length; s++) {
                    mainElement = pageScope.ArrayFunctions.FindInObject(model[elementNameInSchedule], editedIdName, serverData[s][idName]);
                    if (mainElement.rowVersion !== serverData[s].RowVersion) {
                        for (var e = 0; model[elementNameInSchedule].length; e++) {
                            if (model[elementNameInSchedule][e][editedIdName] === serverData[s][idName]) {
                                model[elementName][e].rowVersion = serverData[s].RowVersion;
                                model[elementNameInSchedule][e].rowVersion = serverData[s].RowVersion;
                                model[elementName][e].number = number;
                                model[elementNameInSchedule][e].number = number;
                                objectToSend.push(serverData[s]);
                                objectToSend[objectToSend.length - 1].number = number;
                                number++;
                                break;
                            }
                        }
                        concurrencyObject = concurrencyObject.concat(pageScope.generalModel.AngularCopy(objectToSend));
                        concurrencyObject[concurrencyObject.length - 1].Concurrency = true;
                    }
                }

                for (var r = 0; r < model[elementNameInSchedule].length; r++) {
                    mainElement = pageScope.ArrayFunctions.FindInObject(serverData, idName, model[elementNameInSchedule][r][editedIdName]);
                    if (mainElement === null) {
                        model[elementNameInSchedule][r].concurrencyToDelete = true;
                    }
                }

                pageScope.$eval(action)(concurrencyObject, true);

                if (!angular.element('#MainObjectServerConcurrency').find('.InfoTextServer').length) {
                    pageScope.generalModel.ShowServerData('#MainObjectServerConcurrency', angular.element('#MainObjectServerConcurrency'), '', model, '', '', parent);
                }

                angular.element('.InfoTextServer').off('mouseover').mouseover(function (e) {
                    if (angular.element(this).parents('md-tab-content').length) {
                        angular.element('.PopUp', this).css({ 'top': angular.element(this)[0].getBoundingClientRect().top - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().top, 'right': angular.element(this)[0].getBoundingClientRect().left - angular.element(this).parents('md-tab-content')[0].getBoundingClientRect().width });
                    }
                    else {
                        angular.element('.PopUp', this).css({ 'top': e.pageY, 'right': $window.innerWidth - e.pageX });
                    }
                    angular.element('.PopUp', this).removeClass('DisplayNone');
                });
                angular.element('.InfoTextServer').off('mouseout').mouseout(function () {
                    angular.element('.PopUp', this).addClass('DisplayNone');
                });
            };

            pageScope.generalModel.ClearDeletedEditedObjects = function () {
                pageScope.generalModel.DeletedElements = [];
                pageScope.generalModel.EditedElements = [];
            };

            pageScope.generalModel.CheckInnerObjectRowVersion = function (object, serverData, model) {
                var keys = Object.keys(object);
                var finalContent = [];
                for (var k = 0; k < keys.length; k++) {
                    if ((((typeof pageScope.generalModel.ExtraConnections !== 'undefined') && ((typeof object[keys[k]] === 'object') && !$filter('filter')(pageScope.generalModel.ExtraConnections, { PathName: keys[k] }, true).length)) || (typeof pageScope.generalModel.ExtraConnections === 'undefined')) && ((typeof model.ArrayGridObjects === 'undefined') || (typeof model.ArrayGridObjects !== 'undefined') && !$filter('filter')(model.ArrayGridObjects, { SecondGrid: 'Grid' + keys[k] }, true).length)) {
                        if ((object[keys[k]] !== null) && (((Array.isArray(object[keys[k]])) && (typeof object[keys[k]][0] !== 'undefined') && (object[keys[k]][0].hasOwnProperty('RowVersion')) && !pageScope.generalModel.IsUndefinedEmptyOrNull(serverData[keys[k]][0]) && (object[keys[k]][0].RowVersion !== serverData[keys[k]][0].RowVersion)) || ((!Array.isArray(object[keys[k]])) && (typeof object[keys[k]] !== 'undefined') && (object[keys[k]].hasOwnProperty('RowVersion')) && !pageScope.generalModel.IsUndefinedEmptyOrNull(serverData[keys[k]]) && (object[keys[k]].RowVersion !== serverData[keys[k]].RowVersion)))) {
                            finalContent.push(keys[k]);
                        }
                    }
                }
                return finalContent
            };
        }
        return ConcurrencyData;
    }]);
})();
(function () {
    "use strict";
    myApp.factory('GetIp', ["$location", function ($location) {

        function GetIp(specificApiName) {
            var port = "";
            var protocol = "http";
            var api = myApplication.apiName;

            if ((typeof specificApiName !== 'undefined') && (specificApiName !== null) && (specificApiName !== '')) {
                api = specificApiName;
            }

            if (myApplication.projectType === myApplication.projectTypeWeb) {
                if ($location.port() !== '') {
                    port = ':' + $location.port();
                }

                if (($location.protocol() !== '') && (myApplication.projectType === myApplication.projectTypeWeb)) {
                    protocol = $location.protocol();
                }

                let apiLink = protocol + '://' + $location.host() + port + '/' + api;

                return apiLink;
            }
            else {
                if (myApplication.apiMobileServerPort) {
                    port = ':' + myApplication.apiMobileServerPort;
                }

                let apiLink = myApplication.protocol + '://' + myApplication.apiMobileServerLink + port + '/' + api;

                return apiLink;
            }
        };

        return GetIp;
    }]);
})();
(function () {
    "use strict";
    myApp.factory('HistoryService', ["GeneralModel", "HistoryModel", "$q", "$filter", "$sessionStorage", function (GeneralModel, HistoryModel, $q, $filter, $sessionStorage) {

        function History(pageScope) {
            var scope = pageScope;
            scope.historyModel = HistoryModel.model;
            scope.generalModel = GeneralModel.model;

            scope.generalModel.LoadHistory = function (elementId, gridName, idName, creationUserId, creationDatetime) {
                if (scope.generalModel.IsHistoryOpen) {
                    return;
                }

                scope.generalModel.IsHistoryOpen = true;
                scope.historyModel.Token = $sessionStorage.Token;
                scope.historyModel.HistoryId = elementId;
                scope.historyModel.CreationUserId = creationUserId;
                scope.historyModel.CreationDatetime = creationDatetime;
                scope.historyModel.HistoryIdName = idName;
                scope.historyModel.ListHistory = [];

                $q.when(HistoryModel.ListHistory()).then(function () {
                    if (gridName !== "") {
                        var grid = angular.element("#" + gridName + "").dxDataGrid('instance');
                        var dataSource = grid.getDataSource();
                        var objectForFilter = {};
                        objectForFilter[scope.historyModel.HistoryIdName] = scope.historyModel.HistoryId;
                        var rowData = $filter('filter')(dataSource._store._array, objectForFilter, true)[0];
                    }

                    var existTranslation = !scope.generalModel.IsUndefinedEmptyOrNullObject(Helpers.Translations);
                    var selectedLanguage = myApplication.getLanguageObject.selectedLanguage('historyTexts', myApplication);

                    scope.historyModel.GridHistory = {
                        bindingOptions: {
                            dataSource: 'historyModel.ListHistory'
                        },
                        filterRow: {
                            visible: true,
                            applyFilter: "auto"
                        },
                        headerFilter: {
                            visible: true
                        },
                        paging: {
                            pageSize: 15
                        },
                        showBorders: true,
                        columns: [{
                            dataField: "Field",
                            caption: existTranslation ? Helpers.Translations.HistoriesField : selectedLanguage.field,
                            alignment: 'left'
                        }, {
                            dataField: "OldValue",
                            caption: existTranslation ? Helpers.Translations.HistoriesOldValue : selectedLanguage.oldRegister,
                            alignment: 'left'
                        }, {
                            dataField: "NewValue",
                            caption: existTranslation ? Helpers.Translations.HistoriesNewValue : selectedLanguage.newRegister,
                            alignment: 'left'
                        }, {
                            dataField: "CreationUserName",
                            caption: existTranslation ? Helpers.Translations.UsersName : selectedLanguage.user,
                            alignment: 'left'
                        }, {
                            dataField: "CreationDatetime",
                            caption: existTranslation ? Helpers.Translations.HistoriesAlterationDate : selectedLanguage.alterationDate,
                            dataType: "datetime",
                            format: myApplication.dateTimeFormat,
                            sortOrder: 'desc',
                            alignment: 'center'
                        }],
                        noDataText: existTranslation ? Helpers.Translations.NoDataFound : selectedLanguage.noDataFound,
                        customizeColumns: function (columns) {
                            $.each(columns, function (_, element) {
                                element.headerCellTemplate = function (header, info) {
                                    $(header)
                                        .html(info.column.caption)
                                        .addClass('DataGridHeaderCellCenter');
                                    $('.dx-column-indicators')
                                        .addClass('DataGridHeaderCellIndicatorLeft');
                                };
                            });
                        }
                    };

                    scope.generalModel.OpenDialog('DialogHistory');
                }).catch(function (exception) {
                    scope.generalModel.HandleResultException(exception);
                });
            };
        }

        return History;
    }]);
})();
(function () {
    "use strict";
    myApp.directive('resizable', ["$window", function ($window) {
        var toCall;
        var previousPositionX;
        var previousPositionY;
        function throttle(fun) {
            if (toCall === undefined) {
                toCall = fun;
                setTimeout(function () {
                    toCall();
                    toCall = undefined;
                }, 100);
            } else {
                toCall = fun;
            }
        }
        return {
            restrict: 'AE',
            scope: {
                rDirections: '=',
                rCenteredX: '=',
                rCenteredY: '=',
                rWidth: '=',
                rHeight: '=',
                rFlex: '=',
                rGrabber: '@',
                rDisabled: '@'
            },
            link: function (scope, element, attr) {
                var previousElement = angular.element(element).prev('div');
                var flexBasis = 'flexBasis' in document.documentElement.style ? 'flexBasis' :
                    'webkitFlexBasis' in document.documentElement.style ? 'webkitFlexBasis' :
                        'msFlexPreferredSize' in document.documentElement.style ? 'msFlexPreferredSize' : 'flexBasis';

                scope.$watch('rWidth', function (value) {
                    element[0].style.width = scope.rWidth + 'px';
                });
                scope.$watch('rHeight', function (value) {
                    element[0].style.height = scope.rHeight + 'px';
                });

                element.addClass('resizable');

                var style = window.getComputedStyle(element[0], null),
                    w,
                    h,
                    dir = scope.rDirections,
                    vx = scope.rCenteredX ? 2 : 1,
                    vy = scope.rCenteredY ? 2 : 1,
                    inner = scope.rGrabber ? scope.rGrabber : '<span><span></span></span>',
                    start,
                    dragDir,
                    axis,
                    info = {};

                var updateInfo = function (e) {
                    info.width = false; info.height = false;
                    if (axis === 'x') {
                        info.width = parseInt(element[0].style[scope.rFlex ? flexBasis : 'width']);
                        if (!isNaN(info.width)) {
                            var ScreenWidth = $window.innerWidth;
                            angular.element(previousElement).css('width', '' + ScreenWidth - info.width + 'px');
                        }
                    }
                    else {
                        info.height = parseInt(element[0].style[scope.rFlex ? flexBasis : 'height']);
                    }
                    info.id = element[0].id;
                    info.evt = e;
                };

                var dragging = function (e) {
                    var prop, offset = axis === 'x' ? start - e.clientX : start - e.clientY;
                    switch (dragDir) {
                        case 'top':
                            prop = scope.rFlex ? flexBasis : 'height';
                            element[0].style[prop] = h + (offset * vy) + 'px';
                            break;
                        case 'bottom':
                            prop = scope.rFlex ? flexBasis : 'height';
                            element[0].style[prop] = h - (offset * vy) + 'px';
                            break;
                        case 'right':
                            prop = scope.rFlex ? flexBasis : 'width';
                            element[0].style[prop] = w - (offset * vx) + 'px';
                            break;
                        case 'left':
                            prop = scope.rFlex ? flexBasis : 'width';
                            element[0].style[prop] = w + (offset * vx) + 'px';
                            break;
                    }
                    updateInfo(e);
                    throttle(function () { scope.$emit('angular-resizable.resizing', info); });
                };
                var dragEnd = function (e) {
                    if (previousPositionX === e.clientX && previousPositionY === e.clientY) {
                        previousPositionX = '';
                        previousPositionY = '';
                        if (angular.element(e.target).parents('.resizable').hasClass('Closed')) {
                            angular.element(e.target).parents('.resizable').removeClass('Closed');
                            angular.element(e.target).parents('.resizable').width('200px');
                        }
                        else {
                            angular.element(e.target).parents('.resizable').addClass('Closed');
                            angular.element(e.target).parents('.resizable').width('2px');
                        }
                    }
                    updateInfo();
                    scope.$emit('angular-resizable.resizeEnd', info);
                    scope.$apply();
                    document.removeEventListener('mouseup', dragEnd, false);
                    document.removeEventListener('mousemove', dragging, false);
                    element.removeClass('no-transition');
                };
                var dragStart = function (e, direction) {
                    dragDir = direction;
                    axis = dragDir === 'left' || dragDir === 'right' ? 'x' : 'y';
                    start = axis === 'x' ? e.clientX : e.clientY;
                    w = parseInt(style.getPropertyValue('width'));
                    h = parseInt(style.getPropertyValue('height'));

                    element.addClass('no-transition');

                    document.addEventListener('mouseup', dragEnd, false);
                    document.addEventListener('mousemove', dragging, false);

                    if (e.stopPropagation) e.stopPropagation();
                    if (e.preventDefault) e.preventDefault();
                    e.cancelBubble = true;
                    e.returnValue = false;

                    updateInfo(e);
                    scope.$emit('angular-resizable.resizeStart', info);
                    scope.$apply();
                };

                dir.forEach(function (direction) {
                    var grabber = document.createElement('div');

                    grabber.setAttribute('class', 'rg-' + direction);
                    grabber.innerHTML = inner;
                    element[0].appendChild(grabber);
                    grabber.ondragstart = function () { return false; };
                    grabber.addEventListener('mousedown', function (e) {
                        previousPositionX = e.clientX;
                        previousPositionY = e.clientY;
                        var disabled = (scope.rDisabled === 'true');
                        if (!disabled && e.which === 1) {
                            dragStart(e, direction);
                        }
                    }, false);
                });
            }
        };
    }]);
})();
(function () {
    "use strict";
    myApp.factory('Validations', ["$state", function ($state) {
        var validations = {
            ValidationsGeneral: function CustomValidations(xhr, ajaxOptions, thrownError) {
                var errorMessage = "";
                if ((xhr.status === 401) && (angular.element('body').scope().generalModel.Expired !== true)) {
                    if (myApplication.projectType === myApplication.projectTypeWeb) {
                        angular.element('body').scope().generalModel.Expired = true;
                        if (myApplication.differentLoginPages.length && (myApplication.differentLoginPages.indexOf($state.current.name) > -1)) {
                            $state.go(myApplication.differentLogin);
                        }
                        else {
                            $state.go('Login');
                        }
                    }
                    else {
                        angular.element('body').scope().generalModel.Expired = true;
                        window.location.href = '../ApplicationControl/index.1739284541000.html';
                    }
                }
                else if (xhr.status === 403) {
                    errorMessage = ' - ' + myApplication.getLanguageObject.selectedLanguage('validationsTexts', myApplication).notAllowed;
                }
                else if ((xhr.data !== null) && (typeof xhr.data !== 'undefined')) {
                    if (typeof xhr.data === "object") {
                        errorMessage = " - " + xhr.data.Message;
                    }
                    else {
                        errorMessage = " - " + xhr.data;
                    }
                }
                else if (typeof xhr.statusText !== 'undefined') {
                    errorMessage = " - " + xhr.statusText;
                }
                return myApplication.getLanguageObject.selectedLanguage('validationsTexts', myApplication).error + " (" + xhr.status + ")" + errorMessage;
            },
            ValidationsLogin: function CustomValidationsLoginFunction(xhr, ajaxOptions, thrownError) {
                var errorMessage = "";
                if (xhr.status === 400) {
                    errorMessage = "400 - " + xhr.responseJSON.error;
                }
                else {
                    errorMessage = xhr.status + " - " + "Invalid Login.";
                }
                return errorMessage;
            },
            ValidationsParameters: function ParametersValidationsFunction(originalObject) {
                var newObject;
                if ((originalObject === null) || (typeof originalObject === "undefined")) {
                    newObject = originalObject;
                }
                else {
                    newObject = JSON.parse(JSON.stringify(originalObject));
                }

                (function filter(originalObject) {
                    $.each(originalObject, function (key, value) {
                        if (value === "" || value === null) {
                            delete originalObject[key];
                        } else if (Object.prototype.toString.call(value) === '[object Object]') {
                            filter(value);
                        } else if ($.isArray(value)) {
                            var indexToRemove = [];
                            $.each(value, function (k, v) {
                                if ((v === "") || (v === null)) {
                                    indexToRemove.push(k);
                                } else if (typeof v === "object") {
                                    filter(v);
                                }
                            });
                            if (indexToRemove.length) {
                                originalObject[key] = value.filter(function (v, index) {
                                    return (indexToRemove.indexOf(index) < 0);
                                });
                            }
                        }
                    });
                })(newObject);

                return newObject;
            }
        }
        return validations;
    }]);
})();
(function () {
    "use strict";
    myApp.factory('SaveCancelButtons', ["$q", "GeneralModel", function ($q, GeneralModel) {

        function CreateButtons(scope, model, validationGroup) {

            angular.element("#SideBarSaveButton").dxButton({
                validationGroup: validationGroup,
                onClick: function () {
                    if (scope.generalModel.SidebarOptions['State']['SaveOption']) {
                        model.SecondGridEditData = [];
                        scope.generalModel.FullPageLoading = true;
                        model.CancelSaveProcess = true;
                        model.LastSavedGrid = '';
                        scope.generalModel.ConcurrencyBeforeSave(model);

                        $q.when(scope.generalModel.ProcessSaveGridsPatchMode(model)).then(function () {
                            GeneralModel.ShowToast(myApplication.getLanguageObject.selectedLanguage('saveCancelButtonsTexts', myApplication).successfullSave);
                            scope.ReloadPage();
                        }).catch(function (reason) {
                            if (reason.Code === '409') {
                                scope.generalModel.ConcurrencyError = true;
                            }

                            if (reason.Message) {
                                reason = reason.Message;
                            }

                            GeneralModel.ShowToastWarning(reason);
                            scope.generalModel.FullPageLoading = false;
                        });
                    }
                }
            });

            angular.element("#SideBarCancelButton").dxButton({
                onClick: function () {
                    if (scope.generalModel.SidebarOptions['State']['CancelOption']) {
                        scope.generalModel.FullPageLoading = true;
                        scope.generalModel.ParentRowInserted = [];
                        scope.generalModel.ClearDeletedEditedObjects();

                        for (var k = 0; k < model.ArrayGridObjects.length; k++) {
                            var grid = angular.element("#" + model.ArrayGridObjects[k].GridName + "").dxDataGrid('instance');

                            Helpers.DevExtreme.Grid.RemoveEditData(grid, true, true);

                            if (typeof model[model.ArrayGridObjects[k].ObjectName + "ToolsState"] !== 'undefined') {
                                model[model.ArrayGridObjects[k].ObjectName + "ToolsState"] = false;
                            }

                            if (scope.generalModel.ConcurrencyError) {
                                model[model.ArrayGridObjects[k].ObjectName + 'Element'] = scope.generalModel.AngularCopy(model.ServerData);
                            }
                            else {
                                model[model.ArrayGridObjects[k].ObjectName + 'Element'] = scope.generalModel.AngularCopy(model.OriginalElements[model.ArrayGridObjects[k].ObjectName + 'Element']);
                            }

                            if (model.ArrayGridObjects[k].SecondGrid !== '') {
                                grid.collapseAll(-1);
                            }

                            grid.option('dataSource', model[model.ArrayGridObjects[k].ObjectName + 'Element']);
                            grid.refresh();
                        }

                        if (typeof model.ToolsStateItems !== 'undefined') {
                            model.ToolsStateItems = [];
                        }

                        if (typeof model.ToolsState !== 'undefined') {
                            model.ToolsState = false;
                        }

                        scope.generalModel.SidebarOptions['State']['SaveOption'] = false;
                        scope.generalModel.SidebarOptions['State']['CancelOption'] = false;
                        scope.generalModel.FullPageLoading = false;
                    }
                }
            });
        }

        return CreateButtons;
    }]);
})();
(function () {
    "use strict";
    myApp.factory('SwebModal', ["$timeout", function ($timeout) {

        function SwebModal(scope) {
            scope.generalModel.OpenSwebModal = function (data) {
                if (typeof data === 'string') {
                    data = { Element: data };
                }
                var id = data.Element;
                if (angular.element("#" + id).length) {
                    $timeout(function () {
                        var number = 0;

                        if (angular.element(".SwebActiveModal").length) {
                            angular.element(".SwebActiveModal").each(function () {
                                if (parseInt(angular.element(this).attr('data-target').substr(9)) >= number) {
                                    number = parseInt(angular.element(this).attr('data-target').substr(9)) + 1;
                                }
                            });
                        }

                        angular.element("#" + id).removeClass("animated fadeOut");
                        angular.element("#" + id).addClass("SwebActiveModal animated fadeIn");
                        angular.element("#" + id).attr("data-target", "SwebModal" + number + "");

                        if (data.Width) {
                            angular.element("#" + id).css('width', data.Width);
                        }

                        if (data.Height) {
                            angular.element("#" + id).css('height', data.Height);
                        }

                        angular.element("body").append("<div class=\"BackgroundSwebModal animated fadeIn\"></div>");
                        angular.element(".BackgroundSwebModal").last().attr("data-target", "SwebBackgroundModal" + number + "");

                        if (number > 0) {
                            angular.element("#" + id).css('z-index', (parseInt(angular.element(".SwebActiveModal[data-target=\"SwebModal" + (number - 1) + "\"]").css('z-index')) + 20));
                            angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").css('z-index', (parseInt(angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + (number - 1) + "\"]").css('z-index')) + 20));
                        }

                        if (data.ClickOutsideToClose) {
                            angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").on('click', function () {
                                scope.generalModel.CloseSwebModal(id);
                            });
                        }
                    }, 200);
                }

                if (data.OnComplete) {
                    data.OnComplete();

                    var pageHeight = angular.element(window).height();
                    var height = ((80 * pageHeight) / 100);

                    for (var a = 0; a < angular.element('.ModalContent').length; a++) {
                        if (!angular.element(angular.element('.ModalContent')[a]).parents('#TicketDialog').length) {
                            angular.element('.ModalContent.scroll-wrapper').css('max-height', height - 90 + "px");

                            $timeout(function () {
                                angular.element('.ModalContent.scroll-content').css('max-height', height - 130 + "px");
                            }, 200);
                        }
                    }
                }
            };

            scope.generalModel.CloseSwebModal = function (data) {
                if (typeof data === 'string') {
                    data = { Element: data };
                }

                var id = data.Element;

                angular.element("#" + id).addClass("animated fadeOut");

                if (typeof angular.element("#" + id).attr('data-target') !== 'undefined') {
                    var number = angular.element("#" + id).attr('data-target').substr(9);
                    angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").addClass("animated fadeOut");
                    $timeout(function () {
                        angular.element("#" + id).removeClass("SwebActiveModal");
                        angular.element(".BackgroundSwebModal[data-target=\"SwebBackgroundModal" + number + "\"]").remove();
                        angular.element("#" + id).attr("data-target", "");
                        if (!scope.generalModel.IsUndefinedEmptyOrNull(data.OnComplete)) {
                            data.OnComplete();
                        }
                    }, 500);
                }
            };
        }
        return SwebModal;
    }]);
})();
(function () {
    "use strict";
    myApp.controller(myApplication.generalCtrl, function ($scope, $rootScope, $locale, GeneralModel, GeneralFunctions) {
        $scope.generalModel = GeneralModel.model;
        GeneralFunctions($scope, $rootScope);
        $scope.generalModel.SetMyForms();
    });
})();
var webTranslations = [
    {
        Language: 'PT',
        Translations: [
            { Code: "PageName", OriginalText: "4Lean Configurador de Soluções" },
            { Code: "BuilderPageName", OriginalText: "4Lean Gerador de Configurador de Estruturas" },
            { Code: "ServicePageName", OriginalText: "4Lean Gerador de Configurador de Serviços" },
            { Code: "GeneralGuide", OriginalText: "Guia Geral" },
            { Code: "MakeListLeanProject", OriginalText: "Faça uma Lista/Projeto Lean" },
            { Code: "MakeList", OriginalText: "Faça uma Lista" },
            { Code: "Search", OriginalText: "Pesquisa..." },
            { Code: "Help", OriginalText: "Ajuda" },
            { Code: "Filters", OriginalText: "Filtros" },
            { Code: "ImportCsv", OriginalText: "Importar CSV" },
            { Code: "SelectFileAndDrag", OriginalText: "Selecione o arquivo ou arraste-o para aqui" },
            { Code: "List", OriginalText: "Lista" },
            { Code: "Area", OriginalText: "Área" },
            { Code: "Options", OriginalText: "Opções" },
            { Code: "Duplicate", OriginalText: "Duplicar" },
            { Code: "DuplicateMultiple", OriginalText: "Duplicar x" },
            { Code: "Remove", OriginalText: "Remover" },
            { Code: "PleaseChooseOption", OriginalText: "Por favor, escolha uma opção…" },
            { Code: "Notes", OriginalText: "Notas" },
            { Code: "LeanProject", OriginalText: "Projeto Lean" },
            { Code: "Next", OriginalText: "Seguinte" },
            { Code: "ProjectInformation", OriginalText: "Informações do Projeto" },
            { Code: "ProjectName", OriginalText: "Nome do Projeto" },
            { Code: "CoordinatorName", OriginalText: "Nome do Coordenador" },
            { Code: "CompanyName", OriginalText: "Nome da Empresa" },
            { Code: "ContactName", OriginalText: "Nome do Contacto" },
            { Code: "City", OriginalText: "Cidade" },
            { Code: "Country", OriginalText: "País" },
            { Code: "PhoneNumber", OriginalText: "Número de Telefone" },
            { Code: "PleaseContactMe", OriginalText: "Por favor Contate-me" },
            { Code: "Email", OriginalText: "E-mail" },
            { Code: "Submit", OriginalText: "Submeter" },
            { Code: "Copy", OriginalText: "Copiar" },
            { Code: "CopyAll", OriginalText: "Copiar Tudo" },
            { Code: "Quantity", OriginalText: "Quantidade" },
            { Code: "SolutionDetailTitle", OriginalText: "Vista Individual" },
            { Code: "Back", OriginalText: "Voltar" },
            { Code: "Previous", OriginalText: "Anterior" },
            { Code: "Import", OriginalText: "Importar" },
            { Code: "ImportCsvAllowedFiles", OriginalText: "Somente arquivos .csv são permitidos." },
            { Code: "InvalidFile", OriginalText: "Ficheiro Inválido:" },
            { Code: "ProjectSubmited", OriginalText: "Projeto Enviado" },
            { Code: "NoSolutionsWereFound", OriginalText: "Nenhuma solução foi encontrada." },
            { Code: "ProjectSubmitedSuccess", OriginalText: "O Seu Projeto Foi Enviado Com Sucesso." },
            { Code: "CheckYourEmail", OriginalText: "Por favor, verifique o seu e-mail para mais detalhes." },
            { Code: "Copied", OriginalText: "Copiado" },
            { Code: "Files", OriginalText: "Ficheiros" },
            { Code: "NoFiles", OriginalText: "Sem Ficheiros..." },
            { Code: "Specifications", OriginalText: "Especificações" },
            { Code: "NoSpecificationsAvailable", OriginalText: "Não há Especificações disponíveis." },
            { Code: "NoFilesAvailable", OriginalText: "Não há Ficheiros disponíveis." },
            { Code: "NoLinksAvailable", OriginalText: "Não há Links disponíveis." },
            { Code: "Menus", OriginalText: "Menu" },
            { Code: "Restart", OriginalText: "Recomeçar" },
            { Code: "MoreInfo", OriginalText: "+Info" },
            { Code: "Structures", OriginalText: "Structures" },
            { Code: "OpenStructures", OriginalText: "Abrir Structures" },
            { Code: "IndividualUrlCopied", OriginalText: "Link individual copiado com sucesso." },
            { Code: "CopyGeneralLink", OriginalText: "Copiar link geral" },
            { Code: "UrlMaxLengthReached", OriginalText: "Não foi possível copiar o link porque o tamanho máximo foi atingido." },
            { Code: "GeneralUrlCopied", OriginalText: "Link geral copiado com sucesso." },
            { Code: "Topic", OriginalText: "Tópico" },
            { Code: "Type", OriginalText: "Tipo" },
            { Code: "ExternalWidth", OriginalText: "Largura Externa [mm]" },
            { Code: "InternalWidth", OriginalText: "Largura Interna [mm]" },
            { Code: "ExternalDepth", OriginalText: "Profundidade Externa [mm]" },
            { Code: "InternalDepth", OriginalText: "Profundidade Interna [mm]" },
            { Code: "HeightThickness", OriginalText: "Altura / Espessura [mm]" },
            { Code: "Weight", OriginalText: "Peso [kg]" },
            { Code: "Orientation", OriginalText: "Orientação" },
            { Code: "DepthHu", OriginalText: "Qtd. Profundidade HU [un]" },
            { Code: "Slope", OriginalText: "Inclinação" },
            { Code: "SlopeDirection", OriginalText: "Direção da Inclinação" },
            { Code: "FreeSpace", OriginalText: "Espaço Livre [mm]" },
            { Code: "HUSupportType", OriginalText: "Tipo de Suporte HU" },
            { Code: "HUSupport", OriginalText: "Suporte HU" },
            { Code: "RollJoints", OriginalText: "Rolamentos" },
            { Code: "GuideType", OriginalText: "Tipo de Guia" },
            { Code: "ProfileSupportQuantity", OriginalText: "Quantidade de Suporte de Perfil" },
            { Code: "Annotations", OriginalText: "Anotações" },
            { Code: "UploadPhoto", OriginalText: "Upload Foto" },
            { Code: "ClearPhoto", OriginalText: "Limpar Foto" },
            { Code: "AddColumn", OriginalText: "Adicionar Coluna" },
            { Code: "InvalidStructurePosition", OriginalText: "Posição de Estrutura Inválida" },
            { Code: "VisitDetails", OriginalText: "Detalhes da Visita" },
            { Code: "ContactType", OriginalText: "Tipo de Contacto" },
            { Code: "CustomerDetails", OriginalText: "Detalhes do Cliente" },
            { Code: "Customer", OriginalText: "Cliente" },
            { Code: "Location", OriginalText: "Localização" },
            { Code: "Address", OriginalText: "Endereço" },
            { Code: "ContactName", OriginalText: "Nome do Contato" },
            { Code: "ContactEmail", OriginalText: "Email do Contato" },
            { Code: "SalesPerson", OriginalText: "Comercial" },
            { Code: "Market", OriginalText: "Mercado" },
            { Code: "RequestDetails", OriginalText: "Detalhes do Pedido" },
            { Code: "RequestsToOpen", OriginalText: "Pedidos para Abrir" },
            { Code: "RequestType", OriginalText: "Tipo de Pedido" },
            { Code: "FromPreviousRequest", OriginalText: "De Pedido Anterior" },
            { Code: "GlobalProposal", OriginalText: "Proposta Global" },
            { Code: "GlobalProposalRequestNumber", OriginalText: "Número Global do Pedido Proposta" },
            { Code: "ProjectDetails", OriginalText: "Detalhes do Projeto" },
            { Code: "AssemblyType", OriginalText: "Tipo de Montagem" },
            { Code: "IncludeTransport", OriginalText: "Incluir Transporte" },
            { Code: "SolutionCode", OriginalText: "Código da Solução" },
            { Code: "ProjectApplication", OriginalText: "Aplicação do Projeto" },
            { Code: "PreviousProcess", OriginalText: "Processo Anterior" },
            { Code: "NextProcess", OriginalText: "Próximo Processo" },
            { Code: "InternalOrExternalMeasures", OriginalText: "Medidas Internas / Externas" },
            { Code: "SubmissionType", OriginalText: "Tipo de Submissão" },
            { Code: "Draft", OriginalText: "Rascunho" },
            { Code: "AssemblyCuttingList", OriginalText: "Lista de Corte da Montagem" },
            { Code: "ProposalRequest", OriginalText: "Pedido de Proposta" },
            { Code: "Photos", OriginalText: "Fotografias" },
            { Code: "LocateInMakeAList", OriginalText: "Localizar na Lista" },
            { Code: "LocateInServiceRequestList", OriginalText: "Localizar na Lista de Pedidos de Serviços" },
            { Code: "LocateInServiceList", OriginalText: "Localizar na Lista de Serviços" },
            { Code: "ServiceList", OriginalText: "Lista de Serviços" },
            { Code: "ServiceRequestList", OriginalText: "Lista de Pedidos de Serviços" },
            { Code: "Location", OriginalText: "Localização" },
            { Code: "DojoRental", OriginalText: "Aluguer de DOJO" },
            { Code: "CoffeeBreakIncluded", OriginalText: "Pausa para Café Incluída" },
            { Code: "LunchIncluded", OriginalText: "Almoço Incluído" },
            { Code: "ParticipantsList", OriginalText: "Lista de Participantes" },
            { Code: "ParticipantsNumber", OriginalText: "# Participantes" },
            { Code: "ExpensesIncluded", OriginalText: "Despesas Incluídas" },
            { Code: "SafetyEquipmentIncluded", OriginalText: "Equipamento de Segurança Incluído" },
            { Code: "SafetyTrainingIncluded", OriginalText: "Formação em Segurança Incluída" },
            { Code: "AtYourPlace", OriginalText: "No seu Lugar" },
            { Code: "ServiceProviderEmail", OriginalText: "Email do Prestador de Serviço" },
            { Code: "ServiceRequesterEmail", OriginalText: "Email do Requerente de Serviço" },
            { Code: "LinksToSend", OriginalText: "# Links para Enviar" },
            { Code: "Login", OriginalText: "Iniciar Sessão" },
            { Code: "Logout", OriginalText: "Sair" },
            { Code: "User", OriginalText: "Utilizador" },
            { Code: "Password", OriginalText: "Palavra-Passe" },
            { Code: "InvalidLogin", OriginalText: "Informações para login inválidas." },
            { Code: "Services", OriginalText: "Serviços" },
            { Code: "FilterCode", OriginalText: "Código Filtro" },
            { Code: "SetFilterCode", OriginalText: "Definir Código Filtro" },
            { Code: "Save", OriginalText: "Guardar" },
        ]
    },
    {
        Language: 'EN',
        Translations: [
            { Code: "PageName", OriginalText: "4Lean Solution Configurator" },
            { Code: "BuilderPageName", OriginalText: "4Lean Structure Builder Configurator" },
            { Code: "ServicePageName", OriginalText: "4Lean Service Configurator" },
            { Code: "GeneralGuide", OriginalText: "General Guide" },
            { Code: "MakeListLeanProject", OriginalText: "Make a List / LeanProject" },
            { Code: "MakeList", OriginalText: "Make a List" },
            { Code: "Search", OriginalText: "Search..." },
            { Code: "Help", OriginalText: "Help" },
            { Code: "Filters", OriginalText: "Filters" },
            { Code: "ImportCsv", OriginalText: "Import CSV" },
            { Code: "SelectFileAndDrag", OriginalText: "Select your file or drag it here." },
            { Code: "List", OriginalText: "List" },
            { Code: "Area", OriginalText: "Area" },
            { Code: "Options", OriginalText: "Options" },
            { Code: "Duplicate", OriginalText: "Duplicate" },
            { Code: "DuplicateMultiple", OriginalText: "Duplicate x" },
            { Code: "Remove", OriginalText: "Remove" },
            { Code: "PleaseChooseOption", OriginalText: "Please choose one option..." },
            { Code: "Notes", OriginalText: "Notes" },
            { Code: "LeanProject", OriginalText: "Lean Project" },
            { Code: "Next", OriginalText: "Next" },
            { Code: "ProjectInformation", OriginalText: "Project Information" },
            { Code: "ProjectName", OriginalText: "Project Name" },
            { Code: "CoordinatorName", OriginalText: "Coordinator Name" },
            { Code: "CompanyName", OriginalText: "Company Name" },
            { Code: "ContactName", OriginalText: "Contact Name" },
            { Code: "City", OriginalText: "City" },
            { Code: "Country", OriginalText: "Country" },
            { Code: "PhoneNumber", OriginalText: "Phone Number" },
            { Code: "PleaseContactMe", OriginalText: "Please Contact Me" },
            { Code: "Email", OriginalText: "Email" },
            { Code: "Submit", OriginalText: "Submit" },
            { Code: "Copy", OriginalText: "Copy" },
            { Code: "CopyAll", OriginalText: "Copy All" },
            { Code: "Quantity", OriginalText: "Quantity" },
            { Code: "SolutionDetailTitle", OriginalText: "Individual View" },
            { Code: "Back", OriginalText: "Back" },
            { Code: "Previous", OriginalText: "Previous" },
            { Code: "Import", OriginalText: "Import" },
            { Code: "ImportCsvAllowedFiles", OriginalText: "Only .csv file is allowed." },
            { Code: "InvalidFile", OriginalText: "Invalid File:" },
            { Code: "ProjectSubmited", OriginalText: "Project Submited" },
            { Code: "NoSolutionsWereFound", OriginalText: "No solutions where found." },
            { Code: "ProjectSubmitedSuccess", OriginalText: "Your Project Was Submited Successfully." },
            { Code: "CheckYourEmail", OriginalText: "Please check your email for more details." },
            { Code: "Copied", OriginalText: "Copied" },
            { Code: "Files", OriginalText: "Files" },
            { Code: "NoFiles", OriginalText: "No Files..." },
            { Code: "Specifications", OriginalText: "Specifications" },
            { Code: "NoSpecificationsAvailable", OriginalText: "There are no Specifications available." },
            { Code: "NoFilesAvailable", OriginalText: "There are no Files available." },
            { Code: "NoLinksAvailable", OriginalText: "There are no Links available." },
            { Code: "Menus", OriginalText: "Menu" },
            { Code: "Restart", OriginalText: "Restart" },
            { Code: "MoreInfo", OriginalText: "+Info" },
            { Code: "Structures", OriginalText: "Structures" },
            { Code: "OpenStructures", OriginalText: "Open Structures" },
            { Code: "IndividualUrlCopied", OriginalText: "Individual link successfully copied." },
            { Code: "CopyGeneralLink", OriginalText: "Copy general link" },
            { Code: "UrlMaxLengthReached", OriginalText: "Unable to copy link because the maximum size was reached." },
            { Code: "GeneralUrlCopied", OriginalText: "General link successfully copied." },
            { Code: "Topic", OriginalText: "Topic" },
            { Code: "Type", OriginalText: "Type" },
            { Code: "ExternalWidth", OriginalText: "External Width [mm]" },
            { Code: "InternalWidth", OriginalText: "Internal Width [mm]" },
            { Code: "ExternalDepth", OriginalText: "External Depth [mm]" },
            { Code: "InternalDepth", OriginalText: "Internal Depth [mm]" },
            { Code: "HeightThickness", OriginalText: "Height / Thickness [mm]" },
            { Code: "Weight", OriginalText: "Weight [kg]" },
            { Code: "Orientation", OriginalText: "Orientation" },
            { Code: "DepthHu", OriginalText: "Depth Hu Qty [un]" },
            { Code: "Slope", OriginalText: "Slope" },
            { Code: "SlopeDirection", OriginalText: "Slope Direction" },
            { Code: "FreeSpace", OriginalText: "Free Space [mm]" },
            { Code: "HUSupportType", OriginalText: "HU Support Type" },
            { Code: "HUSupport", OriginalText: "HU Support" },
            { Code: "RollJoints", OriginalText: "Rolls Joints" },
            { Code: "GuideType", OriginalText: "Guide Type" },
            { Code: "ProfileSupportQuantity", OriginalText: "Profile Support Quantity" },
            { Code: "Annotations", OriginalText: "Annotations" },
            { Code: "UploadPhoto", OriginalText: "Upload Photo" },
            { Code: "ClearPhoto", OriginalText: "Clean Foto" },
            { Code: "AddColumn", OriginalText: "Add Column" },
            { Code: "InvalidStructurePosition", OriginalText: "Invalid Structure Position" },
            { Code: "VisitDetails", OriginalText: "Visit Details" },
            { Code: "ContactType", OriginalText: "Contact Type" },
            { Code: "CustomerDetails", OriginalText: "Customer Details" },
            { Code: "Customer", OriginalText: "Customer" },
            { Code: "Location", OriginalText: "Location" },
            { Code: "Address", OriginalText: "Address" },
            { Code: "ContactName", OriginalText: "Contact Name" },
            { Code: "ContactEmail", OriginalText: "Contact Email" },
            { Code: "SalesPerson", OriginalText: "Sales Person" },
            { Code: "Market", OriginalText: "Market" },
            { Code: "RequestDetails", OriginalText: "Request Details" },
            { Code: "RequestsToOpen", OriginalText: "Requests to Open" },
            { Code: "RequestType", OriginalText: "Request Type" },
            { Code: "FromPreviousRequest", OriginalText: "From Previous Request" },
            { Code: "GlobalProposal", OriginalText: "Global Proposal" },
            { Code: "GlobalProposalRequestNumber", OriginalText: "Global Proposal Request Number" },
            { Code: "ProjectDetails", OriginalText: "Project Details" },
            { Code: "AssemblyType", OriginalText: "Assembly Type" },
            { Code: "IncludeTransport", OriginalText: "Include Transport" },
            { Code: "SolutionCode", OriginalText: "Solution Code" },
            { Code: "ProjectApplication", OriginalText: "Project Application" },
            { Code: "PreviousProcess", OriginalText: "Previous Process" },
            { Code: "NextProcess", OriginalText: "Next Process" },
            { Code: "InternalOrExternalMeasures", OriginalText: "Internal / External Measures" },
            { Code: "SubmissionType", OriginalText: "Submission Type" },
            { Code: "Draft", OriginalText: "Draft" },
            { Code: "AssemblyCuttingList", OriginalText: "Assembly Cutting List" },
            { Code: "ProposalRequest", OriginalText: "Proposal Request" },
            { Code: "Photos", OriginalText: "Photos" },
            { Code: "LocateInMakeAList", OriginalText: "Locate in Make a List" },
            { Code: "LocateInServiceRequestList", OriginalText: "Locate in Service Request List" },
            { Code: "LocateInServiceList", OriginalText: "Locate in Service List" },
            { Code: "ServiceList", OriginalText: "Service List" },
            { Code: "ServiceRequestList", OriginalText: "Service Request List" },
            { Code: "Location", OriginalText: "Location" },
            { Code: "DojoRental", OriginalText: "DOJO Rental" },
            { Code: "CoffeeBreakIncluded", OriginalText: "Coffee Break Included" },
            { Code: "LunchIncluded", OriginalText: "Lunch Included" },
            { Code: "ParticipantsList", OriginalText: "Participants list" },
            { Code: "ParticipantsNumber", OriginalText: "# Participants" },
            { Code: "ExpensesIncluded", OriginalText: "Expenses Included" },
            { Code: "SafetyEquipmentIncluded", OriginalText: "Safety Equipment Included" },
            { Code: "SafetyTrainingIncluded", OriginalText: "Safety Training Included" },
            { Code: "AtYourPlace", OriginalText: "At your Place" },
            { Code: "ServiceProviderEmail", OriginalText: "Service Provider Email" },
            { Code: "ServiceRequesterEmail", OriginalText: "Service Requester Email" },
            { Code: "LinksToSend", OriginalText: "# Links to Send" },
            { Code: "Login", OriginalText: "Login" },
            { Code: "Logout", OriginalText: "Logout" },
            { Code: "User", OriginalText: "User" },
            { Code: "Password", OriginalText: "Password" },
            { Code: "InvalidLogin", OriginalText: "Invalid login information." },
            { Code: "Services", OriginalText: "Services" },
            { Code: "FilterCode", OriginalText: "Filter Code" },
            { Code: "SetFilterCode", OriginalText: "Set Filter Code" },
            { Code: "Save", OriginalText: "Save" },
        ]
    },
    {
        Language: 'FR',
        Translations: [
            { Code: "PageName", OriginalText: "4Lean Configurateur de Solution" },
            { Code: "BuilderPageName", OriginalText: "4Lean Configurateur de Constructeur de Structures" },
            { Code: "ServicePageName", OriginalText: "4Lean Configurateur de Services" },
            { Code: "GeneralGuide", OriginalText: "Guide Général" },
            { Code: "MakeListLeanProject", OriginalText: "Faire une Liste/Projet Lean" },
            { Code: "MakeList", OriginalText: "Faire une Liste" },
            { Code: "Search", OriginalText: "Chercher..." },
            { Code: "Help", OriginalText: "Aide" },
            { Code: "Filters", OriginalText: "Filtres" },
            { Code: "ImportCsv", OriginalText: "Importer CSV" },
            { Code: "SelectFileAndDrag", OriginalText: "Sélectionnez votre fichier ou faites-le glisser ici." },
            { Code: "List", OriginalText: "Liste" },
            { Code: "Area", OriginalText: "Domaine" },
            { Code: "Options", OriginalText: "Options" },
            { Code: "Duplicate", OriginalText: "Dupliquer" },
            { Code: "DuplicateMultiple", OriginalText: "Dupliquer x" },
            { Code: "Remove", OriginalText: "Retirer" },
            { Code: "PleaseChooseOption", OriginalText: "S'il vous plait, choisissez une option..." },
            { Code: "Notes", OriginalText: "Notes" },
            { Code: "LeanProject", OriginalText: "Projet Lean" },
            { Code: "Next", OriginalText: "Suivant" },
            { Code: "ProjectInformation", OriginalText: "Renseignements sur le Projet" },
            { Code: "ProjectName", OriginalText: "Nom du Projet" },
            { Code: "CoordinatorName", OriginalText: "Nom du Coordinateur" },
            { Code: "CompanyName", OriginalText: "Nom de l‘Entreprise" },
            { Code: "ContactName", OriginalText: "Nom du Contact" },
            { Code: "City", OriginalText: "Ville" },
            { Code: "Country", OriginalText: "Pays" },
            { Code: "PhoneNumber", OriginalText: "Numéro de Téléphone" },
            { Code: "PleaseContactMe", OriginalText: "S'il vous plait Contactez moi" },
            { Code: "Email", OriginalText: "E-mail" },
            { Code: "Submit", OriginalText: "Soumettre" },
            { Code: "Copy", OriginalText: "Copie" },
            { Code: "CopyAll", OriginalText: "Tout Copier" },
            { Code: "Quantity", OriginalText: "Quantité" },
            { Code: "SolutionDetailTitle", OriginalText: "Vue Individuelle" },
            { Code: "Back", OriginalText: "Retour" },
            { Code: "Previous", OriginalText: "Précédent" },
            { Code: "Import", OriginalText: "Importer" },
            { Code: "ImportCsvAllowedFiles", OriginalText: "Seul le fichier .csv est autorisé." },
            { Code: "InvalidFile", OriginalText: "Fichier Non Valide:" },
            { Code: "ProjectSubmited", OriginalText: "Projet Soumis" },
            { Code: "NoSolutionsWereFound", OriginalText: "Aucune solution n'a été trouvée." },
            { Code: "ProjectSubmitedSuccess", OriginalText: "Votre Projet A Été Soumis Avec Succès." },
            { Code: "CheckYourEmail", OriginalText: "Veuillez vérifier votre email pour plus de détails." },
            { Code: "Copied", OriginalText: "Copié" },
            { Code: "Files", OriginalText: "Fichiers" },
            { Code: "NoFiles", OriginalText: "Sans Fichiers..." },
            { Code: "Specifications", OriginalText: "Spécifications" },
            { Code: "NoSpecificationsAvailable", OriginalText: "Il n'y a pas de Spécifications disponibles." },
            { Code: "NoFilesAvailable", OriginalText: "Il n'y a pas de Fichiers disponibles." },
            { Code: "NoLinksAvailable", OriginalText: "Il n'y a pas de Links disponibles." },
            { Code: "Menus", OriginalText: "Menu" },
            { Code: "Restart", OriginalText: "Recommencer" },
            { Code: "MoreInfo", OriginalText: "+Info" },
            { Code: "Structures", OriginalText: "Structures" },
            { Code: "OpenStructures", OriginalText: "Ouvrir Structures" },
            { Code: "IndividualUrlCopied", OriginalText: "Lien individuel copié avec succès." },
            { Code: "CopyGeneralLink", OriginalText: "Copier le lien général" },
            { Code: "UrlMaxLengthReached", OriginalText: "Le lien n'a pas pu être copié car la taille maximale a été atteinte." },
            { Code: "GeneralUrlCopied", OriginalText: "Lien général copié avec succès." },
            { Code: "Topic", OriginalText: "Sujet" },
            { Code: "Type", OriginalText: "Type" },
            { Code: "ExternalWidth", OriginalText: "Largeur Externe [mm]" },
            { Code: "InternalWidth", OriginalText: "Largeur Interne [mm]" },
            { Code: "ExternalDepth", OriginalText: "Profondeur Externe [mm]" },
            { Code: "InternalDepth", OriginalText: "Profondeur Interne [mm]" },
            { Code: "HeightThickness", OriginalText: "Hauteur / Épaisseur [mm]" },
            { Code: "Weight", OriginalText: "Poids [kg]" },
            { Code: "Orientation", OriginalText: "Orientation" },
            { Code: "DepthHu", OriginalText: "Qtt. Profondeur HU [un]" },
            { Code: "Slope", OriginalText: "Pente" },
            { Code: "SlopeDirection", OriginalText: "Direction de Pente" },
            { Code: "FreeSpace", OriginalText: "Espace Libre [mm]" },
            { Code: "HUSupportType", OriginalText: "Type de Support HU" },
            { Code: "HUSupport", OriginalText: "Support HU" },
            { Code: "RollJoints", OriginalText: "Joints à Rouleaux" },
            { Code: "GuideType", OriginalText: "Type de Guide" },
            { Code: "ProfileSupportQuantity", OriginalText: "Quantité de Support de Profil" },
            { Code: "Annotations", OriginalText: "Annotations" },
            { Code: "UploadPhoto", OriginalText: "Téléchargement de Photos" },
            { Code: "ClearPhoto", OriginalText: "Photo Propre" },
            { Code: "AddColumn", OriginalText: "Ajouter Colonne" },
            { Code: "InvalidStructurePosition", OriginalText: "Position Structure Invalide" },
            { Code: "VisitDetails", OriginalText: "Détails De La Visite" },
            { Code: "ContactType", OriginalText: "Type de Contact" },
            { Code: "CustomerDetails", OriginalText: "Détails du Client" },
            { Code: "Customer", OriginalText: "Client" },
            { Code: "Location", OriginalText: "Emplacement" },
            { Code: "Address", OriginalText: "Adresse" },
            { Code: "ContactName", OriginalText: "Nom du Contact" },
            { Code: "ContactEmail", OriginalText: "Email du Contact" },
            { Code: "SalesPerson", OriginalText: "Commercial" },
            { Code: "Market", OriginalText: "Marché" },
            { Code: "RequestDetails", OriginalText: "Détails de La Demande" },
            { Code: "RequestsToOpen", OriginalText: "Demandes à Ouvrir" },
            { Code: "RequestType", OriginalText: "Type de Demande" },
            { Code: "FromPreviousRequest", OriginalText: "De Demande Précédente" },
            { Code: "GlobalProposal", OriginalText: "Proposition Mondiale" },
            { Code: "GlobalProposalRequestNumber", OriginalText: "Numéro Global de Demande de Proposition" },
            { Code: "ProjectDetails", OriginalText: "Détails du Projet" },
            { Code: "AssemblyType", OriginalText: "Type d'Assemblage" },
            { Code: "IncludeTransport", OriginalText: "Inclure le Transport" },
            { Code: "SolutionCode", OriginalText: "Code de la Solution" },
            { Code: "ProjectApplication", OriginalText: "Application du Projet" },
            { Code: "PreviousProcess", OriginalText: "Processus Précédent" },
            { Code: "NextProcess", OriginalText: "Processus Suivant" },
            { Code: "InternalOrExternalMeasures", OriginalText: "Mesures Internes / Externes" },
            { Code: "SubmissionType", OriginalText: "Type de Soumission" },
            { Code: "Draft", OriginalText: "Brouillon" },
            { Code: "AssemblyCuttingList", OriginalText: "Liste de Découpe de l'Assemblage" },
            { Code: "ProposalRequest", OriginalText: "Demande de Proposition" },
            { Code: "Photos", OriginalText: "Photos" },
            { Code: "LocateInMakeAList", OriginalText: "Localiser dans Faire une Liste" },
            { Code: "LocateInServiceRequestList", OriginalText: "Localiser dans Liste de Demandes de Service" },
            { Code: "LocateInServiceList", OriginalText: "Localiser dans Liste de Services" },
            { Code: "ServiceList", OriginalText: "Liste de Services" },
            { Code: "ServiceRequestList", OriginalText: "Liste de Demandes de Service" },
            { Code: "Location", OriginalText: "Emplacement" },
            { Code: "DojoRental", OriginalText: "Location du DOJO" },
            { Code: "CoffeeBreakIncluded", OriginalText: "Pause Café Incluse" },
            { Code: "LunchIncluded", OriginalText: "Déjeuner Inclus" },
            { Code: "ParticipantsList", OriginalText: "Liste de Participants" },
            { Code: "ParticipantsNumber", OriginalText: "# Participants" },
            { Code: "ExpensesIncluded", OriginalText: "Frais Inclus" },
            { Code: "SafetyEquipmentIncluded", OriginalText: "Équipement de Sécurité Inclus" },
            { Code: "SafetyTrainingIncluded", OriginalText: "Formation de Sécurité Incluse" },
            { Code: "AtYourPlace", OriginalText: "Chez vous" },
            { Code: "ServiceProviderEmail", OriginalText: "Email du Fourniseur de Service" },
            { Code: "ServiceRequesterEmail", OriginalText: "Email du Demandeur de Service" },
            { Code: "LinksToSend", OriginalText: "# Liens à Envoyer" },
            { Code: "Login", OriginalText: "Se Connecter" },
            { Code: "Logout", OriginalText: "Se Déconnecter" },
            { Code: "User", OriginalText: "Utilisateur" },
            { Code: "Password", OriginalText: "Mot de Passe" },
            { Code: "InvalidLogin", OriginalText: "Informations de connexion invalides." },
            { Code: "Services", OriginalText: "Services" },
            { Code: "FilterCode", OriginalText: "Code Filtre" },
            { Code: "SetFilterCode", OriginalText: "Définir Code Filtre" },
            { Code: "Save", OriginalText: "Enregister" },
        ]
    },
    {
        Language: 'ES',
        Translations: [
            { Code: "PageName", OriginalText: "4Lean Configurador de Soluciones" },
            { Code: "BuilderPageName", OriginalText: "4Lean Configurador de Constructor de Estructuras" },
            { Code: "ServicePageName", OriginalText: "4Lean Configurador de Servicios" },
            { Code: "GeneralGuide", OriginalText: "Guía General" },
            { Code: "MakeListLeanProject", OriginalText: "Crear una Lista/Proyecto Lean" },
            { Code: "MakeList", OriginalText: "Crear una Lista" },
            { Code: "Search", OriginalText: "Buscar..." },
            { Code: "Help", OriginalText: "Ayuda" },
            { Code: "Filters", OriginalText: "Filtros" },
            { Code: "ImportCsv", OriginalText: "Importar CSV" },
            { Code: "SelectFileAndDrag", OriginalText: "Seleccione su archivo o arrástrelo aquí." },
            { Code: "List", OriginalText: "Lista" },
            { Code: "Area", OriginalText: "Área" },
            { Code: "Options", OriginalText: "Opciones" },
            { Code: "Duplicate", OriginalText: "Duplicar" },
            { Code: "DuplicateMultiple", OriginalText: "Duplicar x" },
            { Code: "Remove", OriginalText: "Eliminar" },
            { Code: "PleaseChooseOption", OriginalText: "Por favor, elija una opción..." },
            { Code: "Notes", OriginalText: "Notas" },
            { Code: "LeanProject", OriginalText: "Proyecto Lean" },
            { Code: "Next", OriginalText: "Siguiente" },
            { Code: "ProjectInformation", OriginalText: "Información del Proyecto" },
            { Code: "ProjectName", OriginalText: "Nombre del Proyecto" },
            { Code: "CoordinatorName", OriginalText: "Nombre del Coordinador" },
            { Code: "CompanyName", OriginalText: "Nombre de la Empresa" },
            { Code: "ContactName", OriginalText: "Nombre de Contacto" },
            { Code: "City", OriginalText: "Ciudad" },
            { Code: "Country", OriginalText: "País" },
            { Code: "PhoneNumber", OriginalText: "Número de Teléfono" },
            { Code: "PleaseContactMe", OriginalText: "Por favor Contáctame" },
            { Code: "Email", OriginalText: "E-mail" },
            { Code: "Submit", OriginalText: "Enviar" },
            { Code: "Copy", OriginalText: "Copiar" },
            { Code: "CopyAll", OriginalText: "Copie Todo" },
            { Code: "Quantity", OriginalText: "Cantidad" },
            { Code: "SolutionDetailTitle", OriginalText: "Vista Individual" },
            { Code: "Back", OriginalText: "Volver" },
            { Code: "Previous", OriginalText: "Previo" },
            { Code: "Import", OriginalText: "Importar" },
            { Code: "ImportCsvAllowedFiles", OriginalText: "Sólo se permiten archivos .csv." },
            { Code: "InvalidFile", OriginalText: "Archivo Inválido:" },
            { Code: "ProjectSubmited", OriginalText: "Proyecto Enviado" },
            { Code: "NoSolutionsWereFound", OriginalText: "No se encontraron soluciones." },
            { Code: "ProjectSubmitedSuccess", OriginalText: "Su Proyecto Fue Enviado Correctamente." },
            { Code: "CheckYourEmail", OriginalText: "Consulte su correo electrónico para obtener más detalles." },
            { Code: "Copied", OriginalText: "Copiado" },
            { Code: "Files", OriginalText: "Archivos" },
            { Code: "NoFiles", OriginalText: "Sin Archivos..." },
            { Code: "Specifications", OriginalText: "Especificaciones" },
            { Code: "NoSpecificationsAvailable", OriginalText: "No hay Especificaciones disponibles." },
            { Code: "NoFilesAvailable", OriginalText: "No hay Archivos disponibles." },
            { Code: "NoLinksAvailable", OriginalText: "No hay Links disponibles." },
            { Code: "Menus", OriginalText: "Menú" },
            { Code: "Restart", OriginalText: "Reanudar" },
            { Code: "MoreInfo", OriginalText: "+Info" },
            { Code: "Structures", OriginalText: "Structures" },
            { Code: "OpenStructures", OriginalText: "Abrir Structures" },
            { Code: "IndividualUrlCopied", OriginalText: "Enlace individual copiado con éxito." },
            { Code: "CopyGeneralLink", OriginalText: "Copiar enlace general" },
            { Code: "UrlMaxLengthReached", OriginalText: "No se pudo copiar el enlace porque se alcanzó el tamaño máximo." },
            { Code: "GeneralUrlCopied", OriginalText: "Enlace general copiado con éxito." },
            { Code: "Topic", OriginalText: "Tema" },
            { Code: "Type", OriginalText: "Tipo" },
            { Code: "ExternalWidth", OriginalText: "Ancho Externo [mm]" },
            { Code: "InternalWidth", OriginalText: "Ancho Interno [mm]" },
            { Code: "ExternalDepth", OriginalText: "Profundidad Externa [mm]" },
            { Code: "InternalDepth", OriginalText: "Profundidad Interna [mm]" },
            { Code: "HeightThickness", OriginalText: "Altura / Grosor [mm]" },
            { Code: "Weight", OriginalText: "Peso [kg]" },
            { Code: "Orientation", OriginalText: "Orientación" },
            { Code: "DepthHu", OriginalText: "Ctd. Profundidad HU [un]" },
            { Code: "Slope", OriginalText: "Pendiente" },
            { Code: "SlopeDirection", OriginalText: "Dirección de Pendiente" },
            { Code: "FreeSpace", OriginalText: "Espacio Libre [mm]" },
            { Code: "HUSupportType", OriginalText: "Tipo de Soporte HU" },
            { Code: "HUSupport", OriginalText: "Soporte HU" },
            { Code: "RollJoints", OriginalText: "Uniones Rodantes" },
            { Code: "GuideType", OriginalText: "Tipo de Guía" },
            { Code: "ProfileSupportQuantity", OriginalText: "Cantidad de Soporte de Perfil" },
            { Code: "Annotations", OriginalText: "Anotaciones" },
            { Code: "UploadPhoto", OriginalText: "Subir Foto" },
            { Code: "ClearPhoto", OriginalText: "Photo Limpia" },
            { Code: "AddColumn", OriginalText: "Agregar Columna" },
            { Code: "InvalidStructurePosition", OriginalText: "Posición Estructura Inválida" },
            { Code: "VisitDetails", OriginalText: "Detalles de La Visita" },
            { Code: "ContactType", OriginalText: "Tipo de Contacto" },
            { Code: "CustomerDetails", OriginalText: "Detalles del Cliente" },
            { Code: "Customer", OriginalText: "Cliente" },
            { Code: "Location", OriginalText: "Ubicación" },
            { Code: "Address", OriginalText: "Dirección" },
            { Code: "ContactName", OriginalText: "Nombre de Contacto" },
            { Code: "ContactEmail", OriginalText: "Correo Electrónico del Contacto" },
            { Code: "SalesPerson", OriginalText: "Vendedor" },
            { Code: "Market", OriginalText: "Mercado" },
            { Code: "RequestDetails", OriginalText: "Detalles de la Solicitud" },
            { Code: "RequestsToOpen", OriginalText: "Solicitudes para Abrir" },
            { Code: "RequestType", OriginalText: "Tipo de Solicitud" },
            { Code: "FromPreviousRequest", OriginalText: "De Solicitud Anterior" },
            { Code: "GlobalProposal", OriginalText: "Propuesta Global" },
            { Code: "GlobalProposalRequestNumber", OriginalText: "Número Global de Solicitud de Propuesta" },
            { Code: "ProjectDetails", OriginalText: "Detalles del Proyecto" },
            { Code: "AssemblyType", OriginalText: "Tipo de Ensamblaje" },
            { Code: "IncludeTransport", OriginalText: "Incluir Transporte" },
            { Code: "SolutionCode", OriginalText: "Código de Solución" },
            { Code: "ProjectApplication", OriginalText: "Aplicación del Proyecto" },
            { Code: "PreviousProcess", OriginalText: "Proceso Anterior" },
            { Code: "NextProcess", OriginalText: "Siguiente Proceso" },
            { Code: "InternalOrExternalMeasures", OriginalText: "Medidas Internas / Externas" },
            { Code: "SubmissionType", OriginalText: "Tipo de Presentación" },
            { Code: "Draft", OriginalText: "Borrador" },
            { Code: "AssemblyCuttingList", OriginalText: "Lista de Corte del Ensamblaje" },
            { Code: "ProposalRequest", OriginalText: "Solicitud de Propuesta" },
            { Code: "Photos", OriginalText: "Fotos" },
            { Code: "LocateInMakeAList", OriginalText: "Localizar en Hacer una Lista" },
            { Code: "LocateInServiceRequestList", OriginalText: "Localizar en Lista de Solicitudes de Servicio" },
            { Code: "LocateInServiceList", OriginalText: "Localizar en Lista de Servicio" },
            { Code: "ServiceList", OriginalText: "Lista de Servicio" },
            { Code: "ServiceRequestList", OriginalText: "Lista de Solicitudes de Servicio" },
            { Code: "Location", OriginalText: "Ubicación" },
            { Code: "DojoRental", OriginalText: "Alquiler de DOJO" },
            { Code: "CoffeeBreakIncluded", OriginalText: "Pausa para el Café Incluida" },
            { Code: "LunchIncluded", OriginalText: "Almuerzo Incluido" },
            { Code: "ParticipantsList", OriginalText: "Lista de Participantes" },
            { Code: "ParticipantsNumber", OriginalText: "# Participantes" },
            { Code: "ExpensesIncluded", OriginalText: "Gastos Incluidos" },
            { Code: "SafetyEquipmentIncluded", OriginalText: "Equipo de Seguridad Incluido" },
            { Code: "SafetyTrainingIncluded", OriginalText: "Formación en Seguridad Incluido" },
            { Code: "AtYourPlace", OriginalText: "En tu Lugar" },
            { Code: "ServiceProviderEmail", OriginalText: "Correo Electrónico del Proveedor de Servicios" },
            { Code: "ServiceRequesterEmail", OriginalText: "Correo Electrónico el Solicitante de Servicios" },
            { Code: "LinksToSend", OriginalText: "# Enlaces para Enviar" },
            { Code: "Login", OriginalText: "Acceso" },
            { Code: "Logout", OriginalText: "Logout" },
            { Code: "User", OriginalText: "Usuario" },
            { Code: "Password", OriginalText: "Contraseña" },
            { Code: "InvalidLogin", OriginalText: "Información de inicio de sesión no válida." },
            { Code: "Services", OriginalText: "Servicios" },
            { Code: "FilterCode", OriginalText: "Código Filtro" },
            { Code: "SetFilterCode", OriginalText: "Establecer Código Filtro" },
            { Code: "Save", OriginalText: "Guardar" },
        ]
    },
    {
        Language: 'IT',
        Translations: [
            { Code: "PageName", OriginalText: "4Lean Configuratore di Soluzioni" },
            { Code: "BuilderPageName", OriginalText: "4Lean Configuratore del Generatore di Strutture" },
            { Code: "ServicePageName", OriginalText: "4Lean Configuratore di Servizi" },
            { Code: "GeneralGuide", OriginalText: "Guida Generale" },
            { Code: "MakeListLeanProject", OriginalText: "Creare una Lista/Progetto Lean" },
            { Code: "MakeList", OriginalText: "Creare una Lista" },
            { Code: "Search", OriginalText: "Ricerca..." },
            { Code: "Help", OriginalText: "Aiuto" },
            { Code: "Filters", OriginalText: "Filtri" },
            { Code: "ImportCsv", OriginalText: "Importare CSV" },
            { Code: "SelectFileAndDrag", OriginalText: "Seleziona il tuo file o trascinalo qui." },
            { Code: "List", OriginalText: "Lista" },
            { Code: "Area", OriginalText: "Area" },
            { Code: "Options", OriginalText: "Opzioni" },
            { Code: "Duplicate", OriginalText: "Duplicare" },
            { Code: "DuplicateMultiple", OriginalText: "Duplicare x" },
            { Code: "Remove", OriginalText: "Rimuovere" },
            { Code: "PleaseChooseOption", OriginalText: "Per favore, scegli un'opzione..." },
            { Code: "Notes", OriginalText: "Annotazioni" },
            { Code: "LeanProject", OriginalText: "Progetto Lean" },
            { Code: "Next", OriginalText: "Seguente" },
            { Code: "ProjectInformation", OriginalText: "Informazioni del Progetto" },
            { Code: "ProjectName", OriginalText: "Nome del Progetto" },
            { Code: "CoordinatorName", OriginalText: "Nome Coordinatore" },
            { Code: "CompanyName", OriginalText: "Nome della Ditta" },
            { Code: "ContactName", OriginalText: "Nome del Contatto" },
            { Code: "City", OriginalText: "Città" },
            { Code: "Country", OriginalText: "Paese" },
            { Code: "PhoneNumber", OriginalText: "Numero di Telefono" },
            { Code: "PleaseContactMe", OriginalText: "Contattami" },
            { Code: "Email", OriginalText: "E-mail" },
            { Code: "Submit", OriginalText: "Inviare" },
            { Code: "Copy", OriginalText: "Copiare" },
            { Code: "CopyAll", OriginalText: "Copia Tutto" },
            { Code: "Quantity", OriginalText: "Quantità" },
            { Code: "SolutionDetailTitle", OriginalText: "Visualizzazione Individuale" },
            { Code: "Back", OriginalText: "Ritorno" },
            { Code: "Previous", OriginalText: "Precedente" },
            { Code: "Import", OriginalText: "Importare" },
            { Code: "ImportCsvAllowedFiles", OriginalText: "È consentito solo il file .csv." },
            { Code: "InvalidFile", OriginalText: "File Non Valido:" },
            { Code: "ProjectSubmited", OriginalText: "Progetto Inviato" },
            { Code: "NoSolutionsWereFound", OriginalText: "Nessuna soluzione è stata trovata." },
            { Code: "ProjectSubmitedSuccess", OriginalText: "Il Tuo Progetto È Stato Inviato Con Successo." },
            { Code: "CheckYourEmail", OriginalText: "Per favore verifica la tua email per maggiori dettagli." },
            { Code: "Copied", OriginalText: "Copiato" },
            { Code: "Files", OriginalText: "File" },
            { Code: "NoFiles", OriginalText: "Nessun File..." },
            { Code: "Specifications", OriginalText: "Specifiche" },
            { Code: "NoSpecificationsAvailable", OriginalText: "Non ci sono Specifiche disponibili." },
            { Code: "NoFilesAvailable", OriginalText: "Non ci sono File disponibili." },
            { Code: "NoLinksAvailable", OriginalText: "Non ci sono Collegamenti disponibili." },
            { Code: "Menus", OriginalText: "Menu" },
            { Code: "Restart", OriginalText: "Ricomincia" },
            { Code: "MoreInfo", OriginalText: "+Info" },
            { Code: "Structures", OriginalText: "Structures" },
            { Code: "OpenStructures", OriginalText: "Structures Aperte" },
            { Code: "IndividualUrlCopied", OriginalText: "Link individuale copiato correttamente." },
            { Code: "CopyGeneralLink", OriginalText: "Copia il link generale" },
            { Code: "UrlMaxLengthReached", OriginalText: "Impossibile copiare il link perché è stata raggiunta la dimsensione massima." },
            { Code: "GeneralUrlCopied", OriginalText: "Link generale copiato correttamente." },
            { Code: "Topic", OriginalText: "Argomento" },
            { Code: "Type", OriginalText: "Tipo" },
            { Code: "ExternalWidth", OriginalText: "Larghezza Esterna [mm]" },
            { Code: "InternalWidth", OriginalText: "Larghezza Interna [mm]" },
            { Code: "ExternalDepth", OriginalText: "Profondità Esterna [mm]" },
            { Code: "InternalDepth", OriginalText: "Profondità Interna [mm]" },
            { Code: "HeightThickness", OriginalText: "Altezza / Spessore [mm]" },
            { Code: "Weight", OriginalText: "Peso [kg]" },
            { Code: "Orientation", OriginalText: "Orientamento" },
            { Code: "DepthHu", OriginalText: "Quantità Profondità HU [un]" },
            { Code: "Slope", OriginalText: "Pendenza" },
            { Code: "SlopeDirection", OriginalText: "Direzione Pendenza" },
            { Code: "FreeSpace", OriginalText: "Spazio Libero [mm]" },
            { Code: "HUSupportType", OriginalText: "Tipo di Supporto HU" },
            { Code: "HUSupport", OriginalText: "Supporto HU" },
            { Code: "RollJoints", OriginalText: "Giunti a Rulli" },
            { Code: "GuideType", OriginalText: "Tipo di Guida" },
            { Code: "ProfileSupportQuantity", OriginalText: "Quantità di Supporto del Profilo" },
            { Code: "Annotations", OriginalText: "Annotazioni" },
            { Code: "UploadPhoto", OriginalText: "Caricamento di Foto" },
            { Code: "ClearPhoto", OriginalText: "Foto Pulita" },
            { Code: "AddColumn", OriginalText: "Aggiungi Colonna" },
            { Code: "InvalidStructurePosition", OriginalText: "Posizione Di Struttura Non Valida" },
            { Code: "VisitDetails", OriginalText: "Dettagli Della Visita" },
            { Code: "ContactType", OriginalText: "Tipo di Contatto" },
            { Code: "CustomerDetails", OriginalText: "Dettagli del Cliente" },
            { Code: "Customer", OriginalText: "Cliente" },
            { Code: "Location", OriginalText: "Posizione" },
            { Code: "Address", OriginalText: "Indirizzo" },
            { Code: "ContactName", OriginalText: "Nome del Contatto" },
            { Code: "ContactEmail", OriginalText: "Email del Contatto" },
            { Code: "SalesPerson", OriginalText: "Venditore" },
            { Code: "Market", OriginalText: "Mercato" },
            { Code: "RequestDetails", OriginalText: "Dettagli Della Richiesta" },
            { Code: "RequestsToOpen", OriginalText: "Richieste di Apertura" },
            { Code: "RequestType", OriginalText: "Tipo di Richiesta" },
            { Code: "FromPreviousRequest", OriginalText: "Da Richiesta Precedente" },
            { Code: "GlobalProposal", OriginalText: "Proposta Globale" },
            { Code: "GlobalProposalRequestNumber", OriginalText: "Numero Globale di Richiesta di Proposta" },
            { Code: "ProjectDetails", OriginalText: "Dettagli del Progetto" },
            { Code: "AssemblyType", OriginalText: "Tipo di Assemblaggio" },
            { Code: "IncludeTransport", OriginalText: "Includere il Trasporto" },
            { Code: "SolutionCode", OriginalText: "Codice della Soluzione" },
            { Code: "ProjectApplication", OriginalText: "Applicazione del Progetto" },
            { Code: "PreviousProcess", OriginalText: "Processo Precedente" },
            { Code: "NextProcess", OriginalText: "Prossimo Processo" },
            { Code: "InternalOrExternalMeasures", OriginalText: "Misure Interne / Esterne" },
            { Code: "SubmissionType", OriginalText: "Tipo di Presentazione" },
            { Code: "Draft", OriginalText: "Bozza" },
            { Code: "AssemblyCuttingList", OriginalText: "Lista di Taglio dell'Assemblaggio" },
            { Code: "ProposalRequest", OriginalText: "Richiesta di Proposta" },
            { Code: "Photos", OriginalText: "Foto" },
            { Code: "LocateInMakeAList", OriginalText: "Individuare in Fare una Lista" },
            { Code: "LocateInServiceRequestList", OriginalText: "Individuare in Elenco delle Richieste di Servizio" },
            { Code: "LocateInServiceList", OriginalText: "Individuare in Elenco di Servizio" },
            { Code: "ServiceList", OriginalText: "Elenco di Servizio" },
            { Code: "ServiceRequestList", OriginalText: "Elenco delle Richieste di Servizio" },
            { Code: "Location", OriginalText: "Posizione" },
            { Code: "DojoRental", OriginalText: "Noleggio DOJO" },
            { Code: "CoffeeBreakIncluded", OriginalText: "Pausa Caffè Inclusa" },
            { Code: "LunchIncluded", OriginalText: "Pranzo Incluso" },
            { Code: "ParticipantsList", OriginalText: "Elenco dei Participanti" },
            { Code: "ParticipantsNumber", OriginalText: "# Participanti" },
            { Code: "ExpensesIncluded", OriginalText: "Spese Incluse" },
            { Code: "SafetyEquipmentIncluded", OriginalText: "Attrezzatura di Sicurezza Inclusa" },
            { Code: "SafetyTrainingIncluded", OriginalText: "Formazione sulla Sicurezza Inclusa" },
            { Code: "AtYourPlace", OriginalText: "Al tu Posto" },
            { Code: "ServiceProviderEmail", OriginalText: "Email del Fornitore di Servizi" },
            { Code: "ServiceRequesterEmail", OriginalText: "Email del Richiedente di Servizi" },
            { Code: "LinksToSend", OriginalText: "# Link da Inviare" },
            { Code: "Login", OriginalText: "Login" },
            { Code: "Logout", OriginalText: "Sair" },
            { Code: "User", OriginalText: "Utilizzatore" },
            { Code: "Password", OriginalText: "Password" },
            { Code: "InvalidLogin", OriginalText: "Informazioni di accesso non valide." },
            { Code: "Services", OriginalText: "Servizi" },
            { Code: "FilterCode", OriginalText: "Codice Filtro" },
            { Code: "SetFilterCode", OriginalText: "Imposta Codice Filtro" },
            { Code: "Save", OriginalText: "Salva" },
        ]
    }
];
"use strict"

var codes = {
    //#region Application
    Application: {
        Solutions: "01",
        Builder: "04",
        Services: "05"
    },
    ProjectType: {
        ServiceList: "01",
        ServiceRequestList: "02"
    }
    //#endregion
};
(function () {
    "use strict";

    myApp.controller('ServiceGuideAppController', function ($scope, GeneralLoadData, GeneralModel, $q, $timeout, $compile, $mdDialog, GetIp, $http, $mdConstant, $sessionStorage, $sce, $location, $stateParams) {
        var delayTimer, delayHelpFilter, originalValue, userToken;
        var zoomObject;
        var lastSolutionId = 0;

        $scope.Project = {
            Solutions: [],
            Details: {}
        };

        $scope.Menus = [];
        $scope.SearchValues = [];
        $scope.HelpSearchValues = [];
        $scope.separatorKeysForEmails = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.SPACE, $mdConstant.KEY_CODE.SEMICOLO];
        $scope.ItemsPerPage = 60;
        $scope.CurrentPage = 1;
        $scope.ShowInfoPages = false;
        $scope.HasHelp = false;
        $scope.HasLogin = true;
        $scope.Codes = codes;

        CleanSolutionDetail();
        CleanSequencer();
        SetSEO();

        var urlParameters = null;

        this.$onInit = function () {
            $scope.generalModel = GeneralModel.model;
            $scope.Helpers = Helpers;

            $scope.Logout();
            SetParameters();
            SetLanguages();
            SetApplication();
        };

        function SetParameters() {
            if ($stateParams.P) {
                urlParameters = urlParameters || {};
                urlParameters.P = parseInt($stateParams.P);
            }

            if ($stateParams.C) {
                urlParameters = urlParameters || {};
                urlParameters.C = $stateParams.C.split(",");
            }

            if ($stateParams.S) {
                urlParameters = urlParameters || {};
                urlParameters.S = $stateParams.S.split(",");
            }

            if ($stateParams.O) {
                urlParameters = urlParameters || {};
                urlParameters.O = ($stateParams.O.toUpperCase() === "TRUE");
            }
        }

        function SetLanguages() {
            $scope.LanguageSelected = localStorage.getItem("languageSelected");

            if (!$scope.LanguageSelected) {
                $scope.LanguageSelected = "EN";
            }

            $scope.Languages = ["EN", "ES", "FR", "IT", "PT"].reverse();

            SetTranslations();
        }

        $scope.ChangeLanguage = function (language) {
            $scope.LanguageSelected = language;

            localStorage.setItem("languageSelected", language);

            SetTranslations();
            SetApplication();
        }

        $scope.ApplyFilter = function () {
            clearTimeout(delayTimer);

            delayTimer = setTimeout(function () {
                Filter()
            }, 250);
        }

        function SetApplication() {
            $scope.generalModel.FullPageLoading = true;
            $scope.HasHelp = false;
            var promises = [];
            var openMenu = !urlParameters;

            var parameters = {
                applicationCode: codes.Application.Services,
                languageId: $scope.LanguageSelected
            };

            promises.push(GeneralLoadData.GeneralGet("Menu", "Get", parameters, null));

            delete parameters.applicationCode;

            promises.push(GeneralLoadData.GeneralGet("ServiceGuide", "Get", parameters, null));

            parameters = { applicationCode: codes.Application.Services };
            promises.push(GeneralLoadData.GeneralGet("Document", "CheckIfExists", parameters, null));

            $q.all(promises).then(function (result) {
                SetMenus(result[0], openMenu);
                SetSolutions(result[1]);
                SetHelp(result[2]);

                SetFilters();
                SetSolutionPages();
                SetSolutionQrCodes();

                SetSearchValuesFromRoute();
                SetCharacteristicsFromRoute();
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                OpenSolutionDetailFromSearchValues();
                SetActivePageFromRoute();
                InitializeFilterCodeMask();

                if (!$scope.Menus.length) {
                    $scope.generalModel.FullPageLoading = false;
                }

                urlParameters = null;
            });
        }

        function SetSolutions(result) {
            $scope.Solutions = result.data.Solutions;
            $scope.SolutionsFiltered = result.data.Solutions;
            $scope.Characteristics = result.data.Characteristics;
        }

        function SetHelp(result) {
            $scope.HasHelp = result.data;
        }

        function SetFilters() {
            $scope.FilterDescriptionLength = ($scope.Characteristics.length - 1) * 3;
            $scope.FilterCodeLength = Math.max.apply(Math, $scope.Characteristics.map(function (characteristic) { return characteristic.StartIndex; })) + 2;
            $scope.FilterCode = ''.padEnd($scope.FilterCodeLength, '_');
            $scope.FilterDescription = ''.padEnd($scope.FilterDescriptionLength, ' | ');

            $scope.SearchValues = [];
        }

        //#region Individual View
        function CleanSolutionDetail() {
            $scope.SolutionDetail = {};
            $scope.SolutionDetail.Photographies = [];
            $scope.SolutionDetail.Links = [];
            $scope.SolutionDetail.Files = [];
            $scope.SolutionDetail.Specifications = [];
            $scope.SolutionDetail.StartPhotographyIndex = -1;
            $scope.SolutionDetail.SelectedPhotographyIndex = -1;
        }

        $scope.OpenSolutionDetail = function (solution) {
            $scope.SolutionSelected = solution;

            SetSolutionDetail();

            $mdDialog.show({
                contentElement: '#DialogSolutionDetail',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
                onComplete: function () {
                    SetProjectQuantity();
                }
            });
        }

        function SetSolutionDetail() {
            GetDetails($scope.SolutionSelected);

            SetSolutionDetailQrCode("QrSolutionDetail");
        }

        function GetDetails(solution) {
            $scope.generalModel.FullPageLoading = true;

            var specifications = solution.Specifications.filter(filter => filter.Show);
            var parameters = { solutionId: solution.Code };

            CleanSolutionDetail();

            GeneralLoadData.GeneralGet("ServiceGuide", "GetDetails", parameters, null).then(function (result) {
                $scope.SolutionDetail.Links = result.data.Links;
                $scope.SolutionDetail.Files = result.data.Files;
                $scope.SolutionDetail.Specifications = specifications;
                $scope.SetPhotographies(result.data.SolutionDetailPhotographies);
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        $scope.SetPhotographies = function (photographies) {
            if (!photographies) {
                return;
            }

            $scope.SolutionDetail.StartPhotographyIndex = 0;
            $scope.SolutionDetail.SelectedPhotographyIndex = 0;

            photographies.forEach(photography => {
                var newPhotographyImage = $scope.GetPhotography(photography.Photography);

                var newPhotography = {
                    Photography: newPhotographyImage
                }

                $scope.SolutionDetail.Photographies.push(newPhotography);
            });
        }

        function SetSolutionDetailQrCode() {
            $timeout(function () {
                SetQrCode("QrSolutionDetail", $scope.SolutionSelected);
            });
        }

        function SetProjectQuantity() {
            if (!$scope.SolutionSelected.ProjectQuantity) {
                $scope.SolutionSelected.ProjectQuantity = 0;
            }

            $timeout(() => {
                var element = document.getElementById('selectedSolutionQuantity');

                element.focus();
                element.select();
            }, 0)
        }

        $scope.SetFiltersToSolution = function () {
            let solutionSelectedCode = $scope.SolutionSelected.Code;

            SetSolutionFilters(solutionSelectedCode);           
        }

        function SetSolutionFilters(code) {
            $scope.SearchValues = [];
            $scope.FilterClear();

            $scope.Characteristics.forEach((characteristic) => {
                var optionCodeToSelect = code.substr(0, 2);
                var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === optionCodeToSelect));

                code = code.slice(2);

                if (!characteristicOption) {
                    return;
                }

                characteristicOption.Selected = true;
            });
        }

        $scope.CloseSolutionDetail = function () {
            $mdDialog.hide({
                contentElement: '#DialogSolutionDetail'
            });

            CleanSolutionDetail();
        }

        $scope.GetIndexSolutionSelected = function () {
            if ($scope.SolutionsFiltered === undefined) {
                return null;
            }

            var indexSolutionSelected = $scope.SolutionsFiltered.indexOf($scope.SolutionSelected);

            return indexSolutionSelected;
        }

        $scope.ShowPreviousSolutionDetail = function () {
            if ($scope.SolutionsFiltered === undefined) {
                return false;
            }

            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            var show = (indexSolutionSelected !== 0);

            return show;
        }

        $scope.GetSelectedSolutionPhotography = function (index) {
            var photography;

            if (!$scope.SolutionSelected) {
                return;
            }

            if (!$scope.SolutionSelected.HasDetails && $scope.SolutionSelected.SeoInformation && $scope.SolutionSelected.SeoInformation.PhotographyName) {
                photography = $scope.GetPhotography($scope.SolutionSelected.SeoInformation.PhotographyName);
            }
            else {
                if (!$scope.SolutionDetail.Photographies.length) {
                    return;
                }

                photography = $scope.SolutionDetail.Photographies[index].Photography;
            }

            return photography;
        }

        $scope.GetSolutionDescription = function (solution) {
            if (!solution) {
                return;
            }

            if (!solution.SeoInformation || !solution.SeoInformation.Description) {
                var description = solution.Description;

                return description;
            }

            return solution.SeoInformation.Description;
        }

        $scope.PreviousSolutionDetail = function () {
            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            $scope.SolutionSelected = $scope.SolutionsFiltered[indexSolutionSelected - 1];

            SetSolutionDetail();
            SetProjectQuantity();
        }

        $scope.ShowNextSolutionDetail = function () {
            if ($scope.SolutionsFiltered === undefined) {
                return false;
            }

            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            var show = (indexSolutionSelected !== ($scope.SolutionsFiltered.length - 1));

            return show;
        }

        $scope.NextSolutionDetail = function () {
            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            $scope.SolutionSelected = $scope.SolutionsFiltered[indexSolutionSelected + 1];

            SetSolutionDetail();
            SetProjectQuantity();
        }

        function OpenSolutionDetailFromSearchValues() {
            if (!urlParameters || (urlParameters.O !== true) || !urlParameters.S) {
                return;
            }

            if (urlParameters.S.length !== 1) {
                return;
            }

            var searchValue = urlParameters.S[0];
            var solution = $scope.Solutions.find(find => (find.Code === searchValue));

            if (solution) {
                $scope.OpenSolutionDetail(solution);
            }
        }
        //#endregion

        //#region SEO
        function SetSEO() {
            var titleTag = angular.element('title');
            var canonicalLinkTag = document.querySelector('link[rel="canonical"]')
            var metaDescription = angular.element('meta[name="description"]');
            var metaKeywords = angular.element('meta[name="keywords"]');

            titleTag[0].innerText = "4Lean Service Guide Configurator";
            canonicalLinkTag.setAttribute('href', "https://customer.4lean.net/solutionConfigurator/BuilderStructureConfigurator");
            metaDescription.attr('content', "The Structure Builder Configurator has thousands of configurations. You can see videos/images, pick a standard structure and reconfigure to your own structure, get bill of materials to get a proposal.");
            metaKeywords.attr('content', "lean manufacturing,Lean,kaizen,kaizen video,lean manufacturing video,lean manufacturing examples,logistics,logistic train,lean system,Solutions,Workstation,Production,Waste Reduction,Lean Thinking,Industry 4.0,How to,How to make,Mizusumashi,Process,manufacturing,karakuri, configurator");
        }
        //#endregion

        //#region Make a List
        $scope.HasSelectedSolutions = function () {
            if (!$scope.Solutions) {
                return false;
            }

            var selectedSolution = $scope.Solutions.find(single => single.ProjectQuantity && (single.ProjectQuantity > 0))

            return selectedSolution;
        }

        $scope.OpenServiceRequestListDialog = function (projectTypeCode) {
            $scope.StepProjectServiceRequest = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;
            $scope.SendSequencer = false;

            $scope.Project.Details.ProjectType = projectTypeCode;

            var solutionsToAdd = $scope.Solutions.filter(filter => (filter.ProjectQuantity && (filter.ProjectQuantity > 0)));

            solutionsToAdd.forEach(solution => {
                solution.MinimumQuantity = solution.ProjectQuantity;

                var solutionsInProject = $scope.Project.Solutions.filter(where => (where.Code === solution.Code));
                var quantityInProject = solutionsInProject.sum('ProjectQuantity');
                var quantityToAdd = solution.ProjectQuantity - quantityInProject;

                if (quantityToAdd > 0) {
                    var solutionToAdd;

                    if (solutionsInProject.length) {
                        solutionToAdd = angular.copy(solutionsInProject[0]);
                    } else {
                        solutionToAdd = angular.copy(solution);

                        SetSolutionToAdd(solutionToAdd);
                    }

                    solutionToAdd.ProjectQuantity = quantityToAdd;

                    $scope.Project.Solutions.push(solutionToAdd);

                    AddInSequencer(solutionToAdd);
                }
            });

            if (!$scope.Project.Solutions.length) {
                GeneralModel.ShowToastWarning("Please select at least one solution to complete the project.");

                return;
            }

            $scope.StepProjectServiceRequest = true;

            var parentElement = angular.element(document.body);

            $mdDialog.show({
                contentElement: '#DialogProject',
                parent: parentElement,
                multiple: false,
                clickOutsideToClose: false
            });
        }

        function SetSolutionToAdd(solution) {
            delete solution.DrawingNumber;
            delete solution.HasBuilderCsv;
            delete solution.HasDetails;
            delete solution.MinimumQuantity;
            delete solution.SolutionNumber;
            delete solution.SeoInformation;

            var solutionSpecifications = solution.Specifications.filter(filter => filter.Show);

            solution.Id = ++lastSolutionId;
            solution.Specifications = solutionSpecifications;
            solution.ParticipantsQuantity = 0;
            solution.Participants = [];
            solution.QuantityToDuplicate = 1;

            solution.LinksToSendQuantity = (solution.Links) ? solution.Links.length : 0;
            solution.LinksToSend = [];

            if (solution.Links) {
                solution.Links.forEach(link => {
                    solution.LinksToSend.push(link.Description);
                });
            }

            solution.Files = [];
        }

        $scope.CloseProject = function () {
            $scope.StepProjectServiceRequest = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;

            $mdDialog.hide({
                contentElement: '#DialogProject'
            });
        }

        $scope.OnLocationChange = function (solution) {
            if (solution.IsAtYourSite) {
                solution.IsDojoRentalIncluded = false;
                solution.IsCoffeeBreakIncluded = false;
                solution.IsLunchIncluded = false;
            }
            else {
                solution.Address = null;
            }

            $scope.ReplicateValue(solution, 'IsAtYourSite');
        };

        $scope.SetOriginalValue = function (valueToSet) {
            originalValue = valueToSet;
        }

        $scope.ReplicateValue = function (solution, property) {
            if (!solution || Helpers.Object.IsUndefinedEmptyOrNull(solution[property])) {
                return;
            }

            if (solution[property] === originalValue) {
                return;
            }

            var solutionsToUpdate;

            if (property === 'Address') {
                solutionsToUpdate = $scope.Project.Solutions.filter(filter => (!filter[property] && filter.IsAtYourSite));
            }
            else {
                solutionsToUpdate = $scope.Project.Solutions.filter(filter => Helpers.Object.IsUndefinedEmptyNullOrZero(filter[property]));
            }

            solutionsToUpdate.forEach(solutionToUpdate => {
                solutionToUpdate[property] = solution[property];

                if (!solutionToUpdate.Participants.length && (property === 'ParticipantsQuantity')) {
                    solutionToUpdate.Participants = angular.copy(solution.Participants);
                }

                if (!solutionToUpdate.LinksToSend.length && (property === 'LinksToSendQuantity')) {
                    solutionToUpdate.LinksToSend = angular.copy(solution.LinksToSend);
                }
            });
        }

        $scope.ReplicateArrayItemValue = function (solution, property, index) {
            if (!solution || !solution[property][index]) {
                return;
            }

            var solutionsToUpdate = $scope.Project.Solutions.filter(filter => (!filter[property][index] && (index <= (filter[property].length - 1))))

            solutionsToUpdate.forEach(solutionToUpdate => {
                solutionToUpdate[property][index] = solution[property][index];
            });
        }
        //#endregion

        function GetSolutionByCode(solutions, code) {
            var solution = solutions.find(first => (first.Code === code));

            return solution;
        }

        $scope.OpenCloseFilter = function (e) {
            var content = e.target.nextElementSibling;

            e.target.classList.toggle("active");

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
                content.parentElement.style.paddingBottom = null;
            } else {
                CalculateMaxHeight(content);
            }
        }

        $(window).resize(function () {
            var characteristicsOptionsElements = document.getElementsByClassName("CharacteristicOptions");
            var characteristicsOptionsElementsLength = characteristicsOptionsElements.length;

            for (var i = 0; i < characteristicsOptionsElementsLength; i++) {
                var characteristicsOptionsElement = characteristicsOptionsElements[i];

                if (characteristicsOptionsElement.style.maxHeight) {
                    CalculateMaxHeight(characteristicsOptionsElement);
                }
            }
        });

        function CalculateMaxHeight(characteristicsOptionsElement) {
            characteristicsOptionsElement.style.maxHeight = characteristicsOptionsElement.scrollHeight + "px";
            characteristicsOptionsElement.parentElement.style.paddingBottom = "15px";
        }

        $scope.FilterClearShow = function () {
            if (!$scope.Characteristics) {
                return false;
            }

            var show = $scope.Characteristics.filter(where => where.CharacteristicOptions.filter(secondWhere => secondWhere.Selected).length).length;

            return show;
        }

        $scope.FilterClear = function () {
            var characteristics = $scope.Characteristics.filter(where => where.CharacteristicOptions.filter(secondWhere => secondWhere.Selected).length);
            var characteristicsLength = characteristics.length;

            for (var i = 0; i < characteristicsLength; i++) {
                var characteristic = characteristics[i];
                var characteristicOptions = characteristic.CharacteristicOptions.filter(where => where.Selected);
                var characteristicOptionsLength = characteristicOptions.length;

                for (var j = 0; j < characteristicOptionsLength; j++) {
                    var characteristicOption = characteristicOptions[j];

                    characteristicOption.Selected = false;
                }
            }

            $scope.FilterCode = ''.padEnd($scope.FilterCodeLength, '_');
            $scope.FilterDescription = ''.padEnd($scope.FilterDescriptionLength, ' | ');
        }

        $scope.GetCharacteristicOptionCount = function (characteristic, characteristicOption) {
            var count = $scope.SolutionsFiltered.filter(where => (where.Code.substr(characteristic.StartIndex, 2) === characteristicOption.Code)).length;

            return count;
        }

        $scope.GetCheckBoxEditor = function () {
            this.characteristicOption.Selected = this.characteristicOption.Selected || false;

            var checkBoxEditor = {
                bindingOptions: {
                    value: "characteristicOption.Selected"
                },
                elementAttr: {
                    class: "CharacteristicOptionCheckBox"
                },
                onValueChanged: function () {
                    clearTimeout(delayTimer);

                    delayTimer = setTimeout(function () {
                        FilterCharacteristicOption();
                    }, 250);
                }
            };

            return checkBoxEditor;
        }

        function FilterCharacteristicOption() {
            for (var i = 0; i < $scope.Characteristics.length; i++) {
                var characteristic = $scope.Characteristics[i];

                SetFilter(characteristic);
            }

            Filter();
        };

        function SetFilter(characteristic) {
            var characteristicOptionCode = "__";
            var characteristicOptionDescription = "";
            var characteristicOptionsSelected = characteristic.CharacteristicOptions.filter(where => (where.Selected));

            if (characteristicOptionsSelected.length === 1) {
                characteristicOptionCode = characteristicOptionsSelected[0].Code;
                characteristicOptionDescription = characteristicOptionsSelected[0].Description;
            }

            $scope.FilterCode = $scope.FilterCode.substr(0, characteristic.StartIndex) + characteristicOptionCode + $scope.FilterCode.substr(characteristic.StartIndex + 2);

            var characteristicIndex = $scope.Characteristics.indexOf(characteristic);
            var filterDescriptionSplited = $scope.FilterDescription.split(' | ');
            $scope.FilterDescription = "";

            for (var i = 0; i < filterDescriptionSplited.length; i++) {
                if (i === characteristicIndex) {
                    $scope.FilterDescription += characteristicOptionDescription;
                }
                else {
                    $scope.FilterDescription += filterDescriptionSplited[i];
                }

                if (i !== (filterDescriptionSplited.length - 1)) {
                    $scope.FilterDescription += " | ";
                }
            }
        }

        function Filter() {
            var i;
            var solutionsFiltered = [];

            if ($scope.SearchValues.length) {
                for (i = 0; i < $scope.Solutions.length; i++) {
                    var solutionToAnalyse = $scope.Solutions[i];

                    for (var j = 0; j < $scope.SearchValues.length; j++) {
                        var searchValue = $scope.SearchValues[j];

                        if (searchValue) {
                            searchValue = searchValue.toLowerCase().trim();

                            if (solutionToAnalyse.Code.toLowerCase().trim().includes(searchValue) || solutionToAnalyse.Description.toLowerCase().trim().includes(searchValue)) {
                                solutionsFiltered.push(solutionToAnalyse);
                                break;
                            }

                            var existsInSpecifications = solutionToAnalyse.Specifications.some(some => some.Description.toLowerCase().includes(searchValue));

                            if (existsInSpecifications) {
                                solutionsFiltered.push(solutionToAnalyse);
                                break;
                            }
                        }
                    }
                }
            } else {
                solutionsFiltered = $scope.Solutions;
            }

            if (solutionsFiltered.length) {
                for (i = 0; i < $scope.Characteristics.length; i++) {
                    var characteristicsItem = $scope.Characteristics[i];
                    var characteristicOptionCodes = characteristicsItem.CharacteristicOptions.filter(where => (where.Selected)).map(function (characteristicOption) { return characteristicOption.Code; });

                    if (!characteristicOptionCodes.length || (characteristicOptionCodes.length === characteristicsItem.CharacteristicOptions.length)) {
                        continue;
                    }

                    solutionsFiltered = solutionsFiltered.filter(where => characteristicOptionCodes.includes(where.Code.substr(characteristicsItem.StartIndex, 2)));

                    if (!solutionsFiltered.length) {
                        break;
                    }
                }
            }

            //SetDefaultSolution(solutionsFiltered);

            $timeout(function () {
                $scope.SolutionsFiltered = solutionsFiltered;
                SetSolutionQrCodes();
                SetSolutionPages();
            });
        }

        //function SetDefaultSolution(solutionsFiltered) {
        //    var defaultSolution = $scope.Solutions.find(find => (find.Code === "999999999999999999"))

        //    if (!defaultSolution) {
        //        return;
        //    }

        //    var defaultSolutionInFilter = solutionsFiltered.find(find => (find.Code === "999999999999999999"))

        //    if (!defaultSolutionInFilter) {
        //        solutionsFiltered.push(defaultSolution);
        //    }
        //}

        function SetSolutionQrCodes() {
            $timeout(function () {
                for (var i = 0; i < $scope.SolutionsFiltered.length; i++) {
                    var solution = $scope.SolutionsFiltered[i];

                    SetQrCode("Qr", solution);
                }
            });
        }

        function SetQrCode(id, solution) {
            $("#" + id + solution.Code).ClassyQR({
                size: 90,
                type: 'text',
                text: solution.Code
            });
        }

        //#region Photography
        $scope.GetPhotography = function (photography) {
            if ($scope.generalModel.IsUndefinedEmptyOrNull(photography)) {
                photography = 'images/FallBackImage.1739284541000.png';
            }
            else {
                if (photography.endsWith(".png")) {
                    photography = GetBaseUrl(true) + photography;
                }
                else {
                    photography = 'data:image/jpg;base64,' + photography;
                }
            }

            return photography;
        };

        $scope.GetSolutionPhotography = function (solution) {
            var photography;

            if (!solution) {
                photography = $scope.GetPhotography(null);

                return photography;
            }

            if (solution.SeoInformation && solution.SeoInformation.PhotographyName) {
                photography = $scope.GetPhotography(solution.SeoInformation.PhotographyName);

                return photography;
            }

            if (solution.Photography) {
                photography = $scope.GetPhotography(solution.Photography);

                return photography;
            }

            GetSolutionPhotographyFromServer(solution.Code);

            photography = $scope.GetPhotography(null);

            return photography;
        };

        function GetSolutionPhotographyFromServer(solutionCode, specificSolution) {
            var solutionCodeToGet;

            if (solutionCode) {
                solutionCodeToGet = solutionCode;
            } else {
                solutionCodeToGet = specificSolution.Code;
            }

            var solutionFiltered = GetSolutionByCode($scope.SolutionsFiltered, solutionCodeToGet);
            var solution = GetSolutionByCode($scope.Solutions, solutionCodeToGet);

            solution.Photography = " ";
            solutionFiltered.Photography = " ";

            var parameters = {
                solutionId: solutionCodeToGet
            };

            GeneralLoadData.GeneralGet("ServiceGuide", "GetSolutionPhotography", parameters, null).then(function (result) {
                solution.Photography = result.data;
                solutionFiltered.Photography = result.data;

                if (specificSolution) {
                    specificSolution.Photography = result.data;
                }
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            });
        }
        //#endregion

        $scope.GetLanguagePhotography = function (flag) {
            var photography = "images/flags/" + flag.toLowerCase() + ".1739284541000.png";

            var findElement = $("#Language" + flag);
            findElement.attr("alt", flag);
            findElement.attr("title", flag);

            return photography;
        }

        $scope.ScrollbarOptions = {
            "onScroll": function (y) {
                var buttonTopVisibility = (y.scroll > 100);

                if (buttonTopVisibility !== $scope.ButtonTopVisibility) {
                    $timeout(function () {
                        $scope.ButtonTopVisibility = buttonTopVisibility;
                    });
                }
            }
        };

        $scope.ScrollToTop = function (elementId) {
            angular.element(elementId).animate({ scrollTop: 0 }, 400);
        };

        $scope.Copy = function (elementId, event) {
            if (event) {
                event.stopPropagation();
            }

            var element = document.getElementById(elementId);
            var selection = window.getSelection();
            var range = document.createRange();

            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("Copy");

            GeneralModel.ShowToastWarning(Helpers.Translations.Copied + ": " + element.innerHTML);
        }

        $scope.CopyWithWhitespaces = function (elementId, event) {
            if (event) {
                event.stopPropagation();
            }

            let element = document.getElementById(elementId);
            let textToCopy = element.innerHTML.replace(/_/g, ' ');
            let tempElement = document.createElement("textarea");

            document.body.appendChild(tempElement);
            tempElement.value = textToCopy;

            tempElement.select();
            document.execCommand("copy");

            document.body.removeChild(tempElement);

            GeneralModel.ShowToast(Helpers.Translations.Copied + ": " + textToCopy);
        };

        $scope.CopyAll = function (code, description) {
            var valueToCopy = code + '\n' + description;
            var elementToCopy = document.createElement('textarea');

            elementToCopy.value = valueToCopy;

            document.body.appendChild(elementToCopy);
            elementToCopy.select();
            document.execCommand('copy');
            document.body.removeChild(elementToCopy);

            GeneralModel.ShowToast(Helpers.Translations.Copied + ": " + valueToCopy);
        }

        $scope.DeleteSolution = function (solutionToDelete) {
            $scope.Project.Solutions.remove(solutionToDelete);

            RemoveInSequencer(solutionToDelete);

            var solution = $scope.Solutions.find(find => (find.Code === solutionToDelete.Code));

            if (!solution) {
                return;
            }

            solution.ProjectQuantity -= solutionToDelete.ProjectQuantity;
            solution.MinimumQuantity = solution.ProjectQuantity;

            if (!$scope.Project.Solutions.length) {
                $scope.CloseProject();
            }
        }

        $scope.DuplicateSolution = function (solutionToDuplicate, ignoreAddColumn) {
            var positionToInsert = $scope.Project.Solutions.indexOf(solutionToDuplicate);

            if (positionToInsert < 0) {
                return;
            }

            var solution = $scope.Solutions.find(find => (find.Code === solutionToDuplicate.Code));

            if (!solution) {
                return;
            }

            var numberOfSolutionsToDuplicate = solutionToDuplicate.QuantityToDuplicate;

            solutionToDuplicate.QuantityToDuplicate = 1;

            solution.ProjectQuantity += (numberOfSolutionsToDuplicate * solutionToDuplicate.ProjectQuantity);
            solution.MinimumQuantity = solution.ProjectQuantity;
            positionToInsert++

            for (let i = 0; i < numberOfSolutionsToDuplicate; i++) {
                solutionToDuplicate = angular.copy(solutionToDuplicate);

                solutionToDuplicate.Id = ++lastSolutionId;
                $scope.Project.Solutions.splice(positionToInsert, 0, solutionToDuplicate);
                AddInSequencer(solutionToDuplicate, ignoreAddColumn);
            }
        }

        $scope.ShowProjectSolutions = function () {
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;
            $scope.SendSequencer = false;
            $scope.StepProjectServiceRequest = true;
        }

        function GetSolutionToSetQuantity(solutionCode) {
            var solutionFiltered = GetSolutionByCode($scope.Solutions, solutionCode);

            if (!solutionFiltered) {
                return solutionFiltered;
            }

            if (!solutionFiltered.ProjectQuantity) {
                solutionFiltered.ProjectQuantity = 0;
            }

            return solutionFiltered;
        };

        function SetSolutionQuantity(solution, quantity) {
            if (!solution) {
                return;
            }

            solution.ProjectQuantity += quantity;

            var solutionOutsideProject = GetSolutionToSetQuantity(solution.Code);

            if (!solutionOutsideProject) {
                return;
            }

            solutionOutsideProject.ProjectQuantity += quantity;
            solutionOutsideProject.MinimumQuantity = solutionOutsideProject.ProjectQuantity;
        };

        $scope.IncreaseProjectQuantityInRequestList = function (solution) {
            if (!solution) {
                return;
            }

            SetSolutionQuantity(solution, 1);
        };

        $scope.DecreaseProjectQuantityInRequestList = function (solution) {
            if (!solution) {
                return;
            }

            if (solution.ProjectQuantity === 1) {
                return;
            }

            SetSolutionQuantity(solution, -1);
        };

        $scope.IncreaseProjectQuantity = function (solutionCode) {
            var solution = GetSolutionToSetQuantity(solutionCode);

            if (!solution) {
                return;
            }

            solution.ProjectQuantity++;
        };

        $scope.DecreaseProjectQuantity = function (solutionCode) {
            var solution = GetSolutionToSetQuantity(solutionCode);

            if (!solution) {
                return;
            }

            var minimumQuantity = $scope.GetMinimumQuantity(solution);

            if (solution.ProjectQuantity === minimumQuantity) {
                return;
            }

            if (solution.ProjectQuantity === 0) {
                return;
            }

            solution.ProjectQuantity--;
        };

        $scope.GetMinimumQuantity = function (solutionCode) {
            if (!solutionCode) {
                return 0;
            }

            var minimumQuantity = solutionCode.MinimumQuantity || 0;

            return minimumQuantity;
        }

        $scope.OnParticipantsQuantityChange = function (solution) {
            SetParticipantsList(solution);
            $scope.ReplicateValue(solution, 'ParticipantsQuantity');
        }

        $scope.OnDeleteParticipant = function (solution, index) {
            if (!solution || !solution.Participants || ((solution.Participants.length - 1) < index)) {
                return;
            }

            solution.Participants.splice(index, 1);
            solution.ParticipantsQuantity--;
        }

        function SetParticipantsList(solution) {
            var quantityToUpdate = (solution.ParticipantsQuantity - solution.Participants.length);

            if (quantityToUpdate > 0) {
                for (let i = 0; i < quantityToUpdate; i++) {
                    solution.Participants.push('');
                }
            }
            else if (quantityToUpdate < 0) {
                solution.Participants = solution.Participants.slice(0, solution.ParticipantsQuantity);
            }
        }

        $scope.OnLinksToSendQuantityQuantityChange = function (solution) {
            SetLinksToSendList(solution);
            $scope.ReplicateValue(solution, 'LinksToSendQuantity');
        }

        $scope.OnDeleteLinkToSend = function (solution, index) {
            if (!solution || !solution.LinksToSend || ((solution.LinksToSend.length - 1) < index)) {
                return;
            }

            solution.LinksToSend.splice(index, 1);
            solution.LinksToSendQuantity--;
        }

        function SetLinksToSendList(solution) {
            var quantityToUpdate = (solution.LinksToSendQuantity - solution.LinksToSend.length);

            if (quantityToUpdate > 0) {
                for (let i = 0; i < quantityToUpdate; i++) {
                    solution.LinksToSend.push('');
                }
            }
            else if (quantityToUpdate < 0) {
                solution.LinksToSend = solution.LinksToSend.slice(0, solution.LinksToSendQuantity);
            }
        }

        $scope.ShowProjectDetails = function () {
            var isFormValid = IsFormValid();

            if (!isFormValid) {
                $scope.ShowProjectDetailsInvalidFields = true;

                return;
            }

            SetProjectDetails();

            $scope.SendSequencer = $scope.StepProjectSequencer;
            $scope.StepProjectServiceRequest = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = true;
            $scope.StepProjectSubmitted = false;
            $scope.ShowProjectDetailsInvalidFields = false;
        }

        function SetProjectDetails() {
            var details = localStorage.getItem("ServiceProject.Details");
            var projectType = $scope.Project.Details.ProjectType;

            if (details) {
                $scope.Project.Details = JSON.parse(details);
            }

            if ($scope.Project.Details) {
                if ($scope.Project.Details.ServiceProviderEmail) {
                    $scope.Project.Details.ServiceProviderEmails = [];
                    $scope.Project.Details.ServiceRequesterEmails = [];

                    var emailsToAdd = $scope.Project.Details.ServiceProviderEmail.split(';');

                    for (var i = 0; i < emailsToAdd.length; i++) {
                        var emailToAdd = emailsToAdd[i];

                        if (!emailToAdd.length) {
                            continue;
                        }

                        $scope.Project.Details.ServiceProviderEmails.push(emailToAdd);
                    }

                    delete $scope.Project.Details.ServiceProviderEmail;
                }
            }
            else {
                $scope.Project.Details = {};
            }

            if (!$scope.Project.Details.ServiceProviderEmails) {
                $scope.Project.Details.ServiceProviderEmails = [];
            }

            if (!$scope.Project.Details.ServiceRequesterEmails) {
                $scope.Project.Details.ServiceRequesterEmails = [];
            }

            $scope.Project.Details.ProjectType = projectType;
        }

        function IsFormValid() {
            var solutionWithInvalidLocation = $scope.Project.Solutions.find(find => Helpers.Object.IsUndefinedEmptyOrNull(find.IsAtYourSite));

            if (solutionWithInvalidLocation) {
                Helpers.HTML.ScrollToElement(`solution_${solutionWithInvalidLocation.Id}`);

                GeneralModel.ShowToastWarning("Location is required!");

                return false;
            }

            var solutionWithInvalidAddress = $scope.Project.Solutions.find(find => !find.Address && find.IsAtYourSite);

            if (solutionWithInvalidAddress) {
                Helpers.HTML.ScrollToElement(`solution_${solutionWithInvalidAddress.Id}`);
                Helpers.HTML.FocusElement(`Address_${solutionWithInvalidAddress.Id}`);

                GeneralModel.ShowToastWarning("Address is required!");

                return false;
            }

            var solutionWithInvalidParticipantsQuantity = $scope.Project.Solutions.find(find => (Helpers.Object.IsUndefinedEmptyOrNull(find.ParticipantsQuantity) || (find.ParticipantsQuantity < 0)))

            if (solutionWithInvalidParticipantsQuantity) {
                Helpers.HTML.ScrollToElement(`solution_${solutionWithInvalidParticipantsQuantity.Id}`);
                Helpers.HTML.FocusElement(`ParticipantsQuantity_${solutionWithInvalidParticipantsQuantity.Id}`);

                GeneralModel.ShowToastWarning("Invalid participants quantity!");

                return false;
            }

            return true;
        }

        $scope.ProjectSubmit = function () {
            var isFormValid = IsProjectSubmitFormValid();

            if (isFormValid) {
                SendProject();

                return;
            }

            $scope.ShowProjectDetailsInvalidFields = true;
        }

        function IsProjectSubmitFormValid() {
            if (!$scope.Project.Details.ServiceRequesterEmails.length) {
                GeneralModel.ShowToastWarning("At least one Service Requester Email is required!");

                return false;
            }

            var areEmailsValid = (ValidateEmails($scope.Project.Details.ServiceProviderEmails, false) && ValidateEmails($scope.Project.Details.ServiceRequesterEmails, true));

            if (areEmailsValid) {
                return true;
            }

            return false;
        }

        $scope.ProjectComplete = function () {
            $scope.Project.Solutions = [];

            var solutionsToUpdate = $scope.Solutions.filter(filter => (filter.ProjectQuantity > 0));

            solutionsToUpdate.forEach(solutionToUpdate => {
                solutionToUpdate.ProjectQuantity = 0;
                solutionToUpdate.MinimumQuantity = 0;
            });

            $mdDialog.hide({
                contentElement: '#DialogProject'
            });
        }

        function ValidateEmails(emailsToValidate, required) {
            var existValidEmail = false;

            if (!emailsToValidate) {
                return !required;
            }

            for (var i = 0; i < emailsToValidate.length; i++) {
                var emailToValidate = emailsToValidate[i];

                if (!emailToValidate.length) {
                    continue;
                }

                var emailValid = ValidateEmail(emailToValidate, true);

                if (!emailValid) {
                    return false;
                }

                existValidEmail = true;
            }

            if (!existValidEmail && required) {
                GeneralModel.ShowToastWarning("You must insert at least one valid email.");

                return false;
            }

            return true;
        }

        function ValidateEmail(emailToValidate, showErrorMessage) {
            if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailToValidate)) {
                return true;
            }

            if (showErrorMessage) {
                GeneralModel.ShowToastWarning("Email '" + emailToValidate + "' is invalid.");
            }

            return false;
        }

        function SendProject() {
            $scope.generalModel.FullPageLoading = true;

            var solutionsToSend = [];

            $scope.Project.Solutions.forEach(solution => {
                let solutionToSend = angular.copy(solution);

                delete solutionToSend.Characteristics;
                delete solutionToSend.Description;
                delete solutionToSend.Id;
                delete solutionToSend.QuantityToDuplicate;
                delete solutionToSend.Photography;

                solutionsToSend.push(solutionToSend);
            });

            if (!$scope.User) {
                delete $scope.Project.Details.ServiceProviderEmails;
            }

            var parameters = {
                Solutions: solutionsToSend,
                ProjectDetail: $scope.Project.Details,
                Language: $scope.LanguageSelected,
                SendSequencer: $scope.SendSequencer
            };

            $q.when(GeneralLoadData.GeneralPost("ServiceGuide", "Send", parameters, userToken)).then(function () {
                localStorage.setItem("ServiceProject.Details", JSON.stringify($scope.Project.Details));

                $scope.Project.Solutions = []
                $scope.StepProjectSolutions = false;
                $scope.StepProjectSequencer = false;
                $scope.StepProjectDetails = false;
                $scope.StepProjectSubmitted = true;

                CleanSequencer();
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        //#region CSV
        $scope.OpenImportCsvDialog = function () {
            $scope.File = '';
            $scope.generalModel.FullPageLoading = true;
            $scope.UploadBox = { Multiple: false, Pattern: '.csv', Accept: '.csv', Capture: 'camera', Validate: { size: { max: '1MB', min: '1B' }, height: { max: 12000 }, width: { max: 12000 } }, DragOverClass: { accept: 'dragover', reject: 'dragover-err', pattern: '*' }, Options: { debounce: 100 }, Resize: { width: 400, height: 400, centerCrop: false }, ResizeIf: '$width > 400 || $height > 400', FirefoxPaste: true };

            $mdDialog.show({
                contentElement: '#DialogImportCsv',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false
            });

            $scope.generalModel.FullPageLoading = false;
        };

        $scope.ImportCsv = function () {
            $scope.generalModel.FullPageLoading = true;

            var apiUrl = GetIp();
            var formData = new FormData();
            formData.append("", $scope.File);

            var settings = {
                "cache": false,
                "method": 'POST',
                headers: { "Content-Type": undefined },
            };

            return $http.post(apiUrl + '/api/ServiceGuide/ImportCsv', formData, settings)
                .then(function (result) {
                    ImportCsvData(result.data);
                }).catch(function (reason) {
                    GeneralModel.ShowToastWarning(reason);
                }).finally(function () {
                    $scope.generalModel.CloseDialog('DialogImportCsv');
                    $scope.generalModel.FullPageLoading = false;
                });
        };

        $('#alt-style-pagination').pagination({
            items: 260,
            itemOnPage: $scope.ItemsPerPage,
            currentPage: $scope.CurrentPage,
            cssStyle: '',
            prevText: '',
            nextText: '',
            displayedPages: 4,
            edges: 1,
            ellipsePageSet: false,
            onInit: function () { },
            onPageClick: function (page, _evt) {
                $scope.CurrentPage = page;
                $scope.ScrollToTop('.ListSolutions');
            }
        });

        function ImportCsvData(solutionsImported) {
            solutionsImported.forEach(solutionImported => {
                var solution = GetSolutionByCode($scope.Solutions, solutionImported.Code);

                if (!solution) {
                    return;
                }

                if (isNaN(solution.MinimumQuantity)) {
                    solution.MinimumQuantity = solutionImported.ProjectQuantity;
                }
                else {
                    solution.MinimumQuantity = solution.MinimumQuantity + solutionImported.ProjectQuantity;
                }

                if (isNaN(solution.ProjectQuantity)) {
                    solution.ProjectQuantity = solutionImported.ProjectQuantity;
                }
                else {
                    solution.ProjectQuantity = solution.ProjectQuantity + solutionImported.ProjectQuantity;
                }

                var solutionToAdd = SetSolutionToAddInImportCsv(solution, solutionImported);

                solutionToAdd.Id = ++lastSolutionId;

                $scope.Project.Solutions.push(solutionToAdd);

                AddInSequencer(solutionToAdd);
            });
        };

        function SetSolutionToAddInImportCsv(solution, solutionFromCsv) {
            var solutionToAdd = angular.copy(solution);

            SetPropertyValueInt(solutionToAdd, solutionFromCsv, "ParticipantsQuantity");
            SetPropertyValueInt(solutionToAdd, solutionFromCsv, "LinksToSendQuantity");

            solutionToAdd.IsAtYourSite = solutionFromCsv.IsAtYourSite;
            solutionToAdd.ProjectQuantity = solutionFromCsv.ProjectQuantity;
            solutionToAdd.IsDojoRentalIncluded = solutionFromCsv.IsDojoRentalIncluded;
            solutionToAdd.IsCoffeeBreakIncluded = solutionFromCsv.IsCoffeeBreakIncluded;
            solutionToAdd.IsLunchIncluded = solutionFromCsv.IsLunchIncluded;
            solutionToAdd.IsSafetyTrainingIncluded = solutionFromCsv.IsSafetyTrainingIncluded;
            solutionToAdd.IsExpensesIncluded = solutionFromCsv.IsExpensesIncluded;
            solutionToAdd.IsSafetyEquipmentIncluded = solutionFromCsv.IsSafetyEquipmentIncluded;
            solutionToAdd.Participants = solutionFromCsv.Participants;
            solutionToAdd.LinksToSend = solutionFromCsv.LinksToSend;
            solutionToAdd.Address = solutionFromCsv.Address;
            solutionToAdd.RequestsToOpen = solutionFromCsv.RequestsToOpen;
            solutionToAdd.Notes = solutionFromCsv.Notes;

            return solutionToAdd;
        };

        function SetPropertyValueInt(solution, csvSolution, propertyName) {
            var valueToSet = parseInt(csvSolution[propertyName]);

            if (!valueToSet || isNaN(valueToSet)) {
                valueToSet = 0;
            }

            solution[propertyName] = valueToSet;
        };
        //#endregion

        function SetSolutionPages() {
            var numberOfPages = $scope.SolutionsFiltered.length / $scope.ItemsPerPage;

            if (numberOfPages > 1) {
                $scope.ShowInfoPages = true;
            } else {
                $scope.ShowInfoPages = false;
            }

            $scope.CurrentPage = 1;

            $('#alt-style-pagination').pagination('updateItems', numberOfPages);
            $scope.ScrollToTop('.ListSolutions');
        }

        function GetCodesFromCharacteristic(characteristic) {
            var codes = [];
            var isCharacteristicValid = ((characteristic.length % 2) === 0);

            if (!isCharacteristicValid) {
                return codes;
            }

            for (var i = 0; i < characteristic.length; i += 2) {
                codes.push(characteristic.substr(i, 2));
            }

            return codes;
        }

        function SelectCharacteristicOption(mainCode, optionCode) {
            var characteristics = $scope.Characteristics;

            var characteristic = characteristics.find(find => (find.Code === mainCode));

            if (!characteristic) {
                return;
            }

            if (optionCode.toUpperCase() === "ALL") {
                for (var i = 0; i < characteristic.CharacteristicOptions.length; i++) {
                    var characteristicOption = characteristic.CharacteristicOptions[i];

                    characteristicOption.Selected = true;
                }

                return;
            }

            var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === optionCode));

            if (!characteristicOption) {
                return;
            }

            characteristicOption.Selected = true;
        }

        function GetSelectedCharacteristicsOptions() {
            var selectedCharacteristicsToReturn = [];
            var selectedCharacteristics = $scope.Characteristics.filter(filter => filter.CharacteristicOptions.some(some => some.Selected));

            for (var i = 0; i < selectedCharacteristics.length; i++) {
                var selectedCharacteristicToAnalyse = selectedCharacteristics[i];

                var selectedCharacteristicsOptions = selectedCharacteristicToAnalyse.CharacteristicOptions.filter(filter => filter.Selected);

                if (selectedCharacteristicToAnalyse.CharacteristicOptions.length === selectedCharacteristicsOptions.length) {
                    selectedCharacteristicsToReturn.push(selectedCharacteristicToAnalyse.Code);

                    continue;
                }

                var optionCodes = selectedCharacteristicToAnalyse.Code;

                for (var j = 0; j < selectedCharacteristicsOptions.length; j++) {
                    optionCodes += selectedCharacteristicsOptions[j].Code;
                }

                selectedCharacteristicsToReturn.push(optionCodes);
            }

            return selectedCharacteristicsToReturn;
        }

        //function GetSolutionsFromCsvInMenu(filename) {
        //    $scope.generalModel.FullPageLoading = true;

        //    var promises = [];

        //    var parameters = {
        //        filename: filename
        //    };

        //    promises.push(GeneralLoadData.GeneralGet("SolutionGuide", "GetSolutionsFromCsv", parameters, null));

        //    $q.all(promises).then(function (result) {
        //        var results = result[0].data;

        //        if (!results.length) {
        //            GeneralModel.ShowToastWarning(Helpers.Translations.NoSolutionsWereFound);

        //            return;
        //        }

        //        $scope.CloseMenus();
        //        SetProjectSolutions(results);

        //        if ($scope.HasSelectedSolutions()) {
        //            $scope.OpenProjectDialog();
        //        }
        //    }).catch(function (reason) {
        //        GeneralModel.ShowToastWarning(reason);
        //    }).finally(function () {
        //        $scope.generalModel.FullPageLoading = false;
        //    });
        //}

        //#region Link
        function GetBaseUrl(isToSeo) {
            var baseUrl = $location.protocol() + '://' + $location.host();

            if ($location.port() !== '') {
                baseUrl += ':' + $location.port();
            }

            if (isToSeo) {
                baseUrl += '/Solution/';
            }
            else {
                baseUrl += '/SolutionConfigurator/ServiceConfigurator/';
            }

            return baseUrl;
        }

        $scope.CopyIndividualLink = function () {
            var url = GetIndividualLink($scope.SolutionSelected);

            CopyToClipboard(url);

            GeneralModel.ShowToast(Helpers.Translations.IndividualUrlCopied);
        }

        function GetIndividualLink(solution) {
            var url = GetBaseUrl();

            url = url.slice(0, -1);

            var json = "?S=" + solution.Code + "&O=true";

            url += json;

            url = url.replace(/ /g, "%20");

            return url;
        }

        function CopyToClipboard(textToCopy) {
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(textToCopy);

                return;
            }

            var temporaryElement = document.createElement('textarea');

            temporaryElement.value = textToCopy;
            document.body.appendChild(temporaryElement);
            temporaryElement.select();
            document.execCommand('Copy');
            document.body.removeChild(temporaryElement);
        }

        $scope.CopyGeneralLink = function () {
            var url = GetBaseUrl();

            url = url.slice(0, -1);

            var selectedCharacteristicsOptions = GetSelectedCharacteristicsOptions();

            var json = "?P=" + $scope.CurrentPage;

            if (selectedCharacteristicsOptions && selectedCharacteristicsOptions.length) {
                json += "&C=" + selectedCharacteristicsOptions.toString();
            }

            if ($scope.SearchValues.length) {
                var searchValues = $scope.SearchValues.toString();

                json += "&S=" + searchValues;
            }

            if (json.length > 260) {
                GeneralModel.ShowToastWarning(Helpers.Translations.UrlMaxLengthReached);

                return;
            }

            url += json;

            CopyToClipboard(url);

            GeneralModel.ShowToast(Helpers.Translations.GeneralUrlCopied);
        }

        $scope.GetSolutionIndividualLink = function (solution) {
            if (!solution) {
                return;
            }

            var link = GetIndividualLink(solution);

            return link;
        }
        //#endregion

        //#region Route
        function SetSearchValuesFromRoute() {
            if (!urlParameters || !urlParameters.S || !urlParameters.S.length) {
                return;
            }

            urlParameters.S.forEach(searchValue => {
                if (searchValue.length) {
                    $scope.SearchValues.push(searchValue);
                }
            });

            Filter();
        }

        function SetCharacteristicsFromRoute() {
            if (!urlParameters || !urlParameters.C || !urlParameters.C.length) {
                return;
            }

            for (var i = 0; i < urlParameters.C.length; i++) {
                var characteristicToAnalyse = urlParameters.C[i];

                var codes = GetCodesFromCharacteristic(characteristicToAnalyse);

                if (!codes.length) {
                    continue;
                }

                var mainCode = codes[0];

                if (codes.length === 1) {
                    SelectCharacteristicOption(mainCode, 'ALL');

                    continue;
                }

                for (var j = 1; j < codes.length; j++) {
                    SelectCharacteristicOption(mainCode, codes[j])
                }
            }

            FilterCharacteristicOption();
        }

        function SetActivePageFromRoute() {
            if (!urlParameters || !urlParameters.P) {
                return;
            }

            var activePage = urlParameters.P;

            if (isNaN(activePage)) {
                return;
            }

            var numberOfPages = $scope.SolutionsFiltered.length / $scope.ItemsPerPage;

            if ((activePage >= 1) && (activePage <= numberOfPages)) {
                $scope.CurrentPage = activePage;

                $('#alt-style-pagination').pagination('selectPage', activePage);
                $scope.ScrollToTop('.ListSolutions');
            }
        }
        //#endregion

        //#region Emails
        $scope.AddEmail = function (originalEmail) {
            var values = originalEmail.split(/[ ,]+/);

            if (values.length < 2) {
                return;
            }

            for (var i = 0; i < values.length; i++) {
                var value = values[i].replace('<', '').replace('>', '');

                if (ValidateEmail(value, false)) {
                    var emailPosition = $scope.Project.Details.Emails.indexOf(originalEmail);

                    if (emailPosition > -1) {
                        $scope.Project.Details.Emails[emailPosition] = value;
                    }

                    break;
                }
            }
        }
        //#endregion

        //#region Help
        $scope.ApplyHelpFilter = function () {
            clearTimeout(delayHelpFilter);

            delayHelpFilter = setTimeout(function () {
                HelpFilter()
            }, 250);
        }

        $scope.OpenHelp = function () {
            $scope.HelpSearchValues = [];

            LoadHelp();

            $mdDialog.show({
                contentElement: '#DialogHelp',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
            })
        };

        $scope.CloseHelp = function () {
            $mdDialog.hide({
                contentElement: '#DialogHelp'
            });
        }

        function HelpFilter() {
            var i;
            var helpLinksFiltered = [];

            if ($scope.HelpSearchValues.length) {
                for (i = 0; i < $scope.HelpLinks.length; i++) {
                    var helpLinkToAnalyse = $scope.HelpLinks[i];

                    for (var j = 0; j < $scope.HelpSearchValues.length; j++) {
                        var searchValue = $scope.HelpSearchValues[j];

                        if (searchValue) {
                            searchValue = searchValue.toLowerCase().trim();

                            if (helpLinkToAnalyse.Name.toLowerCase().trim().includes(searchValue)) {
                                helpLinksFiltered.push(helpLinkToAnalyse);
                                break;
                            }
                        }
                    }
                }
            } else {
                helpLinksFiltered = $scope.HelpLinks;
            }

            $timeout(function () {
                $scope.HelpLinksFiltered = helpLinksFiltered;
            });
        }

        function LoadHelp() {
            $scope.LoadingHelp = true;
            $scope.HelpLinks = [];
            $scope.HelpLinksFiltered = [];
            var parameters = { applicationCode: codes.Application.Services };

            GeneralLoadData.GeneralGet("Document", "List", parameters, null).then(function (result) {
                $scope.HelpLinks = result.data;
                $scope.HelpLinksFiltered = $scope.HelpLinks;
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.LoadingHelp = false;
            });
        }
        //#endregion

        //#region Translations
        function SetTranslations() {
            var translations = webTranslations.find(first => (first.Language === $scope.LanguageSelected));

            Helpers.Translation.SetTranslations($sessionStorage, translations.Translations);
        }
        //#endregion

        //#region Zoom
        $scope.ApplyZoom = function (e) {
            if (!zoomObject) {
                SetZoomObject();
            }

            var lensPosition = GetLensPosition(e);

            SetZoomedPhotography(lensPosition);
        }

        function SetZoomObject() {
            var lens = document.getElementById("ZoomLens");
            var photography = document.getElementById("Photography");
            var individualSolutionPhotography = document.getElementById("IndividualSolutionPhotography");

            var scaleX = 234 / lens.offsetWidth;
            var scaleY = 234 / lens.offsetHeight;

            zoomObject = {
                lens: lens,
                photography: photography,
                individualSolutionPhotography: individualSolutionPhotography,
                scaleX: scaleX,
                scaleY: scaleY
            };
        }

        function GetLensPosition(e) {
            var cursorPositions = GetCursorPositions(e);
            e.preventDefault();

            var lensPosition = {
                lensX: cursorPositions.cursorPositionX - (zoomObject.lens.offsetWidth / 2),
                lensY: cursorPositions.cursorPositionY - (zoomObject.lens.offsetHeight / 2)
            };

            CheckLensPosition(lensPosition, "lensX", zoomObject.photography.width, zoomObject.lens.offsetWidth);
            CheckLensPosition(lensPosition, "lensY", zoomObject.photography.height, zoomObject.lens.offsetHeight);

            AdjustLens(lensPosition);

            return lensPosition;
        }

        function SetZoomedPhotography(lensPosition) {
            var zoomedPhotography = document.getElementById("ZoomedPhotography");

            if (!zoomedPhotography.style.backgroundSize) {
                zoomedPhotography.style.backgroundSize = (zoomObject.photography.width * zoomObject.scaleX) + "px " + (zoomObject.photography.height * zoomObject.scaleY) + "px";
            }

            zoomedPhotography.style.backgroundPosition = "-" + (lensPosition.lensX * zoomObject.scaleX) + "px -" + (lensPosition.lensY * zoomObject.scaleY) + "px";
        }

        function CheckLensPosition(lensPosition, measurement, photographyMax, offset) {
            if (lensPosition[measurement] > photographyMax - offset) {
                lensPosition[measurement] = photographyMax - offset;
            }

            if (lensPosition[measurement] < 0) {
                lensPosition[measurement] = 0;
            }
        }

        function AdjustLens(lensPosition) {
            zoomObject.lens.style.left = lensPosition.lensX + ((zoomObject.individualSolutionPhotography.offsetWidth - zoomObject.photography.width) / 2) + "px";
            zoomObject.lens.style.top = lensPosition.lensY + ((zoomObject.individualSolutionPhotography.offsetHeight - zoomObject.photography.height) / 2) + "px";
        }

        function GetCursorPositions(e) {
            var photographyPosition = zoomObject.photography.getBoundingClientRect();
            var pagePosition = e || window.event;

            var cursorPositionX = pagePosition.pageX - photographyPosition.left;
            var cursorPositionY = pagePosition.pageY - photographyPosition.top;

            cursorPositionX = cursorPositionX - window.pageXOffset;
            cursorPositionY = cursorPositionY - window.pageYOffset;

            var cursorPositions = { cursorPositionX: cursorPositionX, cursorPositionY: cursorPositionY };

            return cursorPositions;
        }

        $scope.HideLens = function () {
            $scope.ShowZoomLens = false;
        }

        $scope.ShowLens = function () {
            $scope.ShowZoomLens = true;
        }
        //#endregion

        //#region Download
        $scope.DownloadFile = function (file) {
            var fileName = file.Name + file.Extension;

            var parameters = {
                'applicationCode': codes.Application.Services,
                'fileName': fileName,
                'folderName': $scope.SolutionSelected.Code
            };

            GeneralLoadData.PreviewFiles("Document", "DownloadFile", parameters).then(function (result) {
                $scope.generalModel.DownloadResultBlob(result);
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            });
        }
        //#endregion

        //#region SlideShow
        $scope.SetPhotography = function (photographyPositionToSet) {
            $scope.SolutionDetail.SelectedPhotographyIndex = photographyPositionToSet;
        }

        $scope.GoPreviousPhotography = function () {
            if ($scope.SolutionDetail.StartPhotographyIndex > 0) {
                $scope.SolutionDetail.StartPhotographyIndex--;
            }
        }

        $scope.GoNextPhotography = function () {
            var lastPosition = $scope.SolutionDetail.Photographies.length - 1;

            if (lastPosition > ($scope.SolutionDetail.StartPhotographyIndex + 2)) {
                $scope.SolutionDetail.StartPhotographyIndex++;
            }
        }

        $scope.ShowGoNextPhotography = function () {
            var lastPosition = $scope.SolutionDetail.Photographies.length - 1;

            if (lastPosition < 3) {
                return false;
            }

            if (lastPosition > ($scope.SolutionDetail.StartPhotographyIndex + 2)) {
                return true;
            }

            return false;
        }
        //#endregion

        //#region Menus
        function SetMenus(result, open) {
            $scope.Menus = result.data;

            if (!$scope.Menus.length) {
                return;
            }

            $scope.MenusHistory = [];
            $scope.MenusHistory.push($scope.Menus[0]);

            SetMenu();

            if (!open) {
                return;
            }

            $scope.OpenMenus();
        }

        function SetMenu() {
            var lastMenuIndex = $scope.MenusHistory.length - 1;

            $scope.SelectedMenu = $scope.MenusHistory[lastMenuIndex];

            ClearMenuSelectedOption();

            if ($scope.SelectedMenu.Photography) {
                return;
            }

            var parameters = {
                applicationCode: codes.Application.Services,
                menuCode: $scope.SelectedMenu.Code
            };

            $scope.generalModel.FullPageLoading = true;

            GeneralLoadData.GeneralGet("Menu", "ListPhotography", parameters).then(function (result) {
                var photographies = result.data;
                var photography = photographies.find(find => (find.FileName.toUpperCase() === "Menu".toUpperCase()));

                if (photography) {
                    $scope.SelectedMenu.Photography = $scope.GetPhotography(photography.FileArray);
                } else {
                    $scope.SelectedMenu.Photography = $scope.GetPhotography();
                }

                for (var i = 0; i < $scope.SelectedMenu.MenuOptions.length; i++) {
                    var menuOption = $scope.SelectedMenu.MenuOptions[i];
                    photography = photographies.find(find => (find.FileName === menuOption.Code));

                    if (photography) {
                        menuOption.Photography = $scope.GetPhotography(photography.FileArray);
                    } else {
                        menuOption.Photography = $scope.GetPhotography();
                    }
                }
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        $scope.OpenMenus = function () {
            if (!document.getElementById('DialogMenus')) {
                return;
            }

            $mdDialog.show({
                contentElement: '#DialogMenus',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false,
            });
        };

        $scope.CloseMenus = function () {
            $mdDialog.hide({
                contentElement: '#DialogMenus'
            });

            ApplyMenuFilters();
        }

        function ApplyMenuFilters() {
            $scope.FilterClear();

            for (var i = 0; i < $scope.MenusHistory.length; i++) {
                var menuHistory = $scope.MenusHistory[i];
                var menuSelected = menuHistory.MenuOptions.find(find => find.Selected);

                if (!menuSelected) {
                    continue;
                }

                var menuOptionsFilters = menuSelected.Filters;

                if (!menuOptionsFilters) {
                    continue;
                }

                for (var k = 0; k < menuOptionsFilters.length; k++) {
                    var menuOptionFilters = menuOptionsFilters[k];
                    var index = menuOptionFilters.indexOf(".");
                    var characteristicCode = menuOptionFilters.substr(0, index);
                    var characteristic = $scope.Characteristics.find(find => (find.Code === characteristicCode));

                    if (!characteristic) {
                        continue;
                    }

                    var characteristicOptionCode = menuOptionFilters.substr(index + 1);
                    var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === characteristicOptionCode));

                    if (!characteristicOption) {
                        continue;
                    }

                    characteristicOption.Selected = true;
                }
            }
        }

        $scope.MenuOptionClick = function (menuOption) {
            ClearMenuSelectedOption();

            menuOption.Selected = true;

            if (menuOption.Link) {
                Helpers.Page.OpenInNewTab(menuOption.Link);

                return;
            }

            if (menuOption.Csv) {
                //GetSolutionsFromCsvInMenu(menuOption.Csv);

                return;
            }

            if (menuOption.Menu) {
                var validNextMenu = NextMenu(menuOption);

                if (validNextMenu) {
                    return;
                }
            }

            $scope.CloseMenus();
        }

        function NextMenu(menuOption) {
            var nextMenu = $scope.Menus.find(find => (find.Code === menuOption.Menu));

            if (!nextMenu) {
                return false;
            }

            $scope.MenusHistory.push(nextMenu);

            SetMenu();

            return true;
        }

        $scope.PreviousMenu = function () {
            $scope.MenusHistory.pop();

            SetMenu();
        }

        $scope.RestartMenus = function () {
            $scope.MenusHistory = [];

            $scope.MenusHistory.push($scope.Menus[0]);

            SetMenu();
        }

        function ClearMenuSelectedOption() {
            var selectedMenuOption = $scope.SelectedMenu.MenuOptions.find(find => find.Selected);

            if (selectedMenuOption) {
                selectedMenuOption.Selected = false;
            }
        }
        //#endregion

        //#region Youtube Player
        $scope.GetVideoLink = function (link) {
            if (!link || !link.Url) {
                return;
            }

            var url = $sce.trustAsResourceUrl(link.Url);

            return url;
        };
        //#endregion

        //#region Files
        $scope.OnFileUpload = function (solution, file) {
            if (!solution || !file) {
                return;
            }

            var fileReader = new FileReader();

            fileReader.onload = function (e) {
                if (!fileToUpload) {
                    return;
                }

                var fileInBase64 = e.target.result;

                fileInBase64 = fileInBase64.replace('data:' + fileToUpload.type + ';base64,', '');

                var fileToAdd = {
                    FileType: fileToUpload.type,
                    FileName: fileToUpload.name,
                    FileInBase64: fileInBase64
                }

                solution.Files.push(fileToAdd);

                $scope.$apply();
            };

            var fileToUpload = file;

            fileReader.readAsDataURL(file);
        };

        $scope.OnDeleteFile = function (solution, file) {
            if (!solution || !solution.Files || !solution.Files.length || !file) {
                return;
            }

            solution.Files.remove(file);
        };

        $scope.GetFileImage = function (file) {
            if (!file || !file.FileType) {
                return 'images/FallBackImage.1739284541000.png';
            }

            switch (file.FileType) {
                case 'application/pdf':
                    return 'images/file-icons/pdf.svg';
                case 'image/png':
                case 'image/jpeg':
                    return $scope.GetPhotography(file.FileInBase64);
                case 'application/vnd.ms-excel':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    return 'images/file-icons/xls.svg';
                default:
                    return 'images/file-icons/file.svg';
            }
        };

        function CleanFiles() {
            var solutionsWithFiles = $scope.Project.Solutions.filter(filter => (filter.Files && filter.Files.length));

            solutionsWithFiles.forEach(solutionWithFiles => {
                solutionWithFiles.Files = [];
            });
        };
        //#endregion

        //#region Login
        $scope.OpenLogin = function () {
            $scope.Logout();

            $mdDialog.show({
                contentElement: '#DialogLogin',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false
            });
        };

        $scope.Login = function (isFormValid) {
            if (!isFormValid) {
                $scope.LoginClicked = false;
                GeneralModel.ShowToastWarning(Helpers.Translations.InvalidLogin);

                return;
            }

            $scope.LoginClicked = false;
            $scope.generalModel.FullPageLoading = true;

            var parameters = {
                'username': $scope.LoginData.Username,
                'password': $scope.LoginData.Password,
                'grant_type': 'password'
            };

            GeneralLoadData.GetToken(parameters).then(function (result) {
                userToken = result.token_type + " " + result.access_token;

                var promise = GeneralLoadData.GeneralGet("User", "DetailsLogin", {}, userToken, null, null, true);

                return promise;
            }).then(function (result) {
                $scope.User = {
                    Name: result.data.Name,
                    Email: result.data.Email,
                    ClientName: result.data.ClientName,
                    ServiceUploadFiles: result.data.ServiceUploadFiles
                }

                $scope.generalModel.CloseDialog('DialogLogin');
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        };

        $scope.Logout = function () {
            delete $scope.User;

            $scope.LoginClicked = false;
            $scope.LoginData = {};
            userToken = null;
            CleanFiles();
        };
        //#endregion

        //#region Sequencer
        $scope.HasSolutionsToSequence = function () {
            var hasSolutionsToSequence = ($scope.Project.Solutions && ($scope.Project.Solutions.length > 1));

            return hasSolutionsToSequence;
        };

        $scope.ShowProjectSequencer = function () {
            var isFormValid = IsFormValid();

            if (!isFormValid) {
                $scope.ShowProjectDetailsInvalidFields = true;

                return;
            }

            $timeout(SetSortable);

            $scope.SendSequencer = false;
            $scope.StepProjectServiceRequest = false;
            $scope.StepProjectSequencer = true;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;
        }

        function CleanSequencer() {
            $scope.Sequencer = {};
            $scope.Sequencer.Columns = [];
        };

        function AddInSequencer(solution, ignoreAddColumn) {
            var columnId = 1;

            if (solution.ColumnId) {
                columnId = solution.ColumnId;
            }
            else {
                solution.ColumnId = columnId;
            }

            var sequencerColumn = $scope.Sequencer.Columns.find(find => (find.Id === columnId));

            if (sequencerColumn) {
                solution.Order = sequencerColumn.Solutions.length;

                sequencerColumn.Solutions.push(solution);

                if (ignoreAddColumn) {
                    return;
                }

                columnId = sequencerColumn.Solutions.length;

                let newColumn = {
                    Id: columnId,
                    Position: columnId,
                    Solutions: []
                }

                $scope.Sequencer.Columns.push(newColumn);
            }
            else {
                solution.Order = 0;

                let newColumn = {
                    Id: columnId,
                    Position: columnId,
                    Solutions: [solution]
                };

                $scope.Sequencer.Columns.push(newColumn);
            }
        };

        function RemoveInSequencer(solution) {
            if (!solution) {
                return;
            }

            $scope.Sequencer.Columns.forEach(column => {
                var solutionToDelete = column.Solutions.find(find => (find.Id === solution.Id));

                if (solutionToDelete) {
                    Reorder(column.ColumnId, solution.Order, null, false, solution.Id);

                    column.Solutions.remove(solutionToDelete);

                    if (!column.Solutions.length) {
                        $scope.Sequencer.Columns.remove(column);
                    }
                }
            });

            var columnToRemove = $scope.Sequencer.Columns.find(find => (find.Id === solution.Id));

            if (!columnToRemove || columnToRemove.Solutions.length) {
                return;
            }

            $scope.Sequencer.Columns.remove(columnToRemove);

            if ($scope.Project.Solutions.length === 1) {
                $scope.BackToStepProjectServiceRequest();
            }
        };

        function OrderColumn(columnId, setOrder) {
            var column = $scope.Sequencer.Columns.find(find => (find.Id === columnId));

            var solutionsOrdered = column.Solutions.sort(function (a, b) {
                if (a.Order < b.Order) {
                    return -1;
                }

                if (a.Order > b.Order) {
                    return 1;
                }

                return 0;
            });

            if (setOrder) {
                var newOrder = 0;

                solutionsOrdered.forEach(solution => {
                    solution.Order = newOrder;

                    newOrder++;
                });
            }

            column.Solutions = solutionsOrdered;
        };

        $scope.BackToStepProjectServiceRequest = function (solution) {
            $scope.StepProjectServiceRequest = true;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;

            if (solution) {
                var elementId = "solution_" + solution.Id;

                $timeout(function () {
                    Helpers.HTML.ScrollToElement(elementId);
                }, 200);
            }
        };

        $scope.GetNumberOfItems = function (columnId) {
            var column = $scope.Sequencer.Columns.find(find => (find.Id === columnId));

            if (!column || !column.Solutions) {
                return 0;
            }

            var numberOfItems = column.Solutions.length;

            return numberOfItems;
        };

        function SetSortable() {
            $('.SortableCards').each(function () {
                var columnId = $(this).attr('column-id');

                $(this).dxSortable({
                    data: {
                        ColumnId: columnId
                    },
                    group: 'tasksGroup',
                    moveItemOnDrop: true,
                    onDragEnd: function (e) {
                        var oldColumnId = e.fromData.ColumnId;
                        var newColumnId = e.toData.ColumnId;

                        e.cancel = true;

                        if ((oldColumnId === newColumnId) && (e.fromIndex === e.toIndex)) {
                            return;
                        }

                        var solutionId = e.itemElement.attr('solution-id');

                        if (oldColumnId !== newColumnId) {
                            UpdatePosition(solutionId, oldColumnId, newColumnId, e.fromIndex, e.toIndex);

                            return;
                        }

                        Reorder(solutionId, oldColumnId, e.fromIndex, e.toIndex);
                    }
                });
            });

            Helpers.DevExtreme.Scroll.Refresh('#Kanban');
            Helpers.DevExtreme.Scroll.Refresh('.ScrollableCards');
        };

        function UpdatePosition(solutionId, oldColumnId, newColumnId, fromIndex, toIndex) {
            solutionId = +solutionId;
            oldColumnId = +oldColumnId;
            newColumnId = +newColumnId;

            var oldColumn = $scope.Sequencer.Columns.find(find => (find.Id === oldColumnId));
            var newColumn = $scope.Sequencer.Columns.find(find => (find.Id === newColumnId));
            var solution = oldColumn.Solutions.find(find => (find.Id === solutionId));

            oldColumn.Solutions.splice(fromIndex, 1);

            var solutionsToDecrementOrderInOldColumn = oldColumn.Solutions.filter(filter => (filter.Order > fromIndex));

            solutionsToDecrementOrderInOldColumn.forEach(solution => {
                solution.Order--;
            });

            var solutionsToIncrementOrderInNewColumn = newColumn.Solutions.filter(filter => (filter.Order >= toIndex));

            solution.ColumnId = newColumnId;
            solution.Order = toIndex;

            newColumn.Solutions.splice(toIndex, 0, solution);

            solutionsToIncrementOrderInNewColumn.forEach(solution => {
                solution.Order++;
            });

            $timeout($scope.$apply());
        }

        function Reorder(solutionId, columnId, fromIndex, toIndex) {
            solutionId = +solutionId;
            columnId = +columnId;

            var column = $scope.Sequencer.Columns.find(find => (find.Id === columnId));
            var solution = column.Solutions.find(find => (find.Id === solutionId));

            if (fromIndex < toIndex) {
                let solutionToDecrementOrder = column.Solutions.filter(filter => ((filter.Order > fromIndex) && (filter.Order <= toIndex)));

                solutionToDecrementOrder.forEach(solution => {
                    solution.Order--;
                });

            }
            else if (fromIndex > toIndex) {
                let solutionsToIncrementOrder = column.Solutions.filter(filter => (filter.Order < fromIndex) && (filter.Order >= toIndex));

                solutionsToIncrementOrder.forEach(solution => {
                    solution.Order++;
                });
            }

            solution.Order = toIndex;

            $timeout($scope.$apply());

            OrderColumn(columnId);
        }
        //#endregion

        //#region Filter Code Mask
        //#region Initialize
        function InitializeFilterCodeMask() {
            let maxLength = $scope.FilterCodeLength || 30;

            $scope.EditFilterCodeComponent = {
                Options: {
                    bindingOptions: {
                        value: 'EditFilterCodeComponent.Code'
                    },
                    mask: '9'.repeat(maxLength)
                }
            };
        }
        //#endregion

        //#region Modal
        $scope.OpenDialogFilterCode = function () {
            $scope.File = '';
            $scope.generalModel.FullPageLoading = true;

            $scope.EditFilterCodeComponent = {
                Code: angular.copy($scope.FilterCode).replace(/_/g, ' ')
            }

            $mdDialog.show({
                contentElement: '#DialogFilterCode',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false
            });

            $scope.generalModel.FullPageLoading = false;
        };

        function CloseDialogFilterCode() {
            delete $scope.EditFilterCodeComponent.Code;

            $scope.generalModel.CloseDialog('DialogFilterCode');
        };
        //#endregion

        $scope.EditFilterCode = function () {
            let code = $scope.EditFilterCodeComponent.Code;

            SetSolutionFilters(code);
            CloseDialogFilterCode();
        };
        //#endregion
    });
})();
(function () {
    "use strict";

    myApp.controller('BuilderConfiguratorAppController', function ($scope, GeneralLoadData, GeneralModel, $q, $timeout, $mdDialog, GetIp, $http, $mdConstant, $sessionStorage, $sce, $stateParams, $location, $state) {
        var zoomObject, originalValue;
        var delayTimer, delayHelpFilter;
        var lastStructureId = 0;
        let detailsImported = {};

        $scope.Project = {
            Structures: [],
            Details: {}
        };

        $scope.StructuresProject = {
            Structures: []
        };

        $scope.Menus = [];
        $scope.SearchValues = [];
        $scope.HelpSearchValues = [];
        $scope.separatorKeysForEmails = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.SPACE, $mdConstant.KEY_CODE.SEMICOLO];
        $scope.ItemsPerPage = 60;
        $scope.CurrentPage = 1;
        $scope.ShowInfoPages = false;
        $scope.HasHelp = false;
        $scope.MenuOpen = false;
        $scope.CanUploadPhoto = (window.FileReader);
        $scope.EditFilterCodeComponent = {
            Options: {
                bindingOptions: {
                    value: 'EditFilterCodeComponent.Code'
                }
            }
        };

        SetSEO();
        CleanStructureDetail();
        CleanSequencer();

        var urlParameters = null;

        this.$onInit = function () {
            $scope.generalModel = GeneralModel.model;
            $scope.generalModel.FullPageLoading = true;
            $scope.Helpers = Helpers;

            SetParameters();
            SetLanguages();
            SetSubmissionTypes();
            SetStructures(true);
        };

        function SetSubmissionTypes() {
            $scope.SubmissiontTypes = [{
                Code: "01",
                Description: Helpers.Translations.Draft
            }, {
                Code: "02",
                Description: Helpers.Translations.AssemblyCuttingList
            }, {
                Code: "03",
                Description: Helpers.Translations.ProposalRequest
            }];
        }

        function SetParameters() {
            if ($stateParams.P) {
                urlParameters = urlParameters || {};
                urlParameters.P = parseInt($stateParams.P);
            }

            if ($stateParams.C) {
                urlParameters = urlParameters || {};
                urlParameters.C = $stateParams.C.split(",");
            }

            if ($stateParams.S) {
                urlParameters = urlParameters || {};
                urlParameters.S = $stateParams.S.split(",");
            }

            if ($stateParams.O) {
                urlParameters = urlParameters || {};
                urlParameters.O = ($stateParams.O.toUpperCase() === "TRUE");
            }
        }

        function SetLanguages() {
            $scope.LanguageSelected = localStorage.getItem("languageSelected");

            if (!$scope.LanguageSelected) {
                $scope.LanguageSelected = "EN";
            }

            $scope.Languages = ["EN", "ES", "FR", "IT", "PT"].reverse();

            SetTranslations();
        }

        $scope.GetLanguagePhotography = function (flag) {
            var photography = "images/flags/" + flag.toLowerCase() + ".1739284541000.png";

            var findElement = $("#Language" + flag);
            findElement.attr("alt", flag);
            findElement.attr("title", flag);

            return photography;
        }

        $scope.ChangeLanguage = function (language) {
            $scope.generalModel.FullPageLoading = true;
            $scope.LanguageSelected = language;

            localStorage.setItem("languageSelected", language);

            SetTranslations();
            SetStructures(false);
        }

        $scope.ApplyFilter = function () {
            clearTimeout(delayTimer);

            delayTimer = setTimeout(function () {
                Filter()
            }, 250);
        }

        $scope.GetCharacteristicsPhotographies = function (structureCode, characteristicMainCode) {
            if (!structureCode) {
                return false;
            }

            if (!characteristicMainCode || (characteristicMainCode === structureCode.substr(0, 2))) {
                return true;
            }

            return false;
        }

        function SetStructures(checkStructures) {
            $scope.HasHelp = false;

            var promises = [];
            var openMenu = !urlParameters;

            var parameters = {
                languageId: $scope.LanguageSelected
            };

            promises.push(GeneralLoadData.GeneralGet("BuilderConfigurator", "Get", parameters, null));

            parameters = {
                applicationCode: codes.Application.Builder
            };

            promises.push(GeneralLoadData.GeneralGet("Document", "CheckIfExists", parameters, null));

            parameters = {
                applicationCode: codes.Application.Builder,
                languageId: $scope.LanguageSelected
            };

            promises.push(GeneralLoadData.GeneralGet("Menu", "Get", parameters, null));

            $q.all(promises).then(function (result) {
                $scope.Structures = result[0].data.Structures;
                $scope.StructuresFiltered = result[0].data.Structures;
                $scope.Characteristics = result[0].data.Characteristics;
                $scope.Orientations = result[0].data.Orientations;
                $scope.Slopes = result[0].data.Slopes;
                $scope.SlopeDirections = result[0].data.SlopeDirections;
                $scope.HUSupportTypes = result[0].data.HUSupportTypes;
                $scope.HUSupports = result[0].data.HUSupports;
                $scope.RollJoints = result[0].data.RollJoints;
                $scope.GuideTypes = result[0].data.GuideTypes;
                $scope.Types = result[0].data.Types;
                $scope.ContactTypes = result[0].data.ContactTypes;
                $scope.SalesPersons = result[0].data.SalesPersons;
                $scope.Markets = result[0].data.Markets;
                $scope.RequestTypes = result[0].data.RequestTypes;
                $scope.AssemblyTypes = result[0].data.AssemblyTypes;
                $scope.InternalExternalMeasures = result[0].data.InternalExternalMeasures;
                $scope.ProfileSupportQuantities = result[0].data.ProfileSupportQuantities;

                $scope.HasHelp = result[1].data;

                SetMenus(result[2], openMenu);

                $scope.FilterDescriptionLength = 14 * 3;
                $scope.FilterCodeLength = Math.max.apply(Math, $scope.Characteristics.map(function (characteristic) { return characteristic.StartIndex; })) + 2;
                $scope.FilterCode = ''.padEnd($scope.FilterCodeLength, '_');
                $scope.FilterDescription = ''.padEnd($scope.FilterDescriptionLength, ' | ');

                $scope.SearchValues = [];

                InitializeFilterCodeMask();
                SetStructurePages();
                SetStructureQrCodes();

                var firstCharacteristic = $scope.Characteristics[0];

                $scope.Characteristics[0].Visible = true;

                SetSearchValuesFromRoute();
                SetCharacteristicsFromRoute();

                $timeout(function () {
                    FilterCharacteristicOption(firstCharacteristic);

                    if (checkStructures) {
                        SetStructuresSubmitted();

                        if ($scope.StructuresProject && $scope.StructuresProject.Structures.length) {
                            $scope.OpenStructures();
                        }
                    }
                });
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                OpenStructureDetailsFromSearchValues();

                $scope.generalModel.FullPageLoading = false;

                urlParameters = null;
            });
        }

        function InitializeFilterCodeMask() {
            $("#EditFilterCodeComponent").dxTextBox("instance").option("mask", '9'.repeat($scope.FilterCodeLength));
        }

        $scope.CopyIndividualViewLink = function () {
            var url = GetBaseUrl();

            url = url.slice(0, -1);

            var json = "?S=" + $scope.StructureSelected.Code + "&O=true";

            url += json;

            url = url.replace(/ /g, "%20");

            CopyToClipboard(url);

            GeneralModel.ShowToast(Helpers.Translations.IndividualUrlCopied);
        }

        function GetBaseUrl() {
            var baseUrl = $location.protocol() + "://" + $location.host();

            if ($location.port() !== '') {
                baseUrl += ':' + $location.port();
            }

            baseUrl += "/SolutionConfigurator/StructureBuilderConfigurator/";

            return baseUrl;
        }

        $scope.OpenStructureDetail = function (structure) {
            $scope.StructureSelected = structure;

            SetStructureDetail();

            $mdDialog.show({
                contentElement: '#DialogSolutionDetail',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
                onComplete: function () {
                    SetProjectQuantity();
                }
            });
        }

        function OpenStructureDetailsFromSearchValues() {
            if (!urlParameters || (urlParameters.O !== true) || !urlParameters.S) {
                return;
            }

            if (urlParameters.S.length !== 1) {
                return;
            }

            var searchValue = urlParameters.S[0];
            var structure = $scope.Structures.find(find => (find.Code === searchValue));

            if (structure) {
                $scope.OpenStructureDetail(structure);
            }
        }

        $scope.CloseStructureDetail = function () {
            $mdDialog.hide({
                contentElement: '#DialogSolutionDetail'
            });

            CleanStructureDetail();
        }

        function GetStructureByCode(structures, code) {
            var structure = structures.find(first => (first.Code === code));

            return structure;
        }

        $scope.GetIndexStructureSelected = function () {
            if ($scope.StructuresFiltered === undefined) {
                return null;
            }

            var indexStructureSelected = $scope.StructuresFiltered.indexOf($scope.StructureSelected);

            return indexStructureSelected;
        }

        $scope.ShowPreviousStructureDetail = function () {
            if ($scope.StructuresFiltered === undefined) {
                return false;
            }

            var indexStructureSelected = $scope.GetIndexStructureSelected();
            var show = (indexStructureSelected !== 0);

            return show;
        }

        $scope.PreviousStructureDetail = function () {
            var indexStructureSelected = $scope.GetIndexStructureSelected();
            $scope.StructureSelected = $scope.StructuresFiltered[indexStructureSelected - 1];

            SetStructureDetail();
            SetProjectQuantity();
        }

        $scope.ShowNextStructureDetail = function () {
            if ($scope.StructuresFiltered === undefined) {
                return false;
            }

            var indexStructureSelected = $scope.GetIndexStructureSelected();
            var show = (indexStructureSelected !== ($scope.StructuresFiltered.length - 1));

            return show;
        }

        $scope.NextStructureDetail = function () {
            var indexStructureSelected = $scope.GetIndexStructureSelected();
            $scope.StructureSelected = $scope.StructuresFiltered[indexStructureSelected + 1];

            SetStructureDetail();
            SetProjectQuantity();
        }

        $scope.OpenCloseFilter = function (e) {
            var content = e.target.nextElementSibling;

            e.target.classList.toggle("active");

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
                content.parentElement.style.paddingBottom = null;
            } else {
                CalculateMaxHeight(content);
            }
        }

        $(window).resize(function () {
            var characteristicsOptionsElements = document.getElementsByClassName("CharacteristicOptions");
            var characteristicsOptionsElementsLength = characteristicsOptionsElements.length;

            for (var i = 0; i < characteristicsOptionsElementsLength; i++) {
                var characteristicsOptionsElement = characteristicsOptionsElements[i];

                if (characteristicsOptionsElement.style.maxHeight) {
                    CalculateMaxHeight(characteristicsOptionsElement);
                }
            }
        });

        function CalculateMaxHeight(characteristicsOptionsElement) {
            characteristicsOptionsElement.style.maxHeight = characteristicsOptionsElement.scrollHeight + "px";
            characteristicsOptionsElement.parentElement.style.paddingBottom = "15px";
        }

        $scope.FilterClearShow = function () {
            if ($scope.Characteristics === undefined) {
                return false;
            }

            var show = $scope.Characteristics.filter(where => where.CharacteristicOptions.filter(secondWhere => secondWhere.Selected).length).length;

            return show;
        }

        $scope.FilterClear = function () {
            var characteristics = $scope.Characteristics;
            var characteristicsLength = characteristics.length;

            for (var i = 0; i < characteristicsLength; i++) {
                var characteristic = characteristics[i];
                var characteristicOptions = characteristic.CharacteristicOptions.filter(where => where.Selected);
                var characteristicOptionsLength = characteristicOptions.length;

                for (var j = 0; j < characteristicOptionsLength; j++) {
                    var characteristicOption = characteristicOptions[j];

                    characteristicOption.Selected = false;
                }

                if (i > 0) {
                    characteristic.Visible = false;
                }
            }

            $scope.FilterCode = ''.padEnd($scope.FilterCodeLength, '_');
            $scope.FilterDescription = ''.padEnd($scope.FilterDescriptionLength, ' | ');

            FilterCharacteristicOption($scope.Characteristics[0], true);
        }

        function FilterClearCharacteristicsOptions() {
            var firtsCharacteristicCode = $scope.Characteristics[0].Code;
            var characteristics = $scope.Characteristics.filter(where => ((where.Code !== firtsCharacteristicCode) && where.CharacteristicOptions.filter(secondWhere => secondWhere.Selected).length));
            var characteristicsLength = characteristics.length;

            for (var i = 0; i < characteristicsLength; i++) {
                var characteristic = characteristics[i];
                var characteristicOptions = characteristic.CharacteristicOptions.filter(where => where.Selected);
                var characteristicOptionsLength = characteristicOptions.length;

                for (var j = 0; j < characteristicOptionsLength; j++) {
                    var characteristicOption = characteristicOptions[j];

                    characteristicOption.Selected = false;
                }
            }
        }

        $scope.GetCharacteristicOptionCount = function (characteristic, characteristicOption) {
            var count = $scope.StructuresFiltered.filter(where => (where.Code.substr(characteristic.StartIndex, 2) === characteristicOption.Code)).length;

            return count;
        }

        $scope.GetCheckBoxEditor = function () {
            this.characteristicOption.Selected = this.characteristicOption.Selected || false;

            var checkBoxEditor = {
                bindingOptions: {
                    value: "characteristicOption.Selected"
                },
                elementAttr: {
                    class: "CharacteristicOptionCheckBox"
                },
                onValueChanged: function (e) {
                    clearTimeout(delayTimer);
                    var characteristic = this.$parent.characteristic;
                    var selectedOptionCode = e.model.$parent.characteristicOption.Code;
                    var characteriticCode = this.$parent.characteristic.Code;

                    if ((characteriticCode === $scope.Characteristics[0].Code) && !$scope.MenuOpen) {
                        FilterClearCharacteristicsOptions();
                    }

                    if (!e.previousValue) {
                        SetSelectedMainCharacteristic(characteristic, selectedOptionCode);
                    }

                    var mainCharacteristicsSelected = $scope.Characteristics[0].CharacteristicOptions.some(some => some.Selected);

                    if (!mainCharacteristicsSelected) {
                        $scope.FilterClear();
                    }

                    delayTimer = setTimeout(function () {
                        FilterCharacteristicOption(characteristic);
                    }, 250);
                }
            };

            return checkBoxEditor;
        }

        function SetSelectedMainCharacteristic(characteristic, characteristicOptionCode) {
            if (characteristic.Code !== $scope.Characteristics[0].Code) {
                return;
            }

            var selectedCharacteristicOption;
            var characteristicOptions = $scope.Characteristics[0].CharacteristicOptions;
            var selectedCharacteristicsOptions = characteristicOptions.filter(filter => filter.Selected);

            for (var i = 0; i < selectedCharacteristicsOptions.length; i++) {
                selectedCharacteristicOption = selectedCharacteristicsOptions[i];

                selectedCharacteristicOption.Selected = false;
            }

            selectedCharacteristicOption = characteristicOptions.find(find => (find.Code === characteristicOptionCode));
            selectedCharacteristicOption.Selected = true;

            for (i = 0; i < $scope.Characteristics.length; i++) {
                characteristic = $scope.Characteristics[i];

                var visible = !characteristic.MainCode || (characteristic.MainCode === selectedCharacteristicOption.Code);

                characteristic.Visible = visible;
            }

            ResetFilterCodeAndDescription();
        }

        function FilterCharacteristicOption(characteristic, ignoreApplyFilter) {
            var characteristicOptionCode = "__";
            var characteristicOptionDescription = "";

            var characteristicOptionsSelected = characteristic.CharacteristicOptions.filter(where => (where.Selected));

            if (characteristicOptionsSelected.length === 1) {
                characteristicOptionCode = characteristicOptionsSelected[0].Code;
                characteristicOptionDescription = characteristicOptionsSelected[0].Description;
            }

            $scope.FilterCode = $scope.FilterCode.substr(0, characteristic.StartIndex) + characteristicOptionCode + $scope.FilterCode.substr(characteristic.StartIndex + 2);

            var characteristicsVisibles = $scope.Characteristics.filter(filter => filter.Visible);
            var characteristicIndex = characteristicsVisibles.indexOf(characteristic);
            var filterDescriptionSplited = $scope.FilterDescription.split(' | ');
            $scope.FilterDescription = "";

            for (var i = 0; i < filterDescriptionSplited.length; i++) {
                if (i === characteristicIndex) {
                    $scope.FilterDescription += characteristicOptionDescription;
                }
                else {
                    $scope.FilterDescription += filterDescriptionSplited[i];
                }

                if (i !== (filterDescriptionSplited.length - 1)) {
                    $scope.FilterDescription += " | ";
                }
            }

            if (ignoreApplyFilter) {
                return;
            }

            Filter();
        };

        function Filter() {
            var i;
            var structuresFiltered = [];

            if ($scope.SearchValues.length) {
                for (i = 0; i < $scope.Structures.length; i++) {
                    var structureToAnalyse = $scope.Structures[i];

                    for (var j = 0; j < $scope.SearchValues.length; j++) {
                        var searchValue = $scope.SearchValues[j];

                        if (searchValue) {
                            searchValue = searchValue.toLowerCase().trim();

                            if (structureToAnalyse.Code.toLowerCase().trim().includes(searchValue)) {
                                structuresFiltered.push(structureToAnalyse);

                                break;
                            }

                            if (structureToAnalyse.Description.toLowerCase().trim().includes(searchValue)) {
                                structuresFiltered.push(structureToAnalyse);

                                break;
                            }
                        }
                    }
                }
            } else {
                structuresFiltered = $scope.Structures;
            }

            if (structuresFiltered.length) {
                for (i = 0; i < $scope.Characteristics.length; i++) {
                    var characteristicsItem = $scope.Characteristics[i];
                    var characteristicOptionCodes = characteristicsItem.CharacteristicOptions.filter(where => (where.Selected)).map(function (characteristicOption) { return characteristicOption.Code; });

                    if (!characteristicOptionCodes.length || (characteristicOptionCodes.length === characteristicsItem.CharacteristicOptions.length)) {
                        continue;
                    }

                    structuresFiltered = structuresFiltered.filter(where => characteristicOptionCodes.includes(where.Code.substr(characteristicsItem.StartIndex, 2)));

                    if (!structuresFiltered.length) {
                        break;
                    }
                }
            }

            SetDefaultStructure(structuresFiltered);

            $timeout(function () {
                $scope.StructuresFiltered = structuresFiltered;
                SetStructureQrCodes();
                SetStructurePages();
                SetActivePageFromRoute();
            });
        }

        $scope.EditFilterCode = function () {
            let code = $scope.EditFilterCodeComponent.Code;

            SetStructureFilters(code);
            CloseDialogFilterCode();
        };

        $scope.OpenDialogFilterCode = function () {
            $scope.File = '';
            $scope.generalModel.FullPageLoading = true;

            $scope.EditFilterCodeComponent = {
                Code: angular.copy($scope.FilterCode).replace(/_/g, ' ')
            }

            $mdDialog.show({
                contentElement: '#DialogFilterCode',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false
            });

            $scope.generalModel.FullPageLoading = false;

            $timeout(function () {
                let dxTextBoxInstance = $("#EditFilterCodeComponent").dxTextBox("instance");

                if (dxTextBoxInstance) {
                    dxTextBoxInstance.focus();
                }
            }, 0);
        };

        function CloseDialogFilterCode() {
            delete $scope.EditFilterCodeComponent.Code;

            $scope.generalModel.CloseDialog('DialogFilterCode');
        };

        function SetDefaultStructure(structuresFiltered) {
            var defaultStructure = $scope.Structures.find(find => (find.Code === codes.BlankStructureCode));

            if (!defaultStructure) {
                return;
            }

            var defaultStructureInFilter = structuresFiltered.find(find => (find.Code === codes.BlankStructureCode));

            if (!defaultStructureInFilter) {
                structuresFiltered.push(defaultStructure);
            }
        }

        function ResetFilterCodeAndDescription() {
            $scope.FilterDescriptionLength = 14 * 3;

            $scope.FilterCodeLength = Math.max.apply(Math, $scope.Characteristics.filter(filter => filter.Visible).map(function (characteristic) { return characteristic.StartIndex; })) + 2;
            $scope.FilterCode = ''.padEnd($scope.FilterCodeLength, '_');
            $scope.FilterDescription = ''.padEnd($scope.FilterDescriptionLength, ' | ');

            InitializeFilterCodeMask();

            var characteristicsVisibles = $scope.Characteristics.filter(filter => filter.Visible);

            for (var i = 0; i < characteristicsVisibles.length; i++) {
                var characteristic = characteristicsVisibles[i]

                FilterCharacteristicOption(characteristic, true);
            }
        }

        function SetStructureQrCodes() {
            $timeout(function () {
                for (var i = 0; i < $scope.StructuresFiltered.length; i++) {
                    var structure = $scope.StructuresFiltered[i];

                    SetQrCode("Qr", structure);
                }
            });
        }

        function SetStructureDetailQrCode() {
            $timeout(function () {
                SetQrCode("QrStructureDetail", $scope.StructureSelected);
            });
        }

        function SetQrCode(id, structure) {
            $("#" + id + structure.Code).ClassyQR({
                size: 90,
                type: 'text',
                text: structure.Code
            });
        }

        $scope.GetPhotography = function (photography) {
            if ($scope.generalModel.IsUndefinedEmptyOrNull(photography)) {
                photography = 'images/FallBackImage.1739284541000.png';
            }
            else {
                photography = 'data:image/jpg;base64,' + photography;
            }

            return photography;
        };

        $scope.GetStructurePhotography = function (structure) {
            var photography;

            if (!structure) {
                photography = $scope.GetPhotography(null);

                return photography;
            }

            if (structure.Photography) {
                photography = $scope.GetPhotography(structure.Photography);

                return photography;
            }

            GetStructurePhotographyFromServer(structure.Code);

            photography = $scope.GetPhotography(null);

            return photography;
        };

        function GetStructurePhotographyFromServer(structureCode, specificStructure) {
            var structureCodeToGet;

            if (structureCode) {
                structureCodeToGet = structureCode;
            } else {
                structureCodeToGet = specificStructure.Code;
            }

            var structureFiltered = GetStructureByCode($scope.StructuresFiltered, structureCodeToGet);
            var structure = GetStructureByCode($scope.Structures, structureCodeToGet);

            structure.Photography = " ";
            structureFiltered.Photography = " ";

            var parameters = {
                structureId: structureCodeToGet
            };

            $q.when(GeneralLoadData.GeneralGet("BuilderConfigurator", "GetStructurePhotography", parameters, null)).then(function (result) {
                structure.Photography = result.data;
                structureFiltered.Photography = result.data;

                if (specificStructure) {
                    specificStructure.Photography = result.data;
                }
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            });
        }

        $scope.GetCharacteristicOptionPhotography = function (id, structure, characteristic) {
            var photography;

            if (structure === undefined) {
                return photography;
            }

            var title = characteristic.Description + " -> ";
            var characteristicOptionCode = structure.Code.substr(characteristic.StartIndex, 2);
            var characteristicOption = characteristic.CharacteristicOptions.filter(where => (where.Code === characteristicOptionCode))[0];

            if (characteristicOption !== undefined) {
                photography = characteristicOption.Photography;
                title += characteristicOption.Description;
            }

            var findElement = $("#" + id + structure.Code + characteristic.Code);
            findElement.attr("alt", title);
            findElement.attr("title", title);

            photography = $scope.GetPhotography(photography);

            return photography;
        }

        $scope.ScrollbarOptions = {
            "onScroll": function (y) {
                var buttonTopVisibility = (y.scroll > 100);

                if (buttonTopVisibility !== $scope.ButtonTopVisibility) {
                    $timeout(function () {
                        $scope.ButtonTopVisibility = buttonTopVisibility;
                    });
                }
            }
        };

        $scope.ScrollToTop = function (elementId) {
            angular.element(elementId).animate({ scrollTop: 0 }, 400);
        };

        $scope.Copy = function (elementId, event) {
            if (event) {
                event.stopPropagation();
            }

            var element = document.getElementById(elementId);
            var selection = window.getSelection();
            var range = document.createRange();

            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("Copy");

            GeneralModel.ShowToast(Helpers.Translations.Copied + ": " + element.innerHTML);
        }

        $scope.CopyWithWhitespaces = function (elementId, event) {
            if (event) {
                event.stopPropagation();
            }

            let element = document.getElementById(elementId);
            let textToCopy = element.innerHTML.replace(/_/g, ' ');
            let tempElement = document.createElement("textarea");

            document.body.appendChild(tempElement);
            tempElement.value = textToCopy;

            tempElement.select();
            document.execCommand("copy");

            document.body.removeChild(tempElement);

            GeneralModel.ShowToast(Helpers.Translations.Copied + ": " + textToCopy);
        };

        $scope.CopyAll = function (code, description) {
            var valueToCopy = code + '\n' + description;
            var elementToCopy = document.createElement('textarea');

            elementToCopy.value = valueToCopy;

            document.body.appendChild(elementToCopy);
            elementToCopy.select();
            document.execCommand('copy');
            document.body.removeChild(elementToCopy);

            GeneralModel.ShowToast(Helpers.Translations.Copied + ": " + valueToCopy);
        }

        function CopyToClipboard(textToCopy) {
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(textToCopy);

                return;
            }

            var temporaryElement = document.createElement('textarea');

            temporaryElement.value = textToCopy;
            document.body.appendChild(temporaryElement);
            temporaryElement.select();
            document.execCommand('Copy');
            document.body.removeChild(temporaryElement);
        }

        function SetProjectQuantity() {
            if (!$scope.StructureSelected.ProjectQuantity) {
                $scope.StructureSelected.ProjectQuantity = 0;
            }

            $timeout(() => {
                var element = document.getElementById('selectedStructureQuantity');

                element.focus();
                element.select();
            }, 0)
        }

        $scope.FilterOption = function (structure) {
            return function (fieldOption) {
                var structureMainCode = structure.Code.slice(0, 2);

                if (structureMainCode === fieldOption.MainCode) {
                    return true;
                }

                return false;
            };
        };

        $scope.OpenProjectDialog = function () {
            $scope.StepMakeAList = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectSubmitted = false;

            var structuresToAdd = $scope.Structures.filter(filter => (filter.ProjectQuantity > 0));

            structuresToAdd.forEach(structure => {
                var numberOfStructuresToAdd = $scope.Project.Structures.count("Code", structure.Code);

                numberOfStructuresToAdd = structure.ProjectQuantity - numberOfStructuresToAdd;

                if (numberOfStructuresToAdd <= 0) {
                    return;
                }

                structure.MinimumQuantity = structure.ProjectQuantity;

                var structureToAdd = SetStructureToAdd(structure);

                for (let i = 1; i <= numberOfStructuresToAdd; i++) {
                    var structureToAdd = angular.copy(structureToAdd);

                    lastStructureId++;
                    structureToAdd.Id = lastStructureId;

                    $scope.Project.Structures.push(structureToAdd);

                    AddInSequencer(structureToAdd);
                }
            });

            $scope.StepMakeAList = true;

            $mdDialog.show({
                contentElement: '#DialogProject',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false
            });
        }

        $scope.BackToMakeAList = function (structure) {
            $scope.StepMakeAList = true;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectSubmitted = false;

            if (structure) {
                var elementId = "structure_" + structure.Id;

                $timeout(function () {
                    Helpers.HTML.ScrollToElement(elementId);
                }, 100);
            }
        }

        function SetStructureToAdd(structure) {
            var mainCode = structure.Code.substr(0, 2);
            var structureCharacteristics = $scope.Characteristics.filter(filter => (!filter.MainCode || (filter.MainCode === mainCode)));
            var structureToAdd = angular.copy(structure);

            structureToAdd.Characteristics = structureCharacteristics;

            structureCharacteristics.forEach(structureCharacteristic => {
                if (!structureCharacteristic.Field) {
                    return;
                }

                var valueCodeToSet = structure.Code.substr(structureCharacteristic.StartIndex, 2);
                var optionToSet = structureCharacteristic.CharacteristicOptions.find(find => (find.Code === valueCodeToSet));

                if (optionToSet) {
                    var valueToAdd;

                    switch (structureCharacteristic.Field) {
                        case "ExternalWidth":
                        case "InternalWidth":
                        case "ExternalDepth":
                        case "InternalDepth":
                        case "HeightThickness":
                        case "DepthHu":
                        case "FreeSpace":
                            valueToAdd = parseInt(optionToSet.Description);

                            if (!valueToAdd || isNaN(valueToAdd)) {
                                valueToAdd = 0;
                            }

                            break;

                        case "Weight":
                            valueToAdd = parseFloat(optionToSet.Description);

                            if (!valueToAdd || isNaN(valueToAdd)) {
                                valueToAdd = 0;
                            }

                            break;

                        case "Orientation":
                        case "Slope":
                        case "SlopeDirection":
                        case "HUSupportType":
                        case "SlopeDirection":
                        case "HUSupport":
                        case "RollJoint":
                        case "GuideType":
                            var arrayToCheck = structureCharacteristic.Field + "s";
                            var validValue = CheckDropDownValue($scope[arrayToCheck], optionToSet.Description);

                            if (validValue) {
                                valueToAdd = optionToSet.Description;
                            }

                            break;

                        case "ProfileSupportQuantity":
                            var arrayToCheck = "ProfileSupportQuantities";
                            var validValue = CheckDropDownValue($scope[arrayToCheck], optionToSet.Description);

                            if (validValue) {
                                valueToAdd = optionToSet.Description;
                            }

                            break;

                        default:
                            valueToAdd = optionToSet.Description;
                    }

                    structureToAdd[structureCharacteristic.Field] = valueToAdd;
                }
            });

            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "ExternalWidth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "InternalWidth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "ExternalDepth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "InternalDepth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "HeightThickness", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "DepthHu", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "FreeSpace", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "Weight", 0);

            SetFieldsToConsiderInLeanProject(structureToAdd);

            structureToAdd.StructureQuantityToDuplicate = 1;

            delete structureToAdd.DrawingNumber;
            delete structureToAdd.HasDetails;
            delete structureToAdd.MinimumQuantity;
            delete structureToAdd.ProjectQuantity;
            delete structureToAdd.SeoInformation;
            delete structureToAdd.SolutionNumber;

            return structureToAdd;
        }

        function SetFieldsToConsiderInLeanProject(structure) {
            let mainCode = structure.Code.substring(0, 2);
            let fieldsToConsiderInLeanProject = $scope.Characteristics.filter(filter => (!filter.MainCode || (filter.MainCode === mainCode)) && filter.ConsiderInLeanProject && filter.Field).map(map => map.Field);

            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structure, "FieldsToConsiderInLeanProject", fieldsToConsiderInLeanProject);
        }

        function CheckDropDownValue(arrayToCheck, valueToCheck) {
            var validValue = arrayToCheck.some(some => (some.Description === valueToCheck));

            return validValue;
        }

        $scope.GetFieldsToConsiderInLeanProject = function (structure) {
            if (!$scope.StepProjectSequencer) {
                return;
            }

            let fields = structure.FieldsToConsiderInLeanProject;
            let fieldsToConsiderInLeanProject = fields.map(field => structure[field]).filter(value => value).join(" | ");

            return fieldsToConsiderInLeanProject;
        };

        $scope.DeleteStructure = function (structureToDelete) {
            structureToDelete.ProjectQuantity = 0;

            $scope.Project.Structures.remove(structureToDelete);

            RemoveInSequencer(structureToDelete);

            var structure = $scope.Structures.find(find => (find.Code === structureToDelete.Code));

            if (!structure) {
                return;
            }

            structure.ProjectQuantity--;
            structure.MinimumQuantity--;

            if (!$scope.Project.Structures.length) {
                $scope.CloseProject();
            }
        }

        $scope.DuplicateStructure = function (structureToDuplicate) {
            var positionToInsert = $scope.Project.Structures.indexOf(structureToDuplicate);

            if (positionToInsert < 0) {
                return;
            }

            var structure = $scope.Structures.find(find => (find.Code === structureToDuplicate.Code));

            if (!structure) {
                return;
            }

            var numberOfStructuresToDuplicate = structureToDuplicate.StructureQuantityToDuplicate;

            structureToDuplicate.StructureQuantityToDuplicate = 1;

            structure.ProjectQuantity = structure.ProjectQuantity + numberOfStructuresToDuplicate;
            structure.MinimumQuantity = structure.MinimumQuantity + numberOfStructuresToDuplicate;
            positionToInsert++;

            for (let i = 0; i < numberOfStructuresToDuplicate; i++) {
                structureToDuplicate = angular.copy(structureToDuplicate);
                lastStructureId++;

                structureToDuplicate.Id = lastStructureId;
                $scope.Project.Structures.splice(positionToInsert, 0, structureToDuplicate);
                AddInSequencer(structureToDuplicate);
            }

            return structureToDuplicate;
        }

        $scope.CloseProject = function () {
            if ($scope.StepProjectSubmitted) {
                $scope.ProjectComplete();

                return;
            }

            $scope.StepMakeAList = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectSubmitted = false;

            $mdDialog.hide({
                contentElement: '#DialogProject'
            });
        }

        $scope.SetOriginalValue = function (valueToSet) {
            originalValue = valueToSet;
        }

        $scope.ReplicateValue = function (structure, property, newValue) {
            if (!structure) {
                return;
            }

            if (!structure[property]) {
                return;
            }

            var valueToConsider;

            if (newValue) {
                valueToConsider = newValue;
            }
            else {
                if (structure[property] === originalValue) {
                    return;
                }

                valueToConsider = structure[property];
            }

            var structuresToUpdate = $scope.Project.Structures.filter(filter => ((filter.Code === structure.Code) && !filter[property]));

            structuresToUpdate.forEach(structureToUpdate => {
                structureToUpdate[property] = valueToConsider;
            });
        }

        $scope.HasSelectedStructures = function () {
            if (!$scope.Structures) {
                return false;
            }

            var selectedStructure = $scope.Structures.find(single => (single.ProjectQuantity && (single.ProjectQuantity > 0)))

            return selectedStructure;
        }

        function GetStructureToSetQuantity(structureCode) {
            var structureFiltered = GetStructureByCode($scope.Structures, structureCode);

            if (!structureFiltered) {
                return structureFiltered;
            }

            if (!structureFiltered.ProjectQuantity) {
                structureFiltered.ProjectQuantity = 0;
            }

            return structureFiltered;
        };

        $scope.IncreaseProjectQuantity = function (structureCode) {
            var structure = GetStructureToSetQuantity(structureCode);

            if (!structure) {
                return;
            }

            structure.ProjectQuantity++;
        };

        $scope.DecreaseProjectQuantity = function (structureCode) {
            var structure = GetStructureToSetQuantity(structureCode);

            if (!structure) {
                return;
            }

            var minimumQuantity = $scope.GetMinimumQuantity(structure);

            if (structure.ProjectQuantity === minimumQuantity) {
                return;
            }

            structure.ProjectQuantity--;
        };

        $scope.GetMinimumQuantity = function (structure) {
            if (!structure) {
                return 0;
            }

            var minimumQuantity = structure.MinimumQuantity || 0;

            return minimumQuantity;
        }

        $scope.OnUploadPhoto = function (structure, photo) {
            if (!photo || !structure) {
                return;
            }

            var fileReader = new FileReader();

            fileReader.onload = function (e) {
                var photoInBase64 = e.target.result;
                var imageType = Helpers.Upload.GetImageTypeFromBase64(photoInBase64);

                photoInBase64 = photoInBase64.replace('data:' + imageType + ';base64,', '');
                structure.Photography = photoInBase64;
                structure.UploadedPhoto = true;

                $scope.UploadedPhoto = null;
                $scope.$apply();
            };

            fileReader.readAsDataURL(photo);
        }

        $scope.ClearPhoto = function (structure) {
            if (!structure) {
                return;
            }

            if (!structure.UploadedPhoto) {
                return;
            }

            if (structure.Code) {
                var mainStructure = GetStructureByCode($scope.Structures, structure.Code);

                structure.Photography = mainStructure.Photography;
                structure.UploadedPhoto = false;
            } else {
                structure.Photography = null;
            }
        }

        //#region Sequencer
        function AddInSequencer(structure) {
            var mainCode = structure.Code.slice(0, 2);
            var columnId = mainCode + ".0001";

            if (structure.ColumnId) {
                columnId = structure.ColumnId;
            }
            else {
                structure.ColumnId = columnId;
            }

            var sequencerColumn = $scope.Sequencer.Columns.find(find => (find.Id === columnId));

            if (sequencerColumn) {
                structure.Order = sequencerColumn.Structures.length;

                sequencerColumn.Structures.push(structure);
            }
            else {
                var index = columnId.split('.')[1];
                var characteristicOption = structure.Characteristics[0].CharacteristicOptions.find(find => (find.Code === mainCode));

                structure.Order = 0;

                var newColumn = {
                    Id: columnId,
                    MainCode: mainCode,
                    Position: index,
                    Description: characteristicOption.Description,
                    Structures: [structure]
                };

                $scope.Sequencer.Columns.push(newColumn);
            }
        }

        function RemoveInSequencer(structure) {
            var structureMainCode = structure.Code.slice(0, 2);

            $scope.Sequencer.Columns.forEach(column => {
                if (column.MainCode !== structureMainCode) {
                    return;
                }

                var structureToDelete = column.Structures.find(find => (find.Id === structure.Id));

                if (structureToDelete) {
                    Reorder(column.ColumnId, structure.Order, null, false, structure.Id);

                    column.Structures.remove(structureToDelete);

                    if (!column.Structures.length) {
                        $scope.Sequencer.Columns.remove(column);
                    }
                }
            });
        }

        $scope.ShowProjectSequencer = function () {
            $scope.Sequencer.Columns.forEach(column => {
                OrderColumn(column.Id, true);
            });

            $timeout(SetSortable);

            $scope.StepMakeAList = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSequencer = true;
            $scope.StepProjectSubmitted = false;
        }

        $scope.AddColumn = function (column) {
            var canAddColumn = $scope.CheckAddColumn(column);

            if (!canAddColumn) {
                return;
            }

            var position = GetNextPosition(column);
            var columnId = column.MainCode + "." + position;

            var newColumn = {
                Id: columnId,
                MainCode: column.MainCode,
                Position: position,
                Description: column.Description,
                Structures: []
            };

            $scope.Sequencer.Columns.push(newColumn);

            $timeout(SetSortable);
        }

        function GetNextPosition(column) {
            var position = column.Position;

            position = Number(position) + 1;
            position = String(position).padStart(4, '0');

            return position;
        }

        $scope.CheckAddColumn = function (column) {
            var columnsOfSameMainCode = $scope.Sequencer.Columns.filter(filter => (filter.MainCode === column.MainCode));
            var maximum = columnsOfSameMainCode.max("Position");

            if (maximum === column.Position) {
                return true;
            }

            return false;
        }

        function SetSortable() {
            $(".SortableCards").each(function () {
                var columnId = $(this).attr("column-id");

                $(this).dxSortable({
                    data: {
                        ColumnId: columnId
                    },
                    group: "tasksGroup",
                    moveItemOnDrop: true,
                    onDragEnd: function (e) {
                        var oldColumnId = e.fromData.ColumnId;
                        var newColumnId = e.toData.ColumnId;
                        var oldColumnMainCode = oldColumnId.slice(0, 2);
                        var newColumnMainCode = newColumnId.slice(0, 2);

                        e.cancel = true;

                        if (oldColumnMainCode !== newColumnMainCode) {
                            GeneralModel.ShowToastWarning(Helpers.Translations.InvalidStructurePosition);

                            return;
                        }

                        if ((oldColumnId === newColumnId) && (e.fromIndex === e.toIndex)) {
                            return;
                        }

                        var structureId = e.itemElement.attr("structure-id");

                        if (oldColumnId !== newColumnId) {
                            UpdatePosition(structureId, oldColumnId, newColumnId, e.fromIndex, e.toIndex);

                            return;
                        }

                        Reorder(newColumnId, e.fromIndex, e.toIndex, true, structureId);
                    }
                });
            })

            Helpers.DevExtreme.Scroll.Refresh('#Kanban');
            Helpers.DevExtreme.Scroll.Refresh('.ScrollableCards');
        }

        function UpdatePosition(structureId, oldColumnId, newColumnId, oldIndex, newIndex) {
            structureId = Number(structureId);

            var oldColumn = $scope.Sequencer.Columns.find(find => (find.Id === oldColumnId));
            var newColumn = $scope.Sequencer.Columns.find(find => (find.Id === newColumnId));
            var structure = oldColumn.Structures.find(find => (find.Id === structureId));
            var oldStructureIndex = oldColumn.Structures.findIndex(find => (find.Id === structureId));

            structure.ColumnId = newColumnId;
            oldColumn.Structures.splice(oldStructureIndex, 1);
            newColumn.Structures.push(structure);

            Reorder(newColumnId, null, newIndex, false, structureId);
            Reorder(oldColumnId, oldIndex, null, true, structureId);
        }

        function Reorder(columnId, oldIndex, newIndex, refreshScope, structureId) {
            if (!columnId) {
                return;
            }

            structureId = Number(structureId);

            var column = $scope.Sequencer.Columns.find(find => (find.Id === columnId));
            var structuresToReorder;
            var coefficient = -1;

            if (oldIndex === null) {
                coefficient = 1;
                structuresToReorder = column.Structures.filter(filter => ((filter.Id === structureId) || (filter.Order >= newIndex)));
            }
            else if (newIndex === null) {
                structuresToReorder = column.Structures.filter(filter => ((filter.Id === structureId) || (filter.Order >= oldIndex)));
            }
            else if (newIndex > oldIndex) {
                structuresToReorder = column.Structures.filter(filter => ((filter.Id === structureId) || ((filter.Order >= oldIndex) && (filter.Order <= newIndex))));
            }
            else {
                structuresToReorder = column.Structures.filter(filter => ((filter.Id === structureId) || ((filter.Order <= oldIndex) && (filter.Order >= newIndex))));
                coefficient = 1;
            }

            structuresToReorder.forEach(structureToReorder => {
                if (structureToReorder.Id === structureId) {
                    structureToReorder.Order = newIndex;

                    return;
                }

                structureToReorder.Order = structureToReorder.Order + coefficient;
            });

            OrderColumn(columnId);

            if (refreshScope) {
                $timeout($scope.$apply());
            }
        }

        function OrderColumn(columnId, setOrder) {
            var column = $scope.Sequencer.Columns.find(find => (find.Id === columnId));

            var structuresOrdered = column.Structures.sort(function (a, b) {
                if (a.Order < b.Order) {
                    return -1;
                }

                if (a.Order > b.Order) {
                    return 1;
                }

                return 0;
            });

            if (setOrder) {
                var newOrder = 0;

                structuresOrdered.forEach(structure => {
                    structure.Order = newOrder;

                    newOrder++;
                });
            }

            column.Structures = structuresOrdered;
        }

        $scope.GetNumberOfItens = function (columnId) {
            var numberOfItens = $('div[column-id="' + columnId + '"]').children(':visible').length;

            return numberOfItens;
        }

        function CleanSequencer() {
            $scope.Sequencer = {};
            $scope.Sequencer.Columns = [];
        }
        //#endregion

        //#region Project Submission Form
        $scope.ShowProjectDetails = function () {
            SetProjectDetails();

            $scope.StepMakeAList = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = true;
            $scope.StepProjectSubmitted = false;
            $scope.ShowProjectDetailsInvalidFields = false;
        }

        function SetProjectDetails() {
            var details;

            if (Object.keys(detailsImported).length) {
                details = detailsImported;
                $scope.Project.Details = details;
            }
            else {
                details = localStorage.getItem("BuilderProject.Details");

                if (details) {
                    $scope.Project.Details = JSON.parse(details)

                    delete $scope.Project.Details.Photos;
                }
            }

            if (!Object.keys(detailsImported).length) {
                if ($scope.Project.Details) {
                    if ($scope.Project.Details.Email) {
                        $scope.Project.Details.Emails = [];
                        $scope.Project.Details.ContactEmails = [];

                        var emailsToAdd = $scope.Project.Details.Email.split(";");

                        for (var i = 0; i < emailsToAdd.length; i++) {
                            var emailToAdd = emailsToAdd[i];

                            if (!emailToAdd.length) {
                                continue;
                            }

                            $scope.Project.Details.Emails.push(emailToAdd);
                        }

                        delete $scope.Project.Details.Email;
                    }
                }
                else {
                    $scope.Project.Details = {}
                }
            }

            if (!$scope.Project.Details.Quantity) {
                $scope.Project.Details.Quantity = 1;
            }

            if (!$scope.Project.Details.ContactEmails) {
                $scope.Project.Details.ContactEmails = [];
            }

            if (!$scope.Project.Details.Emails) {
                $scope.Project.Details.Emails = [];
            }

            if (!$scope.Project.Details.SubmissionTypeCode) {
                $scope.Project.Details.SubmissionTypeCode = "01";
            }

            if (!$scope.Project.Details.Photos || !$scope.Project.Details.Photos.length) {
                $scope.Project.Details.Photos = [{
                    Photography: null
                }, {
                    Photography: null
                }, {
                    Photography: null
                }, {
                    Photography: null
                }, {
                    Photography: null
                }];
            }
        }

        $scope.BackToLeanProject = function () {
            $scope.StepMakeAList = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSequencer = true;
            $scope.StepProjectSubmitted = false;
        }

        $scope.ProjectSubmit = function () {
            var isFormValid = IsFormValid();

            if (isFormValid) {
                SendProject();

                return;
            }

            $scope.ShowProjectDetailsInvalidFields = true;
        }

        function IsFormValid() {
            if (!ValidateFieldValue("Customer", "Customer is required!")) {
                return false;
            }

            if (!ValidateFieldValue("AssemblyType", "Assembly type is required!")) {
                return false;
            }

            if (!$scope.Project.Details.Quantity || ($scope.Project.Details.Quantity < 1)) {
                GeneralModel.ShowToastWarning("Quantity is invalid. Must be at least 1!");

                return false;
            }

            if (!$scope.Project.Details.Emails || !$scope.Project.Details.Emails.length) {
                GeneralModel.ShowToastWarning("At least one email is required!");

                return false;
            }

            var isEmailsValid = ValidateEmails($scope.Project.Details.Emails, true) && ValidateEmails($scope.Project.Details.ContactEmails, false);

            if (isEmailsValid) {
                return true;
            }

            return false;
        }

        function ValidateFieldValue(field, errorMessage) {
            if ($scope.Project.Details[field]) {
                return true;
            }

            GeneralModel.ShowToastWarning(errorMessage);

            return false;
        }

        function SendProject() {
            $scope.generalModel.FullPageLoading = true;

            var structuresToSend = [];

            $scope.Project.Structures.forEach(structure => {
                var structureToSend = angular.copy(structure);

                delete structureToSend.Characteristics;
                delete structureToSend.Description;
                delete structureToSend.Id;
                delete structureToSend.StructureQuantityToDuplicate;

                if (!structureToSend.UploadedPhoto) {
                    delete structureToSend.Photography;
                }

                delete structureToSend.UploadedPhoto;

                structuresToSend.push(structureToSend);
            });

            var parameters = {
                Structures: structuresToSend,
                ProjectDetail: $scope.Project.Details,
                Language: $scope.LanguageSelected
            };

            parameters.ProjectDetail.Photos = parameters.ProjectDetail.Photos.filter(filter => filter.Photography);

            $q.when(GeneralLoadData.GeneralPost("BuilderConfigurator", "Send", parameters, null)).then(function () {
                delete $scope.Project.Details.Photos;

                localStorage.setItem("BuilderProject.Details", JSON.stringify($scope.Project.Details))

                detailsImported = {};
                $scope.Project.Structures = []
                $scope.StepMakeAList = false;
                $scope.StepProjectDetails = false;
                $scope.StepProjectSubmitted = true;

                CleanSequencer();
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        $scope.ProjectComplete = function () {
            $scope.Project.Structures = [];

            $scope.Structures.forEach(structure => {
                if (structure.ProjectQuantity && (structure.ProjectQuantity > 0)) {
                    structure.ProjectQuantity = 0;
                    structure.MinimumQuantity = 0;
                }
            });

            $mdDialog.hide({
                contentElement: '#DialogProject'
            });
        }
        //#endregion

        //#region Imports
        $scope.OpenImportCsvDialog = function () {
            $scope.File = '';
            $scope.generalModel.FullPageLoading = true;
            $scope.UploadBox = { Multiple: false, Pattern: '.csv', Accept: '.csv', Capture: 'camera', Validate: { size: { max: '1MB', min: '1B' }, height: { max: 12000 }, width: { max: 12000 } }, DragOverClass: { accept: 'dragover', reject: 'dragover-err', pattern: '*' }, Options: { debounce: 100 }, Resize: { width: 400, height: 400, centerCrop: false }, ResizeIf: '$width > 400 || $height > 400', FirefoxPaste: true };

            $mdDialog.show({
                contentElement: '#DialogImportCsv',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false
            });

            $scope.generalModel.FullPageLoading = false;
        };

        $scope.ImportCsv = function () {
            $scope.generalModel.FullPageLoading = true;

            var apiUrl = GetIp();
            var formData = new FormData();

            formData.append("", $scope.File);

            var settings = {
                "cache": false,
                "method": 'POST',
                headers: { "Content-Type": undefined },
            };

            var importCsvApiUrl = apiUrl + "/api/BuilderConfigurator/ImportCsv";

            return $http.post(importCsvApiUrl, formData, settings)
                .then(function (result) {
                    ImportCsvData(result.data);
                }).catch(function (reason) {
                    GeneralModel.ShowToastWarning(reason);
                }).finally(function () {
                    $scope.generalModel.CloseDialog('DialogImportCsv');
                    $scope.generalModel.FullPageLoading = false;
                })
        }

        function ImportCsvData(structuresImported) {
            if (!structuresImported) {
                return;
            }

            structuresImported.forEach(structureImported => {
                var structure = GetStructureByCode($scope.Structures, structureImported.Code);

                if (!structure) {
                    return;
                }

                if (isNaN(structure.MinimumQuantity)) {
                    structure.MinimumQuantity = 1
                }
                else {
                    structure.MinimumQuantity = structure.MinimumQuantity + 1;
                }

                if (isNaN(structure.ProjectQuantity)) {
                    structure.ProjectQuantity = 1;
                }
                else {
                    structure.ProjectQuantity = structure.ProjectQuantity + 1;
                }

                structure.Photography = structure.Photography || structureImported.Photography;

                var structureToAdd = SetStructureToAddInImportCsv(structure, structureImported);

                lastStructureId++;
                structureToAdd.Id = lastStructureId;

                $scope.Project.Structures.push(structureToAdd);

                AddInSequencer(structureToAdd);
            });

            SetProjectDetailsFromCsv(structuresImported);
        }

        function SetStructureToAddInImportCsv(structure, structureFromCsv) {
            var mainCode = structure.Code.substr(0, 2);
            var structureCharacteristics = $scope.Characteristics.filter(filter => (!filter.MainCode || (filter.MainCode === mainCode)));
            var structureToAdd = angular.copy(structure);

            structureToAdd.Characteristics = structureCharacteristics;

            SetPropertyValueInt(structureToAdd, structureFromCsv, "Order");
            SetPropertyValueInt(structureToAdd, structureFromCsv, "ExternalWidth");
            SetPropertyValueInt(structureToAdd, structureFromCsv, "InternalWidth");
            SetPropertyValueInt(structureToAdd, structureFromCsv, "ExternalDepth");
            SetPropertyValueInt(structureToAdd, structureFromCsv, "InternalDepth");
            SetPropertyValueInt(structureToAdd, structureFromCsv, "HeightThickness");
            SetPropertyValueInt(structureToAdd, structureFromCsv, "DepthHu");
            SetPropertyValueInt(structureToAdd, structureFromCsv, "FreeSpace");
            SetPropertyValueFloat(structureToAdd, structureFromCsv, "Weight");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "Orientation");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "Slope");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "SlopeDirection");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "HUSupportType");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "HUSupport");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "RollJoint");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "GuideType");
            SetPropertyValueDropDown(structureToAdd, structureFromCsv, "ProfileSupportQuantity");
            SetFieldsToConsiderInLeanProject(structureToAdd);

            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "ExternalWidth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "InternalWidth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "ExternalDepth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "InternalDepth", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "HeightThickness", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "DepthHu", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "FreeSpace", 0);
            Helpers.Object.SetPropertyValueIfUndefinedOrNull(structureToAdd, "Weight", 0);

            structureToAdd.Topic = structureFromCsv.Topic;
            structureToAdd.Type = structureFromCsv.Type;
            structureToAdd.Annotations = structureFromCsv.Annotations;
            structureToAdd.StructureQuantityToDuplicate = 1;
            structureToAdd.ColumnId = structureFromCsv.ColumnId;

            delete structureToAdd.DrawingNumber;
            delete structureToAdd.HasDetails;
            delete structureToAdd.MinimumQuantity;
            delete structureToAdd.ProjectQuantity;
            delete structureToAdd.SeoInformation;
            delete structureToAdd.SolutionNumber;

            return structureToAdd;
        }

        function SetProjectDetailsFromCsv(structuresImported) {
            if (!structuresImported.length) {
                return;
            }

            let structureImported = structuresImported[0];

            detailsImported = {};

            SetProjectDetailInformationFromCsv(structureImported, "ContactType");
            SetProjectDetailInformationFromCsv(structureImported, "Country");
            SetProjectDetailInformationFromCsv(structureImported, "Customer");
            SetProjectDetailInformationFromCsv(structureImported, "Location");
            SetProjectDetailInformationFromCsv(structureImported, "Address");
            SetProjectDetailInformationFromCsv(structureImported, "ContactName");
            SetProjectDetailInformationFromCsv(structureImported, "ContactEmails", true);
            SetProjectDetailInformationFromCsv(structureImported, "SalesPerson");
            SetProjectDetailInformationFromCsv(structureImported, "Market");
            SetProjectDetailInformationFromCsv(structureImported, "RequestType");
            SetProjectDetailInformationFromCsv(structureImported, "FromPreviousRequest");
            SetProjectDetailInformationFromCsv(structureImported, "GlobalProposal");
            SetProjectDetailInformationFromCsv(structureImported, "GlobalProposalRequestNumberFrom");
            SetProjectDetailInformationFromCsv(structureImported, "GlobalProposalRequestNumberTo");
            SetProjectDetailInformationFromCsv(structureImported, "AssemblyType");
            SetProjectDetailInformationFromCsv(structureImported, "Quantity");
            SetProjectDetailInformationFromCsv(structureImported, "IncludeTransport");
            SetProjectDetailInformationFromCsv(structureImported, "SolutionCode");
            SetProjectDetailInformationFromCsv(structureImported, "ProjectApplication");
            SetProjectDetailInformationFromCsv(structureImported, "PreviousProcess");
            SetProjectDetailInformationFromCsv(structureImported, "NextProcess");
            SetProjectDetailInformationFromCsv(structureImported, "InternalOrExternalMeasures");
            SetProjectDetailInformationFromCsv(structureImported, "Emails", true);
            SetProjectDetailInformationFromCsv(structureImported, "Notes");
        }

        function SetProjectDetailInformationFromCsv(structureImported, field, isList) {
            if (structureImported[field]) {
                let valueToSet;

                if (isList) {
                    valueToSet = structureImported[field].split(",");
                }
                else {
                    valueToSet = structureImported[field]
                }

                detailsImported[field] = valueToSet;
            }
        }

        function SetPropertyValueInt(structure, csvStructure, propertyName) {
            var valueToSet = parseFloat(csvStructure[propertyName]);

            if (!valueToSet || isNaN(valueToSet)) {
                valueToSet = 0;
            }

            structure[propertyName] = valueToSet;
        }

        function SetPropertyValueFloat(structure, csvStructure, propertyName) {
            var valueToSet = parseInt(csvStructure[propertyName]);

            if (!valueToSet || isNaN(valueToSet)) {
                valueToSet = 0;
            }

            structure[propertyName] = valueToSet;
        }

        function SetPropertyValueDropDown(structure, csvStructure, propertyName) {
            var arrayToCheck;

            if (propertyName === "ProfileSupportQuantity") {
                arrayToCheck = "ProfileSupportQuantities";
            }
            else {
                arrayToCheck = propertyName + "s";
            }

            var validValue = CheckDropDownValue($scope[arrayToCheck], csvStructure[propertyName]);

            if (validValue) {
                structure[propertyName] = csvStructure[propertyName];
            }
        }
        //#endregion

        function ValidateEmails(emailsToValidate, required) {
            var existValidEmail = false;

            for (var i = 0; i < emailsToValidate.length; i++) {
                var emailToValidate = emailsToValidate[i];

                if (!emailToValidate.length) {
                    continue;
                }

                var emailValid = ValidateEmail(emailToValidate, true);

                if (!emailValid) {
                    return false;
                }

                existValidEmail = true;
            }

            if (!existValidEmail && required) {
                GeneralModel.ShowToastWarning("You must insert at least one valid email.");

                return false;
            }

            return true;
        }

        function ValidateEmail(emailToValidate, showErrorMessage) {
            if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailToValidate)) {
                return true;
            }

            if (showErrorMessage) {
                GeneralModel.ShowToastWarning("Email '" + emailToValidate + "' is invalid.");
            }

            return false;
        }

        $('#alt-style-pagination').pagination({
            items: 260,
            itemOnPage: $scope.ItemsPerPage,
            currentPage: $scope.CurrentPage,
            cssStyle: '',
            prevText: '',
            nextText: '',
            displayedPages: 4,
            edges: 1,
            ellipsePageSet: false,
            onInit: function () { },
            onPageClick: function (page, _evt) {
                $scope.CurrentPage = page;
                $scope.ScrollToTop('.ListSolutions');
            }
        });

        function SetStructurePages() {
            var numberOfPages = $scope.StructuresFiltered.length / $scope.ItemsPerPage;

            if (numberOfPages > 1) {
                $scope.ShowInfoPages = true;
            } else {
                $scope.ShowInfoPages = false;
            }

            $('#alt-style-pagination').pagination('updateItems', numberOfPages);
            $scope.ScrollToTop('.ListStructures');
        }

        function SelectCharacteristicOption(mainCode, code, optionCode) {
            var characteristics = $scope.Characteristics;

            var characteristic = characteristics.find(find => (find.MainCode === mainCode) && (find.Code === code));

            if (!characteristic) {
                return false;
            }

            characteristic.Visible = true;

            if (optionCode.toUpperCase() === "ALL") {
                for (var i = 0; i < characteristic.CharacteristicOptions.length; i++) {
                    var characteristicOption = characteristic.CharacteristicOptions[i];

                    characteristicOption.Selected = true;
                    characteristicOption.Visible = true;
                }

                return true;
            }

            var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === optionCode));

            if (!characteristicOption) {
                return false;
            }

            characteristicOption.Selected = true;
            characteristicOption.Visible = true;

            return true;
        }

        function GetCodesFromCharacteristic(characteristic) {
            var codes = [];
            var isCharacteristicValid = ((characteristic.length % 2) === 0);

            if (!isCharacteristicValid) {
                return codes;
            }

            for (var i = 0; i < characteristic.length; i += 2) {
                codes.push(characteristic.substr(i, 2));
            }

            return codes;
        }

        //#region Details
        $scope.SetFiltersToStructure = function () {
            let structureSelectedCode = $scope.StructureSelected.Code;

            SetStructureFilters(structureSelectedCode);
        }

        function SetStructureFilters(code) {
            var mainCode = code.substr(0, 2);

            code = code.slice(2);

            $scope.SearchValues = [];
            $scope.FilterClear();

            SetSelectedMainCharacteristic($scope.Characteristics[0], mainCode);

            $timeout(function () {
                $scope.Characteristics.forEach((characteristic) => {
                    if (characteristic.MainCode && (characteristic.MainCode === mainCode)) {
                        var optionCodeToSelect = code.substr(0, 2);

                        code = code.slice(2);
                        SelectCharacteristicOption(mainCode, characteristic.Code, optionCodeToSelect);
                    }
                });

                ResetFilterCodeAndDescription();
            });
        };

        function SetStructureDetail() {
            GetDetails($scope.StructureSelected);

            SetStructureDetailQrCode("QrStructureDetail");
        }

        function GetDetails(structure) {
            $scope.generalModel.FullPageLoading = true;

            var parameters = {
                structureId: structure.Code
            };

            CleanStructureDetail();

            GeneralLoadData.GeneralGet("BuilderConfigurator", "GetDetails", parameters, null).then(function (result) {
                $scope.StructureDetail.Links = result.data.Links;
                $scope.StructureDetail.Files = result.data.Files;
                $scope.SetPhotographies(result.data.Photographies);
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        function CleanStructureDetail() {
            $scope.StructureDetail = {};
            $scope.StructureDetail.Photographies = [];
            $scope.StructureDetail.Links = [];
            $scope.StructureDetail.Files = [];
            $scope.StructureDetail.StartPhotographyIndex = -1;
            $scope.StructureDetail.SelectedPhotographyIndex = -1;
        }

        $scope.SetPhotographies = function (photographies) {
            if (!photographies) {
                return;
            }

            $scope.StructureDetail.StartPhotographyIndex = 0;
            $scope.StructureDetail.SelectedPhotographyIndex = 0;

            photographies.forEach(photography => {
                var newPhotography = $scope.GetPhotography(photography);

                $scope.StructureDetail.Photographies.push(newPhotography);
            });
        }
        //#endregion

        //#region Download
        $scope.DownloadFile = function (file) {
            var fileName = file.Name + file.Extension;

            var parameters = {
                'applicationCode': codes.Application.Builder,
                'fileName': fileName,
                'folderName': file.FolderName
            };

            GeneralLoadData.PreviewFiles("Document", "DownloadFile", parameters).then(function (result) {
                $scope.generalModel.DownloadResultBlob(result);
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            });
        }
        //#endregion

        //#region Emails
        $scope.AddEmail = function (originalEmail, isTechnicalEmail) {
            var values = originalEmail.split(/[ ,]+/);

            if (values.length < 2) {
                return;
            }

            for (var i = 0; i < values.length; i++) {
                var value = values[i].replace('<', '').replace('>', '');
                var isEmailValid = ValidateEmail(value, false);

                if (isEmailValid) {
                    var emails = $scope.Project.Details.Emails;

                    if (isTechnicalEmail) {
                        emails = $scope.Project.Details.ContactEmails;
                    }

                    var emailPosition = emails.indexOf(originalEmail);

                    if (emailPosition > -1) {
                        emails[emailPosition] = value;
                    }

                    break;
                }
            }
        }
        //#endregion

        //#region Help
        $scope.ApplyHelpFilter = function () {
            clearTimeout(delayHelpFilter);

            delayHelpFilter = setTimeout(function () {
                HelpFilter()
            }, 250);
        }

        $scope.OpenHelp = function () {
            $scope.HelpSearchValues = [];

            LoadHelp();

            $mdDialog.show({
                contentElement: '#DialogHelp',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
            })
        };

        $scope.CloseHelp = function () {
            $mdDialog.hide({
                contentElement: '#DialogHelp'
            });
        };

        function HelpFilter() {
            var i;
            var helpLinksFiltered = [];

            if ($scope.HelpSearchValues.length) {
                for (i = 0; i < $scope.HelpLinks.length; i++) {
                    var helpLinkToAnalyse = $scope.HelpLinks[i];

                    for (var j = 0; j < $scope.HelpSearchValues.length; j++) {
                        var searchValue = $scope.HelpSearchValues[j];

                        if (searchValue) {
                            searchValue = searchValue.toLowerCase().trim();

                            if (helpLinkToAnalyse.Name.toLowerCase().trim().includes(searchValue)) {
                                helpLinksFiltered.push(helpLinkToAnalyse);
                                break;
                            }
                        }
                    }
                }
            } else {
                helpLinksFiltered = $scope.HelpLinks;
            }

            $timeout(function () {
                $scope.HelpLinksFiltered = helpLinksFiltered;
            });
        }

        function LoadHelp() {
            $scope.LoadingHelp = true;
            $scope.HelpLinks = [];
            $scope.HelpLinksFiltered = [];

            var parameters = {
                applicationCode: codes.Application.Builder
            };

            GeneralLoadData.GeneralGet("Document", "List", parameters, null).then(function (result) {
                $scope.HelpLinks = result.data;
                $scope.HelpLinksFiltered = $scope.HelpLinks;
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.LoadingHelp = false;
            });
        }
        //#endregion

        //#region SlideShow
        $scope.SetPhotography = function (photographyPositionToSet) {
            $scope.StructureDetail.SelectedPhotographyIndex = photographyPositionToSet;
        }

        $scope.GoPreviousPhotography = function () {
            if ($scope.StructureDetail.StartPhotographyIndex > 0) {
                $scope.StructureDetail.StartPhotographyIndex--;
            }
        }

        $scope.GoNextPhotography = function () {
            var lastPosition = $scope.StructureDetail.Photographies.length - 1;

            if (lastPosition > ($scope.StructureDetail.StartPhotographyIndex + 2)) {
                $scope.StructureDetail.StartPhotographyIndex++;
            }
        }

        $scope.ShowGoNextPhotography = function () {
            var lastPosition = $scope.StructureDetail.Photographies.length - 1;

            if (lastPosition < 3) {
                return false;
            }

            if (lastPosition > ($scope.StructureDetail.StartPhotographyIndex + 2)) {
                return true;
            }

            return false;
        }
        //#endregion

        //#region Structures
        function SetStructuresSubmitted() {
            var structureProject = localStorage.getItem("StructuresProjectSubmitted");

            if (!structureProject) {
                return;
            }

            structureProject = JSON.parse(structureProject)

            for (var i = 0; i < structureProject.Structures.length; i++) {
                var structure = structureProject.Structures[i];

                CheckAndAddStructure(structure, structureProject.Database);
            }

            localStorage.removeItem("StructuresProjectSubmitted");
        }

        function CheckAndAddStructure(structure, database) {
            if (!structure || !structure.Code) {
                return;
            }

            if (structure.Code.length !== 30) {
                return;
            }

            var newStructure = $scope.StructuresProject.Structures.find(find => (find.Code === structure.Code));

            if (newStructure) {
                return;
            }

            newStructure = {
                Code: structure.Code,
                Notes: structure.Notes,
                DatabaseName: database,
                TimesImported: 0
            };

            $scope.StructuresProject.Structures.push(newStructure);
        }

        $scope.ImportStructureCsv = function (structure) {
            if (!structure || !structure.HasBuilderCsv) {
                return;
            }

            $scope.generalModel.FullPageLoading = true;

            var parameters = {
                structureId: structure.Code,
                databaseName: structure.DatabaseName
            };

            GeneralLoadData.GeneralGet("BuilderConfigurator", "ImportStructureCsv", parameters, null).then(function (result) {
                ImportCsvData(result.data);

                structure.TimesImported += 1;
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            })
        }

        $scope.GetProjectStructurePhotography = function (structure) {
            var photography;

            if (!structure) {
                photography = $scope.GetPhotography(null);

                return photography;
            }

            if (structure.Photography) {
                photography = $scope.GetPhotography(structure.Photography);

                return photography;
            }

            GetProjectStructurePhotographyFromServer(structure);

            photography = $scope.GetPhotography(null);

            return photography;
        };

        function GetProjectStructurePhotographyFromServer(structure) {
            structure.Photography = " ";

            var parameters = {
                structureId: structure.Code,
                databaseName: structure.DatabaseName
            };

            $q.when(GeneralLoadData.GeneralGet("StructureConfigurator", "GetToStructureBuilder", parameters, null)).then(function (result) {
                structure.Photography = result.data.Photography;
                structure.HasBuilderCsv = result.data.HasBuilderCsv;
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            });
        }

        $scope.OpenStructures = function () {
            if ($scope.MenuOpen) {
                $scope.CloseMenus();
            }

            $mdDialog.show({
                contentElement: '#DialogStructures',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
            })
        };

        $scope.CloseStructures = function () {
            $mdDialog.hide({
                contentElement: '#DialogStructures'
            });
        };
        //#endregion

        //#region Translations
        function SetTranslations() {
            var translations = webTranslations.find(first => (first.Language === $scope.LanguageSelected));

            Helpers.Translation.SetTranslations($sessionStorage, translations.Translations);
        }
        //#endregion

        //#region Youtube Player
        $scope.GetVideoLink = function (link) {
            if (!link || !link.Url) {
                return;
            }

            var url = $sce.trustAsResourceUrl(link.Url);

            return url;
        };
        //#endregion

        //#region Zoom
        $scope.ApplyZoom = function (e) {
            if (!zoomObject) {
                SetZoomObject();
            }

            var lensPosition = GetLensPosition(e);

            SetZoomedPhotography(lensPosition);
        }

        function SetZoomObject() {
            var lens = document.getElementById("ZoomLens");
            var photography = document.getElementById("Photography");
            var individualStructurePhotography = document.getElementById("IndividualSolutionPhotography");

            var scaleX = 234 / lens.offsetWidth;
            var scaleY = 234 / lens.offsetHeight;

            zoomObject = {
                lens: lens,
                photography: photography,
                individualStructurePhotography: individualStructurePhotography,
                scaleX: scaleX,
                scaleY: scaleY
            };
        }

        function GetLensPosition(e) {
            var cursorPositions = GetCursorPositions(e);
            e.preventDefault();

            var lensPosition = {
                lensX: cursorPositions.cursorPositionX - (zoomObject.lens.offsetWidth / 2),
                lensY: cursorPositions.cursorPositionY - (zoomObject.lens.offsetHeight / 2)
            };

            CheckLensPosition(lensPosition, "lensX", zoomObject.photography.width, zoomObject.lens.offsetWidth);
            CheckLensPosition(lensPosition, "lensY", zoomObject.photography.height, zoomObject.lens.offsetHeight);

            AdjustLens(lensPosition);

            return lensPosition;
        }

        function SetZoomedPhotography(lensPosition) {
            var zoomedPhotography = document.getElementById("ZoomedPhotography");

            if (!zoomedPhotography.style.backgroundSize) {
                zoomedPhotography.style.backgroundSize = (zoomObject.photography.width * zoomObject.scaleX) + "px " + (zoomObject.photography.height * zoomObject.scaleY) + "px";
            }

            zoomedPhotography.style.backgroundPosition = "-" + (lensPosition.lensX * zoomObject.scaleX) + "px -" + (lensPosition.lensY * zoomObject.scaleY) + "px";
        }

        function CheckLensPosition(lensPosition, measurement, photographyMax, offset) {
            if (lensPosition[measurement] > photographyMax - offset) {
                lensPosition[measurement] = photographyMax - offset;
            }

            if (lensPosition[measurement] < 0) {
                lensPosition[measurement] = 0;
            }
        }

        function AdjustLens(lensPosition) {
            zoomObject.lens.style.left = lensPosition.lensX + ((zoomObject.individualStructurePhotography.offsetWidth - zoomObject.photography.width) / 2) + "px";
            zoomObject.lens.style.top = lensPosition.lensY + ((zoomObject.individualStructurePhotography.offsetHeight - zoomObject.photography.height) / 2) + "px";
        }

        function GetCursorPositions(e) {
            var photographyPosition = zoomObject.photography.getBoundingClientRect();
            var pagePosition = e || window.event;

            var cursorPositionX = pagePosition.pageX - photographyPosition.left;
            var cursorPositionY = pagePosition.pageY - photographyPosition.top;

            cursorPositionX = cursorPositionX - window.pageXOffset;
            cursorPositionY = cursorPositionY - window.pageYOffset;

            var cursorPositions = { cursorPositionX: cursorPositionX, cursorPositionY: cursorPositionY };

            return cursorPositions;
        }

        $scope.HideLens = function () {
            $scope.ShowZoomLens = false;
        }

        $scope.ShowLens = function () {
            $scope.ShowZoomLens = true;
        }
        //#endregion

        //#region Menus
        function SetMenus(result, open) {
            $scope.Menus = result.data;

            if (!$scope.Menus.length) {
                return;
            }

            $scope.MenusHistory = [];
            $scope.MenusHistory.push($scope.Menus[0]);

            SetMenu();

            if (!open) {
                return;
            }

            $scope.OpenMenus();
        }

        function SetMenu() {
            var lastMenuIndex = $scope.MenusHistory.length - 1;

            $scope.SelectedMenu = $scope.MenusHistory[lastMenuIndex];

            ClearMenuSelectedOption();

            if ($scope.SelectedMenu.Photography) {
                return;
            }

            var parameters = {
                applicationCode: codes.Application.Builder,
                menuCode: $scope.SelectedMenu.Code
            };

            $scope.generalModel.FullPageLoading = true;

            GeneralLoadData.GeneralGet("Menu", "ListPhotography", parameters).then(function (result) {
                var photographies = result.data;
                var photography = photographies.find(find => (find.FileName.toUpperCase() === "Menu".toUpperCase()));

                if (photography) {
                    $scope.SelectedMenu.Photography = $scope.GetPhotography(photography.FileArray);
                } else {
                    $scope.SelectedMenu.Photography = $scope.GetPhotography();
                }

                for (var i = 0; i < $scope.SelectedMenu.MenuOptions.length; i++) {
                    var menuOption = $scope.SelectedMenu.MenuOptions[i];
                    photography = photographies.find(find => (find.FileName === menuOption.Code));

                    if (photography) {
                        menuOption.Photography = $scope.GetPhotography(photography.FileArray);
                    } else {
                        menuOption.Photography = $scope.GetPhotography();
                    }
                }
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        $scope.OpenMenus = function () {
            $scope.MenuOpen = true;

            $mdDialog.show({
                contentElement: '#DialogMenus',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false,
            })
        };

        $scope.CloseMenus = function () {
            $mdDialog.hide({
                contentElement: '#DialogMenus'
            });

            ApplyMenuFilters();

            $timeout(function () {
                $scope.MenuOpen = false;
            });
        }

        function ApplyMenuFilters() {
            $scope.FilterClear();

            for (var i = 0; i < $scope.MenusHistory.length; i++) {
                var menuHistory = $scope.MenusHistory[i];
                var menuSelected = menuHistory.MenuOptions.find(find => find.Selected);

                if (!menuSelected) {
                    continue;
                }

                var menuOptionsFilters = menuSelected.Filters;

                if (!menuOptionsFilters) {
                    continue;
                }

                SetCharacteristicsFromMenu(menuOptionsFilters);
            }
        }

        function SetCharacteristicsFromMenu(characteristics) {
            if (!characteristics.length) {
                return;
            }

            if (!characteristics || !characteristics.length) {
                return;
            }

            var mainCode = $scope.Characteristics[0].MainCode;

            for (var i = 0; i < characteristics.length; i++) {
                var filter = characteristics[i];
                var index = filter.indexOf('.');
                var characteristicCode = filter.substr(0, index);
                var characteristic = $scope.Characteristics.find(find => (find.MainCode === mainCode) && (find.Code === characteristicCode));

                if (!characteristic) {
                    continue;
                }

                var characteristicOptionCode = filter.substr(index + 1);
                var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === characteristicOptionCode));

                if (!characteristicOption) {
                    continue;
                }

                var selected = SelectCharacteristicOption(mainCode, characteristicCode, characteristicOptionCode);

                if (!selected) {
                    continue;
                }

                if (i == 0) {
                    SetSelectedMainCharacteristic($scope.Characteristics[0], characteristicOptionCode);
                    mainCode = characteristicOptionCode;
                }
            }

            ResetFilterCodeAndDescription();
        }

        $scope.MenuOptionClick = function (menuOption) {
            ClearMenuSelectedOption();

            menuOption.Selected = true;

            if (menuOption.Link) {
                Helpers.Page.OpenInNewTab(menuOption.Link);

                return;
            }

            if (menuOption.Menu) {
                var validNextMenu = NextMenu(menuOption);

                if (validNextMenu) {
                    return;
                }
            }

            $scope.CloseMenus();
        }

        function NextMenu(menuOption) {
            var nextMenu = $scope.Menus.find(find => (find.Code === menuOption.Menu));

            if (!nextMenu) {
                return false;
            }

            $scope.MenusHistory.push(nextMenu);

            SetMenu();

            return true;
        }

        $scope.PreviousMenu = function () {
            $scope.MenusHistory.pop();

            SetMenu();
        }

        $scope.RestartMenus = function () {
            $scope.MenusHistory = [];

            $scope.MenusHistory.push($scope.Menus[0]);

            SetMenu();
        }

        function ClearMenuSelectedOption() {
            var selectedMenuOption = $scope.SelectedMenu.MenuOptions.find(find => find.Selected);

            if (selectedMenuOption) {
                selectedMenuOption.Selected = false;
            }
        }
        //#endregion

        //#region Route
        function SetSearchValuesFromRoute() {
            if (!urlParameters || !urlParameters.S || !urlParameters.S.length) {
                return;
            }

            urlParameters.S.forEach(searchValue => {
                if (searchValue.length) {
                    $scope.SearchValues.push(searchValue);
                }
            });
        }

        function SetCharacteristicsFromRoute() {
            if (!urlParameters || !urlParameters.C || !urlParameters.C.length) {
                return;
            }

            var mainCode;
            var firstCharacteristic = $scope.Characteristics[0];

            for (var i = 0; i < urlParameters.C.length; i++) {
                var characteristic = urlParameters.C[i];

                var codes = GetCodesFromCharacteristic(characteristic);

                if (!codes.length) {
                    continue;
                }

                var firstCode = codes[0];

                if ((firstCode === firstCharacteristic.Code) && codes[1]) {
                    mainCode = codes[1];

                    SelectCharacteristicOption(firstCharacteristic.MainCode, firstCharacteristic.Code, codes[1]);
                    SetSelectedMainCharacteristic(firstCharacteristic, codes[1]);

                    continue;
                }

                if (!mainCode) {
                    break;
                }

                if (codes.length === 1) {
                    SelectCharacteristicOption(mainCode, firstCode, 'ALL');

                    continue;
                }

                for (var j = 1; j < codes.length; j++) {
                    SelectCharacteristicOption(mainCode, firstCode, codes[j]);
                }
            }

            ResetFilterCodeAndDescription();
        }

        function SetActivePageFromRoute() {
            if (!urlParameters || !urlParameters.P) {
                return;
            }

            var activePage = urlParameters.P;

            if (isNaN(activePage)) {
                return;
            }

            var numberOfPages = $scope.StructuresFiltered.length / $scope.ItemsPerPage;

            if ((activePage >= 1) && (activePage <= numberOfPages)) {
                $scope.CurrentPage = activePage;

                //$('#alt-style-pagination').pagination('selectPage', activePage);
                $scope.ScrollToTop('.ListStructures');
            }
        }
        //#endregion

        //#region General Link
        $scope.CopyGeneralLink = function () {
            var url = GetBaseUrl();

            url = url.slice(0, -1);

            var selectedCharacteristicsOptions = GetSelectedCharacteristicsOptions();

            var json = "?P=" + $scope.CurrentPage;

            if (selectedCharacteristicsOptions && selectedCharacteristicsOptions.length) {
                json += "&C=" + selectedCharacteristicsOptions.toString();
            }

            if ($scope.SearchValues.length) {
                var searchValues = $scope.SearchValues.toString();

                json += "&S=" + searchValues;
            }

            if (json.length > 260) {
                GeneralModel.ShowToastWarning(Helpers.Translations.UrlMaxLengthReached);

                return;
            }

            url += json;

            CopyToClipboard(url);

            GeneralModel.ShowToast(Helpers.Translations.GeneralUrlCopied);
        }

        function GetSelectedCharacteristicsOptions() {
            var selectedCharacteristicsToReturn = [];
            var selectedCharacteristics = $scope.Characteristics.filter(where => where.CharacteristicOptions.some(some => some.Selected));

            for (var i = 0; i < selectedCharacteristics.length; i++) {
                var selectedCharacteristicToAnalyse = selectedCharacteristics[i];

                var selectedCharacteristicOption = selectedCharacteristicToAnalyse.CharacteristicOptions.filter(where => where.Selected);

                if (selectedCharacteristicToAnalyse.CharacteristicOptions.length === selectedCharacteristicOption.length) {
                    selectedCharacteristicsToReturn.push(selectedCharacteristicToAnalyse.Code);

                    continue;
                }

                var optionCodes = selectedCharacteristicToAnalyse.Code;

                for (var j = 0; j < selectedCharacteristicOption.length; j++) {
                    optionCodes += selectedCharacteristicOption[j].Code;
                }

                selectedCharacteristicsToReturn.push(optionCodes);
            }

            return selectedCharacteristicsToReturn;
        }
        //#endregion

        //#region SEO
        function SetSEO() {
            var titleTag = angular.element('title');
            var canonicalLinkTag = document.querySelector('link[rel="canonical"]')
            var metaDescription = angular.element('meta[name="description"]');
            var metaKeywords = angular.element('meta[name="keywords"]');

            titleTag[0].innerText = "4Lean Structure Builder Configurator";
            canonicalLinkTag.setAttribute('href', "https://customer.4lean.net/solutionConfigurator/BuilderStructureConfigurator");
            metaDescription.attr('content', "The Structure Builder Configurator has thousands of configurations. You can see videos/images, pick a standard structure and reconfigure to your own structure, get bill of materials to get a proposal.");
            metaKeywords.attr('content', "lean manufacturing,Lean,kaizen,kaizen video,lean manufacturing video,lean manufacturing examples,logistics,logistic train,lean system,Solutions,Workstation,Production,Waste Reduction,Lean Thinking,Industry 4.0,How to,How to make,Mizusumashi,Process,manufacturing,karakuri, configurator");
        }
        //#endregion
    });
})();
(function () {
    "use strict";

    myApp.controller('SolutionGuideAppCtrl', function ($scope, GeneralLoadData, GeneralModel, $q, $timeout, $compile, $mdDialog, GetIp, $http, $mdConstant, $sessionStorage, $sce, $location, $stateParams) {
        var delayTimer, delayHelpFilter;
        var zoomObject;

        $scope.Project = {
            Solutions: [],
            Details: {}
        };

        $scope.Menus = [];
        $scope.SearchValues = [];
        $scope.HelpSearchValues = [];
        $scope.separatorKeysForEmails = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, $mdConstant.KEY_CODE.SPACE, $mdConstant.KEY_CODE.SEMICOLO];
        $scope.ItemsPerPage = 60;
        $scope.CurrentPage = 1;
        $scope.ShowInfoPages = false;
        $scope.HasHelp = false;
        CleanSolutionDetail();
        var urlParameters = null;
        var defaultTitle = "4Lean Solution Configurator";
        var defaultCanonicalUrl = "https://customer.4lean.net/SolutionConfigurator/SolutionConfigurator";
        var defaultMetaDescription = "The Solutions Configurator has thousands of solutions.You can view videos/images and change the size of the structure and get bill of materials, to get the cost.";
        var defaultMetaKeyword = "lean manufacturing,Lean,kaizen,kaizen video,lean manufacturing video,lean manufacturing examples,logistics,logistic train,lean system,Solutions,Workstation,Production,Waste Reduction,Lean Thinking,Industry 4.0,How to,How to make,Mizusumashi,Process,manufacturing,karakuri";

        this.$onInit = function () {
            $scope.generalModel = GeneralModel.model;
            $scope.Helpers = Helpers;

            SetParameters();
            SetLanguages();
            SetApplication();
        };

        function SetParameters() {
            if ($stateParams.P) {
                urlParameters = urlParameters || {};
                urlParameters.P = parseInt($stateParams.P);
            }

            if ($stateParams.C) {
                urlParameters = urlParameters || {};
                urlParameters.C = $stateParams.C.split(",");
            }

            if ($stateParams.S) {
                urlParameters = urlParameters || {};
                urlParameters.S = $stateParams.S.split(",");
            }

            if ($stateParams.O) {
                urlParameters = urlParameters || {};
                urlParameters.O = ($stateParams.O.toUpperCase() === "TRUE");
            }
        }

        function SetLanguages() {
            $scope.LanguageSelected = localStorage.getItem("languageSelected");

            if ($scope.generalModel.IsUndefinedEmptyOrNull($scope.LanguageSelected)) {
                $scope.LanguageSelected = "EN";
            }

            $scope.Languages = ["EN", "ES", "FR", "IT", "PT"].reverse();

            SetTranslations();
        }

        $scope.ChangeLanguage = function (language) {
            $scope.LanguageSelected = language;

            localStorage.setItem("languageSelected", language);

            SetTranslations();
            SetApplication();
        }

        $scope.ApplyFilter = function () {
            clearTimeout(delayTimer);

            delayTimer = setTimeout(function () {
                Filter()
            }, 250);
        }

        function SetApplication() {
            $scope.generalModel.FullPageLoading = true;
            $scope.HasHelp = false;
            var promises = [];
            var openMenu = !urlParameters;

            var parameters = {
                applicationCode: codes.Application.Solutions,
                languageId: $scope.LanguageSelected
            };

            promises.push(GeneralLoadData.GeneralGet("Menu", "Get", parameters, null));

            delete parameters.applicationCode;

            promises.push(GeneralLoadData.GeneralGet("SolutionGuide", "Get", parameters, null));

            parameters = { applicationCode: codes.Application.Solutions };
            promises.push(GeneralLoadData.GeneralGet("Document", "CheckIfExists", parameters, null));

            $q.all(promises).then(function (result) {
                SetMenus(result[0], openMenu);
                SetSolutions(result[1]);
                SetHelp(result[2]);

                SetFilters();
                SetSolutionPages();
                SetSolutionQrCodes();

                SetSearchValuesFromRoute();
                SetCharacteristicsFromRoute();
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                OpenSolutionDetailFromSearchValues();
                SetActivePageFromRoute();
                InitializeFilterCodeMask();

                if (!$scope.Menus.length) {
                    $scope.generalModel.FullPageLoading = false;
                }

                urlParameters = null;
            });
        }

        function SetSolutions(result) {
            $scope.Solutions = result.data.Solutions;
            $scope.SolutionsFiltered = result.data.Solutions;
            $scope.Characteristics = result.data.Characteristics;
            $scope.Areas = result.data.Area;
        }

        function SetHelp(result) {
            $scope.HasHelp = result.data;
        }

        function SetFilters() {
            $scope.FilterDescriptionLength = ($scope.Characteristics.length - 1) * 3;
            $scope.FilterCodeLength = Math.max.apply(Math, $scope.Characteristics.map(function (characteristic) { return characteristic.StartIndex; })) + 2;
            $scope.FilterCode = ''.padEnd($scope.FilterCodeLength, '_');
            $scope.FilterDescription = ''.padEnd($scope.FilterDescriptionLength, ' | ');

            $scope.SearchValues = [];
        }

        $scope.OpenSolutionDetail = function (solution) {
            $scope.SolutionSelected = solution;

            SetSolutionDetail();
            SetSeoData(solution);

            $mdDialog.show({
                contentElement: '#DialogSolutionDetail',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
                onComplete: function () {
                    SetProjectQuantity();
                }
            });
        }

        function OpenSolutionDetailFromSearchValues() {
            if (!urlParameters || (urlParameters.O !== true) || !urlParameters.S) {
                return;
            }

            if (urlParameters.S.length !== 1) {
                return;
            }

            var searchValue = urlParameters.S[0];
            var solution = $scope.Solutions.find(find => (find.Code === searchValue));

            if (solution) {
                $scope.OpenSolutionDetail(solution);
            }
        }

        $scope.CloseSolutionDetail = function () {
            $mdDialog.hide({
                contentElement: '#DialogSolutionDetail'
            });

            CleanSolutionDetail();
            SetSeoData();
        }

        function SetSeoData(solution) {
            var titleTag = angular.element('title');
            var canonicalLinkTag = document.querySelector('link[rel="canonical"]')
            var metaDescription = angular.element('meta[name="description"]');
            var metaKeywords = angular.element('meta[name="keywords"]');

            if (!solution) {
                titleTag[0].innerText = defaultTitle;
                canonicalLinkTag.setAttribute('href', defaultCanonicalUrl);
                metaDescription.attr('content', defaultMetaDescription);
                metaKeywords.attr('content', defaultMetaKeyword);

                return;
            }

            var url = GetIndividualLink(solution);

            titleTag[0].innerText = defaultTitle + ' - ' + solution.Description;
            canonicalLinkTag.setAttribute('href', url);

            if (solution.SeoInformation) {
                metaDescription.attr('content', solution.SeoInformation.Description)
                metaKeywords.attr('content', solution.SeoInformation.Keywords)
            }
        }

        function GetSolutionById(solutions, id) {
            var solution = solutions.find(first => (first.Id === id));

            return solution;
        }

        function GetSolutionByCode(solutions, code) {
            var solution = solutions.find(first => (first.Code === code));

            return solution;
        }

        function GetSolutionByOldId(solutions, oldId) {
            var solution = solutions.find(first => (first.OldId === oldId));

            return solution;
        }

        $scope.GetIndexSolutionSelected = function () {
            if ($scope.SolutionsFiltered === undefined) {
                return null;
            }

            var indexSolutionSelected = $scope.SolutionsFiltered.indexOf($scope.SolutionSelected);

            return indexSolutionSelected;
        }

        $scope.ShowPreviousSolutionDetail = function () {
            if ($scope.SolutionsFiltered === undefined) {
                return false;
            }

            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            var show = (indexSolutionSelected !== 0);

            return show;
        }

        $scope.PreviousSolutionDetail = function () {
            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            $scope.SolutionSelected = $scope.SolutionsFiltered[indexSolutionSelected - 1];

            SetSolutionDetail();
            SetProjectQuantity();
        }

        $scope.ShowNextSolutionDetail = function () {
            if ($scope.SolutionsFiltered === undefined) {
                return false;
            }

            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            var show = (indexSolutionSelected !== ($scope.SolutionsFiltered.length - 1));

            return show;
        }

        $scope.NextSolutionDetail = function () {
            var indexSolutionSelected = $scope.GetIndexSolutionSelected();
            $scope.SolutionSelected = $scope.SolutionsFiltered[indexSolutionSelected + 1];

            SetSolutionDetail();
            SetProjectQuantity();
        }

        $scope.OpenCloseFilter = function (e) {
            var content = e.target.nextElementSibling;

            e.target.classList.toggle("active");

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
                content.parentElement.style.paddingBottom = null;
            } else {
                CalculateMaxHeight(content);
            }
        }

        $(window).resize(function () {
            var characteristicsOptionsElements = document.getElementsByClassName("CharacteristicOptions");
            var characteristicsOptionsElementsLength = characteristicsOptionsElements.length;

            for (var i = 0; i < characteristicsOptionsElementsLength; i++) {
                var characteristicsOptionsElement = characteristicsOptionsElements[i];

                if (characteristicsOptionsElement.style.maxHeight) {
                    CalculateMaxHeight(characteristicsOptionsElement);
                }
            }
        });

        function CalculateMaxHeight(characteristicsOptionsElement) {
            characteristicsOptionsElement.style.maxHeight = characteristicsOptionsElement.scrollHeight + "px";
            characteristicsOptionsElement.parentElement.style.paddingBottom = "15px";
        }

        $scope.FilterClearShow = function () {
            if ($scope.Characteristics === undefined) {
                return false;
            }

            var show = $scope.Characteristics.filter(where => where.CharacteristicOptions.filter(secondWhere => secondWhere.Selected).length).length;

            return show;
        }

        $scope.FilterClear = function () {
            var characteristics = $scope.Characteristics.filter(where => where.CharacteristicOptions.filter(secondWhere => secondWhere.Selected).length);
            var characteristicsLength = characteristics.length;

            for (var i = 0; i < characteristicsLength; i++) {
                var characteristic = characteristics[i];
                var characteristicOptions = characteristic.CharacteristicOptions.filter(where => where.Selected);
                var characteristicOptionsLength = characteristicOptions.length;

                for (var j = 0; j < characteristicOptionsLength; j++) {
                    var characteristicOption = characteristicOptions[j];

                    characteristicOption.Selected = false;
                }
            }

            $scope.FilterCode = ''.padEnd($scope.FilterCodeLength, '_');
            $scope.FilterDescription = ''.padEnd($scope.FilterDescriptionLength, ' | ');
        }

        $scope.GetCharacteristicOptionCount = function (characteristic, characteristicOption) {
            var count = $scope.SolutionsFiltered.filter(where => (where.Code.substr(characteristic.StartIndex, 2) === characteristicOption.Code)).length;

            return count;
        }

        $scope.GetCheckBoxEditor = function () {
            this.characteristicOption.Selected = this.characteristicOption.Selected || false;

            var checkBoxEditor = {
                bindingOptions: {
                    value: "characteristicOption.Selected"
                },
                elementAttr: {
                    class: "CharacteristicOptionCheckBox"
                },
                onValueChanged: function () {
                    clearTimeout(delayTimer);

                    delayTimer = setTimeout(function () {
                        FilterCharacteristicOption();
                    }, 250);
                }
            };

            return checkBoxEditor;
        }

        function FilterCharacteristicOption() {
            for (var i = 0; i < $scope.Characteristics.length; i++) {
                var characteristic = $scope.Characteristics[i];

                SetFilter(characteristic);
            }

            Filter();
        };

        function SetFilter(characteristic) {
            var characteristicOptionCode = "__";
            var characteristicOptionDescription = "";
            var characteristicOptionsSelected = characteristic.CharacteristicOptions.filter(where => (where.Selected));

            if (characteristicOptionsSelected.length === 1) {
                characteristicOptionCode = characteristicOptionsSelected[0].Code;
                characteristicOptionDescription = characteristicOptionsSelected[0].Description;
            }

            $scope.FilterCode = $scope.FilterCode.substr(0, characteristic.StartIndex) + characteristicOptionCode + $scope.FilterCode.substr(characteristic.StartIndex + 2);

            var characteristicIndex = $scope.Characteristics.indexOf(characteristic);
            var filterDescriptionSplited = $scope.FilterDescription.split(' | ');
            $scope.FilterDescription = "";

            for (var i = 0; i < filterDescriptionSplited.length; i++) {
                if (i === characteristicIndex) {
                    $scope.FilterDescription += characteristicOptionDescription;
                }
                else {
                    $scope.FilterDescription += filterDescriptionSplited[i];
                }

                if (i !== (filterDescriptionSplited.length - 1)) {
                    $scope.FilterDescription += " | ";
                }
            }
        }

        function Filter() {
            var i;
            var solutionsFiltered = [];

            if ($scope.SearchValues.length) {
                for (i = 0; i < $scope.Solutions.length; i++) {
                    var solutionToAnalyse = $scope.Solutions[i];

                    for (var j = 0; j < $scope.SearchValues.length; j++) {
                        var searchValue = $scope.SearchValues[j];

                        if (searchValue) {
                            searchValue = searchValue.toLowerCase().trim();

                            if (solutionToAnalyse.Code.toLowerCase().trim().includes(searchValue) || solutionToAnalyse.Description.toLowerCase().trim().includes(searchValue)) {
                                solutionsFiltered.push(solutionToAnalyse);
                                break;
                            }

                            if (solutionToAnalyse.DrawingNumber && solutionToAnalyse.DrawingNumber.toLowerCase().trim().includes(searchValue)) {
                                solutionsFiltered.push(solutionToAnalyse);
                                break
                            }
                        }
                    }
                }
            } else {
                solutionsFiltered = $scope.Solutions;
            }

            if (solutionsFiltered.length) {
                for (i = 0; i < $scope.Characteristics.length; i++) {
                    var characteristicsItem = $scope.Characteristics[i];
                    var characteristicOptionCodes = characteristicsItem.CharacteristicOptions.filter(where => (where.Selected)).map(function (characteristicOption) { return characteristicOption.Code; });

                    if (!characteristicOptionCodes.length || (characteristicOptionCodes.length === characteristicsItem.CharacteristicOptions.length)) {
                        continue;
                    }

                    solutionsFiltered = solutionsFiltered.filter(where => characteristicOptionCodes.includes(where.Code.substr(characteristicsItem.StartIndex, 2)));

                    if (!solutionsFiltered.length) {
                        break;
                    }
                }
            }

            SetDefaultSolution(solutionsFiltered);

            $timeout(function () {
                $scope.SolutionsFiltered = solutionsFiltered;
                SetSolutionQrCodes();
                SetSolutionPages();
            });
        }

        function SetDefaultSolution(solutionsFiltered) {
            var defaultSolution = $scope.Solutions.find(find => (find.Code === "999999999999999999"))

            if (!defaultSolution) {
                return;
            }

            var defaultSolutionInFilter = solutionsFiltered.find(find => (find.Code === "999999999999999999"))

            if (!defaultSolutionInFilter) {
                solutionsFiltered.push(defaultSolution);
            }
        }

        function SetSolutionQrCodes() {
            $timeout(function () {
                for (var i = 0; i < $scope.SolutionsFiltered.length; i++) {
                    var solution = $scope.SolutionsFiltered[i];

                    SetQrCode("Qr", solution);
                }
            });
        }

        function SetSolutionDetailQrCode() {
            $timeout(function () {
                SetQrCode("QrSolutionDetail", $scope.SolutionSelected);
            });
        }

        function SetQrCode(id, solution) {
            $("#" + id + solution.Code).ClassyQR({
                size: 90,
                type: 'text',
                text: solution.Code
            });
        }

        //#region Photography
        $scope.GetPhotography = function (photography) {
            if ($scope.generalModel.IsUndefinedEmptyOrNull(photography)) {
                photography = 'images/FallBackImage.1739284541000.png';
            }
            else {
                if (photography.endsWith(".png")) {
                    photography = GetBaseUrl(true) + photography;
                }
                else {
                    photography = 'data:image/jpg;base64,' + photography;
                }
            }

            return photography;
        };

        $scope.GetSolutionPhotography = function (solution) {
            var photography;

            if (!solution) {
                photography = $scope.GetPhotography(null);

                return photography;
            }

            if (solution.SeoInformation && solution.SeoInformation.PhotographyName) {
                photography = $scope.GetPhotography(solution.SeoInformation.PhotographyName);

                return photography;
            }

            if (solution.Photography) {
                photography = $scope.GetPhotography(solution.Photography);

                return photography;
            }

            GetSolutionPhotographyFromServer(solution.Code);

            photography = $scope.GetPhotography(null);

            return photography;
        };

        function GetSolutionPhotographyFromServer(solutionCode, specificSolution) {
            var solutionCodeToGet;

            if (solutionCode) {
                solutionCodeToGet = solutionCode;
            } else {
                solutionCodeToGet = specificSolution.Code;
            }

            var solutionFiltered = GetSolutionByCode($scope.SolutionsFiltered, solutionCodeToGet);
            var solution = GetSolutionByCode($scope.Solutions, solutionCodeToGet);

            solution.Photography = " ";
            solutionFiltered.Photography = " ";

            var parameters = {
                solutionId: solutionCodeToGet
            };

            GeneralLoadData.GeneralGet("SolutionGuide", "GetSolutionPhotography", parameters, null).then(function (result) {
                solution.Photography = result.data;
                solutionFiltered.Photography = result.data;

                if (specificSolution) {
                    specificSolution.Photography = result.data;
                }
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            });
        }
        //#endregion

        $scope.GetSolutionDescription = function (solution) {
            if (!solution) {
                return;
            }

            if (!solution.SeoInformation || !solution.SeoInformation.Description) {
                var description = solution.Description;

                return description;
            }

            return solution.SeoInformation.Description;
        }

        $scope.GetSolutionIndividualLink = function (solution) {
            if (!solution) {
                return;
            }

            var link = GetIndividualLink(solution);

            return link;
        }

        $scope.GetSelectedSolutionPhotography = function (index) {
            var photography;

            if (!$scope.SolutionSelected) {
                return;
            }

            if (!$scope.SolutionSelected.HasDetails && $scope.SolutionSelected.SeoInformation && $scope.SolutionSelected.SeoInformation.PhotographyName) {
                photography = $scope.GetPhotography($scope.SolutionSelected.SeoInformation.PhotographyName);
            }
            else {
                if (!$scope.SolutionDetail.Photographies.length) {
                    return;
                }

                photography = $scope.SolutionDetail.Photographies[index].Photography;
            }

            return photography;
        }

        $scope.GetLanguagePhotography = function (flag) {
            var photography = "images/flags/" + flag.toLowerCase() + ".1739284541000.png";

            var findElement = $("#Language" + flag);
            findElement.attr("alt", flag);
            findElement.attr("title", flag);

            return photography;
        }

        $scope.GetCharacteristicOptionPhotography = function (id, solution, characteristic) {
            var photography;

            if (solution === undefined) {
                return photography;
            }

            var title = characteristic.Description + " -> ";
            var characteristicOptionCode = solution.Code.substr(characteristic.StartIndex, 2);
            var characteristicOption = characteristic.CharacteristicOptions.filter(where => (where.Code === characteristicOptionCode))[0];

            if (characteristicOption !== undefined) {
                photography = characteristicOption.Photography;
                title += characteristicOption.Description;
            }

            var findElement = $("#" + id + solution.Code + characteristic.Code);
            findElement.attr("alt", title);
            findElement.attr("title", title);

            photography = $scope.GetPhotography(photography);

            return photography;
        }

        $scope.ScrollbarOptions = {
            "onScroll": function (y) {
                var buttonTopVisibility = (y.scroll > 100);

                if (buttonTopVisibility !== $scope.ButtonTopVisibility) {
                    $timeout(function () {
                        $scope.ButtonTopVisibility = buttonTopVisibility;
                    });
                }
            }
        };

        $scope.ScrollToTop = function (elementId) {
            angular.element(elementId).animate({ scrollTop: 0 }, 400);
        };

        $scope.Copy = function (elementId, event) {
            if (event) {
                event.stopPropagation();
            }

            var element = document.getElementById(elementId);
            var selection = window.getSelection();
            var range = document.createRange();

            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("Copy");

            GeneralModel.ShowToastWarning(Helpers.Translations.Copied + ": " + element.innerHTML);
        }

        $scope.CopyWithWhitespaces = function (elementId, event) {
            if (event) {
                event.stopPropagation();
            }

            let element = document.getElementById(elementId);
            let textToCopy = element.innerHTML.replace(/_/g, ' ');
            let tempElement = document.createElement("textarea");

            document.body.appendChild(tempElement);
            tempElement.value = textToCopy;

            tempElement.select();
            document.execCommand("copy");

            document.body.removeChild(tempElement);

            GeneralModel.ShowToast(Helpers.Translations.Copied + ": " + textToCopy);
        };

        $scope.CopyAll = function (code, description) {
            var valueToCopy = code + '\n' + description;
            var elementToCopy = document.createElement('textarea');

            elementToCopy.value = valueToCopy;

            document.body.appendChild(elementToCopy);
            elementToCopy.select();
            document.execCommand('copy');
            document.body.removeChild(elementToCopy);

            GeneralModel.ShowToast(Helpers.Translations.Copied + ": " + valueToCopy);
        }

        function SetProjectQuantity() {
            if (!$scope.SolutionSelected.ProjectQuantity) {
                $scope.SolutionSelected.ProjectQuantity = 0;
            }

            $timeout(() => {
                var element = document.getElementById('selectedSolutionQuantity');

                element.focus();
                element.select();
            }, 0)
        }

        $scope.CheckKey = function (keyEvent) {
            if (keyEvent.which === 13) {
                keyEvent.preventDefault();
            }
        };

        $scope.OpenProjectDialog = function () {
            var oldProjectSolutions = angular.copy($scope.Project.Solutions);

            $scope.StepProjectSolutions = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;
            $scope.SendSequencer = false;
            $scope.Project.Solutions = [];

            $scope.Solutions.forEach(solution => {
                if (solution.ProjectQuantity && (solution.ProjectQuantity > 0)) {
                    var solutionsFiltered = $scope.Project.Solutions.filter(where => where.Code === solution.Code);

                    for (var i = 0; i < solution.ProjectQuantity - solutionsFiltered.length; i++) {
                        var oldSolution = oldProjectSolutions.find(find => find.Code === solution.Code);

                        if (oldSolution) {
                            $scope.Project.Solutions.push(angular.copy(oldSolution));
                            oldProjectSolutions.remove(oldSolution);
                        } else {
                            $scope.Project.Solutions.push(angular.copy(solution));
                        }
                    }
                }
            });

            if (!$scope.Project.Solutions.length) {
                GeneralModel.ShowToastWarning("Please select at least one solution to complete the project.");

                return;
            }

            $scope.StepProjectSolutions = true;

            $mdDialog.show({
                contentElement: '#DialogProject',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false
            });
        }

        $scope.DeleteSolution = function (solutionToDelete) {
            var columnIdToReorder = solutionToDelete.ColumnId;

            $scope.DecreaseProjectQuantity(solutionToDelete.Code);

            $scope.Project.Solutions.remove(solutionToDelete);

            if (solutionToDelete.Id || (solutionToDelete.Id === 0)) {
                var element = $('#Solution' + solutionToDelete.Id);

                if (element) {
                    element.remove();
                }
            }

            if (!$scope.Project.Solutions.length) {
                $scope.CloseProject();

                return;
            }

            if (columnIdToReorder) {
                SetSolutionsOrder(columnIdToReorder);
            }

            RemoveAndHideLines(solutionToDelete.Id);
        }

        $scope.DeleteSolutionById = function (solutionId) {
            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            $scope.DeleteSolution(solution);

            UpdateLines();
        }

        $scope.DuplicateSolutionById = function (solutionId) {
            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            var newSolution = $scope.DuplicateSolution(solution);

            AddSolutionToSequencer(newSolution);

            SetNotesOnChange();

            $compile('#Solution' + newSolution.Id)($scope);
        }

        $scope.DuplicateSolution = function (solutionToDuplicate) {
            var positionToInsert = $scope.Project.Solutions.indexOf(solutionToDuplicate);

            if (positionToInsert < 0) {
                return;
            }

            $scope.IncreaseProjectQuantity(solutionToDuplicate.Code);

            positionToInsert++;
            solutionToDuplicate = angular.copy(solutionToDuplicate);

            if (solutionToDuplicate.Order) {
                var maximumId = GetMaximumSolutionId();
                var order = $scope.Project.Solutions.filter(where => (where.ColumnId === solutionToDuplicate.ColumnId)).length;

                order++;
                maximumId++;
                solutionToDuplicate.Order = order;
                solutionToDuplicate.Id = maximumId;
            }

            $scope.Project.Solutions.splice(positionToInsert, 0, solutionToDuplicate);
            CheckSequencerColumns();

            return solutionToDuplicate;
        }

        function GetMaximumSolutionId() {
            var maximumId = 0;

            $scope.Project.Solutions.forEach(solution => {
                if (solution.Id > maximumId) {
                    maximumId = solution.Id;
                }
            });

            return maximumId;
        }

        $scope.CloseProject = function () {
            $scope.StepProjectSolutions = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;

            $mdDialog.hide({
                contentElement: '#DialogProject'
            });
        }

        $scope.ShowProjectSolutions = function () {
            $scope.StepProjectSolutions = true;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;
        }

        $scope.HasSelectedSolutions = function () {
            if (!$scope.Solutions) {
                return false;
            }

            var selectedSolution = $scope.Solutions.find(single => single.ProjectQuantity && (single.ProjectQuantity > 0))

            return selectedSolution;
        }

        $scope.HasSolutionsToSequence = function () {
            if (!$scope.Project.Solutions) {
                return false;
            }

            if ($scope.Project.Solutions.length === 1) {
                return false;
            }

            return true;
        }

        $scope.ShowProjectDetails = function () {
            SetProjectDetails();

            $scope.SendSequencer = $scope.StepProjectSequencer;
            $scope.StepProjectSolutions = false;
            $scope.StepProjectSequencer = false;
            $scope.StepProjectDetails = true;
            $scope.StepProjectSubmitted = false;
            $scope.ShowProjectDetailsInvalidFields = false;
        }

        function SetProjectDetails() {
            var details = localStorage.getItem("Project.Details");

            if (details) {
                $scope.Project.Details = JSON.parse(details)
            }

            if ($scope.Project.Details) {
                if ($scope.Project.Details.Email) {
                    $scope.Project.Details.Emails = [];
                    var emailsToAdd = $scope.Project.Details.Email.split(";");

                    for (var i = 0; i < emailsToAdd.length; i++) {
                        var emailToAdd = emailsToAdd[i];

                        if (!emailToAdd.length) {
                            continue;
                        }

                        $scope.Project.Details.Emails.push(emailToAdd);
                    }

                    delete $scope.Project.Details.Email;
                }
            }
            else {
                $scope.Project.Details = {}
            }

            if (!$scope.Project.Details.Emails) {
                $scope.Project.Details.Emails = [];
            }
        }

        $scope.ShowProjectSequencer = function () {
            SetSequencer();

            $scope.SendSequencer = false;
            $scope.StepProjectSolutions = false;
            $scope.StepProjectSequencer = true;
            $scope.StepProjectDetails = false;
            $scope.StepProjectSubmitted = false;
            $scope.ShowProjectDetailsInvalidFields = false;
        }

        function CheckSequencerColumns() {
            if (!$scope.StepProjectSequencer) {
                return;
            }

            var numberOfSolutions = $scope.Project.Solutions.length;
            var numberOfColumns = $scope.Sequencer.Columns.length;

            if (numberOfSolutions <= numberOfColumns) {
                return;
            }

            var newColumn = { Id: numberOfColumns + 1 };

            $scope.Sequencer.Columns.push(newColumn);
            $timeout(SetSequencerProperties, false);
        }

        function GetSolutionToSetQuantity(solutionCode) {
            var solutionFiltered = GetSolutionByCode($scope.Solutions, solutionCode);

            if (!solutionFiltered) {
                return solutionFiltered;
            }

            if (!solutionFiltered.ProjectQuantity) {
                solutionFiltered.ProjectQuantity = 0;
            }

            return solutionFiltered;
        };

        $scope.IncreaseProjectQuantity = function (solutionCode) {
            var solution = GetSolutionToSetQuantity(solutionCode);

            if (!solution) {
                return;
            }

            solution.ProjectQuantity++;
        };

        $scope.DecreaseProjectQuantity = function (solutionCode) {
            var solution = GetSolutionToSetQuantity(solutionCode);

            if (!solution) {
                return;
            }

            if (solution.ProjectQuantity === 0) {
                return;
            }

            solution.ProjectQuantity--;
        };

        $scope.ProjectSubmit = function () {
            var isFormValid = IsFormValid();

            if (isFormValid) {
                SendProject();

                return;
            }

            $scope.ShowProjectDetailsInvalidFields = true;
        }

        $scope.ProjectComplete = function () {
            $scope.Project.Solutions = [];
            RemoveAllLines();

            $scope.Solutions.forEach(solution => {
                if (solution.ProjectQuantity && (solution.ProjectQuantity > 0)) {
                    solution.ProjectQuantity = 0;
                }
            });

            $mdDialog.hide({
                contentElement: '#DialogProject'
            });
        }

        function IsFormValid() {
            if (!$scope.Project.Details.CompanyName || ($scope.Project.Details.CompanyName.length === 0)) {
                GeneralModel.ShowToastWarning("There are mandatory fields to fill!");

                return false;
            }

            if (!$scope.Project.Details.Emails) {
                GeneralModel.ShowToastWarning("There are mandatory fields to fill!");

                return false;
            }

            if (ValidateEmails()) {
                return true;
            }

            return false;
        }

        function ValidateEmails() {
            var existValidEmail = false;

            for (var i = 0; i < $scope.Project.Details.Emails.length; i++) {
                var emailToValidate = $scope.Project.Details.Emails[i];

                if (!emailToValidate.length) {
                    continue;
                }

                var emailValid = ValidateEmail(emailToValidate, true);

                if (!emailValid) {
                    return false;
                }

                existValidEmail = true;
            }

            if (!existValidEmail) {
                GeneralModel.ShowToastWarning("You must insert at least one valid email.");

                return false;
            }

            return true;
        }

        function ValidateEmail(emailToValidate, showErrorMessage) {
            if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailToValidate)) {
                return true;
            }

            if (showErrorMessage) {
                GeneralModel.ShowToastWarning("Email '" + emailToValidate + "' is invalid.");
            }

            return false;
        }

        function SendProject() {
            $scope.generalModel.FullPageLoading = true;

            var solutionsToSend = [];
            var openStructures = $scope.Project.Details.OpenStructures;

            $scope.Project.Solutions.forEach(solution => {
                var solutionToSend = {
                    Code: solution.Code,
                    Area: solution.Area,
                    Notes: solution.Notes,
                    ColumnId: solution.ColumnId,
                    Order: solution.Order,
                    Id: solution.Id
                }

                solutionsToSend.push(solutionToSend);
            });

            var parameters = {
                Solutions: solutionsToSend,
                ProjectDetail: $scope.Project.Details,
                Language: $scope.LanguageSelected,
                SendSequencer: $scope.SendSequencer
            };

            if ($scope.SendSequencer) {
                for (var i = 0; i < lines.length; i++) {
                    var line = lines[i];

                    var startSolution = GetSolutionById(solutionsToSend, line.StartSolutionId);

                    startSolution.ConnectedToSolutionIds = startSolution.ConnectedToSolutionIds || [];

                    startSolution.ConnectedToSolutionIds.push(line.EndSolutionId);
                }
            }

            GeneralLoadData.GeneralPost("SolutionGuide", "Send", parameters, null).then(function () {
                localStorage.setItem("Project.Details", JSON.stringify($scope.Project.Details))

                $scope.Project.Solutions = []
                $scope.StepProjectSolutions = false;
                $scope.StepProjectSequencer = false;
                $scope.StepProjectDetails = false;
                $scope.StepProjectSubmitted = true;

                if (openStructures) {
                    SendSolutionsToStructures(solutionsToSend);
                }

                $scope.Project.Details.OpenStructures = false;
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        function SendSolutionsToStructures(solutionsToSend) {
            localStorage.setItem("SolutionsSubmitted", JSON.stringify(solutionsToSend));
            $scope.OpenStructures();
        }

        $scope.OpenImportCsvDialog = function () {
            $scope.File = '';
            $scope.generalModel.FullPageLoading = true;
            $scope.UploadBox = { Multiple: false, Pattern: '.csv', Accept: '.csv', Capture: 'camera', Validate: { size: { max: '1MB', min: '1B' }, height: { max: 12000 }, width: { max: 12000 } }, DragOverClass: { accept: 'dragover', reject: 'dragover-err', pattern: '*' }, Options: { debounce: 100 }, Resize: { width: 400, height: 400, centerCrop: false }, ResizeIf: '$width > 400 || $height > 400', FirefoxPaste: true };

            $mdDialog.show({
                contentElement: '#DialogImportCsv',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false
            });

            $scope.generalModel.FullPageLoading = false;
        };

        $scope.ImportCsv = function () {
            $scope.generalModel.FullPageLoading = true;

            var apiUrl = GetIp();
            var formData = new FormData();
            formData.append("", $scope.File);

            var settings = {
                "cache": false,
                "method": 'POST',
                headers: { "Content-Type": undefined },
            };

            return $http.post(apiUrl + '/api/SolutionGuide/ImportCsv', formData, settings)
                .then(function (result) {
                    SetProjectSolutions(result.data);
                }).catch(function (reason) {
                    GeneralModel.ShowToastWarning(reason);
                }).finally(function () {
                    $scope.generalModel.CloseDialog('DialogImportCsv');
                    $scope.generalModel.FullPageLoading = false;
                });
        };

        function SetProjectSolutions(solutions) {
            var maximumId = GetMaximumSolutionId();

            if (maximumId > 0) {
                maximumId++;
            }

            solutions.forEach(solutionToAnalyse => {
                var solution = GetSolutionByCode($scope.Solutions, solutionToAnalyse.Code);

                if (solution) {
                    if (solution.ProjectQuantity && (solution.ProjectQuantity > 0)) {
                        solution.ProjectQuantity++;
                    }
                    else {
                        solution.ProjectQuantity = 1
                    }

                    solution = angular.copy(solution);
                    solution.Notes = solutionToAnalyse.Notes;
                    solution.Photography = solution.Photography || solutionToAnalyse.Photography;

                    if (!solution.Photography || !solution.Photography.trim()) {
                        GetSolutionPhotographyFromServer(null, solution);
                    }

                    if (solutionToAnalyse.Area) {
                        solution.Area = solutionToAnalyse.Area;
                    }

                    if (solutionToAnalyse.ColumnId && (solutionToAnalyse.ColumnId > 0)) {
                        solution.ColumnId = solutionToAnalyse.ColumnId;
                        solution.Order = solutionToAnalyse.Order;

                        if (solutionToAnalyse.Id !== null) {
                            solution.Id = solutionToAnalyse.Id + maximumId;
                        }

                        if (solutionToAnalyse.ConnectedToSolutionIds !== null) {
                            for (var i = 0; i < solutionToAnalyse.ConnectedToSolutionIds.length; i++) {
                                var connectedToSolutionId = solutionToAnalyse.ConnectedToSolutionIds[i] + maximumId;

                                var line = {
                                    StartSolutionId: solution.Id,
                                    EndSolutionId: connectedToSolutionId,
                                }

                                lines.push(line);
                            }
                        }
                    }

                    $scope.Project.Solutions.push(solution);
                }
            });
        }

        $('#alt-style-pagination').pagination({
            items: 260,
            itemOnPage: $scope.ItemsPerPage,
            currentPage: $scope.CurrentPage,
            cssStyle: '',
            prevText: '',
            nextText: '',
            displayedPages: 4,
            edges: 1,
            ellipsePageSet: false,
            onInit: function () { },
            onPageClick: function (page, _evt) {
                $scope.CurrentPage = page;
                $scope.ScrollToTop('.ListSolutions');
            }
        });

        function SetSolutionPages() {
            var numberOfPages = $scope.SolutionsFiltered.length / $scope.ItemsPerPage;

            if (numberOfPages > 1) {
                $scope.ShowInfoPages = true;
            } else {
                $scope.ShowInfoPages = false;
            }

            $scope.CurrentPage = 1;

            $('#alt-style-pagination').pagination('updateItems', numberOfPages);
            $scope.ScrollToTop('.ListSolutions');
        }

        function GetCodesFromCharacteristic(characteristic) {
            var codes = [];
            var isCharacteristicValid = ((characteristic.length % 2) === 0);

            if (!isCharacteristicValid) {
                return codes;
            }

            for (var i = 0; i < characteristic.length; i += 2) {
                codes.push(characteristic.substr(i, 2));
            }

            return codes;
        }

        function SelectCharacteristicOption(mainCode, optionCode) {
            var characteristics = $scope.Characteristics;

            var characteristic = characteristics.find(find => (find.Code === mainCode));

            if (!characteristic) {
                return;
            }

            if (optionCode.toUpperCase() === "ALL") {
                for (var i = 0; i < characteristic.CharacteristicOptions.length; i++) {
                    var characteristicOption = characteristic.CharacteristicOptions[i];

                    characteristicOption.Selected = true;
                }

                return;
            }

            var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === optionCode));

            if (!characteristicOption) {
                return;
            }

            characteristicOption.Selected = true;
        }

        function GetSelectedCharacteristicsOptions() {
            var selectedCharacteristicsToReturn = [];
            var selectedCharacteristics = $scope.Characteristics.filter(filter => filter.CharacteristicOptions.some(some => some.Selected));

            for (var i = 0; i < selectedCharacteristics.length; i++) {
                var selectedCharacteristicToAnalyse = selectedCharacteristics[i];

                var selectedCharacteristicsOptions = selectedCharacteristicToAnalyse.CharacteristicOptions.filter(filter => filter.Selected);

                if (selectedCharacteristicToAnalyse.CharacteristicOptions.length === selectedCharacteristicsOptions.length) {
                    selectedCharacteristicsToReturn.push(selectedCharacteristicToAnalyse.Code);

                    continue;
                }

                var optionCodes = selectedCharacteristicToAnalyse.Code;

                for (var j = 0; j < selectedCharacteristicsOptions.length; j++) {
                    optionCodes += selectedCharacteristicsOptions[j].Code;
                }

                selectedCharacteristicsToReturn.push(optionCodes);
            }

            return selectedCharacteristicsToReturn;
        }

        function GetSolutionsFromCsvInMenu(filename) {
            $scope.generalModel.FullPageLoading = true;

            var promises = [];
            var solutionCodesToGetPhoto = [];
            var solutionsFromCsvMenu = [];

            var parameters = {
                filename: filename
            };

            promises.push(GeneralLoadData.GeneralGet("SolutionGuide", "GetSolutionsFromCsv", parameters, null));

            $q.all(promises).then(function (result) {
                solutionsFromCsvMenu = result[0].data;

                if (!solutionsFromCsvMenu.length) {
                    GeneralModel.ShowToastWarning(Helpers.Translations.NoSolutionsWereFound);

                    return;
                }

                let promisesToGetPhotographies = [];

                solutionCodesToGetPhoto = [...new Set(solutionsFromCsvMenu.map(map => map.Code))];

                solutionCodesToGetPhoto.forEach(solutionCode => {
                    let parameters = {
                        solutionId: solutionCode
                    };

                    let newPromise = GeneralLoadData.GeneralGet("SolutionGuide", "GetSolutionPhotography", parameters, null);

                    promisesToGetPhotographies.push(newPromise);
                });

                return $q.all(promisesToGetPhotographies);
            }).then(function (results) {
                solutionsFromCsvMenu.forEach(solutionFromCsvMenu => {
                    const solutionCodesToGetPhotoIndex = solutionCodesToGetPhoto.indexOf(solutionFromCsvMenu.Code);

                    solutionFromCsvMenu.Photography = results[solutionCodesToGetPhotoIndex].data;
                });

                $scope.CloseMenus();
                SetProjectSolutions(solutionsFromCsvMenu);

                if ($scope.HasSelectedSolutions()) {
                    $scope.OpenProjectDialog();
                }
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        //#region Link
        function GetBaseUrl(isToSeo) {
            var baseUrl = $location.protocol() + '://' + $location.host();

            if ($location.port() !== '') {
                baseUrl += ':' + $location.port();
            }

            if (isToSeo) {
                baseUrl += '/Solution/';
            }
            else {
                baseUrl += '/SolutionConfigurator/SolutionConfigurator/';
            }

            return baseUrl;
        }

        $scope.CopyIndividualLink = function () {
            var url = GetIndividualLink($scope.SolutionSelected);

            CopyToClipboard(url);

            GeneralModel.ShowToast(Helpers.Translations.IndividualUrlCopied);
        }

        function GetIndividualLink(solution) {
            var url = GetBaseUrl();

            url = url.slice(0, -1);

            var json = "?S=" + solution.Code + "&O=true";

            url += json;

            url = url.replace(/ /g, "%20");

            return url;
        }

        function CopyToClipboard(textToCopy) {
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(textToCopy);

                return;
            }

            var temporaryElement = document.createElement('textarea');

            temporaryElement.value = textToCopy;
            document.body.appendChild(temporaryElement);
            temporaryElement.select();
            document.execCommand('Copy');
            document.body.removeChild(temporaryElement);
        }

        $scope.CopyGeneralLink = function () {
            var url = GetBaseUrl();

            url = url.slice(0, -1);

            var selectedCharacteristicsOptions = GetSelectedCharacteristicsOptions();

            var json = "?P=" + $scope.CurrentPage;

            if (selectedCharacteristicsOptions && selectedCharacteristicsOptions.length) {
                json += "&C=" + selectedCharacteristicsOptions.toString();
            }

            if ($scope.SearchValues.length) {
                var searchValues = $scope.SearchValues.toString();

                json += "&S=" + searchValues;
            }

            if (json.length > 260) {
                GeneralModel.ShowToastWarning(Helpers.Translations.UrlMaxLengthReached);

                return;
            }

            url += json;

            CopyToClipboard(url);

            GeneralModel.ShowToast(Helpers.Translations.GeneralUrlCopied);
        }
        //#endregion

        //#region Route
        function SetSearchValuesFromRoute() {
            if (!urlParameters || !urlParameters.S || !urlParameters.S.length) {
                return;
            }

            urlParameters.S.forEach(searchValue => {
                if (searchValue.length) {
                    $scope.SearchValues.push(searchValue);
                }
            });

            Filter();
        }

        function SetCharacteristicsFromRoute() {
            if (!urlParameters || !urlParameters.C || !urlParameters.C.length) {
                return;
            }

            for (var i = 0; i < urlParameters.C.length; i++) {
                var characteristicToAnalyse = urlParameters.C[i];

                var codes = GetCodesFromCharacteristic(characteristicToAnalyse);

                if (!codes.length) {
                    continue;
                }

                var mainCode = codes[0];

                if (codes.length === 1) {
                    SelectCharacteristicOption(mainCode, 'ALL');

                    continue;
                }

                for (var j = 1; j < codes.length; j++) {
                    SelectCharacteristicOption(mainCode, codes[j])
                }
            }

            FilterCharacteristicOption();
        }

        function SetActivePageFromRoute() {
            if (!urlParameters || !urlParameters.P) {
                return;
            }

            var activePage = urlParameters.P;

            if (isNaN(activePage)) {
                return;
            }

            var numberOfPages = $scope.SolutionsFiltered.length / $scope.ItemsPerPage;

            if ((activePage >= 1) && (activePage <= numberOfPages)) {
                $scope.CurrentPage = activePage;

                $('#alt-style-pagination').pagination('selectPage', activePage);
                $scope.ScrollToTop('.ListSolutions');
            }
        }
        //#endregion

        //#region Emails
        $scope.AddEmail = function (originalEmail) {
            var values = originalEmail.split(/[ ,]+/);

            if (values.length < 2) {
                return;
            }

            for (var i = 0; i < values.length; i++) {
                var value = values[i].replace('<', '').replace('>', '');

                if (ValidateEmail(value, false)) {
                    var emailPosition = $scope.Project.Details.Emails.indexOf(originalEmail);

                    if (emailPosition > -1) {
                        $scope.Project.Details.Emails[emailPosition] = value;
                    }

                    break;
                }
            }
        }
        //#endregion

        //#region Help
        $scope.ApplyHelpFilter = function () {
            clearTimeout(delayHelpFilter);

            delayHelpFilter = setTimeout(function () {
                HelpFilter()
            }, 250);
        }

        $scope.OpenHelp = function () {
            $scope.HelpSearchValues = [];

            LoadHelp();

            $mdDialog.show({
                contentElement: '#DialogHelp',
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
            })
        };

        $scope.CloseHelp = function () {
            $mdDialog.hide({
                contentElement: '#DialogHelp'
            });
        }

        function HelpFilter() {
            var i;
            var helpLinksFiltered = [];

            if ($scope.HelpSearchValues.length) {
                for (i = 0; i < $scope.HelpLinks.length; i++) {
                    var helpLinkToAnalyse = $scope.HelpLinks[i];

                    for (var j = 0; j < $scope.HelpSearchValues.length; j++) {
                        var searchValue = $scope.HelpSearchValues[j];

                        if (searchValue) {
                            searchValue = searchValue.toLowerCase().trim();

                            if (helpLinkToAnalyse.Name.toLowerCase().trim().includes(searchValue)) {
                                helpLinksFiltered.push(helpLinkToAnalyse);
                                break;
                            }
                        }
                    }
                }
            } else {
                helpLinksFiltered = $scope.HelpLinks;
            }

            $timeout(function () {
                $scope.HelpLinksFiltered = helpLinksFiltered;
            });
        }

        function LoadHelp() {
            $scope.LoadingHelp = true;
            $scope.HelpLinks = [];
            $scope.HelpLinksFiltered = [];
            var parameters = { applicationCode: codes.Application.Solutions };

            GeneralLoadData.GeneralGet("Document", "List", parameters, null).then(function (result) {
                $scope.HelpLinks = result.data;
                $scope.HelpLinksFiltered = $scope.HelpLinks;
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.LoadingHelp = false;
            });
        }
        //#endregion

        //#region Sequencer
        function SetSequencer() {
            CleanSequencer();

            var checkColumns = false;
            var columnsWithSolutions = [];

            for (var i = 0; i < $scope.Project.Solutions.length; i++) {
                var solution = $scope.Project.Solutions[i];
                var columnId = i + 1;
                var column = { Id: columnId };

                if (!solution.ColumnId) {
                    solution.ColumnId = 1;
                    solution.Order = 99999;
                } else {
                    checkColumns = true;
                }

                solution.OldId = solution.Id;
                solution.Id = i;

                var indexofColumnWithSolutions = columnsWithSolutions.indexOf(solution.ColumnId);

                if (indexofColumnWithSolutions === -1) {
                    columnsWithSolutions.push(solution.ColumnId);
                }

                $scope.Sequencer.Columns.push(column);
            }

            if (checkColumns) {
                CheckSolutionsColumn(columnsWithSolutions);
            }

            SetSolutionsOrder();

            $timeout(function () {
                SetSequencerProperties();

                var solutionsOrdered = $scope.Project.Solutions.sort((a, b) => (a.Order - b.Order));

                for (var i = 0; i < solutionsOrdered.length; i++) {
                    var solution = solutionsOrdered[i];

                    AddSolutionToSequencer(solution);
                }

                SetNotesOnChange();

                $compile('.scrollable-list')($scope);

                if (lines.length) {
                    $timeout(function () {
                        SetLines();
                    }, 250);
                }
            }, false);
        }

        function SetNotesOnChange() {
            $('.SolutionNotes').on('change', function (event) {
                var solutionId = Number(event.target.attributes["solution-id"].value);

                var solution = $scope.Project.Solutions.find(first => (first.Id === solutionId));

                solution.Notes = event.target.value;
            });
        }

        function AddSolutionToSequencer(solution) {
            var content = '';
            content += '<div id="Solution' + solution.Id + '" class="card dx-card dx-theme-text-color dx-theme-background-color" solution-id="' + solution.Id + '">';
            content += '    <div class="col-xs-12 SolutionOptionsArea">';
            content += '        <div class="form-group MarginTop10 SolutionArea col-xs-6">';

            if (solution.Area) {
                content += '            <span>' + solution.Area + '</span>';
            }

            content += '        </div>';
            content += '        <div class="col-xs-6 MarginTop8">';
            content += '            <div class="btn-group FloatRight">';
            content += '                <button class="btn btn btn-light SolutionOptionButton dropdown-toggle" data-toggle="dropdown">';
            content += '                    ' + Helpers.Translations.Options + ' <span class="caret"></span>';
            content += '               </button>';
            content += '                <ul class="dropdown-menu pull-right SolutionOption">';
            content += '                    <li><a ng-click="DuplicateSolutionById(' + solution.Id + ')">' + Helpers.Translations.Duplicate + '</a></li>';
            content += '                    <li><a ng-click="DeleteSolutionById(' + solution.Id + ')">' + Helpers.Translations.Remove + '</a></li>';
            content += '                </ul>';
            content += '            </div>';
            content += '        </div>';
            content += '    </div>';

            content += '    <div class="SolutionPhotographySequencer">';

            var solutionSrc = $scope.GetSolutionPhotography(solution);

            content += '        <img ng-src="' + solutionSrc + '" alt="' + $scope.GetSolutionDescription(solution) + '" title="' + $scope.GetSolutionDescription(solution) + '" />';
            content += '    </div>';

            content += '    <div class="SolutionDetailContent">';
            content += '        <div class="SolutionDetailsBlock">';
            content += '            <div class="col-xs-12">';

            solution.Notes = solution.Notes || "";

            content += '                <textarea class="form-control SolutionNotes" id="Notes' + solution.Id + '" solution-id ="' + solution.Id + '" rows="5" maxlength="100" ng-keydown="CheckKey($event)">' + solution.Notes + '</textarea>';
            content += '             </div>';
            content += '        </div>';
            content += '    </div>';

            content += '    <span class="dotStart" ng-class="{\'dotColorRed\' : DotColorRed(' + solution.Id + ')}" ng-show="ShowDotStart(' + solution.Id + ')" ng-click="StartLine(' + solution.Id + ')"></span>';
            content += '    <span class="dotEnd" ng-show="ShowDotEnd(' + solution.Id + ')" ng-click="EndLine(' + solution.Id + ')"></span>';

            content += '    <span id="DotStart' + solution.Id + '" class="dotStart dotHidden"></span>';
            content += '    <span id="DotEnd' + solution.Id + '" class="dotEnd dotHidden"></span>';

            content += '    <span class="NumberOfStartLinesHidden">{{GetNumberOfStartLinesHidden(' + solution.Id + ')}}</span>';
            content += '    <span class="NumberOfEndLinesHidden">{{GetNumberOfEndLinesHidden(' + solution.Id + ')}}</span>';
            content += '</div>';

            $('#Column' + solution.ColumnId).append(content);
        }

        function CleanSequencer() {
            $scope.Sequencer = {};
            $scope.Sequencer.Columns = [];
        }

        function SetSequencerProperties() {
            $(".scrollable-list").each(function () {
                $(this).dxScrollView({
                    direction: "vertical",
                    showScrollbar: "always",
                    onScroll: function () {
                        UpdateLines();
                    }
                });
            })

            $(".sortable-cards").each(function () {
                var columnId = $(this).attr("column-id");

                $(this).dxSortable({
                    data: { ColumnId: columnId },
                    group: "tasksGroup",
                    moveItemOnDrop: true,
                    onDragEnd: function (e) {
                        var solutionId = e.itemElement.attr("solution-id");

                        MoveSolution(solutionId, e.fromData, e.fromIndex, e.toData, e.toIndex);
                    }
                });
            })

            $(".scrollable-board").each(function () {
                $(this).dxScrollView({
                    direction: "horizontal",
                    showScrollbar: "always",
                    onScroll: function () {
                        UpdateLines();
                    }
                });

                $(this).dxSortable({
                    filter: ".list",
                    itemOrientation: "horizontal",
                    handle: ".list-title",
                    moveItemOnDrop: true
                });
            })
        }

        function MoveSolution(solutionId, fromData, fromIndex, toData, toIndex) {
            if (!solutionId) {
                return;
            }

            var validMove = CheckMove(fromData, fromIndex, toData, toIndex);

            if (!validMove) {
                return;
            }

            solutionId = parseInt(solutionId);

            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            if (!solution) {
                return;
            }

            var fromColumnId = parseInt(fromData.ColumnId);
            var toColumnId = parseInt(toData.ColumnId);

            solution.ColumnId = -1;
            toIndex++;
            fromIndex++;

            if (fromColumnId !== toColumnId) {
                IncrementSolutionsOrder(toColumnId, toIndex);
                DecrementSolutionsOrder(fromColumnId, fromIndex);
            }
            else if (fromIndex > toIndex) {
                IncrementSolutionsOrder(toColumnId, toIndex, fromIndex);
            }
            else {
                DecrementSolutionsOrder(toColumnId, fromIndex, toIndex);
            }

            solution.ColumnId = toColumnId;
            solution.Order = toIndex;

            if (fromColumnId !== toColumnId) {
                RemoveAndHideLines(solutionId);
            }

            $timeout(function () {
                UpdateLines();
            }, 100);
        }

        function CheckMove(fromData, fromIndex, toData, toIndex) {
            if (!fromData || (fromIndex < 0) || !toData || (toIndex < 0)) {
                return false;
            }

            if ((fromData === toData) && (fromIndex === toIndex)) {
                return false;
            }

            return true;
        }

        function CheckSolutionsColumn(columnsWithSolutions) {
            $scope.Sequencer.Columns.forEach(column => {
                var indexofColumnWithSolutions = columnsWithSolutions.indexOf(column.Id);

                if (indexofColumnWithSolutions === -1) {
                    DecrementSolutionsColumnId(column.Id);
                }
            });
        }

        function SetSolutionsOrder(columnId) {
            if (!$scope.Sequencer) {
                return;
            }

            var columnsToSetOrder = $scope.Sequencer.Columns;

            if (columnId) {
                columnsToSetOrder = columnsToSetOrder.filter(where => (where.Id === columnId));
            }

            for (var i = 0; i < columnsToSetOrder.length; i++) {
                var columnToSetOrder = columnsToSetOrder[i];

                var solutionsOrdered = $scope.Project.Solutions.filter(where => (where.ColumnId === columnToSetOrder.Id));

                solutionsOrdered = solutionsOrdered.sort((a, b) => (a.Order > b.Order) ? 2 : ((a.Order === b.Order) ? ((a.Code > b.Code) ? 1 : -1) : -2));

                for (var j = 0; j < solutionsOrdered.length; j++) {
                    var solutionToSetOrder = solutionsOrdered[j];

                    solutionToSetOrder.Order = j + 1;
                }
            }
        }

        function IncrementSolutionsOrder(columnId, orderStart, orderEnd) {
            var solutionsToReorder = $scope.Project.Solutions.filter(where => (where.ColumnId === columnId));

            for (var i = 0; i < solutionsToReorder.length; i++) {
                var solutionToReorder = solutionsToReorder[i];

                if ((solutionToReorder.Order >= orderStart) && (!orderEnd || solutionToReorder.Order <= orderEnd)) {
                    solutionToReorder.Order = solutionToReorder.Order + 1;
                }
            }
        }

        function DecrementSolutionsOrder(columnId, orderStart, orderEnd) {
            var solutionsToReorder = $scope.Project.Solutions.filter(where => (where.ColumnId === columnId));

            for (var i = 0; i < solutionsToReorder.length; i++) {
                var solutionToReorder = solutionsToReorder[i];

                if ((solutionToReorder.Order >= orderStart) && (!orderEnd || solutionToReorder.Order <= orderEnd)) {
                    solutionToReorder.Order = solutionToReorder.Order - 1;
                }
            }
        }

        function DecrementSolutionsColumnId(columnId) {
            var solutionsToReorder = $scope.Project.Solutions.filter(where => (where.ColumnId && (where.ColumnId >= columnId)));

            for (var i = 0; i < solutionsToReorder.length; i++) {
                var solutionToReorder = solutionsToReorder[i];

                solutionToReorder.ColumnId = solutionToReorder.ColumnId - 1;
            }
        }

        //#region Lines
        var lines = [];

        function SetLines() {
            for (var i = 0; i < lines.length; i++) {
                var line = lines[i];

                var newStartSolution = GetSolutionByOldId($scope.Project.Solutions, line.StartSolutionId);
                var newEndSolution = GetSolutionByOldId($scope.Project.Solutions, line.EndSolutionId);

                var newLine = NewLine(newStartSolution.Id, newEndSolution.Id);

                lines[i] = newLine;
            }

            UpdateLines();
        }

        $scope.StartLine = function (solutionId) {
            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            if ($scope.SolutionToStartLine) {
                delete $scope.SolutionToStartLine;
            }
            else {
                $scope.SolutionToStartLine = solution;
            }
        }

        $scope.EndLine = function (solutionId) {
            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            var line = lines.find(first => (first.StartSolutionId === $scope.SolutionToStartLine.Id) && (first.EndSolutionId === solution.Id));

            if (line) {
                RemoveAndHideLine(line);
            }
            else {
                line = NewLine($scope.SolutionToStartLine.Id, solution.Id);

                lines.push(line);
            }

            delete $scope.SolutionToStartLine;
        }

        function NewLine(startLineId, endLineId) {
            var line = new LeaderLine(
                document.getElementById('DotStart' + startLineId),
                document.getElementById('DotEnd' + endLineId),
                {
                    color: '#db4535',
                    path: 'straight'
                }
            );

            line.StartSolutionId = startLineId;
            line.EndSolutionId = endLineId;

            return line;
        }

        $scope.ShowDotStart = function (solutionId) {
            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            if (!solution) {
                return false;
            }

            var show = (!$scope.SolutionToStartLine || ((solution.ColumnId === $scope.SolutionToStartLine.ColumnId) && (solution.Id === $scope.SolutionToStartLine.Id)));

            return show;
        }

        $scope.ShowDotEnd = function (solutionId) {
            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            if (!solution) {
                return false;
            }

            var show = ($scope.SolutionToStartLine && (solution.ColumnId === ($scope.SolutionToStartLine.ColumnId + 1)));

            return show;
        }

        $scope.DotColorRed = function (solutionId) {
            var solution = GetSolutionById($scope.Project.Solutions, solutionId);

            if (!solution) {
                return false;
            }

            var colorRed = ($scope.SolutionToStartLine && (solution.ColumnId === $scope.SolutionToStartLine.ColumnId) && (solution.Id === $scope.SolutionToStartLine.Id));

            return colorRed;
        }

        function UpdateLines() {
            var scrollVertical = $(".scrollable-list");
            var scrollHorizontal = $(".scrollable-board");

            var scrollTop = $(scrollVertical).offset().top;
            var scrollBottom = scrollTop + scrollVertical.height();
            var scrollLeft = $(scrollHorizontal).offset().top;
            var scrollRight = scrollTop + scrollHorizontal.width();

            var existUpdates = false;

            for (var i = 0; i < lines.length; i++) {
                var line = lines[i];

                var dotStart = $('#DotStart' + line.StartSolutionId);
                var dotEnd = $('#DotEnd' + line.EndSolutionId);

                var dotStartTop = $(dotStart).offset().top;
                var dotEndTop = $(dotEnd).offset().top;
                var dotStartLeft = $(dotStart).offset().left;
                var dotEnddotStartLeft = $(dotEnd).offset().left;

                if ((dotStartTop >= scrollTop) && (dotStartTop <= scrollBottom) && (dotEndTop >= scrollTop) && (dotEndTop <= scrollBottom) && (dotStartLeft >= scrollLeft) && (dotStartLeft <= scrollRight) && (dotEnddotStartLeft >= scrollLeft) && (dotEnddotStartLeft <= scrollRight)) {
                    line.position();

                    if (line.Hidden) {
                        line.show();
                        line.Hidden = false;
                        existUpdates = true;
                    }
                }
                else if (!line.Hidden) {
                    line.hide();
                    line.Hidden = true;
                    existUpdates = true;
                }
            }

            if (existUpdates) {
                $scope.$apply();
            }
        }

        function RemoveAllLines() {
            lines = [];
        }

        function RemoveAndHideLines(solutionId) {
            var linesToRemoveAndHide = ListLinesBySolution(solutionId);

            for (var i = 0; i < linesToRemoveAndHide.length; i++) {
                var line = linesToRemoveAndHide[i];

                RemoveAndHideLine(line);
            }
        }

        function HideLine(line) {
            line.remove();
        }

        function RemoveAndHideLine(line) {
            if ($scope.StepProjectSequencer) {
                line.remove();
            }

            lines.remove(line);
        }

        function ListLinesBySolution(solutionId) {
            var linesToReturn = lines.filter(where => (where.StartSolutionId === solutionId) || (where.EndSolutionId === solutionId));

            return linesToReturn;
        }

        $scope.$watch('StepProjectSequencer', function (newValue, oldValue) {
            if ((oldValue === true) && (newValue === false)) {
                for (var i = 0; i < lines.length; i++) {
                    var line = lines[i];

                    HideLine(line);
                }
            }
        });

        $scope.GetNumberOfStartLinesHidden = function (solutionId) {
            var number = lines.filter(where => (where.StartSolutionId === solutionId) && where.Hidden).length;

            var result = '';

            if (number > 0) {
                result = '+' + number;
            }

            return result;
        }

        $scope.GetNumberOfEndLinesHidden = function (solutionId) {
            var number = lines.filter(where => (where.EndSolutionId === solutionId) && where.Hidden).length;

            var result = '';

            if (number > 0) {
                result = '+' + number;
            }

            return result;
        }
        //#endregion
        //#endregion

        //#region Structures
        $scope.OpenStructures = function (solutionCode) {
            var structureslink = $location.protocol() + "://" + $location.host();

            if ($location.port() !== '') {
                structureslink += ':' + $location.port();
            }

            structureslink += "/StructureConfigurator/StructureConfigurator";

            if (solutionCode) {
                var json = "?S=" + solutionCode + "&O=true";

                structureslink += json;
            }

            Helpers.Page.OpenInNewTab(structureslink);
        }
        //#endregion

        //#region Details
        $scope.SetFiltersToSolution = function () {
            let solutionSelectedCode = $scope.SolutionSelected.Code;

            SetSolutionFilters(solutionSelectedCode);
        }

        function SetSolutionFilters(code) {
            $scope.SearchValues = [];
            $scope.FilterClear();

            $scope.Characteristics.forEach((characteristic) => {
                var optionCodeToSelect = code.substr(0, 2);
                var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === optionCodeToSelect));

                code = code.slice(2);

                if (!characteristicOption) {
                    return;
                }

                characteristicOption.Selected = true;
            });
        }

        function SetSolutionDetail() {
            GetDetails($scope.SolutionSelected);

            SetSolutionDetailQrCode("QrSolutionDetail");
        }

        function GetDetails(solution) {
            $scope.generalModel.FullPageLoading = true;
            var parameters = { solutionId: solution.Code };

            CleanSolutionDetail();

            GeneralLoadData.GeneralGet("SolutionGuide", "GetDetails", parameters, null).then(function (result) {
                $scope.SolutionDetail.Links = result.data.Links;
                $scope.SolutionDetail.Files = result.data.Files;
                $scope.SetPhotographies(result.data.SolutionDetailPhotographies, solution);
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        function CleanSolutionDetail() {
            $scope.SolutionDetail = {};
            $scope.SolutionDetail.Photographies = [];
            $scope.SolutionDetail.Links = [];
            $scope.SolutionDetail.Files = [];
            $scope.SolutionDetail.StartPhotographyIndex = -1;
            $scope.SolutionDetail.SelectedPhotographyIndex = -1;
        }

        $scope.SetPhotographies = function (photographies, solution) {
            if (!photographies) {
                return;
            }

            $scope.SolutionDetail.StartPhotographyIndex = 0;
            $scope.SolutionDetail.SelectedPhotographyIndex = 0;

            photographies.forEach(photography => {
                var newPhotographyImage = $scope.GetPhotography(photography.Photography);
                var drawingNumber = photography.DrawingNumber || solution.DrawingNumber;

                var newPhotography = {
                    DrawingNumber: drawingNumber,
                    Photography: newPhotographyImage
                }

                $scope.SolutionDetail.Photographies.push(newPhotography);
            });
        }
        //#endregion

        //#region Translations
        function SetTranslations() {
            var translations = webTranslations.find(first => (first.Language === $scope.LanguageSelected));

            Helpers.Translation.SetTranslations($sessionStorage, translations.Translations);
        }
        //#endregion

        //#region Zoom
        $scope.ApplyZoom = function (e) {
            if (!zoomObject) {
                SetZoomObject();
            }

            var lensPosition = GetLensPosition(e);

            SetZoomedPhotography(lensPosition);
        }

        function SetZoomObject() {
            var lens = document.getElementById("ZoomLens");
            var photography = document.getElementById("Photography");
            var individualSolutionPhotography = document.getElementById("IndividualSolutionPhotography");

            var scaleX = 234 / lens.offsetWidth;
            var scaleY = 234 / lens.offsetHeight;

            zoomObject = {
                lens: lens,
                photography: photography,
                individualSolutionPhotography: individualSolutionPhotography,
                scaleX: scaleX,
                scaleY: scaleY
            };
        }

        function GetLensPosition(e) {
            var cursorPositions = GetCursorPositions(e);
            e.preventDefault();

            var lensPosition = {
                lensX: cursorPositions.cursorPositionX - (zoomObject.lens.offsetWidth / 2),
                lensY: cursorPositions.cursorPositionY - (zoomObject.lens.offsetHeight / 2)
            };

            CheckLensPosition(lensPosition, "lensX", zoomObject.photography.width, zoomObject.lens.offsetWidth);
            CheckLensPosition(lensPosition, "lensY", zoomObject.photography.height, zoomObject.lens.offsetHeight);

            AdjustLens(lensPosition);

            return lensPosition;
        }

        function SetZoomedPhotography(lensPosition) {
            var zoomedPhotography = document.getElementById("ZoomedPhotography");

            if (!zoomedPhotography.style.backgroundSize) {
                zoomedPhotography.style.backgroundSize = (zoomObject.photography.width * zoomObject.scaleX) + "px " + (zoomObject.photography.height * zoomObject.scaleY) + "px";
            }

            zoomedPhotography.style.backgroundPosition = "-" + (lensPosition.lensX * zoomObject.scaleX) + "px -" + (lensPosition.lensY * zoomObject.scaleY) + "px";
        }

        function CheckLensPosition(lensPosition, measurement, photographyMax, offset) {
            if (lensPosition[measurement] > photographyMax - offset) {
                lensPosition[measurement] = photographyMax - offset;
            }

            if (lensPosition[measurement] < 0) {
                lensPosition[measurement] = 0;
            }
        }

        function AdjustLens(lensPosition) {
            zoomObject.lens.style.left = lensPosition.lensX + ((zoomObject.individualSolutionPhotography.offsetWidth - zoomObject.photography.width) / 2) + "px";
            zoomObject.lens.style.top = lensPosition.lensY + ((zoomObject.individualSolutionPhotography.offsetHeight - zoomObject.photography.height) / 2) + "px";
        }

        function GetCursorPositions(e) {
            var photographyPosition = zoomObject.photography.getBoundingClientRect();
            var pagePosition = e || window.event;

            var cursorPositionX = pagePosition.pageX - photographyPosition.left;
            var cursorPositionY = pagePosition.pageY - photographyPosition.top;

            cursorPositionX = cursorPositionX - window.pageXOffset;
            cursorPositionY = cursorPositionY - window.pageYOffset;

            var cursorPositions = { cursorPositionX: cursorPositionX, cursorPositionY: cursorPositionY };

            return cursorPositions;
        }

        $scope.HideLens = function () {
            $scope.ShowZoomLens = false;
        }

        $scope.ShowLens = function () {
            $scope.ShowZoomLens = true;
        }
        //#endregion

        //#region Download
        $scope.DownloadFile = function (file) {
            var fileName = file.Name + file.Extension;

            var parameters = {
                'applicationCode': codes.Application.Solutions,
                'fileName': fileName,
                'folderName': $scope.SolutionSelected.Code
            };

            GeneralLoadData.PreviewFiles("Document", "DownloadFile", parameters).then(function (result) {
                $scope.generalModel.DownloadResultBlob(result);
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            });
        }
        //#endregion

        //#region SlideShow
        $scope.SetPhotography = function (photographyPositionToSet) {
            $scope.SolutionDetail.SelectedPhotographyIndex = photographyPositionToSet;
        }

        $scope.GoPreviousPhotography = function () {
            if ($scope.SolutionDetail.StartPhotographyIndex > 0) {
                $scope.SolutionDetail.StartPhotographyIndex--;
            }
        }

        $scope.GoNextPhotography = function () {
            var lastPosition = $scope.SolutionDetail.Photographies.length - 1;

            if (lastPosition > ($scope.SolutionDetail.StartPhotographyIndex + 2)) {
                $scope.SolutionDetail.StartPhotographyIndex++;
            }
        }

        $scope.ShowGoNextPhotography = function () {
            var lastPosition = $scope.SolutionDetail.Photographies.length - 1;

            if (lastPosition < 3) {
                return false;
            }

            if (lastPosition > ($scope.SolutionDetail.StartPhotographyIndex + 2)) {
                return true;
            }

            return false;
        }
        //#endregion

        //#region Menus
        function SetMenus(result, open) {
            $scope.Menus = result.data;

            if (!$scope.Menus.length) {
                return;
            }

            $scope.MenusHistory = [];
            $scope.MenusHistory.push($scope.Menus[0]);

            SetMenu();

            if (!open) {
                return;
            }

            $scope.OpenMenus();
        }

        function SetMenu() {
            var lastMenuIndex = $scope.MenusHistory.length - 1;

            $scope.SelectedMenu = $scope.MenusHistory[lastMenuIndex];

            ClearMenuSelectedOption();

            if ($scope.SelectedMenu.Photography) {
                return;
            }

            var parameters = {
                applicationCode: codes.Application.Solutions,
                menuCode: $scope.SelectedMenu.Code
            };

            $scope.generalModel.FullPageLoading = true;

            GeneralLoadData.GeneralGet("Menu", "ListPhotography", parameters).then(function (result) {
                var photographies = result.data;
                var photography = photographies.find(find => (find.FileName.toUpperCase() === "Menu".toUpperCase()));

                if (photography) {
                    $scope.SelectedMenu.Photography = $scope.GetPhotography(photography.FileArray);
                } else {
                    $scope.SelectedMenu.Photography = $scope.GetPhotography();
                }

                for (var i = 0; i < $scope.SelectedMenu.MenuOptions.length; i++) {
                    var menuOption = $scope.SelectedMenu.MenuOptions[i];
                    photography = photographies.find(find => (find.FileName === menuOption.Code));

                    if (photography) {
                        menuOption.Photography = $scope.GetPhotography(photography.FileArray);
                    } else {
                        menuOption.Photography = $scope.GetPhotography();
                    }
                }
            }).catch(function (reason) {
                GeneralModel.ShowToastWarning(reason);
            }).finally(function () {
                $scope.generalModel.FullPageLoading = false;
            });
        }

        $scope.OpenMenus = function () {
            $mdDialog.show({
                contentElement: '#DialogMenus',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false,
            })
        };

        $scope.CloseMenus = function () {
            $mdDialog.hide({
                contentElement: '#DialogMenus'
            });

            ApplyMenuFilters();
        }

        function ApplyMenuFilters() {
            $scope.FilterClear();

            for (var i = 0; i < $scope.MenusHistory.length; i++) {
                var menuHistory = $scope.MenusHistory[i];
                var menuSelected = menuHistory.MenuOptions.find(find => find.Selected);

                if (!menuSelected) {
                    continue;
                }

                var menuOptionsFilters = menuSelected.Filters;

                if (!menuOptionsFilters) {
                    continue;
                }

                for (var k = 0; k < menuOptionsFilters.length; k++) {
                    var menuOptionFilters = menuOptionsFilters[k];
                    var index = menuOptionFilters.indexOf(".");
                    var characteristicCode = menuOptionFilters.substr(0, index);
                    var characteristic = $scope.Characteristics.find(find => (find.Code === characteristicCode));

                    if (!characteristic) {
                        continue;
                    }

                    var characteristicOptionCode = menuOptionFilters.substr(index + 1);
                    var characteristicOption = characteristic.CharacteristicOptions.find(find => (find.Code === characteristicOptionCode));

                    if (!characteristicOption) {
                        continue;
                    }

                    characteristicOption.Selected = true;
                }
            }
        }

        $scope.MenuOptionClick = function (menuOption) {
            ClearMenuSelectedOption();

            menuOption.Selected = true;

            if (menuOption.Link) {
                Helpers.Page.OpenInNewTab(menuOption.Link);

                return;
            }

            if (menuOption.Csv) {
                GetSolutionsFromCsvInMenu(menuOption.Csv);

                return;
            }

            if (menuOption.Menu) {
                var validNextMenu = NextMenu(menuOption);

                if (validNextMenu) {
                    return;
                }
            }

            $scope.CloseMenus();
        }

        function NextMenu(menuOption) {
            var nextMenu = $scope.Menus.find(find => (find.Code === menuOption.Menu));

            if (!nextMenu) {
                return false;
            }

            $scope.MenusHistory.push(nextMenu);

            SetMenu();

            return true;
        }

        $scope.PreviousMenu = function () {
            $scope.MenusHistory.pop();

            SetMenu();
        }

        $scope.RestartMenus = function () {
            $scope.MenusHistory = [];

            $scope.MenusHistory.push($scope.Menus[0]);

            SetMenu();
        }

        function ClearMenuSelectedOption() {
            var selectedMenuOption = $scope.SelectedMenu.MenuOptions.find(find => find.Selected);

            if (selectedMenuOption) {
                selectedMenuOption.Selected = false;
            }
        }
        //#endregion

        //#region Youtube Player
        $scope.GetVideoLink = function (link) {
            if (!link || !link.Url) {
                return;
            }

            var url = $sce.trustAsResourceUrl(link.Url);

            return url;
        };
        //#endregion

        //#region Filter Code Mask
        //#region Initialize
        function InitializeFilterCodeMask() {
            let maxLength = $scope.FilterCodeLength || 30;

            $scope.EditFilterCodeComponent = {
                Options: {
                    bindingOptions: {
                        value: 'EditFilterCodeComponent.Code'
                    },
                    mask: '9'.repeat(maxLength)
                }
            };
        }
        //#endregion

        //#region Modal
        $scope.OpenDialogFilterCode = function () {
            $scope.File = '';
            $scope.generalModel.FullPageLoading = true;

            $scope.EditFilterCodeComponent = {
                Code: angular.copy($scope.FilterCode).replace(/_/g, ' ')
            }

            $mdDialog.show({
                contentElement: '#DialogFilterCode',
                parent: angular.element(document.body),
                multiple: false,
                clickOutsideToClose: false
            });

            $scope.generalModel.FullPageLoading = false;
        };

        function CloseDialogFilterCode() {
            delete $scope.EditFilterCodeComponent.Code;

            $scope.generalModel.CloseDialog('DialogFilterCode');
        };
        //#endregion

        $scope.EditFilterCode = function () {
            let code = $scope.EditFilterCodeComponent.Code;

            SetSolutionFilters(code);
            CloseDialogFilterCode();
        };
        //#endregion
    });
})();
(function () {
    "use strict";
    angular.module(myApplication.appName).service('GeneralModel', function ($timeout, $mdToast) {

        var _model = {
            IsOnline: true
        };

        var _ShowToast = function (text) {
            var toast = $mdToast.simple()
                .hideDelay(3000)
                .textContent(text)
                .action('x')
                .highlightAction(true)
                .highlightClass('md-accent')
                .position('bottom left');

            $mdToast.hide();
            $mdToast.show(toast).then(function () { });
        };

        var _ShowToastWarning = function (text) {
            if (_model.Expired !== true) {
                if ((text === '') || (typeof text === 'undefined') || (text.substr(0, 15) === '<!DOCTYPE html>')) {
                    text = myApplication.getLanguageObject.selectedLanguage('warningMessages', myApplication).thereWasErrorTryAgain();
                }
                if (text.indexOf('401') < 0) {
                    var toast = $mdToast.simple()
                        .hideDelay(3000)
                        .textContent(text)
                        .action('x')
                        .toastClass('Warning')
                        .highlightAction(true)
                        .highlightClass('md-accent')
                        .position('bottom left');

                    $mdToast.hide();
                    $mdToast.show(toast).then(function () { });
                }
            }
        };

        var _UpdateStateButton = function (state) {
            $timeout(_model.ButtonTopVisibility = state, 1);
        };

        return {
            model: _model,
            ShowToast: function (text) {
                return _ShowToast(text);
            },
            ShowToastWarning: function (text) {
                return _ShowToastWarning(text);
            },
            UpdateStateButton: function (state) {
                return _UpdateStateButton(state);
            },
        };
    });
})();
(function () {
    "use strict";
    myApp.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise(function ($injector, $location) {
            $injector.invoke(['$state', function ($state) {
                $state.go('SolutionConfigurator');
            }]);
        });

        $stateProvider
            //#region Solutions
            .state('SolutionConfigurator', {
                url: "/SolutionConfigurator?P&C&S&O",
                params: {
                    'P': null,
                    'C': null,
                    'S': null,
                    'O': null
                },
                templateUrl: "Application/Views/Solutions/solutionGuide.1739284541000.html",
                controller: function (GeneralModel, $stateParams) {
                    $stateParams.delete;
                },
                resolve: {
                    params: ['$stateParams', function ($stateParams) {
                        return $stateParams;
                    }]
                }
            })
            .state('StructureBuilderConfigurator', {
                url: "/StructureBuilderConfigurator?P&C&S&O",
                params: {
                    'P': null,
                    'C': null,
                    'S': null,
                    'O': null
                },
                templateUrl: "Application/Views/BuilderConfigurator/builderConfigurator.1739284541000.html",
                controller: function (GeneralModel, $stateParams) {
                    $stateParams.delete;
                },
                resolve: {
                    params: ['$stateParams', function ($stateParams) {
                        return $stateParams;
                    }]
                }
            })
            .state('ServiceConfigurator', {
                url: "/ServiceConfigurator?P&C&S&O",
                params: {
                    'P': null,
                    'C': null,
                    'S': null,
                    'O': null
                },
                templateUrl: "Application/Views/ServiceGuide/serviceGuide.1739284541000.html",
                controller: function (GeneralModel, $stateParams) {
                    $stateParams.delete;
                },
                resolve: {
                    params: ['$stateParams', function ($stateParams) {
                        return $stateParams;
                    }]
                }
            });
        //#endregion
    }]);
})();
(function () {
    "use strict";
    myApp.factory('ExportFiles', ["$q", "GeneralModel", function ($q, GeneralModel) {

        function ExportFiles(scope, model, fileName, format, controller, byId, additionalParameters, customAction) {
            scope.generalModel.FullPageLoading = true;

            switch (format) {

                case 'xml':
                    var action = "ExportToXml";

                    if (!scope.generalModel.IsUndefinedEmptyOrNull(byId)) {
                        action = "ExportToXmlById";
                    }

                    if (!scope.generalModel.IsUndefinedEmptyOrNull(customAction)) {
                        action = customAction;
                    }

                    $q.when(GeneralModel.ExportToXml(model, controller, action, additionalParameters)).then(function () {
                        ReadXml(scope, fileName, model.XmlFile);
                    }).catch(function (reason) {
                        GeneralModel.ShowToastWarning(reason);
                        scope.generalModel.FullPageLoading = false;
                    });

                    break;
            }
        }

        var ReadXml = function (scope, fileName, xmlFile) {
            var byteArray = new Uint8Array(xmlFile);
            var dataToBase64 = new TextDecoder("utf-8").decode(byteArray);
            dataToBase64 = JSON.parse(dataToBase64).FileArray;
            dataToBase64 = dataToBase64.replace(/[\'\"]/g, '');
            var byteCharacters = atob(dataToBase64);
            var blob = new Blob([byteCharacters], {
                type: 'text/xml'
            });
            saveAs(blob, '' + fileName + '.xml');
            scope.generalModel.FullPageLoading = false;
        };

        return ExportFiles;
    }]);
})();
(function () {
    "use strict";
    var version = '11.1.3';
    myApp.factory('UploadMethod', function (GeneralModel, $http, $timeout, $compile, Upload) {

        function UploadMethod(pageScope, parentModel) {
            pageScope.generalModel = GeneralModel.model;
            pageScope.usingFlash = FileAPI && FileAPI.upload !== null;

            pageScope.CloseUploadFileDialog = function () {
                pageScope.generalModel.CloseDialog('DialogInsertImage');
            };

            pageScope.changeAngularVersion = function () {
                window.location.hash = pageScope.angularVersion;
                window.location.reload(true);
            };
            pageScope.angularVersion = window.location.hash.length > 1 ? (window.location.hash.indexOf('/') === 1 ?
                window.location.hash.substring(2) : window.location.hash.substring(1)) : '1.2.24';

            pageScope.invalidFiles = [];
            pageScope.generalModel.InvalidFiles = pageScope.invalidFiles;
            pageScope.invalidFilesAnnex = [];
            pageScope.generalModel.InvalidFilesAnnex = pageScope.invalidFilesAnnex;
            pageScope.invalidFilesNotesAnnex = [];
            pageScope.generalModel.InvalidFilesNotesAnnex = pageScope.invalidFilesNotesAnnex;
            pageScope.invalidFilesNotesAnnexPhoto = [];
            pageScope.generalModel.InvalidFilesNotesAnnexPhoto = pageScope.invalidFilesNotesAnnexPhoto;

            pageScope.$watch('generalModel.InvalidFiles', function (invalidFiles) {
                if (invalidFiles !== null && !angular.isArray(invalidFiles)) {
                    $timeout(function () {
                        pageScope.invalidFiles = [invalidFiles];
                        var maxSize = '';
                        if (pageScope.generalModel.InvalidFiles.$errorMessages.maxSize) {
                            maxSize = '<span>Maximum size exceeded -</span>';
                        }
                        angular.element('#InvalidFiles').append('<p>The file "' + pageScope.generalModel.InvalidFiles.name + '" is Invalid.</p><p>' + maxSize + pageScope.generalModel.InvalidFiles.$errorParam + '<br />Size: ' + pageScope.generalModel.InvalidFiles.size + ' B - Type: ' + pageScope.generalModel.InvalidFiles.type + '</p>');
                    });
                    pageScope.generalModel.LoadingUpload = false;
                }
                else {
                    angular.element('#InvalidFiles').html('');
                }
            });

            pageScope.$watch('generalModel.InvalidFilesAnnex', function (invalidFilesAnnex) {
                if (invalidFilesAnnex !== null && !angular.isArray(invalidFilesAnnex)) {
                    $timeout(function () { pageScope.invalidFilesAnnex = [invalidFilesAnnex]; });
                    pageScope.generalModel.LoadingUpload = false;
                }
            });

            pageScope.$watch('generalModel.InvalidFilesNotesAnnex', function (invalidFilesNotesAnnex) {
                if (invalidFilesNotesAnnex !== null && !angular.isArray(invalidFilesNotesAnnex)) {
                    $timeout(function () {
                        pageScope.invalidFilesNotesAnnex = [invalidFilesNotesAnnex];
                        pageScope.FileUploadNameNotesAnnex = "";
                    });
                    pageScope.generalModel.LoadingUpload = false;
                }
            });

            pageScope.$watch('generalModel.InvalidFilesNotesAnnexPhoto', function (invalidFilesNotesAnnexPhoto) {
                if ((invalidFilesNotesAnnexPhoto !== null) && (!angular.isArray(invalidFilesNotesAnnexPhoto))) {
                    $timeout(function () {
                        pageScope.invalidFilesNotesAnnexPhoto = [invalidFilesNotesAnnexPhoto];
                        pageScope.FileUploadNameNotesAnnexPhoto = "";
                    });
                    pageScope.generalModel.LoadingUpload = false;
                }
            });

            pageScope.$watch('generalModel.Files', function (files) {
                pageScope.formUpload = false;
                if (files !== null) {
                    pageScope.generalModel.LoadingUpload = true;
                    if (!angular.isArray(files)) {
                        $timeout(function () {
                            pageScope.generalModel.Files = files = [files];
                            if (typeof pageScope.generalModel.Files[0].$ngfName !== 'undefined') {
                                pageScope.generalModel.FileUploadName = pageScope.generalModel.Files[0].$ngfName.substring(0, pageScope.generalModel.Files[0].$ngfName.lastIndexOf('.'));
                            }
                            else if (typeof pageScope.generalModel.Files[0].name !== 'undefined') {
                                pageScope.generalModel.FileUploadName = pageScope.generalModel.Files[0].name.substring(0, pageScope.generalModel.Files[0].name.lastIndexOf('.'));
                            }
                        });
                        return;
                    }
                    for (var i = 0; i < files.length; i++) {
                        pageScope.errorMsg = null;
                        (function (f) {
                            pageScope.upload(f, true);
                        })(files[i]);
                    }
                    pageScope.generalModel.LoadingUpload = false;
                }
            });

            pageScope.$watch('generalModel.FilesAnnex', function (files) {
                pageScope.formUpload = false;
                if ((files !== null) && (typeof files !== 'undefined')) {
                    pageScope.generalModel.LoadingUpload = true;
                    if (!angular.isArray(files)) {
                        $timeout(function () {
                            pageScope.generalModel.FilesAnnex = files = [files];
                            if (typeof pageScope.generalModel.FilesAnnex[0].$ngfName !== 'undefined') {
                                pageScope.generalModel.FileUploadNameAnnex = pageScope.generalModel.FilesAnnex[0].$ngfName.substring(0, pageScope.generalModel.FilesAnnex[0].$ngfName.lastIndexOf('.'));
                            }
                            else if (typeof pageScope.generalModel.FilesAnnex[0].name !== 'undefined') {
                                pageScope.generalModel.FileUploadNameAnnex = pageScope.generalModel.FilesAnnex[0].name.substring(0, pageScope.generalModel.FilesAnnex[0].name.lastIndexOf('.'));
                            }
                        });
                        return;
                    }
                    for (var i = 0; i < files.length; i++) {
                        pageScope.errorMsg = null;
                        (function (f) {
                            pageScope.upload(f, true);
                        })(files[i]);
                    }
                    pageScope.generalModel.LoadingUpload = false;
                }
            });

            pageScope.$watch('generalModel.FilesNotesAnnex', function (files) {
                pageScope.formUpload = false;
                if ((files !== null) && (typeof files !== 'undefined')) {
                    pageScope.generalModel.LoadingUpload = true;
                    if (!angular.isArray(files)) {
                        $timeout(function () {
                            pageScope.generalModel.FilesNotesAnnex = files = [files];
                            if (typeof pageScope.generalModel.FilesNotesAnnex[0].$ngfName !== 'undefined') {
                                pageScope.generalModel.FileUploadNameNotesAnnex = pageScope.generalModel.FilesNotesAnnex[0].$ngfName.substring(0, pageScope.generalModel.FilesNotesAnnex[0].$ngfName.lastIndexOf('.'));
                            }
                            else if (typeof pageScope.generalModel.FilesNotesAnnex[0].name !== 'undefined') {
                                pageScope.generalModel.FileUploadNameNotesAnnex = pageScope.generalModel.FilesNotesAnnex[0].name.substring(0, pageScope.generalModel.FilesNotesAnnex[0].name.lastIndexOf('.'));
                            }
                        });
                        return;
                    }
                    for (var i = 0; i < files.length; i++) {
                        pageScope.errorMsg = null;
                        (function (f) {
                            pageScope.upload(f, true);
                        })(files[i]);
                    }
                    pageScope.generalModel.LoadingUpload = false;
                }
            });

            pageScope.$watch('generalModel.FilesNotesAnnexPhoto', function (files) {
                pageScope.formUpload = false;
                if ((files !== null) && (typeof files !== 'undefined')) {
                    pageScope.generalModel.LoadingUpload = true;
                    if (!angular.isArray(files)) {
                        $timeout(function () {
                            pageScope.generalModel.FilesNotesAnnexPhoto = files = [files];
                            if (typeof pageScope.generalModel.FilesNotesAnnexPhoto[0].$ngfName !== 'undefined') {
                                pageScope.generalModel.FileUploadNameNotesAnnexPhoto = pageScope.generalModel.FilesNotesAnnexPhoto[0].$ngfName.substring(0, pageScope.generalModel.FilesNotesAnnexPhoto[0].$ngfName.lastIndexOf('.'));
                            }
                            else if (typeof pageScope.generalModel.FilesNotesAnnexPhoto[0].name !== 'undefined') {
                                pageScope.generalModel.FileUploadNameNotesAnnexPhoto = pageScope.generalModel.FilesNotesAnnexPhoto[0].name.substring(0, pageScope.generalModel.FilesNotesAnnexPhoto[0].name.lastIndexOf('.'));
                            }
                        });
                        return;
                    }
                    for (var i = 0; i < files.length; i++) {
                        pageScope.errorMsg = null;
                        (function (f) {
                            pageScope.upload(f, true);
                        })(files[i]);
                    }
                    pageScope.generalModel.LoadingUpload = false;
                }
            });

            pageScope.uploadPic = function (file) {
                pageScope.formUpload = true;
                if (file !== null) {
                    pageScope.upload(file);
                }
            };

            pageScope.upload = function (file, resumable) {
                pageScope.errorMsg = null;
                if (pageScope.howToSend === 1) {
                    uploadUsingUpload(file, resumable);
                } else if (pageScope.howToSend === 2) {
                    uploadUsing$http(file);
                }
            };

            pageScope.isResumeSupported = Upload.isResumeSupported();

            pageScope.restart = function (file) {
                if (Upload.isResumeSupported()) {
                    $http.get('https://angular-file-upload-cors-srv.appspot.com/upload?restart=true&name=' + encodeURIComponent(file.name)).then(function () {
                        pageScope.upload(file, true);
                    });
                } else {
                    pageScope.upload(file);
                }
            };

            pageScope.chunkSize = 100000;
            function uploadUsingUpload(file, resumable) {
                file.upload = Upload.upload({
                    url: 'https://angular-file-upload-cors-srv.appspot.com/upload' + pageScope.getReqParams(),
                    resumeSizeUrl: resumable ? 'https://angular-file-upload-cors-srv.appspot.com/upload?name=' + encodeURIComponent(file.name) : null,
                    resumeChunkSize: resumable ? pageScope.chunkSize : null,
                    headers: {
                        'optional-header': 'header-value'
                    },
                    data: { username: pageScope.username, file: file }
                });

                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                    });
                }, function (response) {
                    if (response.status > 0)
                        pageScope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });

                file.upload.xhr(function (xhr) {
                });
            }

            function uploadUsing$http(file) {
                file.upload = Upload.http({
                    url: 'https://angular-file-upload-cors-srv.appspot.com/upload' + pageScope.getReqParams(),
                    method: 'POST',
                    headers: {
                        'Content-Type': file.type
                    },
                    data: file
                });

                file.upload.then(function (response) {
                    file.result = response.data;
                }, function (response) {
                    if (response.status > 0)
                        pageScope.errorMsg = response.status + ': ' + response.data;
                });

                file.upload.progress(function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }

            function uploadS3(file) {
                file.upload = Upload.upload({
                    url: pageScope.s3url,
                    method: 'POST',
                    data: {
                        key: file.name,
                        AWSAccessKeyId: pageScope.AWSAccessKeyId,
                        acl: pageScope.acl,
                        policy: pageScope.policy,
                        signature: pageScope.signature,
                        'Content-Type': file.type === null || file.type === '' ? 'application/octet-stream' : file.type,
                        filename: file.name,
                        file: file
                    }
                });

                file.upload.then(function (response) {
                    $timeout(function () {
                        file.result = response.data;
                    });
                }, function (response) {
                    if (response.status > 0)
                        pageScope.errorMsg = response.status + ': ' + response.data;
                });

                file.upload.progress(function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
                storeS3UploadConfigInLocalStore();
            }

            pageScope.generateSignature = function () {
                $http.post('/s3sign?aws-secret-key=' + encodeURIComponent(pageScope.AWSSecretKey), pageScope.jsonPolicy).success(function (data) {
                    pageScope.policy = data.policy;
                    pageScope.signature = data.signature;
                });
            };

            if (localStorage) {
                pageScope.s3url = localStorage.getItem('s3url');
                pageScope.AWSAccessKeyId = localStorage.getItem('AWSAccessKeyId');
                pageScope.acl = localStorage.getItem('acl');
                pageScope.success_action_redirect = localStorage.getItem('success_action_redirect');
                pageScope.policy = localStorage.getItem('policy');
                pageScope.signature = localStorage.getItem('signature');
            }

            pageScope.success_action_redirect = pageScope.success_action_redirect || window.location.protocol + '//' + window.location.host;
            pageScope.jsonPolicy = pageScope.jsonPolicy || '{\n  "expiration": "2020-01-01T00:00:00Z",\n  "conditions": [\n    {"bucket": "angular-file-upload"},\n    ["starts-with", "$key", ""],\n    {"acl": "private"},\n    ["starts-with", "$Content-Type", ""],\n    ["starts-with", "$filename", ""],\n    ["content-length-range", 0, 524288000]\n  ]\n}';
            pageScope.acl = pageScope.acl || 'private';

            function storeS3UploadConfigInLocalStore() {
                if (pageScope.howToSend === 3 && localStorage) {
                    localStorage.setItem('s3url', pageScope.s3url);
                    localStorage.setItem('AWSAccessKeyId', pageScope.AWSAccessKeyId);
                    localStorage.setItem('acl', pageScope.acl);
                    localStorage.setItem('success_action_redirect', pageScope.success_action_redirect);
                    localStorage.setItem('policy', pageScope.policy);
                    localStorage.setItem('signature', pageScope.signature);
                }
            }

            (function handleDynamicEditingOfScriptsAndHtml(pageScope) {
                if (document.getElementById('editArea') !== null) {
                    pageScope.defaultHtml = document.getElementById('editArea').innerHTML.replace(/\t\t\t\t/g, '').replace(/&amp;/g, '&');

                    var fromLocal = (localStorage && localStorage.getItem('editHtml' + version));
                    pageScope.editHtml = fromLocal || pageScope.defaultHtml;
                    function htmlEdit() {
                        document.getElementById('editArea').innerHTML = pageScope.editHtml;
                        $compile(document.getElementById('editArea'))(pageScope);
                        pageScope.editHtml && localStorage && localStorage.setItem('editHtml' + version, pageScope.editHtml);
                    }

                    pageScope.$watch('editHtml', htmlEdit);
                }
            })(pageScope, $http);

            pageScope.confirm = function () {
                return confirm('Tem a certeza? As suas alterações locais serão perdidas.');
            };

            pageScope.getReqParams = function () {
                return pageScope.generateErrorOnServer ? '?errorCode=' + pageScope.serverErrorCode +
                    '&errorMessage=' + pageScope.serverErrorMsg : '';
            };

            angular.element(window).bind('dragover', function (e) {
                e.preventDefault();
            });
            angular.element(window).bind('drop', function (e) {
                e.preventDefault();
            });

            pageScope.modelOptionsObj = {};
            pageScope.$watch('validate+dragOverClass+modelOptions+resize+resizeIf', function (v) {
                pageScope.validateObj = eval('(function(){return ' + pageScope.validate + ';})()');
                pageScope.dragOverClassObj = eval('(function(){return ' + pageScope.dragOverClass + ';})()');
                pageScope.modelOptionsObj = eval('(function(){return ' + pageScope.modelOptions + ';})()');
                pageScope.resizeObj = eval('(function($file){return ' + pageScope.resize + ';})()');
                pageScope.resizeIfFn = eval('(function(){var fn = function($file, $width, $height){return ' + pageScope.resizeIf + ';};return fn;})()');
            });

            pageScope.modelOptionsObj = {};
            pageScope.$watch('validate+dragOverClass+modelOptions+resize+resizeIf', function (v) {
                pageScope.validateObj = eval('(function(){return ' + pageScope.validate + ';})()');
                pageScope.dragOverClassObj = eval('(function(){return ' + pageScope.dragOverClass + ';})()');
                pageScope.modelOptionsObj = eval('(function(){return ' + pageScope.modelOptions + ';})()');
                pageScope.resizeObj = eval('(function($file){return ' + pageScope.resize + ';})()');
                pageScope.resizeIfFn = eval('(function(){var fn = function($file, $width, $height){return ' + pageScope.resizeIf + ';};return fn;})()');
            });

            $timeout(function () {
                pageScope.capture = localStorage.getItem('capture' + version) || 'camera';
                pageScope.pattern = localStorage.getItem('pattern' + version) || 'image/*,audio/*,video/*';
                pageScope.acceptSelect = localStorage.getItem('acceptSelect' + version) || 'image/*,audio/*,video/*';
                pageScope.modelOptions = localStorage.getItem('modelOptions' + version) || '{debounce:100}';
                pageScope.dragOverClass = localStorage.getItem('dragOverClass' + version) || '{accept:\'dragover\', reject:\'dragover-err\', pattern:\'image/*,audio/*,video/*,text/*\'}';
                pageScope.disabled = localStorage.getItem('disabled' + version) === 'true' || false;
                pageScope.multiple = localStorage.getItem('multiple' + version) === 'true' || false;
                pageScope.allowDir = localStorage.getItem('allowDir' + version) === 'true' || true;
                pageScope.validate = localStorage.getItem('validate' + version) || '{size: {max: \'1MB\', min: \'10B\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'5m\'}}';
                pageScope.keep = localStorage.getItem('keep' + version) === 'true' || false;
                pageScope.keepDistinct = localStorage.getItem('keepDistinct' + version) === 'true' || false;
                pageScope.orientation = localStorage.getItem('orientation' + version) === 'true' || false;
                pageScope.runAllValidations = localStorage.getItem('runAllValidations' + version) === 'true' || false;
                pageScope.resize = localStorage.getItem('resize' + version) || "{width: 1000, height: 1000, centerCrop: true}";
                pageScope.resizeIf = localStorage.getItem('resizeIf' + version) || "$width > 5000 || $height > 5000";
                pageScope.dimensions = localStorage.getItem('dimensions' + version) || "$width < 12000 || $height < 12000";
                pageScope.duration = localStorage.getItem('duration' + version) || "$duration < 10000";
                pageScope.maxFiles = localStorage.getItem('maxFiles' + version) || "500";
                pageScope.ignoreInvalid = localStorage.getItem('ignoreInvalid' + version) || "";
                pageScope.$watch('validate+capture+pattern+acceptSelect+disabled+capture+multiple+allowDir+keep+orientation+' +
                    'keepDistinct+modelOptions+dragOverClass+resize+resizeIf+maxFiles+duration+dimensions+ignoreInvalid+runAllValidations', function () {
                        localStorage.setItem('capture' + version, pageScope.capture);
                        localStorage.setItem('pattern' + version, pageScope.pattern);
                        localStorage.setItem('acceptSelect' + version, pageScope.acceptSelect);
                        localStorage.setItem('disabled' + version, pageScope.disabled);
                        localStorage.setItem('multiple' + version, pageScope.multiple);
                        localStorage.setItem('allowDir' + version, pageScope.allowDir);
                        localStorage.setItem('validate' + version, pageScope.validate);
                        localStorage.setItem('keep' + version, pageScope.keep);
                        localStorage.setItem('orientation' + version, pageScope.orientation);
                        localStorage.setItem('keepDistinct' + version, pageScope.keepDistinct);
                        localStorage.setItem('dragOverClass' + version, pageScope.dragOverClass);
                        localStorage.setItem('modelOptions' + version, pageScope.modelOptions);
                        localStorage.setItem('resize' + version, pageScope.resize);
                        localStorage.setItem('resizeIf' + version, pageScope.resizeIf);
                        localStorage.setItem('dimensions' + version, pageScope.dimensions);
                        localStorage.setItem('duration' + version, pageScope.duration);
                        localStorage.setItem('maxFiles' + version, pageScope.maxFiles);
                        localStorage.setItem('ignoreInvalid' + version, pageScope.ignoreInvalid);
                        localStorage.setItem('runAllValidations' + version, pageScope.runAllValidations);
                    });
            });
        }
        return UploadMethod;
    });
})();